import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  AccountNumber: { input: any; output: any };
  BigInt: { input: any; output: any };
  Byte: { input: any; output: any };
  CountryCode: { input: any; output: any };
  Cuid: { input: any; output: any };
  Currency: { input: any; output: any };
  DID: { input: any; output: any };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  DateTimeISO: { input: any; output: any };
  DeweyDecimal: { input: any; output: any };
  Duration: { input: any; output: any };
  EmailAddress: { input: any; output: any };
  GUID: { input: any; output: any };
  HSL: { input: any; output: any };
  HSLA: { input: any; output: any };
  HexColorCode: { input: any; output: any };
  Hexadecimal: { input: any; output: any };
  IBAN: { input: any; output: any };
  IP: { input: any; output: any };
  IPCPatent: { input: any; output: any };
  IPv4: { input: any; output: any };
  IPv6: { input: any; output: any };
  ISBN: { input: any; output: any };
  ISO8601Duration: { input: any; output: any };
  JSON: { input: any; output: any };
  JSONObject: { input: any; output: any };
  JWT: { input: any; output: any };
  LCCSubclass: { input: any; output: any };
  Latitude: { input: any; output: any };
  LocalDate: { input: any; output: any };
  LocalDateTime: { input: any; output: any };
  LocalEndTime: { input: any; output: any };
  LocalTime: { input: any; output: any };
  Locale: { input: any; output: any };
  Long: { input: any; output: any };
  Longitude: { input: any; output: any };
  MAC: { input: any; output: any };
  NegativeFloat: { input: any; output: any };
  NegativeInt: { input: any; output: any };
  NonEmptyString: { input: any; output: any };
  NonNegativeFloat: { input: any; output: any };
  NonNegativeInt: { input: any; output: any };
  NonPositiveFloat: { input: any; output: any };
  NonPositiveInt: { input: any; output: any };
  ObjectID: { input: any; output: any };
  PhoneNumber: { input: any; output: any };
  Port: { input: any; output: any };
  PositiveFloat: { input: any; output: any };
  PositiveInt: { input: any; output: any };
  PostalCode: { input: any; output: any };
  RGB: { input: any; output: any };
  RGBA: { input: any; output: any };
  RoutingNumber: { input: any; output: any };
  SESSN: { input: any; output: any };
  SafeInt: { input: any; output: any };
  SemVer: { input: any; output: any };
  Time: { input: any; output: any };
  TimeZone: { input: any; output: any };
  Timestamp: { input: any; output: any };
  URL: { input: any; output: any };
  USCurrency: { input: any; output: any };
  UUID: { input: any; output: any };
  UnsignedFloat: { input: any; output: any };
  UnsignedInt: { input: any; output: any };
  UtcOffset: { input: any; output: any };
  Void: { input: any; output: any };
};

export type AddPaymentInstrumentInput = {
  billingAddressLine1: Scalars['String']['input'];
  billingAddressLine2?: InputMaybe<Scalars['String']['input']>;
  billingCity: Scalars['String']['input'];
  billingCountry: Scalars['String']['input'];
  billingEmail: Scalars['String']['input'];
  billingFirstName: Scalars['String']['input'];
  billingLastName: Scalars['String']['input'];
  billingPhone?: InputMaybe<Scalars['String']['input']>;
  billingPostalCode: Scalars['String']['input'];
  billingState: Scalars['String']['input'];
  paymentToken: Scalars['String']['input'];
};

export type ApplicantUser = MongoBase & {
  __typename?: 'ApplicantUser';
  accessBlocked?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  fileByFileName?: Maybe<FileInfo>;
  files?: Maybe<Array<Maybe<FileInfo>>>;
  hasVerifiedCredential?: Maybe<Scalars['Boolean']['output']>;
  hasVerifiedIdentity?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ObjectID']['output'];
  isProfileSubmitted?: Maybe<Scalars['Boolean']['output']>;
  payment?: Maybe<ApplicantUserPayment>;
  personalInformation?: Maybe<ApplicantUserPersonalInformation>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  search?: Maybe<ApplicantUserSearch>;
  systemFlags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  termsAndConditions?: Maybe<Array<Maybe<ApplicantUserTermsAndCondition>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
};

export type ApplicantUserFileByFileNameArgs = {
  fileName: Scalars['String']['input'];
};

export type ApplicantUserAddress = {
  __typename?: 'ApplicantUserAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  stateOrProvince?: Maybe<Scalars['String']['output']>;
  streetAddressLine1?: Maybe<Scalars['String']['output']>;
  streetAddressLine2?: Maybe<Scalars['String']['output']>;
  zipOrPostalCode?: Maybe<Scalars['String']['output']>;
};

export type ApplicantUserAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  stateOrProvince?: InputMaybe<Scalars['String']['input']>;
  streetAddressLine1?: InputMaybe<Scalars['String']['input']>;
  streetAddressLine2?: InputMaybe<Scalars['String']['input']>;
  zipOrPostalCode?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicantUserBlobContentAuthHeaderResult = {
  __typename?: 'ApplicantUserBlobContentAuthHeaderResult';
  applicant?: Maybe<ApplicantUser>;
  authHeader?: Maybe<BlobAuthHeader>;
  status: MutationStatus;
};

export type ApplicantUserBlobFileInput = {
  applicantId: Scalars['ObjectID']['input'];
  contentLength: Scalars['Int']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type ApplicantUserCitizenship = {
  __typename?: 'ApplicantUserCitizenship';
  currentCitizenOf?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ApplicantUserCitizenshipInput = {
  currentCitizenOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ApplicantUserContactInformation = {
  __typename?: 'ApplicantUserContactInformation';
  address?: Maybe<ApplicantUserAddress>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Array<Maybe<ApplicantUserPhone>>>;
  primaryPhone?: Maybe<Scalars['String']['output']>;
};

export type ApplicantUserContactInformationInput = {
  address?: InputMaybe<ApplicantUserAddressInput>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Array<InputMaybe<ApplicantUserPhoneInput>>>;
};

export type ApplicantUserDetailsInput = {
  accessBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  isProfileSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  payment?: InputMaybe<ApplicantUserPaymentInput>;
  personalInformation?: InputMaybe<ApplicantUserPersonalInformationInput>;
  schemaVersion?: InputMaybe<Scalars['String']['input']>;
  systemFlags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  termsAndConditions?: InputMaybe<Array<InputMaybe<ApplicantUserTermsAndConditionInput>>>;
  userType?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicantUserIdentityDetails = {
  __typename?: 'ApplicantUserIdentityDetails';
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  generationalSuffix?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  legalNameConsistsOfOneName?: Maybe<Scalars['Boolean']['output']>;
  restOfName?: Maybe<Scalars['String']['output']>;
};

export type ApplicantUserIdentityDetailsInput = {
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  generationalSuffix?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  legalNameConsistsOfOneName?: InputMaybe<Scalars['Boolean']['input']>;
  restOfName?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicantUserIdentityDetailsResult = {
  __typename?: 'ApplicantUserIdentityDetailsResult';
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  generationalSuffix?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  restOfName?: Maybe<Scalars['String']['output']>;
};

export type ApplicantUserMutationResult = MutationResult & {
  __typename?: 'ApplicantUserMutationResult';
  applicantUser?: Maybe<ApplicantUser>;
  status: MutationStatus;
};

export type ApplicantUserNameOnDocumentAsset = MongoSubdocument & {
  __typename?: 'ApplicantUserNameOnDocumentAsset';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  isDeleteRequested?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ApplicantUserNameOnDocumentAssetInput = {
  documentName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  isDeleteRequested?: InputMaybe<Scalars['Boolean']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ApplicantUserOtherIssuingInstitution = {
  __typename?: 'ApplicantUserOtherIssuingInstitution';
  addressLine1?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  stateOrProvince?: Maybe<Scalars['String']['output']>;
  zipOrPostalCode?: Maybe<Scalars['String']['output']>;
};

export type ApplicantUserOtherIssuingInstitutionInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stateOrProvince?: InputMaybe<Scalars['String']['input']>;
  zipOrPostalCode?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicantUserPayment = {
  __typename?: 'ApplicantUserPayment';
  cybersourceCustomerId?: Maybe<Scalars['String']['output']>;
};

export type ApplicantUserPaymentInput = {
  cybersourceCustomerId: Scalars['String']['input'];
};

export type ApplicantUserPersonalInformation = {
  __typename?: 'ApplicantUserPersonalInformation';
  applyingTo?: Maybe<Array<Maybe<Entity>>>;
  citizenship?: Maybe<ApplicantUserCitizenship>;
  contactInformation?: Maybe<ApplicantUserContactInformation>;
  identityDetails?: Maybe<ApplicantUserIdentityDetails>;
  nameOnDocumentAssets?: Maybe<Array<Maybe<ApplicantUserNameOnDocumentAsset>>>;
  professional?: Maybe<ApplicantUserProfessional>;
};

export type ApplicantUserPersonalInformationInput = {
  applyingTo?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  citizenship?: InputMaybe<ApplicantUserCitizenshipInput>;
  contactInformation?: InputMaybe<ApplicantUserContactInformationInput>;
  identityDetails?: InputMaybe<ApplicantUserIdentityDetailsInput>;
  nameOnDocumentAssets?: InputMaybe<Array<InputMaybe<ApplicantUserNameOnDocumentAssetInput>>>;
  professional?: InputMaybe<ApplicantUserProfessionalInput>;
};

export type ApplicantUserPhone = MongoSubdocument & {
  __typename?: 'ApplicantUserPhone';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ApplicantUserPhoneInput = {
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneType?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicantUserPrimaryEducationalInformation = MongoSubdocument & {
  __typename?: 'ApplicantUserPrimaryEducationalInformation';
  attendanceEndedAt?: Maybe<Scalars['Date']['output']>;
  attendanceStartedAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  degreeIssuedAt?: Maybe<Scalars['Date']['output']>;
  degreeTitle?: Maybe<Scalars['String']['output']>;
  graduationYear?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ObjectID']['output'];
  issuingInstitution?: Maybe<Entity>;
  otherIssuingInstitution?: Maybe<ApplicantUserOtherIssuingInstitution>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ApplicantUserPrimaryEducationalInformationInput = {
  attendanceEndedAt?: InputMaybe<Scalars['Date']['input']>;
  attendanceStartedAt?: InputMaybe<Scalars['Date']['input']>;
  degreeIssuedAt?: InputMaybe<Scalars['Date']['input']>;
  degreeTitle?: InputMaybe<Scalars['String']['input']>;
  graduationYear?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  issuingInstitutionId?: InputMaybe<Scalars['ObjectID']['input']>;
  otherIssuingInstitution?: InputMaybe<ApplicantUserOtherIssuingInstitutionInput>;
};

export type ApplicantUserProfessional = {
  __typename?: 'ApplicantUserProfessional';
  citizenshipAtTimeEnteredMedicalInstitution?: Maybe<Scalars['String']['output']>;
  healthProfession?: Maybe<Scalars['String']['output']>;
  primaryEducationalInformation?: Maybe<Array<Maybe<ApplicantUserPrimaryEducationalInformation>>>;
};

export type ApplicantUserProfessionalInput = {
  citizenshipAtTimeEnteredMedicalInstitution?: InputMaybe<Scalars['String']['input']>;
  healthProfession?: InputMaybe<Scalars['String']['input']>;
  primaryEducationalInformation?: InputMaybe<Array<InputMaybe<ApplicantUserPrimaryEducationalInformationInput>>>;
};

export type ApplicantUserPublicFileRemoveInput = {
  applicantId: Scalars['ObjectID']['input'];
  fileName: Scalars['String']['input'];
};

export type ApplicantUserResult = {
  __typename?: 'ApplicantUserResult';
  accessBlocked?: Maybe<Scalars['Boolean']['output']>;
  applyingTo?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ObjectID']['output']>;
  identityDetails?: Maybe<ApplicantUserIdentityDetailsResult>;
  role?: Maybe<Scalars['String']['output']>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
};

export type ApplicantUserSearch = {
  __typename?: 'ApplicantUserSearch';
  hash?: Maybe<Scalars['String']['output']>;
  indexedAt?: Maybe<Scalars['DateTime']['output']>;
  indexingFailedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ApplicantUserSearchFacets = {
  __typename?: 'ApplicantUserSearchFacets';
  accessBlocked?: Maybe<Array<Maybe<FacetDetail>>>;
  applyingTo?: Maybe<Array<Maybe<FacetDetail>>>;
  createdAt?: Maybe<Array<Maybe<FacetDetail>>>;
  dateOfBirth?: Maybe<Array<Maybe<FacetDetail>>>;
  gender?: Maybe<Array<Maybe<FacetDetail>>>;
  generationalSuffix?: Maybe<Array<Maybe<FacetDetail>>>;
  role?: Maybe<Array<Maybe<FacetDetail>>>;
  schemaVersion?: Maybe<Array<Maybe<FacetDetail>>>;
  tags?: Maybe<Array<Maybe<FacetDetail>>>;
  updatedAt?: Maybe<Array<Maybe<FacetDetail>>>;
};

export type ApplicantUserSearchFilterDetail = {
  accessBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  applyingTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateOfBirth?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  gender?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  generationalSuffix?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schemaVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ApplicantUserSearchInput = {
  options?: InputMaybe<ApplicantUserSearchOptions>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicantUserSearchOptions = {
  filter?: InputMaybe<ApplicantUserSearchFilterDetail>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  top?: InputMaybe<Scalars['Int']['input']>;
};

export type ApplicantUserSearchResult = {
  __typename?: 'ApplicantUserSearchResult';
  applicantUserResults?: Maybe<Array<Maybe<ApplicantUserResult>>>;
  count?: Maybe<Scalars['Int']['output']>;
  facets?: Maybe<ApplicantUserSearchFacets>;
};

export type ApplicantUserTermsAndCondition = MongoSubdocument & {
  __typename?: 'ApplicantUserTermsAndCondition';
  acceptanceOf?: Maybe<Scalars['String']['output']>;
  attestedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

export type ApplicantUserTermsAndConditionInput = {
  acceptanceOf?: InputMaybe<Scalars['String']['input']>;
  attestedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  version?: InputMaybe<Scalars['Float']['input']>;
};

export type ApplicantUserUpdateInput = {
  applicantUserDetails?: InputMaybe<ApplicantUserDetailsInput>;
  id: Scalars['ObjectID']['input'];
};

export type ApplicantUserUpdatePaymentInstrumentInput = {
  paymentInstrument: AddPaymentInstrumentInput;
  paymentInstrumentId: Scalars['String']['input'];
};

export type ArchivedCaseSummary = {
  __typename?: 'ArchivedCaseSummary';
  archivedAt: Scalars['DateTime']['output'];
  caseName: Scalars['String']['output'];
  caseType: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  state: Scalars['String']['output'];
};

export type ArchivedCaseSummaryActivityLog = {
  __typename?: 'ArchivedCaseSummaryActivityLog';
  activityBy?: Maybe<User>;
  activityType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  metaData?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ArchivedCaseSummaryAffirmations = {
  __typename?: 'ArchivedCaseSummaryAffirmations';
  audit?: Maybe<ArchivedCaseSummaryAffirmationsAudit>;
};

export type ArchivedCaseSummaryAffirmationsAudit = {
  __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  result?: Maybe<Scalars['String']['output']>;
};

export type ArchivedCaseSummaryDecision = {
  __typename?: 'ArchivedCaseSummaryDecision';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
};

export type ArchivedCaseSummaryFinanceDetails = {
  __typename?: 'ArchivedCaseSummaryFinanceDetails';
  transactions?: Maybe<ArchivedCaseSummaryFinanceDetailsTransactions>;
};

export type ArchivedCaseSummaryFinanceDetailsAdhocTransaction = {
  __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
  amount?: Maybe<Scalars['Float']['output']>;
  approval?: Maybe<ArchivedCaseSummaryFinanceDetailsAdhocTransactionApproval>;
  reason?: Maybe<Scalars['String']['output']>;
  transactionReference?: Maybe<ArchivedCaseSummaryTransactionReference>;
};

export type ArchivedCaseSummaryFinanceDetailsAdhocTransactionApproval = {
  __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransactionApproval';
  isApplicantApprovalRequired?: Maybe<Scalars['Boolean']['output']>;
  isApplicantApproved?: Maybe<Scalars['Boolean']['output']>;
};

export type ArchivedCaseSummaryFinanceDetailsTransactionSubmission = {
  __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission';
  amount?: Maybe<Scalars['Float']['output']>;
  transactionReference?: Maybe<ArchivedCaseSummaryTransactionReference>;
};

export type ArchivedCaseSummaryFinanceDetailsTransactions = {
  __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactions';
  adhocTransactions?: Maybe<Array<Maybe<ArchivedCaseSummaryFinanceDetailsAdhocTransaction>>>;
  submission?: Maybe<ArchivedCaseSummaryFinanceDetailsTransactionSubmission>;
};

export type ArchivedCaseSummaryTransactionReference = {
  __typename?: 'ArchivedCaseSummaryTransactionReference';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
};

export type ArchivedCredentialVerificationCaseSummary = {
  __typename?: 'ArchivedCredentialVerificationCaseSummary';
  activityLog: Array<Maybe<ArchivedCaseSummaryActivityLog>>;
  applicant: ApplicantUser;
  archiveEligibleAt: Scalars['DateTime']['output'];
  archivedAt: Scalars['DateTime']['output'];
  caseDetails: ArchivedCredentialVerificationCaseSummaryCaseDetails;
  caseName: Scalars['String']['output'];
  caseType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  files?: Maybe<Array<Maybe<FileInfo>>>;
  financeDetails: ArchivedCaseSummaryFinanceDetails;
  id: Scalars['ObjectID']['output'];
  lastActivityAt: Scalars['DateTime']['output'];
  state: Scalars['String']['output'];
  submittedAt: Scalars['DateTime']['output'];
};

export type ArchivedCredentialVerificationCaseSummaryCaseDetails = {
  __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetails';
  application: ArchivedCredentialVerificationCaseSummaryCaseDetailsApplication;
  applicationReview: ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReview;
};

export type ArchivedCredentialVerificationCaseSummaryCaseDetailsApplication = {
  __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplication';
  credentialTitle: Scalars['String']['output'];
  credentialType: Scalars['String']['output'];
  dateCredentialIssuedAt: Scalars['DateTime']['output'];
  issuingInstitution?: Maybe<Entity>;
  issuingInstitutionName?: Maybe<Scalars['String']['output']>;
  nameOnCredential: Scalars['String']['output'];
  otherIssuingInstitution?: Maybe<ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationOtherIssuingInstitution>;
  program?: Maybe<Scalars['String']['output']>;
  sendDestination?: Maybe<Entity>;
  sendDestinationName: Scalars['String']['output'];
};

export type ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationOtherIssuingInstitution = {
  __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationOtherIssuingInstitution';
  institutionName?: Maybe<Scalars['String']['output']>;
};

export type ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReview = {
  __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReview';
  affirmations?: Maybe<ArchivedCaseSummaryAffirmations>;
  decision: ArchivedCaseSummaryDecision;
  privateCaseDetails: ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails;
  verificationAffirmations?: Maybe<ArchivedCaseSummaryAffirmations>;
};

export type ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails = {
  __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails';
  alternativeVerifyingEntity?: Maybe<ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsAlternativeVerifyingEntity>;
  institutionContactDetails?: Maybe<ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails>;
  verificationStatus?: Maybe<ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus>;
};

export type ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsAlternativeVerifyingEntity = {
  __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsAlternativeVerifyingEntity';
  isVerifiedWithOther?: Maybe<Scalars['Boolean']['output']>;
  otherDetails?: Maybe<Scalars['String']['output']>;
};

export type ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails = {
  __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
  institutionEmail: Scalars['String']['output'];
  institutionPhone: Scalars['String']['output'];
};

export type ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus = {
  __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus';
  verificationResponse?: Maybe<Scalars['String']['output']>;
};

export type ArchivedIdentityVerificationCaseSummary = {
  __typename?: 'ArchivedIdentityVerificationCaseSummary';
  activityLog: Array<Maybe<ArchivedCaseSummaryActivityLog>>;
  applicant: ApplicantUser;
  archiveEligibleAt: Scalars['DateTime']['output'];
  archivedAt: Scalars['DateTime']['output'];
  caseDetails: ArchivedIdentityVerificationCaseSummaryCaseDetails;
  caseName: Scalars['String']['output'];
  caseType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  files?: Maybe<Array<Maybe<FileInfo>>>;
  financeDetails: ArchivedCaseSummaryFinanceDetails;
  id: Scalars['ObjectID']['output'];
  lastActivityAt: Scalars['DateTime']['output'];
  state: Scalars['String']['output'];
  submittedAt: Scalars['DateTime']['output'];
};

export type ArchivedIdentityVerificationCaseSummaryCaseDetails = {
  __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetails';
  application: ArchivedIdentityVerificationCaseSummaryCaseDetailsApplication;
  applicationReview: ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReview;
};

export type ArchivedIdentityVerificationCaseSummaryCaseDetailsApplication = {
  __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplication';
  passportDetails: ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails;
};

export type ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails = {
  __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails';
  isPassportExpirationDateVisible?: Maybe<Scalars['Boolean']['output']>;
  isPassportInLatinCharacters?: Maybe<Scalars['Boolean']['output']>;
  passportCountry?: Maybe<Scalars['String']['output']>;
  passportExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  passportIssuedAt?: Maybe<Scalars['DateTime']['output']>;
  passportNumber?: Maybe<Scalars['String']['output']>;
};

export type ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReview = {
  __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReview';
  affirmations?: Maybe<ArchivedCaseSummaryAffirmations>;
  decision: ArchivedCaseSummaryDecision;
  notaryAffirmations?: Maybe<ArchivedCaseSummaryAffirmations>;
};

export type ArchivedSendReportCaseSummary = {
  __typename?: 'ArchivedSendReportCaseSummary';
  activityLog: Array<Maybe<ArchivedCaseSummaryActivityLog>>;
  applicant: ApplicantUser;
  archiveEligibleAt: Scalars['DateTime']['output'];
  archivedAt: Scalars['DateTime']['output'];
  caseDetails: ArchivedSendReportCaseSummaryCaseDetails;
  caseName: Scalars['String']['output'];
  caseType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  files?: Maybe<Array<Maybe<FileInfo>>>;
  financeDetails: ArchivedCaseSummaryFinanceDetails;
  id: Scalars['ObjectID']['output'];
  lastActivityAt: Scalars['DateTime']['output'];
  state: Scalars['String']['output'];
  submittedAt: Scalars['DateTime']['output'];
};

export type ArchivedSendReportCaseSummaryCaseDetails = {
  __typename?: 'ArchivedSendReportCaseSummaryCaseDetails';
  application: ArchivedSendReportCaseSummaryCaseDetailsApplication;
  applicationReview: ArchivedSendReportCaseSummaryCaseDetailsApplicationReview;
};

export type ArchivedSendReportCaseSummaryCaseDetailsApplication = {
  __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplication';
  credential: CredentialVerificationCaseV1;
  credentialTitle: Scalars['String']['output'];
  destination: Entity;
  destinationEmail: Scalars['String']['output'];
  destinationName: Scalars['String']['output'];
  destinationPhone: Scalars['String']['output'];
};

export type ArchivedSendReportCaseSummaryCaseDetailsApplicationReview = {
  __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReview';
  affirmations?: Maybe<ArchivedCaseSummaryAffirmations>;
  decision: ArchivedCaseSummaryDecision;
  privateCaseDetails: ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails;
};

export type ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails = {
  __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails';
  institutionContactDetails: ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails;
};

export type ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails = {
  __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
  institutionEmail: Scalars['String']['output'];
  institutionPhone: Scalars['String']['output'];
};

export type BlobActivityLog = {
  __typename?: 'BlobActivityLog';
  data?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ObjectID']['output']>;
  logType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserData>;
};

export type BlobAuthHeader = {
  __typename?: 'BlobAuthHeader';
  authHeader?: Maybe<Scalars['String']['output']>;
  blobName?: Maybe<Scalars['String']['output']>;
  blobPath?: Maybe<Scalars['String']['output']>;
  indexTags?: Maybe<Array<Maybe<BlobIndexTag>>>;
  metadataFields?: Maybe<Array<Maybe<BlobMetadataField>>>;
  requestDate?: Maybe<Scalars['String']['output']>;
};

export type BlobCountriesInput = {
  blobData: CountriesInput;
};

export type BlobCountriesMutationResult = MutationResult & {
  __typename?: 'BlobCountriesMutationResult';
  countries: BlobCountryEvent;
  status: MutationStatus;
};

export type BlobCountry = {
  __typename?: 'BlobCountry';
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  states?: Maybe<Array<Maybe<BlobState>>>;
};

export type BlobCountryEvent = {
  __typename?: 'BlobCountryEvent';
  apiName: Scalars['String']['output'];
  eventPayload?: Maybe<BlobCountryEventPayload>;
  eventTimestamp: Scalars['DateTime']['output'];
  eventUuid: Scalars['String']['output'];
  replayId: Scalars['String']['output'];
};

export type BlobCountryEventPayload = {
  __typename?: 'BlobCountryEventPayload';
  countries: Array<BlobCountry>;
  externalId?: Maybe<Scalars['String']['output']>;
};

export type BlobCountryEventPayloadInput = {
  countries: Array<BlobCountryInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
};

export type BlobCountryInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryName?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<InputMaybe<BlobStateInputData>>>;
};

export type BlobFeatureFlag = {
  __typename?: 'BlobFeatureFlag';
  allowedValues: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  retirementDate: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

export type BlobFeatureFlagInput = {
  blobData: FeatureFlagsInput;
};

export type BlobFeatureFlagInputData = {
  allowedValues: Array<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  retirementDate: Scalars['DateTime']['input'];
  value: Scalars['String']['input'];
};

export type BlobFeatureFlagMutationResult = MutationResult & {
  __typename?: 'BlobFeatureFlagMutationResult';
  featureFlags?: Maybe<Array<BlobFeatureFlag>>;
  status: MutationStatus;
};

export type BlobFinanceAdditionalCharge = {
  __typename?: 'BlobFinanceAdditionalCharge';
  creditGLAccount?: Maybe<Scalars['String']['output']>;
  debitGLAccount?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BlobFinanceAdditionalChargeInput = {
  creditGLAccount?: InputMaybe<Scalars['String']['input']>;
  debitGLAccount?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type BlobFinanceCharge = {
  __typename?: 'BlobFinanceCharge';
  amount?: Maybe<Scalars['Float']['output']>;
  chargeType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ObjectID']['output']>;
};

export type BlobFinanceConfig = {
  __typename?: 'BlobFinanceConfig';
  effectiveAt?: Maybe<Scalars['DateTime']['output']>;
  glConfig?: Maybe<BlobFinanceGlConfig>;
  id?: Maybe<Scalars['String']['output']>;
};

export type BlobFinanceConfigInput = {
  blobData: FinanceConfigInput;
  caseType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type BlobFinanceConfigMutationResult = MutationResult & {
  __typename?: 'BlobFinanceConfigMutationResult';
  financeGlConfig: BlobFinanceConfig;
  status: MutationStatus;
};

export type BlobFinanceConfigNameInput = {
  configBlobName: Scalars['String']['input'];
};

export type BlobFinanceGlAccount = {
  __typename?: 'BlobFinanceGlAccount';
  accountId?: Maybe<Scalars['String']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ObjectID']['output']>;
};

export type BlobFinanceGlConfig = {
  __typename?: 'BlobFinanceGlConfig';
  additionalCharges?: Maybe<Array<Maybe<BlobFinanceAdditionalCharge>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  recognition?: Maybe<BlobFinanceRefund>;
  refunds?: Maybe<BlobFinanceRefund>;
  submission?: Maybe<BlobFinanceSubmission>;
  version?: Maybe<Scalars['String']['output']>;
};

export type BlobFinanceGlConfigInput = {
  additionalCharges?: InputMaybe<Array<InputMaybe<BlobFinanceAdditionalChargeInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  recognition?: InputMaybe<BlobFinanceRefundInput>;
  refunds?: InputMaybe<BlobFinanceRefundInput>;
  submission?: InputMaybe<BlobFinanceSubmissionInput>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type BlobFinanceGlEvent = {
  __typename?: 'BlobFinanceGlEvent';
  eventCode?: Maybe<Scalars['String']['output']>;
  eventDesc?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ObjectID']['output']>;
  records?: Maybe<Array<BlobFinanceGlRecord>>;
};

export type BlobFinanceGlRecord = {
  __typename?: 'BlobFinanceGlRecord';
  amount?: Maybe<Scalars['Float']['output']>;
  glCreditAccountId?: Maybe<Scalars['String']['output']>;
  glDebitAccountId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ObjectID']['output']>;
  inclPNReferenceNumber?: Maybe<Scalars['Boolean']['output']>;
};

export type BlobFinanceGlTemplate = {
  __typename?: 'BlobFinanceGlTemplate';
  events?: Maybe<Array<BlobFinanceGlEvent>>;
  id?: Maybe<Scalars['ObjectID']['output']>;
  isExceptionCase?: Maybe<Scalars['Boolean']['output']>;
};

export type BlobFinanceInput = {
  caseType: Scalars['String']['input'];
};

export type BlobFinanceRefund = {
  __typename?: 'BlobFinanceRefund';
  creditGLAccount?: Maybe<Scalars['String']['output']>;
  debitGLAccount?: Maybe<Scalars['String']['output']>;
};

export type BlobFinanceRefundInput = {
  creditGLAccount?: InputMaybe<Scalars['String']['input']>;
  debitGLAccount?: InputMaybe<Scalars['String']['input']>;
};

export type BlobFinanceSubmission = {
  __typename?: 'BlobFinanceSubmission';
  amount?: Maybe<Scalars['Float']['output']>;
  creditGLAccount?: Maybe<Scalars['String']['output']>;
  debitGLAccount?: Maybe<Scalars['String']['output']>;
};

export type BlobFinanceSubmissionInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  creditGLAccount?: InputMaybe<Scalars['String']['input']>;
  debitGLAccount?: InputMaybe<Scalars['String']['input']>;
};

export type BlobFinancialConfig = {
  __typename?: 'BlobFinancialConfig';
  caseType?: Maybe<Scalars['String']['output']>;
  effectiveAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ruleName?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type BlobHealthProfession = {
  __typename?: 'BlobHealthProfession';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  healthProfessions?: Maybe<Array<Maybe<HealthProfessionsData>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type BlobHealthProfessionsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  healthProfessions?: InputMaybe<Array<InputMaybe<HealthProfessionsDataInput>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type BlobHealthProfessionsMutationResult = MutationResult & {
  __typename?: 'BlobHealthProfessionsMutationResult';
  healthProfessions: BlobHealthProfession;
  status: MutationStatus;
};

export type BlobIndexTag = {
  __typename?: 'BlobIndexTag';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type BlobMetadataField = {
  __typename?: 'BlobMetadataField';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type BlobState = {
  __typename?: 'BlobState';
  stateCode?: Maybe<Scalars['String']['output']>;
  stateName?: Maybe<Scalars['String']['output']>;
};

export type BlobStateInputData = {
  stateCode?: InputMaybe<Scalars['String']['input']>;
  stateName?: InputMaybe<Scalars['String']['input']>;
};

/**  Required to enable Apollo Cache Control  */
export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type CaseDecisionResult = {
  __typename?: 'CaseDecisionResult';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<CaseSearchStaffUserResult>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
};

export type CaseLastActivityResult = {
  __typename?: 'CaseLastActivityResult';
  activity?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CaseReIndexResult = {
  __typename?: 'CaseReIndexResult';
  credentialCaseReIndexErrors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  identityCaseReIndexErrors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sendReportCaseReIndexErrors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CaseResult = {
  __typename?: 'CaseResult';
  applicantId?: Maybe<Scalars['String']['output']>;
  applicantName?: Maybe<Scalars['String']['output']>;
  caseName?: Maybe<Scalars['String']['output']>;
  caseType?: Maybe<Scalars['String']['output']>;
  caseWorkerAssigned?: Maybe<CaseSearchStaffUserResult>;
  clientId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  credentialType?: Maybe<Scalars['String']['output']>;
  decision?: Maybe<CaseDecisionResult>;
  expirationEligibleAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastActivity?: Maybe<CaseLastActivityResult>;
  revisionRequest?: Maybe<CaseRevisionRequestResult>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  systemTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CaseRevisionRequestResult = {
  __typename?: 'CaseRevisionRequestResult';
  commentsToApplicant?: Maybe<Scalars['String']['output']>;
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  requestedBy?: Maybe<CaseSearchStaffUserResult>;
  revisionSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CaseSearchFacets = {
  __typename?: 'CaseSearchFacets';
  caseType?: Maybe<Array<Maybe<FacetDetail>>>;
  caseWorkerAssigned?: Maybe<Array<Maybe<FacetDetail>>>;
  clientId?: Maybe<Array<Maybe<FacetDetail>>>;
  createdAt?: Maybe<Array<Maybe<FacetDetail>>>;
  credentialType?: Maybe<Array<Maybe<FacetDetail>>>;
  decisionCompletedAt?: Maybe<Array<Maybe<FacetDetail>>>;
  decisionCompletedBy?: Maybe<Array<Maybe<FacetDetail>>>;
  decisionResult?: Maybe<Array<Maybe<FacetDetail>>>;
  expirationEligibleAt?: Maybe<Array<Maybe<FacetDetail>>>;
  lastActivityCreatedAt?: Maybe<Array<Maybe<FacetDetail>>>;
  revisionRequestRequestedAt?: Maybe<Array<Maybe<FacetDetail>>>;
  revisionRequestRequestedBy?: Maybe<Array<Maybe<FacetDetail>>>;
  revisionRequestSubmittedAt?: Maybe<Array<Maybe<FacetDetail>>>;
  schemaVersion?: Maybe<Array<Maybe<FacetDetail>>>;
  state?: Maybe<Array<Maybe<FacetDetail>>>;
  submittedAt?: Maybe<Array<Maybe<FacetDetail>>>;
  systemTags?: Maybe<Array<Maybe<FacetDetail>>>;
  tags?: Maybe<Array<Maybe<FacetDetail>>>;
  updatedAt?: Maybe<Array<Maybe<FacetDetail>>>;
};

export type CaseSearchFilterDetail = {
  applicantId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  caseType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  caseWorkerAssigned?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clientId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  credentialType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  decisionCompletedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  decisionCompletedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  decisionResult?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  expirationEligibleAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastActivityCreatedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  revisionRequestRequestedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  revisionRequestRequestedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  revisionRequestSubmittedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schemaVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submittedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  systemTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CaseSearchInput = {
  options?: InputMaybe<CaseSearchOptions>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};

export type CaseSearchOptions = {
  filter?: InputMaybe<CaseSearchFilterDetail>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  top?: InputMaybe<Scalars['Int']['input']>;
};

export type CaseSearchResult = {
  __typename?: 'CaseSearchResult';
  caseResults?: Maybe<Array<Maybe<CaseResult>>>;
  count?: Maybe<Scalars['Int']['output']>;
  facets?: Maybe<CaseSearchFacets>;
};

export type CaseSearchStaffUserResult = {
  __typename?: 'CaseSearchStaffUserResult';
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ObjectID']['output']>;
};

export type CountriesInput = {
  apiName: Scalars['String']['input'];
  eventPayload?: InputMaybe<BlobCountryEventPayloadInput>;
  eventTimestamp: Scalars['DateTime']['input'];
  eventUuid: Scalars['String']['input'];
  replayId: Scalars['String']['input'];
};

export type CredentialVerificationCaseV1 = MongoBase & {
  __typename?: 'CredentialVerificationCaseV1';
  activityLog?: Maybe<Array<Maybe<CredentialVerificationCaseV1ActivityLog>>>;
  applicant?: Maybe<ApplicantUser>;
  archiveEligibleAt?: Maybe<Scalars['DateTime']['output']>;
  assets?: Maybe<CredentialVerificationCaseV1Assets>;
  caseDetails?: Maybe<CredentialVerificationCaseV1CaseDetails>;
  caseFlagged?: Maybe<Array<Maybe<CredentialVerificationCaseV1CaseFlagged>>>;
  caseHistory?: Maybe<Array<Maybe<CredentialVerificationCaseV1CaseHistory>>>;
  caseName?: Maybe<Scalars['String']['output']>;
  caseType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expirationEligibleAt?: Maybe<Scalars['DateTime']['output']>;
  fileByFileName?: Maybe<FileInfo>;
  files?: Maybe<Array<Maybe<FileInfo>>>;
  financeDetails?: Maybe<CredentialVerificationCaseV1FinanceDetails>;
  id: Scalars['ObjectID']['output'];
  isCurrentUserAssigned?: Maybe<Scalars['Boolean']['output']>;
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  lastStatusChangeAt?: Maybe<Scalars['DateTime']['output']>;
  messages?: Maybe<Array<Maybe<CredentialVerificationCaseV1Message>>>;
  purgeEligibleAt?: Maybe<Scalars['DateTime']['output']>;
  revisionRequest?: Maybe<CredentialVerificationCaseV1RevisionRequest>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  search?: Maybe<CredentialVerificationCaseV1Search>;
  state: Scalars['String']['output'];
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  systemTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1FileByFileNameArgs = {
  fileName: Scalars['String']['input'];
};

export type CredentialVerificationCaseV1ActivityLog = MongoSubdocument & {
  __typename?: 'CredentialVerificationCaseV1ActivityLog';
  activityBy?: Maybe<User>;
  activityType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  metaData?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1ActivityLogInput = {
  activityType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  metaData?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CredentialVerificationCaseV1AdhocPaymentRequestInput = {
  adhocPaymentType?: InputMaybe<Scalars['String']['input']>;
  adhocTransactionId?: InputMaybe<Scalars['String']['input']>;
  amount: Scalars['Float']['input'];
  isApplicantApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  reason: Scalars['String']['input'];
};

export type CredentialVerificationCaseV1Affirmations = {
  __typename?: 'CredentialVerificationCaseV1Affirmations';
  audit?: Maybe<CredentialVerificationCaseV1Audit>;
  isCredentialAcceptable?: Maybe<Scalars['String']['output']>;
  isCredentialDetailsAcceptable?: Maybe<Scalars['String']['output']>;
  isCredentialSentForVerification?: Maybe<Scalars['String']['output']>;
  isDateOfBirthAcceptable?: Maybe<Scalars['String']['output']>;
  isEntityAcceptable?: Maybe<Scalars['String']['output']>;
  isNameAcceptable?: Maybe<Scalars['String']['output']>;
  isTranslationAcceptable?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1AffirmationsInput = {
  audit?: InputMaybe<CredentialVerificationCaseV1AuditInput>;
  isCredentialAcceptable?: InputMaybe<Scalars['String']['input']>;
  isCredentialDetailsAcceptable?: InputMaybe<Scalars['String']['input']>;
  isCredentialSentForVerification?: InputMaybe<Scalars['String']['input']>;
  isDateOfBirthAcceptable?: InputMaybe<Scalars['String']['input']>;
  isEntityAcceptable?: InputMaybe<Scalars['String']['input']>;
  isNameAcceptable?: InputMaybe<Scalars['String']['input']>;
  isTranslationAcceptable?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1AlternateVerifyingEntity = {
  __typename?: 'CredentialVerificationCaseV1AlternateVerifyingEntity';
  isVerifiedWithOther?: Maybe<Scalars['Boolean']['output']>;
  otherDetails?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1AlternateVerifyingEntityInput = {
  isVerifiedWithOther?: InputMaybe<Scalars['Boolean']['input']>;
  otherDetails?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1Application = {
  __typename?: 'CredentialVerificationCaseV1Application';
  attestedAt?: Maybe<Scalars['DateTime']['output']>;
  credentialAssets?: Maybe<CredentialVerificationCaseV1CredentialAssets>;
  credentialTitle?: Maybe<Scalars['String']['output']>;
  credentialType?: Maybe<Scalars['String']['output']>;
  dateCredentialIssuedAt?: Maybe<Scalars['Date']['output']>;
  isAttestationComplete?: Maybe<Scalars['Boolean']['output']>;
  isCredentialInEnglish?: Maybe<Scalars['Boolean']['output']>;
  isNameOnCredentialMatchPassport?: Maybe<Scalars['Boolean']['output']>;
  issuingInstitution?: Maybe<Entity>;
  nameOnCredential?: Maybe<Scalars['String']['output']>;
  otherIssuingInstitution?: Maybe<CredentialVerificationCaseV1OtherIssuingInstitution>;
  program?: Maybe<Scalars['String']['output']>;
  sendDestination?: Maybe<Entity>;
};

export type CredentialVerificationCaseV1ApplicationInput = {
  credentialAssets?: InputMaybe<CredentialVerificationCaseV1CredentialAssetsInput>;
  credentialTitle?: InputMaybe<Scalars['String']['input']>;
  credentialType?: InputMaybe<Scalars['String']['input']>;
  dateCredentialIssuedAt?: InputMaybe<Scalars['Date']['input']>;
  isAttestationComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isCredentialInEnglish?: InputMaybe<Scalars['Boolean']['input']>;
  isNameOnCredentialMatchPassport?: InputMaybe<Scalars['Boolean']['input']>;
  issuingInstitution?: InputMaybe<Scalars['ObjectID']['input']>;
  nameOnCredential?: InputMaybe<Scalars['String']['input']>;
  otherIssuingInstitution?: InputMaybe<CredentialVerificationCaseV1OtherIssuingInstitutionInput>;
  program?: InputMaybe<Scalars['String']['input']>;
  sendDestination?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type CredentialVerificationCaseV1ApplicationReview = {
  __typename?: 'CredentialVerificationCaseV1ApplicationReview';
  affirmations?: Maybe<CredentialVerificationCaseV1Affirmations>;
  caseWorkerAssigned?: Maybe<StaffUser>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  decision?: Maybe<CredentialVerificationCaseV1ApplicationReviewDecision>;
  privateCaseDetails?: Maybe<CredentialVerificationCaseV1PrivateCaseDetails>;
  verificationAffirmations?: Maybe<CredentialVerificationCaseV1VerificationAffirmations>;
};

export type CredentialVerificationCaseV1ApplicationReviewDecision = {
  __typename?: 'CredentialVerificationCaseV1ApplicationReviewDecision';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1ApplicationReviewDecisionInput = {
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1ApplicationReviewInput = {
  affirmations?: InputMaybe<CredentialVerificationCaseV1AffirmationsInput>;
  caseWorkerAssigned?: InputMaybe<Scalars['ObjectID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  decision?: InputMaybe<CredentialVerificationCaseV1ApplicationReviewDecisionInput>;
  privateCaseDetails?: InputMaybe<CredentialVerificationCaseV1PrivateCaseDetailsInput>;
  verificationAffirmations?: InputMaybe<CredentialVerificationCaseV1VerificationAffirmationsInput>;
};

export type CredentialVerificationCaseV1AssetHistory = MongoSubdocument & {
  __typename?: 'CredentialVerificationCaseV1AssetHistory';
  assetUploadedBy?: Maybe<StaffUser>;
  assetVersion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1AssetHistoryInput = {
  assetUploadedBy?: InputMaybe<Scalars['ObjectID']['input']>;
  assetVersion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type CredentialVerificationCaseV1Assets = {
  __typename?: 'CredentialVerificationCaseV1Assets';
  private?: Maybe<CredentialVerificationCaseV1AssetsPrivate>;
};

export type CredentialVerificationCaseV1AssetsInput = {
  private?: InputMaybe<CredentialVerificationCaseV1AssetsPrivateInput>;
};

export type CredentialVerificationCaseV1AssetsPrivate = {
  __typename?: 'CredentialVerificationCaseV1AssetsPrivate';
  verificationComponentPacket?: Maybe<Scalars['String']['output']>;
  verificationComponentPacketHistory?: Maybe<Array<Maybe<CredentialVerificationCaseV1AssetHistory>>>;
  verificationForm?: Maybe<Scalars['String']['output']>;
  verificationFormHistory?: Maybe<Array<Maybe<CredentialVerificationCaseV1AssetHistory>>>;
  verificationPacket?: Maybe<Scalars['String']['output']>;
  verificationPacketHistory?: Maybe<Array<Maybe<CredentialVerificationCaseV1AssetHistory>>>;
  verificationPacketResponse?: Maybe<Scalars['String']['output']>;
  verificationPacketResponseHistory?: Maybe<Array<Maybe<CredentialVerificationCaseV1AssetHistory>>>;
};

export type CredentialVerificationCaseV1AssetsPrivateInput = {
  verificationComponentPacket?: InputMaybe<Scalars['String']['input']>;
  verificationComponentPacketVersion?: InputMaybe<Scalars['String']['input']>;
  verificationForm?: InputMaybe<Scalars['String']['input']>;
  verificationFormVersion?: InputMaybe<Scalars['String']['input']>;
  verificationPacket?: InputMaybe<Scalars['String']['input']>;
  verificationPacketResponse?: InputMaybe<Scalars['String']['input']>;
  verificationPacketResponseVersion?: InputMaybe<Scalars['String']['input']>;
  verificationPacketVersion?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1Audit = {
  __typename?: 'CredentialVerificationCaseV1Audit';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  result?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1AuditInput = {
  setAffirmationsComplete: Scalars['Boolean']['input'];
};

export type CredentialVerificationCaseV1BlobContentAuthHeaderResult = MutationResult & {
  __typename?: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult';
  authHeader?: Maybe<BlobAuthHeader>;
  case?: Maybe<CredentialVerificationCaseV1>;
  status: MutationStatus;
};

export type CredentialVerificationCaseV1BlobFileInput = {
  caseId: Scalars['ObjectID']['input'];
  contentLength: Scalars['Int']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type CredentialVerificationCaseV1CaseDetails = {
  __typename?: 'CredentialVerificationCaseV1CaseDetails';
  application?: Maybe<CredentialVerificationCaseV1Application>;
  applicationReview?: Maybe<CredentialVerificationCaseV1ApplicationReview>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1CaseDetailsInput = {
  application?: InputMaybe<CredentialVerificationCaseV1ApplicationInput>;
  applicationReview?: InputMaybe<CredentialVerificationCaseV1ApplicationReviewInput>;
};

export type CredentialVerificationCaseV1CaseFlagged = MongoSubdocument & {
  __typename?: 'CredentialVerificationCaseV1CaseFlagged';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  flagType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1CaseFlaggedInput = {
  flagType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1CaseHistory = MongoSubdocument & {
  __typename?: 'CredentialVerificationCaseV1CaseHistory';
  caseDetails?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetails>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  revisionRequest?: Maybe<CredentialVerificationCaseV1CaseHistoryRevisionRequest>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetails = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetails';
  application?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplication>;
  applicationReview?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReview>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplication = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplication';
  attestedAt?: Maybe<Scalars['DateTime']['output']>;
  credentialAssets?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationCredentialAssets>;
  credentialTitle?: Maybe<Scalars['String']['output']>;
  credentialType?: Maybe<Scalars['String']['output']>;
  dateCredentialIssuedAt?: Maybe<Scalars['DateTime']['output']>;
  isAttestationComplete?: Maybe<Scalars['Boolean']['output']>;
  isCredentialInEnglish?: Maybe<Scalars['Boolean']['output']>;
  isNameOnCredentialMatchPassport?: Maybe<Scalars['Boolean']['output']>;
  issuingInstitution?: Maybe<Entity>;
  nameOnCredential?: Maybe<Scalars['String']['output']>;
  otherIssuingInstitution?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationOtherIssuingInstitution>;
  program?: Maybe<Scalars['String']['output']>;
  sendDestination?: Maybe<Entity>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationCredentialAssets = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationCredentialAssets';
  credential?: Maybe<Scalars['String']['output']>;
  credentialUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  credentialVersion?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Scalars['String']['output']>;
  translationUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  translationVersion?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationOtherIssuingInstitution = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationOtherIssuingInstitution';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  institutionName?: Maybe<Scalars['String']['output']>;
  stateOrProvince?: Maybe<Scalars['String']['output']>;
  zipOrPostalCode?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReview = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReview';
  affirmations?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmations>;
  caseWorkerAssigned?: Maybe<StaffUser>;
  decision?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewDecision>;
  privateCaseDetails?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetails>;
  verificationAffirmations?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewVerificationAffirmations>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmations = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmations';
  audit?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmationsAudit>;
  isCredentialAcceptable?: Maybe<Scalars['String']['output']>;
  isCredentialDetailsAcceptable?: Maybe<Scalars['String']['output']>;
  isCredentialSentForVerification?: Maybe<Scalars['String']['output']>;
  isDateOfBirthAcceptable?: Maybe<Scalars['String']['output']>;
  isEntityAcceptable?: Maybe<Scalars['String']['output']>;
  isNameAcceptable?: Maybe<Scalars['String']['output']>;
  isTranslationAcceptable?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmationsAudit = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmationsAudit';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  result?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewDecision = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewDecision';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetails = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetails';
  alternateVerifyingEntity?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsAlternateVerifyingEntity>;
  entitySuppliedCredential?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsEntitySuppliedCredential>;
  institutionContactDetails?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails>;
  verificationStatus?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsAlternateVerifyingEntity = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsAlternateVerifyingEntity';
  isVerifiedWithOther?: Maybe<Scalars['Boolean']['output']>;
  otherDetails?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsEntitySuppliedCredential = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsEntitySuppliedCredential';
  credential?: Maybe<Scalars['String']['output']>;
  credentialUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  credentialVersion?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Scalars['String']['output']>;
  translationUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  translationVersion?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
  institutionEmail?: Maybe<Scalars['String']['output']>;
  institutionPhone?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus';
  verificationResponse?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewVerificationAffirmations = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewVerificationAffirmations';
  audit?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewVerificationAffirmationsAudit>;
  isCredentialReturnedFromEntity?: Maybe<Scalars['String']['output']>;
  isEntityDetailCorrect?: Maybe<Scalars['String']['output']>;
  isReturnedFromCorrectEntity?: Maybe<Scalars['String']['output']>;
  isVerificationComplete?: Maybe<Scalars['String']['output']>;
  isVerificationComponentPacketCompiled?: Maybe<Scalars['String']['output']>;
  isVerificationInEnglishOrWithTranslation?: Maybe<Scalars['String']['output']>;
  isVerificationMethodAcceptable?: Maybe<Scalars['String']['output']>;
  isVerificationStatusComplete?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewVerificationAffirmationsAudit = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewVerificationAffirmationsAudit';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  result?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryRevisionRequest = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryRevisionRequest';
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  requestedBy?: Maybe<StaffUser>;
  requestedChanges?: Maybe<CredentialVerificationCaseV1CaseHistoryRevisionRequestRequestedChanges>;
  revisionSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  revisionSummary?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryRevisionRequestRequestedChanges = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryRevisionRequestRequestedChanges';
  requestUpdatedCredentialDetails?: Maybe<Scalars['Boolean']['output']>;
  requestUpdatedIssuingInstitution?: Maybe<Scalars['Boolean']['output']>;
  requestUploadCredential?: Maybe<Scalars['Boolean']['output']>;
  requestUploadTranslation?: Maybe<Scalars['Boolean']['output']>;
};

export type CredentialVerificationCaseV1CredentialAssets = {
  __typename?: 'CredentialVerificationCaseV1CredentialAssets';
  credential?: Maybe<Scalars['String']['output']>;
  credentialUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  credentialVersion?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Scalars['String']['output']>;
  translationUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  translationVersion?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CredentialAssetsInput = {
  credential?: InputMaybe<Scalars['String']['input']>;
  credentialUploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialVersion?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Scalars['String']['input']>;
  translationUploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translationVersion?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1DeleteInput = {
  caseId: Scalars['ObjectID']['input'];
};

export type CredentialVerificationCaseV1EntitySuppliedCredential = {
  __typename?: 'CredentialVerificationCaseV1EntitySuppliedCredential';
  credential?: Maybe<Scalars['String']['output']>;
  credentialUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  credentialVersion?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Scalars['String']['output']>;
  translationUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  translationVersion?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1EntitySuppliedCredentialInput = {
  credential?: InputMaybe<Scalars['String']['input']>;
  credentialVersion?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Scalars['String']['input']>;
  translationVersion?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1FileRemoveInput = {
  caseId: Scalars['ObjectID']['input'];
  fileName: Scalars['String']['input'];
};

export type CredentialVerificationCaseV1FinanceDetails = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetails';
  financeConfig?: Maybe<CredentialVerificationCaseV1FinanceDetailsFinanceConfig>;
  revenueRecognition?: Maybe<CredentialVerificationCaseV1RevenueRecognition>;
  serviceFee?: Maybe<Scalars['Float']['output']>;
  transactions?: Maybe<CredentialVerificationCaseV1FinanceDetailsTransactions>;
};

export type CredentialVerificationCaseV1FinanceDetailsFinanceConfig = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfig';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<StaffUser>;
  effectiveAt?: Maybe<Scalars['DateTime']['output']>;
  glConfig?: Maybe<CredentialVerificationCaseV1FinanceDetailsFinanceConfigGlConfig>;
  note?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1FinanceDetailsFinanceConfigGlConfig = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfig';
  additionalCharges?: Maybe<Array<Maybe<CredentialVerificationCaseV1FinanceDetailsFinanceConfigGlConfigAdditionalCharge>>>;
  recognition?: Maybe<CredentialVerificationCaseV1FinanceDetailsFinanceConfigGlConfigRecognition>;
  refunds?: Maybe<CredentialVerificationCaseV1FinanceDetailsFinanceConfigGlConfigRefunds>;
  submission?: Maybe<CredentialVerificationCaseV1FinanceDetailsFinanceConfigGlConfigSubmission>;
};

export type CredentialVerificationCaseV1FinanceDetailsFinanceConfigGlConfigAdditionalCharge = MongoSubdocument & {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfigAdditionalCharge';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1FinanceDetailsFinanceConfigGlConfigRecognition = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfigRecognition';
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1FinanceDetailsFinanceConfigGlConfigRefunds = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfigRefunds';
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1FinanceDetailsFinanceConfigGlConfigSubmission = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfigSubmission';
  amount?: Maybe<Scalars['Float']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1FinanceDetailsInput = {
  transactions?: InputMaybe<CredentialVerificationCaseV1FinanceDetailsTransactionsInput>;
};

export type CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions = MongoSubdocument & {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions';
  amount?: Maybe<Scalars['Float']['output']>;
  approval?: Maybe<CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsApproval>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  financeReference?: Maybe<CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFinanceReference>;
  id: Scalars['ObjectID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  requestedBy?: Maybe<StaffUser>;
  status?: Maybe<Scalars['String']['output']>;
  transactionReference?: Maybe<CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsApproval = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsApproval';
  applicantRespondedAt?: Maybe<Scalars['DateTime']['output']>;
  isApplicantApprovalRequired?: Maybe<Scalars['Boolean']['output']>;
  isApplicantApproved?: Maybe<Scalars['Boolean']['output']>;
};

export type CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsApprovalInput = {
  isApplicantApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isApplicantApproved?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFinanceReference = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFinanceReference';
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
  recognizedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  approval?: InputMaybe<CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsApprovalInput>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1FinanceDetailsTransactions = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
  adhocTransactions?: Maybe<Array<Maybe<CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions>>>;
  submission?: Maybe<CredentialVerificationCaseV1FinanceDetailsTransactionsSubmission>;
};

export type CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorOccurredAt?: Maybe<Scalars['DateTime']['output']>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  reconciliationId?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1FinanceDetailsTransactionsInput = {
  adhocTransactions?: InputMaybe<Array<InputMaybe<CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsInput>>>;
};

export type CredentialVerificationCaseV1FinanceDetailsTransactionsSubmission = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmission';
  amount?: Maybe<Scalars['Float']['output']>;
  transactionReference?: Maybe<CredentialVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference>;
};

export type CredentialVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorOccurredAt?: Maybe<Scalars['DateTime']['output']>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  reconciliationId?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1InstitutionContactDetails = {
  __typename?: 'CredentialVerificationCaseV1InstitutionContactDetails';
  institutionEmail?: Maybe<Scalars['String']['output']>;
  institutionPhone?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1InstitutionContactDetailsInput = {
  institutionEmail?: InputMaybe<Scalars['String']['input']>;
  institutionPhone?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1MergePdfFilesInput = {
  blobPaths: Array<InputMaybe<FileInfoInput>>;
  caseId: Scalars['ObjectID']['input'];
  fileName: Scalars['String']['input'];
};

export type CredentialVerificationCaseV1Message = MongoSubdocument & {
  __typename?: 'CredentialVerificationCaseV1Message';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  embedding?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  initiatedBy?: Maybe<StaffUser>;
  isHiddenFromApplicant?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  sentBy?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1MessageInput = {
  embedding?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  isHiddenFromApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1MutationResult = MutationResult & {
  __typename?: 'CredentialVerificationCaseV1MutationResult';
  credentialVerificationCaseV1?: Maybe<CredentialVerificationCaseV1>;
  status: MutationStatus;
};

export type CredentialVerificationCaseV1OtherIssuingInstitution = {
  __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  institutionName?: Maybe<Scalars['String']['output']>;
  stateOrProvince?: Maybe<Scalars['String']['output']>;
  zipOrPostalCode?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1OtherIssuingInstitutionInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  institutionName?: InputMaybe<Scalars['String']['input']>;
  stateOrProvince?: InputMaybe<Scalars['String']['input']>;
  zipOrPostalCode?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1PrivateCaseDetails = {
  __typename?: 'CredentialVerificationCaseV1PrivateCaseDetails';
  alternateVerifyingEntity?: Maybe<CredentialVerificationCaseV1AlternateVerifyingEntity>;
  entitySuppliedCredential?: Maybe<CredentialVerificationCaseV1EntitySuppliedCredential>;
  institutionContactDetails?: Maybe<CredentialVerificationCaseV1InstitutionContactDetails>;
  verificationStatus?: Maybe<CredentialVerificationCaseV1VerificationStatus>;
};

export type CredentialVerificationCaseV1PrivateCaseDetailsInput = {
  alternateVerifyingEntity?: InputMaybe<CredentialVerificationCaseV1AlternateVerifyingEntityInput>;
  entitySuppliedCredential?: InputMaybe<CredentialVerificationCaseV1EntitySuppliedCredentialInput>;
  institutionContactDetails?: InputMaybe<CredentialVerificationCaseV1InstitutionContactDetailsInput>;
  verificationStatus?: InputMaybe<CredentialVerificationCaseV1VerificationStatusInput>;
};

export type CredentialVerificationCaseV1ProcessPaymentInput = {
  paymentAmount: Scalars['Float']['input'];
};

export type CredentialVerificationCaseV1RequestedChanges = {
  __typename?: 'CredentialVerificationCaseV1RequestedChanges';
  requestUpdatedCredentialDetails?: Maybe<Scalars['Boolean']['output']>;
  requestUpdatedIssuingInstitution?: Maybe<Scalars['Boolean']['output']>;
  requestUploadCredential?: Maybe<Scalars['Boolean']['output']>;
  requestUploadTranslation?: Maybe<Scalars['Boolean']['output']>;
};

export type CredentialVerificationCaseV1RequestedChangesInput = {
  requestUpdatedCredentialDetails?: InputMaybe<Scalars['Boolean']['input']>;
  requestUpdatedIssuingInstitution?: InputMaybe<Scalars['Boolean']['input']>;
  requestUploadCredential?: InputMaybe<Scalars['Boolean']['input']>;
  requestUploadTranslation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CredentialVerificationCaseV1RevenueRecognition = {
  __typename?: 'CredentialVerificationCaseV1RevenueRecognition';
  recognition?: Maybe<CredentialVerificationCaseV1RevenueRecognitionRecognition>;
  submission?: Maybe<CredentialVerificationCaseV1RevenueRecognitionSubmission>;
};

export type CredentialVerificationCaseV1RevenueRecognitionRecognition = {
  __typename?: 'CredentialVerificationCaseV1RevenueRecognitionRecognition';
  amount?: Maybe<Scalars['Float']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
  recognizedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1RevenueRecognitionSubmission = {
  __typename?: 'CredentialVerificationCaseV1RevenueRecognitionSubmission';
  amount?: Maybe<Scalars['Float']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
  recognizedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1RevisionRequest = {
  __typename?: 'CredentialVerificationCaseV1RevisionRequest';
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  requestedBy?: Maybe<StaffUser>;
  requestedChanges?: Maybe<CredentialVerificationCaseV1RequestedChanges>;
  revisionSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  revisionSummary?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1RevisionRequestInput = {
  requestedChanges?: InputMaybe<CredentialVerificationCaseV1RequestedChangesInput>;
  revisionSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  revisionSummary?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1Search = {
  __typename?: 'CredentialVerificationCaseV1Search';
  hash?: Maybe<Scalars['String']['output']>;
  indexedAt?: Maybe<Scalars['DateTime']['output']>;
  indexingFailedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1StateInput = {
  newState?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1UpdateInput = {
  activityLog?: InputMaybe<Array<InputMaybe<CredentialVerificationCaseV1ActivityLogInput>>>;
  adhocPayment?: InputMaybe<CredentialVerificationCaseV1AdhocPaymentRequestInput>;
  archiveEligibleAt?: InputMaybe<Scalars['DateTime']['input']>;
  assets?: InputMaybe<CredentialVerificationCaseV1AssetsInput>;
  caseDetails?: InputMaybe<CredentialVerificationCaseV1CaseDetailsInput>;
  caseFlagged?: InputMaybe<Array<InputMaybe<CredentialVerificationCaseV1CaseFlaggedInput>>>;
  caseName?: InputMaybe<Scalars['String']['input']>;
  caseType?: InputMaybe<Scalars['String']['input']>;
  expirationEligibleAt?: InputMaybe<Scalars['DateTime']['input']>;
  financeDetails?: InputMaybe<CredentialVerificationCaseV1FinanceDetailsInput>;
  id: Scalars['ObjectID']['input'];
  messages?: InputMaybe<Array<InputMaybe<CredentialVerificationCaseV1MessageInput>>>;
  payment?: InputMaybe<CredentialVerificationCaseV1ProcessPaymentInput>;
  purgeEligibleAt?: InputMaybe<Scalars['DateTime']['input']>;
  revisionRequest?: InputMaybe<CredentialVerificationCaseV1RevisionRequestInput>;
  state?: InputMaybe<CredentialVerificationCaseV1StateInput>;
  systemTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CredentialVerificationCaseV1VerificationAffirmations = {
  __typename?: 'CredentialVerificationCaseV1VerificationAffirmations';
  audit?: Maybe<CredentialVerificationCaseV1Audit>;
  isCredentialReturnedFromEntity?: Maybe<Scalars['String']['output']>;
  isEntityDetailCorrect?: Maybe<Scalars['String']['output']>;
  isReturnedFromCorrectEntity?: Maybe<Scalars['String']['output']>;
  isVerificationComplete?: Maybe<Scalars['String']['output']>;
  isVerificationComponentPacketCompiled?: Maybe<Scalars['String']['output']>;
  isVerificationInEnglishOrWithTranslation?: Maybe<Scalars['String']['output']>;
  isVerificationMethodAcceptable?: Maybe<Scalars['String']['output']>;
  isVerificationStatusComplete?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1VerificationAffirmationsInput = {
  audit?: InputMaybe<CredentialVerificationCaseV1AuditInput>;
  isCredentialReturnedFromEntity?: InputMaybe<Scalars['String']['input']>;
  isEntityDetailCorrect?: InputMaybe<Scalars['String']['input']>;
  isReturnedFromCorrectEntity?: InputMaybe<Scalars['String']['input']>;
  isVerificationComplete?: InputMaybe<Scalars['String']['input']>;
  isVerificationComponentPacketCompiled?: InputMaybe<Scalars['String']['input']>;
  isVerificationInEnglishOrWithTranslation?: InputMaybe<Scalars['String']['input']>;
  isVerificationMethodAcceptable?: InputMaybe<Scalars['String']['input']>;
  isVerificationStatusComplete?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1VerificationStatus = {
  __typename?: 'CredentialVerificationCaseV1VerificationStatus';
  verificationResponse?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1VerificationStatusInput = {
  verificationResponse?: InputMaybe<Scalars['String']['input']>;
};

export type Entity = MongoBase & {
  __typename?: 'Entity';
  address?: Maybe<EntityAddressInfo>;
  client?: Maybe<EntityClient>;
  clientDisabledAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<StaffUser>;
  disabledAt?: Maybe<Scalars['Date']['output']>;
  entityLanguage?: Maybe<Scalars['String']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  institutionDisabledAt?: Maybe<Scalars['Date']['output']>;
  isClient?: Maybe<Scalars['Boolean']['output']>;
  isIssuingInstitution?: Maybe<Scalars['Boolean']['output']>;
  issuingInstitution?: Maybe<EntityIssuingInstitution>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EntityAddressInfo = {
  __typename?: 'EntityAddressInfo';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  stateOrProvince?: Maybe<Scalars['String']['output']>;
  zipOrPostalCode?: Maybe<Scalars['String']['output']>;
};

export type EntityAddressInfoInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  stateOrProvince?: InputMaybe<Scalars['String']['input']>;
  zipOrPostalCode?: InputMaybe<Scalars['String']['input']>;
};

export type EntityClient = {
  __typename?: 'EntityClient';
  address?: Maybe<EntityAddressInfo>;
  email?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type EntityClientInput = {
  address?: InputMaybe<EntityAddressInfoInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type EntityCreateInput = {
  address?: InputMaybe<EntityAddressInfoInput>;
  client?: InputMaybe<EntityClientInput>;
  entityLanguage?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  isClient: Scalars['Boolean']['input'];
  isIssuingInstitution: Scalars['Boolean']['input'];
  issuingInstitution?: InputMaybe<EntityIssuingInstitutionInput>;
};

export type EntityIssuingInstitution = {
  __typename?: 'EntityIssuingInstitution';
  address?: Maybe<EntityAddressInfo>;
  email?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type EntityIssuingInstitutionInput = {
  address?: InputMaybe<EntityAddressInfoInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type EntityMutationResult = MutationResult & {
  __typename?: 'EntityMutationResult';
  entity?: Maybe<Entity>;
  status: MutationStatus;
};

export type EntityReIndexResult = {
  __typename?: 'EntityReIndexResult';
  entityReIndexErrors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type EntityResult = {
  __typename?: 'EntityResult';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  disabledAt?: Maybe<Scalars['Date']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isClient?: Maybe<Scalars['Boolean']['output']>;
  isIssuingInstitution?: Maybe<Scalars['Boolean']['output']>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EntitySearchFacets = {
  __typename?: 'EntitySearchFacets';
  country?: Maybe<Array<Maybe<FacetDetail>>>;
  createdAt?: Maybe<Array<Maybe<FacetDetail>>>;
  disabledAt?: Maybe<Array<Maybe<FacetDetail>>>;
  isClient?: Maybe<Array<Maybe<FacetDetail>>>;
  isIssuingInstitution?: Maybe<Array<Maybe<FacetDetail>>>;
  schemaVersion?: Maybe<Array<Maybe<FacetDetail>>>;
  updatedAt?: Maybe<Array<Maybe<FacetDetail>>>;
};

export type EntitySearchFilterDetail = {
  country?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disabledAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isClient?: InputMaybe<Scalars['Boolean']['input']>;
  isIssuingInstitution?: InputMaybe<Scalars['Boolean']['input']>;
  schemaVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EntitySearchInput = {
  options?: InputMaybe<EntitySearchOptions>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};

export type EntitySearchOptions = {
  filter?: InputMaybe<EntitySearchFilterDetail>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  top?: InputMaybe<Scalars['Int']['input']>;
};

export type EntitySearchResult = {
  __typename?: 'EntitySearchResult';
  count?: Maybe<Scalars['Int']['output']>;
  entityResults?: Maybe<Array<Maybe<EntityResult>>>;
  facets?: Maybe<EntitySearchFacets>;
};

export type EntityUpdateInput = {
  address?: InputMaybe<EntityAddressInfoInput>;
  client?: InputMaybe<EntityClientInput>;
  disabledAt?: InputMaybe<Scalars['Date']['input']>;
  entityLanguage?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  isClient?: InputMaybe<Scalars['Boolean']['input']>;
  isClientDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isInstitutionDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isIssuingInstitution?: InputMaybe<Scalars['Boolean']['input']>;
  issuingInstitution?: InputMaybe<EntityIssuingInstitutionInput>;
};

export type FacetDetail = {
  __typename?: 'FacetDetail';
  count?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type FeatureFlagsInput = {
  featureFlags?: InputMaybe<Array<BlobFeatureFlagInputData>>;
};

export type FileInfo = {
  __typename?: 'FileInfo';
  name: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type FileInfoInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
};

export type FinanceConfigInput = {
  effectiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  glConfig?: InputMaybe<BlobFinanceGlConfigInput>;
};

export type GlPostingSummary = MongoBase & {
  __typename?: 'GlPostingSummary';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  glSummary: Array<Maybe<GlPostingSummaryGlSummary>>;
  glTransactionDate: Scalars['Date']['output'];
  id: Scalars['ObjectID']['output'];
  postingAttempt?: Maybe<Array<Maybe<GlPostingSummaryPostingAttempt>>>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GlPostingSummaryCreateInput = {
  glSummary: Array<InputMaybe<GlPostingSummaryGlSummaryInput>>;
  glTransactionDate: Scalars['Date']['input'];
};

export type GlPostingSummaryDeleteInput = {
  id: Scalars['ObjectID']['input'];
};

export type GlPostingSummaryGlSummary = MongoSubdocument & {
  __typename?: 'GlPostingSummaryGlSummary';
  accountingType: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  glAccountId: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GlPostingSummaryGlSummaryInput = {
  accountingType: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  glAccountId: Scalars['String']['input'];
};

export type GlPostingSummaryPostingAttempt = MongoSubdocument & {
  __typename?: 'GlPostingSummaryPostingAttempt';
  attemptData: GlPostingSummaryPostingAttemptAttemptData;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdUser: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  responseData?: Maybe<GlPostingSummaryPostingAttemptResponseData>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GlPostingSummaryPostingAttemptAttemptData = {
  __typename?: 'GlPostingSummaryPostingAttemptAttemptData';
  attemptedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
};

export type GlPostingSummaryPostingAttemptAttemptDataInput = {
  status: Scalars['String']['input'];
};

export type GlPostingSummaryPostingAttemptInput = {
  attemptData?: InputMaybe<GlPostingSummaryPostingAttemptAttemptDataInput>;
  createdUser?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  responseData?: InputMaybe<GlPostingSummaryPostingAttemptResponseDataInput>;
};

export type GlPostingSummaryPostingAttemptResponseData = {
  __typename?: 'GlPostingSummaryPostingAttemptResponseData';
  errorMessage?: Maybe<Scalars['String']['output']>;
  glBatchNumber?: Maybe<Scalars['String']['output']>;
  isSuccess: Scalars['Boolean']['output'];
  jEntryNumber?: Maybe<Scalars['Int']['output']>;
  respondedAt: Scalars['DateTime']['output'];
};

export type GlPostingSummaryPostingAttemptResponseDataInput = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  glBatchNumber?: InputMaybe<Scalars['String']['input']>;
  isSuccess: Scalars['Boolean']['input'];
  jEntryNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type GlPostingSummaryUpdateInput = {
  id: Scalars['ObjectID']['input'];
  postingAttempt?: InputMaybe<Array<InputMaybe<GlPostingSummaryPostingAttemptInput>>>;
};

export type GlTransactionSummary = {
  __typename?: 'GlTransactionSummary';
  amount: Scalars['Float']['output'];
  applicant: ApplicantUser;
  case: Scalars['ObjectID']['output'];
  caseType: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  feeType?: Maybe<Scalars['String']['output']>;
  financeReference: GlTransactionSummaryFinanceReference;
  id: Scalars['ObjectID']['output'];
  institution?: Maybe<Entity>;
  reason?: Maybe<Scalars['String']['output']>;
  transactionReference?: Maybe<GlTransactionSummaryTransactionReference>;
  transactionType: Scalars['String']['output'];
};

export type GlTransactionSummaryCreateInput = {
  amount: Scalars['Float']['input'];
  applicant: Scalars['ObjectID']['input'];
  case: Scalars['ObjectID']['input'];
  caseType: Scalars['String']['input'];
  feeType?: InputMaybe<Scalars['String']['input']>;
  financeReference?: InputMaybe<GlTransactionSummaryFinanceReferenceInput>;
  institution?: InputMaybe<Scalars['ObjectID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  transactionReference?: InputMaybe<GlTransactionSummaryTransactionReferenceeInput>;
  transactionType: Scalars['String']['input'];
};

export type GlTransactionSummaryDeleteInput = {
  id: Scalars['ObjectID']['input'];
};

export type GlTransactionSummaryFinanceReference = {
  __typename?: 'GlTransactionSummaryFinanceReference';
  creditGlAccount: Scalars['String']['output'];
  debitGlAccount: Scalars['String']['output'];
};

export type GlTransactionSummaryFinanceReferenceInput = {
  creditGlAccount: Scalars['String']['input'];
  debitGlAccount: Scalars['String']['input'];
};

export type GlTransactionSummaryTransactionReference = {
  __typename?: 'GlTransactionSummaryTransactionReference';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type GlTransactionSummaryTransactionReferenceeInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export type HealthProfessionsData = {
  __typename?: 'HealthProfessionsData';
  professionCode?: Maybe<Scalars['String']['output']>;
  professionName?: Maybe<Scalars['String']['output']>;
};

export type HealthProfessionsDataInput = {
  professionCode?: InputMaybe<Scalars['String']['input']>;
  professionName?: InputMaybe<Scalars['String']['input']>;
};

export type HealthProfessionsInput = {
  blobData: BlobHealthProfessionsInput;
};

export type IdentityVerificationCaseV1 = MongoBase & {
  __typename?: 'IdentityVerificationCaseV1';
  activityLog?: Maybe<Array<Maybe<IdentityVerificationCaseV1ActivityLog>>>;
  applicant?: Maybe<ApplicantUser>;
  archiveEligibleAt?: Maybe<Scalars['DateTime']['output']>;
  assets?: Maybe<IdentityVerificationCaseV1Assets>;
  caseDetails?: Maybe<IdentityVerificationCaseV1CaseDetails>;
  caseFlagged?: Maybe<Array<Maybe<IdentityVerificationCaseV1CaseFlagged>>>;
  caseHistory?: Maybe<Array<Maybe<IdentityVerificationCaseV1CaseHistory>>>;
  caseName: Scalars['String']['output'];
  caseType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expirationEligibleAt?: Maybe<Scalars['DateTime']['output']>;
  fileByFileName?: Maybe<FileInfo>;
  files?: Maybe<Array<Maybe<FileInfo>>>;
  financeDetails?: Maybe<IdentityVerificationCaseV1FinanceDetails>;
  id: Scalars['ObjectID']['output'];
  isCurrentUserAssigned?: Maybe<Scalars['Boolean']['output']>;
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  lastStatusChangeAt?: Maybe<Scalars['DateTime']['output']>;
  messages?: Maybe<Array<Maybe<IdentityVerificationCaseV1Message>>>;
  purgeEligibleAt?: Maybe<Scalars['DateTime']['output']>;
  revisionRequest?: Maybe<IdentityVerificationCaseV1RevisionRequest>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  search?: Maybe<IdentityVerificationCaseV1Search>;
  state: Scalars['String']['output'];
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  systemTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1FileByFileNameArgs = {
  fileName: Scalars['String']['input'];
};

export type IdentityVerificationCaseV1ActivityLog = MongoSubdocument & {
  __typename?: 'IdentityVerificationCaseV1ActivityLog';
  activityBy?: Maybe<User>;
  activityType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  metaData?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1ActivityLogInput = {
  activityType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  metaData?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type IdentityVerificationCaseV1AdhocPaymentRequestInput = {
  adhocPaymentType?: InputMaybe<Scalars['String']['input']>;
  adhocTransactionId?: InputMaybe<Scalars['String']['input']>;
  amount: Scalars['Float']['input'];
  isApplicantApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  reason: Scalars['String']['input'];
};

export type IdentityVerificationCaseV1Assets = {
  __typename?: 'IdentityVerificationCaseV1Assets';
  private?: Maybe<IdentityVerificationCaseV1AssetsPrivate>;
  shared?: Maybe<IdentityVerificationCaseV1AssetsShared>;
};

export type IdentityVerificationCaseV1AssetsInput = {
  private?: InputMaybe<IdentityVerificationCaseV1AssetsPrivateInput>;
  shared?: InputMaybe<IdentityVerificationCaseV1AssetsSharedInput>;
};

export type IdentityVerificationCaseV1AssetsPrivate = {
  __typename?: 'IdentityVerificationCaseV1AssetsPrivate';
  redactedNotarizedIdForm?: Maybe<Scalars['String']['output']>;
  redactedNotarizedIdFormHistory?: Maybe<Array<Maybe<IdentityVerificationCaseV1AssetsPrivateRedactedNotarizedIdFormHistory>>>;
};

export type IdentityVerificationCaseV1AssetsPrivateInput = {
  redactedNotarizedIdForm?: InputMaybe<Scalars['String']['input']>;
  redactedNotarizedIdFormVersion?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1AssetsPrivateRedactedNotarizedIdFormHistory = MongoSubdocument & {
  __typename?: 'IdentityVerificationCaseV1AssetsPrivateRedactedNotarizedIdFormHistory';
  assetUploadedBy?: Maybe<User>;
  assetVersion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1AssetsShared = {
  __typename?: 'IdentityVerificationCaseV1AssetsShared';
  idForm?: Maybe<Scalars['String']['output']>;
  idFormHistory?: Maybe<Array<Maybe<IdentityVerificationCaseV1AssetsSharedIdFormHistory>>>;
  notarizedIdForm?: Maybe<Scalars['String']['output']>;
  notarizedIdFormHistory?: Maybe<Array<Maybe<IdentityVerificationCaseV1AssetsSharedNotarizedIdFormHistory>>>;
};

export type IdentityVerificationCaseV1AssetsSharedIdFormHistory = MongoSubdocument & {
  __typename?: 'IdentityVerificationCaseV1AssetsSharedIdFormHistory';
  assetUploadedBy?: Maybe<User>;
  assetVersion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1AssetsSharedInput = {
  idForm?: InputMaybe<Scalars['String']['input']>;
  idFormVersion?: InputMaybe<Scalars['String']['input']>;
  notarizedIdForm?: InputMaybe<Scalars['String']['input']>;
  notarizedIdFormVersion?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1AssetsSharedNotarizedIdFormHistory = MongoSubdocument & {
  __typename?: 'IdentityVerificationCaseV1AssetsSharedNotarizedIdFormHistory';
  assetUploadedBy?: Maybe<User>;
  assetVersion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1BlobContentAuthHeaderResult = MutationResult & {
  __typename?: 'IdentityVerificationCaseV1BlobContentAuthHeaderResult';
  authHeader?: Maybe<BlobAuthHeader>;
  case?: Maybe<IdentityVerificationCaseV1>;
  status: MutationStatus;
};

export type IdentityVerificationCaseV1BlobFileInput = {
  caseId: Scalars['ObjectID']['input'];
  contentLength: Scalars['Int']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type IdentityVerificationCaseV1CaseDetails = {
  __typename?: 'IdentityVerificationCaseV1CaseDetails';
  application?: Maybe<IdentityVerificationCaseV1CaseDetailsApplication>;
  applicationReview?: Maybe<IdentityVerificationCaseV1CaseDetailsApplicationReview>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplication = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
  attestedAt?: Maybe<Scalars['DateTime']['output']>;
  caseWorkerModifiedPassportDetails?: Maybe<Scalars['Boolean']['output']>;
  isAttestationComplete?: Maybe<Scalars['Boolean']['output']>;
  notarizationDetails?: Maybe<IdentityVerificationCaseV1CaseDetailsApplicationNotarizationDetails>;
  passportAssets?: Maybe<IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets>;
  passportDetails?: Maybe<IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails>;
  photoAssets?: Maybe<IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationInput = {
  caseWorkerModifiedPassportDetails?: InputMaybe<Scalars['Boolean']['input']>;
  isAttestationComplete?: InputMaybe<Scalars['Boolean']['input']>;
  notarizationDetails?: InputMaybe<IdentityVerificationCaseV1CaseDetailsApplicationNotarizationDetailsInput>;
  passportAssets?: InputMaybe<IdentityVerificationCaseV1CaseDetailsApplicationPassportAssetsInput>;
  passportDetails?: InputMaybe<IdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsInput>;
  photoAssets?: InputMaybe<IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssetsInput>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationNotarizationDetails = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationNotarizationDetails';
  isNotarizationComplete?: Maybe<Scalars['Boolean']['output']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationNotarizationDetailsInput = {
  isNotarizationComplete?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets';
  passport?: Maybe<Scalars['String']['output']>;
  passportExpiration?: Maybe<Scalars['String']['output']>;
  passportExpirationUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  passportExpirationVersion?: Maybe<Scalars['String']['output']>;
  passportTranslation?: Maybe<Scalars['String']['output']>;
  passportTranslationUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  passportTranslationVersion?: Maybe<Scalars['String']['output']>;
  passportUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  passportVersion?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationPassportAssetsInput = {
  passport?: InputMaybe<Scalars['String']['input']>;
  passportExpiration?: InputMaybe<Scalars['String']['input']>;
  passportExpirationVersion?: InputMaybe<Scalars['String']['input']>;
  passportTranslation?: InputMaybe<Scalars['String']['input']>;
  passportTranslationVersion?: InputMaybe<Scalars['String']['input']>;
  passportVersion?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
  isPassportExpirationDateVisible?: Maybe<Scalars['Boolean']['output']>;
  isPassportInLatinCharacters?: Maybe<Scalars['Boolean']['output']>;
  passportCountry?: Maybe<Scalars['String']['output']>;
  passportExpiresAt?: Maybe<Scalars['Date']['output']>;
  passportIssuedAt?: Maybe<Scalars['Date']['output']>;
  passportNumber?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsInput = {
  isPassportExpirationDateVisible?: InputMaybe<Scalars['Boolean']['input']>;
  isPassportInLatinCharacters?: InputMaybe<Scalars['Boolean']['input']>;
  passportCountry?: InputMaybe<Scalars['String']['input']>;
  passportExpiresAt?: InputMaybe<Scalars['Date']['input']>;
  passportIssuedAt?: InputMaybe<Scalars['Date']['input']>;
  passportNumber?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets';
  photo?: Maybe<Scalars['String']['output']>;
  photoUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  photoVersion?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssetsInput = {
  photo?: InputMaybe<Scalars['String']['input']>;
  photoVersion?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationReview = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
  affirmations?: Maybe<IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations>;
  caseWorkerAssigned?: Maybe<StaffUser>;
  decision?: Maybe<IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision>;
  notaryAffirmations?: Maybe<IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations';
  audit?: Maybe<IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAudit>;
  isIdDocumentAcceptable?: Maybe<Scalars['String']['output']>;
  isIdDocumentDetailsAcceptable?: Maybe<Scalars['String']['output']>;
  isPhotoAcceptable?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAudit = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAudit';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  result?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAuditInput = {
  setAffirmationsComplete: Scalars['Boolean']['input'];
};

export type IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsInput = {
  audit?: InputMaybe<IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAuditInput>;
  isIdDocumentAcceptable?: InputMaybe<Scalars['String']['input']>;
  isIdDocumentDetailsAcceptable?: InputMaybe<Scalars['String']['input']>;
  isPhotoAcceptable?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationReviewDecisionInput = {
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationReviewInput = {
  affirmations?: InputMaybe<IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsInput>;
  caseWorkerAssigned?: InputMaybe<Scalars['ObjectID']['input']>;
  decision?: InputMaybe<IdentityVerificationCaseV1CaseDetailsApplicationReviewDecisionInput>;
  notaryAffirmations?: InputMaybe<IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsInput>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations';
  audit?: Maybe<IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAudit>;
  isNotarizedIdAcceptable?: Maybe<Scalars['String']['output']>;
  isNotaryAcceptable?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAudit = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAudit';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  result?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAuditInput = {
  setAffirmationsComplete: Scalars['Boolean']['input'];
};

export type IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsInput = {
  audit?: InputMaybe<IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAuditInput>;
  isNotarizedIdAcceptable?: InputMaybe<Scalars['String']['input']>;
  isNotaryAcceptable?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1CaseDetailsInput = {
  application?: InputMaybe<IdentityVerificationCaseV1CaseDetailsApplicationInput>;
  applicationReview?: InputMaybe<IdentityVerificationCaseV1CaseDetailsApplicationReviewInput>;
};

export type IdentityVerificationCaseV1CaseFlagged = MongoSubdocument & {
  __typename?: 'IdentityVerificationCaseV1CaseFlagged';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  flagType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1CaseFlaggedInput = {
  flagType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1CaseHistory = MongoSubdocument & {
  __typename?: 'IdentityVerificationCaseV1CaseHistory';
  caseDetails?: Maybe<IdentityVerificationCaseV1CaseHistoryCaseDetails>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  revisionRequest?: Maybe<IdentityVerificationCaseV1CaseHistoryRevisionRequest>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1CaseHistoryCaseDetails = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetails';
  application?: Maybe<IdentityVerificationCaseV1CaseHistoryCaseDetailsApplication>;
  applicationReview?: Maybe<IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReview>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1CaseHistoryCaseDetailsApplication = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplication';
  attestedAt?: Maybe<Scalars['DateTime']['output']>;
  caseWorkerModifiedPassportDetails?: Maybe<Scalars['Boolean']['output']>;
  isAttestationComplete?: Maybe<Scalars['Boolean']['output']>;
  notarizationDetails?: Maybe<IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationNotarizationDetails>;
  passportAssets?: Maybe<IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationPassportAssets>;
  passportDetails?: Maybe<IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationPassportDetails>;
  photoAssets?: Maybe<IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationPhotoAssets>;
};

export type IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationNotarizationDetails = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationNotarizationDetails';
  isNotarizationComplete?: Maybe<Scalars['Boolean']['output']>;
};

export type IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationPassportAssets = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationPassportAssets';
  passport?: Maybe<Scalars['String']['output']>;
  passportExpiration?: Maybe<Scalars['String']['output']>;
  passportExpirationUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  passportExpirationVersion?: Maybe<Scalars['String']['output']>;
  passportTranslation?: Maybe<Scalars['String']['output']>;
  passportTranslationUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  passportTranslationVersion?: Maybe<Scalars['String']['output']>;
  passportUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  passportVersion?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationPassportDetails = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationPassportDetails';
  isPassportExpirationDateVisible?: Maybe<Scalars['Boolean']['output']>;
  isPassportInLatinCharacters?: Maybe<Scalars['Boolean']['output']>;
  passportCountry?: Maybe<Scalars['String']['output']>;
  passportExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  passportIssuedAt?: Maybe<Scalars['DateTime']['output']>;
  passportNumber?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationPhotoAssets = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationPhotoAssets';
  photo?: Maybe<Scalars['String']['output']>;
  photoUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  photoVersion?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReview = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReview';
  affirmations?: Maybe<IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmations>;
  caseWorkerAssigned?: Maybe<StaffUser>;
  decision?: Maybe<IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewDecision>;
  notaryAffirmations?: Maybe<IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewNotaryAffirmations>;
};

export type IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmations = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmations';
  audit?: Maybe<IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmationsAudit>;
  isIdDocumentAcceptable?: Maybe<Scalars['String']['output']>;
  isIdDocumentDetailsAcceptable?: Maybe<Scalars['String']['output']>;
  isPhotoAcceptable?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmationsAudit = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmationsAudit';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  result?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewDecision = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewDecision';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewNotaryAffirmations = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewNotaryAffirmations';
  audit?: Maybe<IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewNotaryAffirmationsAudit>;
  isNotarizedIdAcceptable?: Maybe<Scalars['String']['output']>;
  isNotaryAcceptable?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewNotaryAffirmationsAudit = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewNotaryAffirmationsAudit';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  result?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseHistoryRevisionRequest = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryRevisionRequest';
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  requestedBy?: Maybe<StaffUser>;
  requestedChanges?: Maybe<IdentityVerificationCaseV1CaseHistoryRevisionRequestRequestedChanges>;
  revisionSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  revisionSummary?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseHistoryRevisionRequestRequestedChanges = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryRevisionRequestRequestedChanges';
  requestScheduleNotaryCam?: Maybe<Scalars['Boolean']['output']>;
  requestUpdatedPassportDetails?: Maybe<Scalars['Boolean']['output']>;
  requestUploadExpirationPage?: Maybe<Scalars['Boolean']['output']>;
  requestUploadNotarizedIdForm?: Maybe<Scalars['Boolean']['output']>;
  requestUploadPassport?: Maybe<Scalars['Boolean']['output']>;
  requestUploadPassportTranslation?: Maybe<Scalars['Boolean']['output']>;
  requestUploadPhoto?: Maybe<Scalars['Boolean']['output']>;
};

export type IdentityVerificationCaseV1DeleteInput = {
  caseId: Scalars['ObjectID']['input'];
};

export type IdentityVerificationCaseV1FileRemoveInput = {
  caseId: Scalars['ObjectID']['input'];
  fileName: Scalars['String']['input'];
};

export type IdentityVerificationCaseV1FinanceDetails = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetails';
  financeConfig?: Maybe<IdentityVerificationCaseV1FinanceDetailsFinanceConfig>;
  revenueRecognition?: Maybe<IdentityVerificationCaseV1FinanceDetailsRevenueRecognition>;
  serviceFee?: Maybe<Scalars['Float']['output']>;
  transactions?: Maybe<IdentityVerificationCaseV1FinanceDetailsTransactions>;
};

export type IdentityVerificationCaseV1FinanceDetailsFinanceConfig = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfig';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<StaffUser>;
  effectiveAt?: Maybe<Scalars['DateTime']['output']>;
  glConfig?: Maybe<IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfig>;
  note?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfig = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfig';
  additionalCharges?: Maybe<Array<Maybe<IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigAdditionalCharge>>>;
  recognition?: Maybe<IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigRecognition>;
  refunds?: Maybe<IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigRefunds>;
  submission?: Maybe<IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigSubmission>;
};

export type IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigAdditionalCharge = MongoSubdocument & {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigAdditionalCharge';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigRecognition = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigRecognition';
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigRefunds = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigRefunds';
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigSubmission = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigSubmission';
  amount?: Maybe<Scalars['Float']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1FinanceDetailsInput = {
  transactions?: InputMaybe<IdentityVerificationCaseV1FinanceDetailsTransactionsInput>;
};

export type IdentityVerificationCaseV1FinanceDetailsRevenueRecognition = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsRevenueRecognition';
  recognition?: Maybe<IdentityVerificationCaseV1FinanceDetailsRevenueRecognitionRecognition>;
  submission?: Maybe<IdentityVerificationCaseV1FinanceDetailsRevenueRecognitionSubmission>;
};

export type IdentityVerificationCaseV1FinanceDetailsRevenueRecognitionRecognition = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsRevenueRecognitionRecognition';
  amount?: Maybe<Scalars['Float']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
  recognizedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1FinanceDetailsRevenueRecognitionSubmission = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsRevenueRecognitionSubmission';
  amount?: Maybe<Scalars['Float']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
  recognizedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1FinanceDetailsTransactions = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
  adhocTransactions?: Maybe<Array<Maybe<IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction>>>;
  submission?: Maybe<IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission>;
};

export type IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction = MongoSubdocument & {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction';
  amount?: Maybe<Scalars['Float']['output']>;
  approval?: Maybe<IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionApproval>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  financeReference?: Maybe<IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFinanceReference>;
  id: Scalars['ObjectID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  requestedBy?: Maybe<StaffUser>;
  status?: Maybe<Scalars['String']['output']>;
  transactionReference?: Maybe<IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionApproval = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionApproval';
  applicantRespondedAt?: Maybe<Scalars['DateTime']['output']>;
  isApplicantApprovalRequired?: Maybe<Scalars['Boolean']['output']>;
  isApplicantApproved?: Maybe<Scalars['Boolean']['output']>;
};

export type IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionApprovalInput = {
  isApplicantApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isApplicantApproved?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFinanceReference = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFinanceReference';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  approval?: InputMaybe<IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionApprovalInput>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorOccurredAt?: Maybe<Scalars['DateTime']['output']>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  reconciliationId?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1FinanceDetailsTransactionsInput = {
  adhocTransactions?: InputMaybe<Array<InputMaybe<IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionInput>>>;
};

export type IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission';
  amount?: Maybe<Scalars['Float']['output']>;
  transactionReference?: Maybe<IdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference>;
};

export type IdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorOccurredAt?: Maybe<Scalars['DateTime']['output']>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  reconciliationId?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1Message = MongoSubdocument & {
  __typename?: 'IdentityVerificationCaseV1Message';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  embedding?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  initiatedBy?: Maybe<StaffUser>;
  isHiddenFromApplicant?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  sentBy?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1MessageInput = {
  embedding?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  isHiddenFromApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1MutationResult = MutationResult & {
  __typename?: 'IdentityVerificationCaseV1MutationResult';
  identityVerificationCaseV1?: Maybe<IdentityVerificationCaseV1>;
  status: MutationStatus;
};

export type IdentityVerificationCaseV1ProcessPaymentInput = {
  paymentAmount: Scalars['Float']['input'];
  paymentInstrument?: InputMaybe<AddPaymentInstrumentInput>;
  paymentInstrumentId?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1RevisionRequest = {
  __typename?: 'IdentityVerificationCaseV1RevisionRequest';
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  requestedBy?: Maybe<StaffUser>;
  requestedChanges?: Maybe<IdentityVerificationCaseV1RevisionRequestRequestedChanges>;
  revisionSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  revisionSummary?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1RevisionRequestInput = {
  requestedChanges?: InputMaybe<IdentityVerificationCaseV1RevisionRequestRequestedChangesInput>;
  revisionSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  revisionSummary?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1RevisionRequestRequestedChanges = {
  __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges';
  requestScheduleNotaryCam?: Maybe<Scalars['Boolean']['output']>;
  requestUpdatedPassportDetails?: Maybe<Scalars['Boolean']['output']>;
  requestUploadExpirationPage?: Maybe<Scalars['Boolean']['output']>;
  requestUploadNotarizedIdForm?: Maybe<Scalars['Boolean']['output']>;
  requestUploadPassport?: Maybe<Scalars['Boolean']['output']>;
  requestUploadPassportTranslation?: Maybe<Scalars['Boolean']['output']>;
  requestUploadPhoto?: Maybe<Scalars['Boolean']['output']>;
};

export type IdentityVerificationCaseV1RevisionRequestRequestedChangesInput = {
  requestScheduleNotaryCam?: InputMaybe<Scalars['Boolean']['input']>;
  requestUpdatedPassportDetails?: InputMaybe<Scalars['Boolean']['input']>;
  requestUploadExpirationPage?: InputMaybe<Scalars['Boolean']['input']>;
  requestUploadNotarizedIdForm?: InputMaybe<Scalars['Boolean']['input']>;
  requestUploadPassport?: InputMaybe<Scalars['Boolean']['input']>;
  requestUploadPassportTranslation?: InputMaybe<Scalars['Boolean']['input']>;
  requestUploadPhoto?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IdentityVerificationCaseV1Search = {
  __typename?: 'IdentityVerificationCaseV1Search';
  hash?: Maybe<Scalars['String']['output']>;
  indexedAt?: Maybe<Scalars['DateTime']['output']>;
  indexingFailedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1StateInput = {
  newState?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1UpdateInput = {
  activityLog?: InputMaybe<Array<InputMaybe<IdentityVerificationCaseV1ActivityLogInput>>>;
  adhocPayment?: InputMaybe<IdentityVerificationCaseV1AdhocPaymentRequestInput>;
  archiveEligibleAt?: InputMaybe<Scalars['DateTime']['input']>;
  assets?: InputMaybe<IdentityVerificationCaseV1AssetsInput>;
  caseDetails?: InputMaybe<IdentityVerificationCaseV1CaseDetailsInput>;
  caseFlagged?: InputMaybe<Array<InputMaybe<IdentityVerificationCaseV1CaseFlaggedInput>>>;
  caseName?: InputMaybe<Scalars['String']['input']>;
  expirationEligibleAt?: InputMaybe<Scalars['DateTime']['input']>;
  financeDetails?: InputMaybe<IdentityVerificationCaseV1FinanceDetailsInput>;
  id: Scalars['ObjectID']['input'];
  messages?: InputMaybe<Array<InputMaybe<IdentityVerificationCaseV1MessageInput>>>;
  payment?: InputMaybe<IdentityVerificationCaseV1ProcessPaymentInput>;
  purgeEligibleAt?: InputMaybe<Scalars['DateTime']['input']>;
  revisionRequest?: InputMaybe<IdentityVerificationCaseV1RevisionRequestInput>;
  state?: InputMaybe<IdentityVerificationCaseV1StateInput>;
  systemTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Base type for all models in mongo. */
export type MongoBase = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ObjectID']['output'];
  schemaVersion?: Maybe<Scalars['String']['output']>;
  /** Automatically generated timestamp, updated on every save. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Base type for all models in mongo. */
export type MongoSubdocument = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ObjectID']['output'];
  /** Automatically generated timestamp, updated on every save. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type Mutation = {
  __typename?: 'Mutation';
  /** IGNORE: Dummy field necessary for the Mutation type to be valid */
  _empty?: Maybe<Scalars['String']['output']>;
  applicantUserDelete: ApplicantUserMutationResult;
  applicantUserFileCreateAuthHeader: ApplicantUserBlobContentAuthHeaderResult;
  applicantUserFileRemove: ApplicantUserMutationResult;
  applicantUserUpdate: ApplicantUserMutationResult;
  applicantUserUpdatePaymentInstrument: PaymentInstrumentResult;
  credentialVerificationCaseV1Delete?: Maybe<CredentialVerificationCaseV1MutationResult>;
  credentialVerificationCaseV1FileCreateAuthHeader: CredentialVerificationCaseV1BlobContentAuthHeaderResult;
  credentialVerificationCaseV1FileRemove: CredentialVerificationCaseV1MutationResult;
  credentialVerificationCaseV1ImageFileCreateAuthHeader: CredentialVerificationCaseV1BlobContentAuthHeaderResult;
  credentialVerificationCaseV1MergePdfFiles: CredentialVerificationCaseV1MutationResult;
  credentialVerificationCaseV1PdfFileCreateAuthHeader: CredentialVerificationCaseV1BlobContentAuthHeaderResult;
  credentialVerificationCaseV1Update?: Maybe<CredentialVerificationCaseV1MutationResult>;
  entityCreate: EntityMutationResult;
  entityDelete: EntityMutationResult;
  entityUpdate: EntityMutationResult;
  healthProfessionsUpdate?: Maybe<BlobHealthProfessionsMutationResult>;
  identityVerificationCaseV1Delete: IdentityVerificationCaseV1MutationResult;
  identityVerificationCaseV1FileCreateAuthHeader: IdentityVerificationCaseV1BlobContentAuthHeaderResult;
  identityVerificationCaseV1FileRemove: IdentityVerificationCaseV1MutationResult;
  identityVerificationCaseV1ImageFileCreateAuthHeader: IdentityVerificationCaseV1BlobContentAuthHeaderResult;
  identityVerificationCaseV1PdfFileCreateAuthHeader: IdentityVerificationCaseV1BlobContentAuthHeaderResult;
  identityVerificationCaseV1Update: IdentityVerificationCaseV1MutationResult;
  processMaliciousFileScan?: Maybe<ProcessMaliciousFileScanMutationResult>;
  sendReportCaseV1Delete: SendReportCaseV1MutationResult;
  sendReportCaseV1FileRemove: SendReportCaseV1MutationResult;
  sendReportCaseV1ImageFileCreateAuthHeader: SendReportCaseV1BlobContentAuthHeaderResult;
  sendReportCaseV1MergePdfFiles: SendReportCaseV1MutationResult;
  sendReportCaseV1PdfFileCreateAuthHeader: SendReportCaseV1BlobContentAuthHeaderResult;
  sendReportCaseV1Update: SendReportCaseV1MutationResult;
  staffRoleCreate: StaffRoleMutationResult;
  staffRoleDelete: StaffRoleMutationResult;
  staffRoleUpdate: StaffRoleMutationResult;
  staffUserDelete: StaffUserMutationResult;
  staffUserUpdate: StaffUserMutationResult;
  updateBlobCountries?: Maybe<BlobCountriesMutationResult>;
  updateBlobFeatureFlags?: Maybe<BlobFeatureFlagMutationResult>;
  updateBlobFinanceGlConfig?: Maybe<BlobFinanceConfigMutationResult>;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationApplicantUserDeleteArgs = {
  applicantUserId: Scalars['ObjectID']['input'];
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationApplicantUserFileCreateAuthHeaderArgs = {
  input: ApplicantUserBlobFileInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationApplicantUserFileRemoveArgs = {
  input: ApplicantUserPublicFileRemoveInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationApplicantUserUpdateArgs = {
  input: ApplicantUserUpdateInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationApplicantUserUpdatePaymentInstrumentArgs = {
  input: ApplicantUserUpdatePaymentInstrumentInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationCredentialVerificationCaseV1DeleteArgs = {
  input: CredentialVerificationCaseV1DeleteInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationCredentialVerificationCaseV1FileCreateAuthHeaderArgs = {
  input: CredentialVerificationCaseV1BlobFileInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationCredentialVerificationCaseV1FileRemoveArgs = {
  input: CredentialVerificationCaseV1FileRemoveInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationCredentialVerificationCaseV1ImageFileCreateAuthHeaderArgs = {
  input: CredentialVerificationCaseV1BlobFileInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationCredentialVerificationCaseV1MergePdfFilesArgs = {
  input: CredentialVerificationCaseV1MergePdfFilesInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationCredentialVerificationCaseV1PdfFileCreateAuthHeaderArgs = {
  input: CredentialVerificationCaseV1BlobFileInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationCredentialVerificationCaseV1UpdateArgs = {
  input: CredentialVerificationCaseV1UpdateInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationEntityCreateArgs = {
  input: EntityCreateInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationEntityDeleteArgs = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationEntityUpdateArgs = {
  input: EntityUpdateInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationHealthProfessionsUpdateArgs = {
  input: HealthProfessionsInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationIdentityVerificationCaseV1DeleteArgs = {
  input: IdentityVerificationCaseV1DeleteInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationIdentityVerificationCaseV1FileCreateAuthHeaderArgs = {
  input: IdentityVerificationCaseV1BlobFileInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationIdentityVerificationCaseV1FileRemoveArgs = {
  input: IdentityVerificationCaseV1FileRemoveInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationIdentityVerificationCaseV1ImageFileCreateAuthHeaderArgs = {
  input: IdentityVerificationCaseV1BlobFileInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationIdentityVerificationCaseV1PdfFileCreateAuthHeaderArgs = {
  input: IdentityVerificationCaseV1BlobFileInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationIdentityVerificationCaseV1UpdateArgs = {
  input: IdentityVerificationCaseV1UpdateInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationProcessMaliciousFileScanArgs = {
  input: ProcessMaliciousFileScanInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationSendReportCaseV1DeleteArgs = {
  input: SendReportCaseV1DeleteInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationSendReportCaseV1FileRemoveArgs = {
  input: SendReportCaseV1FileRemoveInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationSendReportCaseV1ImageFileCreateAuthHeaderArgs = {
  input: SendReportCaseV1BlobFileInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationSendReportCaseV1MergePdfFilesArgs = {
  input: SendReportCaseV1MergePdfFilesInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationSendReportCaseV1PdfFileCreateAuthHeaderArgs = {
  input: SendReportCaseV1BlobFileInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationSendReportCaseV1UpdateArgs = {
  input: SendReportCaseV1UpdateInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationStaffRoleCreateArgs = {
  input: StaffRoleCreateInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationStaffRoleDeleteArgs = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationStaffRoleUpdateArgs = {
  input: StaffRoleUpdateInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationStaffUserDeleteArgs = {
  input: StaffUserDeleteInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationStaffUserUpdateArgs = {
  input: StaffUserUpdateInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationUpdateBlobCountriesArgs = {
  input: BlobCountriesInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationUpdateBlobFeatureFlagsArgs = {
  input: BlobFeatureFlagInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationUpdateBlobFinanceGlConfigArgs = {
  input: BlobFinanceConfigInput;
};

export type MutationResult = {
  status: MutationStatus;
};

export type MutationStatus = {
  __typename?: 'MutationStatus';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type PaymentBillingInfo = {
  __typename?: 'PaymentBillingInfo';
  billingAddressLine1?: Maybe<Scalars['String']['output']>;
  billingAddressLine2?: Maybe<Scalars['String']['output']>;
  billingCity?: Maybe<Scalars['String']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  billingFirstName?: Maybe<Scalars['String']['output']>;
  billingLastName?: Maybe<Scalars['String']['output']>;
  billingPhone?: Maybe<Scalars['String']['output']>;
  billingPostalCode?: Maybe<Scalars['String']['output']>;
  billingState?: Maybe<Scalars['String']['output']>;
};

export type PaymentInstrument = {
  __typename?: 'PaymentInstrument';
  billTo?: Maybe<PaymentBillingInfo>;
  cardNumber?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  expirationMonth?: Maybe<Scalars['String']['output']>;
  expirationYear?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  paymentInstrumentId?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type PaymentInstrumentResult = {
  __typename?: 'PaymentInstrumentResult';
  paymentInstrument?: Maybe<PaymentInstrument>;
  status: MutationStatus;
};

export type ProcessMaliciousFileScanInput = {
  blobUrl: Scalars['String']['input'];
  initialDelay?: InputMaybe<Scalars['Int']['input']>;
  maxTimeoutMs?: InputMaybe<Scalars['Int']['input']>;
  versionId: Scalars['String']['input'];
};

export type ProcessMaliciousFileScanMutationResult = MutationResult & {
  __typename?: 'ProcessMaliciousFileScanMutationResult';
  isMalicious?: Maybe<Scalars['Boolean']['output']>;
  isSafe?: Maybe<Scalars['Boolean']['output']>;
  scanResult?: Maybe<Scalars['String']['output']>;
  status: MutationStatus;
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type Query = {
  __typename?: 'Query';
  /** IGNORE: Dummy field necessary for the Query type to be valid */
  _empty?: Maybe<Scalars['String']['output']>;
  applicantUser?: Maybe<ApplicantUser>;
  applicantUserCurrent?: Maybe<ApplicantUser>;
  applicantUserCybersourcePublicKeyId?: Maybe<Scalars['String']['output']>;
  applicantUserGetAllTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  applicantUserPaymentInstrument?: Maybe<PaymentInstrument>;
  applicantUserSearch?: Maybe<ApplicantUserSearchResult>;
  archivedCasesByApplicantId?: Maybe<Array<Maybe<ArchivedCaseSummary>>>;
  archivedCredentialVerificationCaseSummary?: Maybe<ArchivedCredentialVerificationCaseSummary>;
  archivedIdentityVerificationCaseSummary?: Maybe<ArchivedIdentityVerificationCaseSummary>;
  archivedSendReportCaseSummary?: Maybe<ArchivedSendReportCaseSummary>;
  blobCountries?: Maybe<BlobCountryEvent>;
  blobFeatureFlags?: Maybe<Array<BlobFeatureFlag>>;
  blobFinanceGlConfigs?: Maybe<BlobFinanceConfig>;
  blobFinancialConfigs?: Maybe<Array<Maybe<BlobFinancialConfig>>>;
  blobFinancialGlConfig?: Maybe<BlobFinanceConfig>;
  blobHealthProfessions?: Maybe<BlobHealthProfession>;
  caseGetAllTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  caseReIndex?: Maybe<CaseReIndexResult>;
  caseSearch?: Maybe<CaseSearchResult>;
  credentialCaseReIndex?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  credentialVerificationCaseV1?: Maybe<CredentialVerificationCaseV1>;
  credentialVerificationCaseV1Current?: Maybe<CredentialVerificationCaseV1>;
  credentialVerificationCasesV1ByApplicant?: Maybe<Array<Maybe<CredentialVerificationCaseV1>>>;
  entities?: Maybe<Array<Maybe<Entity>>>;
  entity?: Maybe<Entity>;
  entityByName?: Maybe<Entity>;
  entityReIndex?: Maybe<EntityReIndexResult>;
  entitySearch?: Maybe<EntitySearchResult>;
  glPostingSummariesByDateRange?: Maybe<Array<Maybe<GlPostingSummary>>>;
  glTransactionSummariesByDateRange?: Maybe<Array<Maybe<GlTransactionSummary>>>;
  identityCaseReIndex?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  identityVerificationCaseV1?: Maybe<IdentityVerificationCaseV1>;
  identityVerificationCaseV1Current?: Maybe<IdentityVerificationCaseV1>;
  identityVerificationCasesV1ByApplicant?: Maybe<Array<Maybe<IdentityVerificationCaseV1>>>;
  sendReportCaseReIndex?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sendReportCaseV1?: Maybe<SendReportCaseV1>;
  sendReportCaseV1Current?: Maybe<SendReportCaseV1>;
  sendReportCasesV1?: Maybe<Array<Maybe<SendReportCaseV1>>>;
  sendReportCasesV1ByApplicant?: Maybe<Array<Maybe<SendReportCaseV1>>>;
  serverDate?: Maybe<Scalars['String']['output']>;
  staffRole?: Maybe<StaffRole>;
  staffRoles?: Maybe<Array<Maybe<StaffRole>>>;
  staffUser?: Maybe<StaffUser>;
  staffUserCurrent?: Maybe<StaffUser>;
  staffUserGetAllTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  staffUserSearch?: Maybe<StaffUserSearchResult>;
  staffUsers?: Maybe<Array<Maybe<StaffUser>>>;
  userReIndex?: Maybe<UserReIndexResult>;
  verifiedCredentialVerificationCaseSummariesByApplicant?: Maybe<Array<Maybe<VerifiedCredentialVerificationCaseSummary>>>;
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryApplicantUserArgs = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryApplicantUserPaymentInstrumentArgs = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryApplicantUserSearchArgs = {
  input?: InputMaybe<ApplicantUserSearchInput>;
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryArchivedCasesByApplicantIdArgs = {
  applicantId: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryArchivedCredentialVerificationCaseSummaryArgs = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryArchivedIdentityVerificationCaseSummaryArgs = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryArchivedSendReportCaseSummaryArgs = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryBlobFinanceGlConfigsArgs = {
  input: BlobFinanceInput;
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryBlobFinancialGlConfigArgs = {
  input: BlobFinanceConfigNameInput;
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryCaseSearchArgs = {
  input?: InputMaybe<CaseSearchInput>;
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryCredentialVerificationCaseV1Args = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryCredentialVerificationCaseV1CurrentArgs = {
  applicantId: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryCredentialVerificationCasesV1ByApplicantArgs = {
  applicantId: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryEntityArgs = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryEntityByNameArgs = {
  entityName: Scalars['String']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryEntitySearchArgs = {
  input?: InputMaybe<EntitySearchInput>;
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryGlPostingSummariesByDateRangeArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryGlTransactionSummariesByDateRangeArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryIdentityVerificationCaseV1Args = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryIdentityVerificationCaseV1CurrentArgs = {
  applicantId: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryIdentityVerificationCasesV1ByApplicantArgs = {
  applicantId: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QuerySendReportCaseV1Args = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QuerySendReportCaseV1CurrentArgs = {
  applicantId: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QuerySendReportCasesV1ByApplicantArgs = {
  applicantId: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryStaffRoleArgs = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryStaffUserArgs = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryStaffUserCurrentArgs = {
  oid?: InputMaybe<Scalars['String']['input']>;
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryStaffUserSearchArgs = {
  input?: InputMaybe<StaffUserSearchInput>;
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryVerifiedCredentialVerificationCaseSummariesByApplicantArgs = {
  applicantId: Scalars['ObjectID']['input'];
};

export type SendReportCaseV1 = MongoBase & {
  __typename?: 'SendReportCaseV1';
  activityLog?: Maybe<Array<Maybe<SendReportCaseV1ActivityLog>>>;
  applicant?: Maybe<ApplicantUser>;
  archiveEligibleAt?: Maybe<Scalars['DateTime']['output']>;
  assets?: Maybe<SendReportCaseV1Asset>;
  caseDetails?: Maybe<SendReportCaseV1CaseDetails>;
  caseFlagged?: Maybe<Array<Maybe<SendReportCaseV1CaseFlagged>>>;
  caseHistory?: Maybe<Array<Maybe<SendReportCaseV1CaseHistory>>>;
  caseName?: Maybe<Scalars['String']['output']>;
  caseType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expirationEligibleAt?: Maybe<Scalars['DateTime']['output']>;
  fileByFileName?: Maybe<FileInfo>;
  files?: Maybe<Array<Maybe<FileInfo>>>;
  financeDetails?: Maybe<SendReportCaseV1FinanceDetails>;
  id: Scalars['ObjectID']['output'];
  isCurrentUserAssigned?: Maybe<Scalars['Boolean']['output']>;
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  lastStatusChangeAt?: Maybe<Scalars['DateTime']['output']>;
  messages?: Maybe<Array<Maybe<SendReportCaseV1Message>>>;
  purgeEligibleAt?: Maybe<Scalars['DateTime']['output']>;
  revisionRequest?: Maybe<SendReportCaseV1RevisionRequest>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  search?: Maybe<SendReportCaseV1Search>;
  state: Scalars['String']['output'];
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  systemTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1FileByFileNameArgs = {
  fileName: Scalars['String']['input'];
};

export type SendReportCaseV1ActivityLog = MongoSubdocument & {
  __typename?: 'SendReportCaseV1ActivityLog';
  activityBy?: Maybe<User>;
  activityType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  metaData?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1ActivityLogInput = {
  activityType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  metaData?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SendReportCaseV1AdhocPaymentRequestInput = {
  adhocPaymentType?: InputMaybe<Scalars['String']['input']>;
  adhocTransactionId?: InputMaybe<Scalars['String']['input']>;
  amount: Scalars['Float']['input'];
  isApplicantApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  reason: Scalars['String']['input'];
};

export type SendReportCaseV1Asset = {
  __typename?: 'SendReportCaseV1Asset';
  private?: Maybe<SendReportCaseV1AssetPrivate>;
};

export type SendReportCaseV1AssetPrivate = {
  __typename?: 'SendReportCaseV1AssetPrivate';
  statusReportCoverLetter?: Maybe<Scalars['String']['output']>;
  statusReportCoverLetterHistory?: Maybe<Array<Maybe<SendReportCaseV1AssetPrivateStatusReportCoverLetterHistory>>>;
  verificationStatusReport?: Maybe<Scalars['String']['output']>;
  verificationStatusReportHistory?: Maybe<Array<Maybe<SendReportCaseV1AssetPrivateVerificationStatusReportHistory>>>;
};

export type SendReportCaseV1AssetPrivateInput = {
  statusReportCoverLetter?: InputMaybe<Scalars['String']['input']>;
  statusReportCoverLetterVersion?: InputMaybe<Scalars['String']['input']>;
  verificationStatusReport?: InputMaybe<Scalars['String']['input']>;
  verificationStatusReportVersion?: InputMaybe<Scalars['String']['input']>;
};

export type SendReportCaseV1AssetPrivateStatusReportCoverLetterHistory = MongoSubdocument & {
  __typename?: 'SendReportCaseV1AssetPrivateStatusReportCoverLetterHistory';
  assetUploadedBy?: Maybe<StaffUser>;
  assetVersion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1AssetPrivateVerificationStatusReportHistory = MongoSubdocument & {
  __typename?: 'SendReportCaseV1AssetPrivateVerificationStatusReportHistory';
  assetUploadedBy?: Maybe<StaffUser>;
  assetVersion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1AssetsInput = {
  private?: InputMaybe<SendReportCaseV1AssetPrivateInput>;
};

export type SendReportCaseV1AuditType = {
  __typename?: 'SendReportCaseV1AuditType';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  result?: Maybe<Scalars['String']['output']>;
};

export type SendReportCaseV1AuditTypeInput = {
  setAffirmationsComplete: Scalars['Boolean']['input'];
};

export type SendReportCaseV1BlobContentAuthHeaderResult = MutationResult & {
  __typename?: 'SendReportCaseV1BlobContentAuthHeaderResult';
  authHeader?: Maybe<BlobAuthHeader>;
  case?: Maybe<SendReportCaseV1>;
  status: MutationStatus;
};

export type SendReportCaseV1BlobFileInput = {
  caseId: Scalars['ObjectID']['input'];
  contentLength: Scalars['Int']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type SendReportCaseV1CaseDetails = {
  __typename?: 'SendReportCaseV1CaseDetails';
  application?: Maybe<SendReportCaseV1CaseDetailsApplication>;
  applicationReview?: Maybe<SendReportCaseV1CaseDetailsApplicationReview>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  initiatedByApplicant?: Maybe<Scalars['Boolean']['output']>;
};

export type SendReportCaseV1CaseDetailsApplication = {
  __typename?: 'SendReportCaseV1CaseDetailsApplication';
  attestedAt?: Maybe<Scalars['DateTime']['output']>;
  credential?: Maybe<CredentialVerificationCaseV1>;
  destination?: Maybe<Entity>;
  isAttestationComplete?: Maybe<Scalars['Boolean']['output']>;
};

export type SendReportCaseV1CaseDetailsApplicationInput = {
  credential?: InputMaybe<Scalars['ObjectID']['input']>;
  destination?: InputMaybe<Scalars['ObjectID']['input']>;
  isAttestationComplete?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SendReportCaseV1CaseDetailsApplicationReview = {
  __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
  affirmations?: Maybe<SendReportCaseV1CaseDetailsApplicationReviewAffirmation>;
  caseWorkerAssigned?: Maybe<StaffUser>;
  decision?: Maybe<SendReportCaseV1CaseDetailsApplicationReviewDecision>;
  privateCaseDetails?: Maybe<SendReportCaseV1CaseDetailsApplicationReviewPrivateCaseDetails>;
};

export type SendReportCaseV1CaseDetailsApplicationReviewAffirmation = {
  __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewAffirmation';
  audit?: Maybe<SendReportCaseV1AuditType>;
  isDestinationAcceptable?: Maybe<Scalars['String']['output']>;
  isReportCompiled?: Maybe<Scalars['String']['output']>;
  isReportSent?: Maybe<Scalars['String']['output']>;
};

export type SendReportCaseV1CaseDetailsApplicationReviewAffirmationInput = {
  audit?: InputMaybe<SendReportCaseV1AuditTypeInput>;
  isDestinationAcceptable?: InputMaybe<Scalars['String']['input']>;
  isReportCompiled?: InputMaybe<Scalars['String']['input']>;
  isReportSent?: InputMaybe<Scalars['String']['input']>;
};

export type SendReportCaseV1CaseDetailsApplicationReviewDecision = {
  __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewDecision';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
};

export type SendReportCaseV1CaseDetailsApplicationReviewDecisionInput = {
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Scalars['String']['input']>;
};

export type SendReportCaseV1CaseDetailsApplicationReviewInput = {
  affirmations?: InputMaybe<SendReportCaseV1CaseDetailsApplicationReviewAffirmationInput>;
  caseWorkerAssigned?: InputMaybe<Scalars['ObjectID']['input']>;
  decision?: InputMaybe<SendReportCaseV1CaseDetailsApplicationReviewDecisionInput>;
};

export type SendReportCaseV1CaseDetailsApplicationReviewPrivateCaseDetails = {
  __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewPrivateCaseDetails';
  institutionContactDetails?: Maybe<SendReportCaseV1CaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails>;
};

export type SendReportCaseV1CaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails = {
  __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
  institutionEmail?: Maybe<Scalars['String']['output']>;
  institutionPhone?: Maybe<Scalars['String']['output']>;
};

export type SendReportCaseV1CaseDetailsInput = {
  application?: InputMaybe<SendReportCaseV1CaseDetailsApplicationInput>;
  applicationReview?: InputMaybe<SendReportCaseV1CaseDetailsApplicationReviewInput>;
  initiatedByApplicant?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SendReportCaseV1CaseFlagged = MongoSubdocument & {
  __typename?: 'SendReportCaseV1CaseFlagged';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  flagType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1CaseFlaggedInput = {
  flagType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type SendReportCaseV1CaseHistory = MongoSubdocument & {
  __typename?: 'SendReportCaseV1CaseHistory';
  caseDetails?: Maybe<SendReportCaseV1CaseDetails>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  revisionRequest?: Maybe<SendReportCaseV1RevisionRequest>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1DeleteInput = {
  caseId: Scalars['ObjectID']['input'];
};

export type SendReportCaseV1FileRemoveInput = {
  caseId: Scalars['ObjectID']['input'];
  fileName: Scalars['String']['input'];
};

export type SendReportCaseV1FinanceDetails = {
  __typename?: 'SendReportCaseV1FinanceDetails';
  financeConfig?: Maybe<SendReportCaseV1FinanceDetailsFinanceConfig>;
  revenueRecognition?: Maybe<SendReportCaseV1FinanceDetailsRevenueRecognition>;
  serviceFee?: Maybe<Scalars['Float']['output']>;
  transactions?: Maybe<SendReportCaseV1FinanceDetailsTransactions>;
};

export type SendReportCaseV1FinanceDetailsFinanceConfig = {
  __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfig';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<StaffUser>;
  effectiveAt?: Maybe<Scalars['DateTime']['output']>;
  glConfig?: Maybe<SendReportCaseV1FinanceDetailsFinanceConfigGlConfig>;
  note?: Maybe<Scalars['String']['output']>;
};

export type SendReportCaseV1FinanceDetailsFinanceConfigGlConfig = {
  __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfigGLConfig';
  additionalCharges?: Maybe<Array<Maybe<SendReportCaseV1FinanceDetailsFinanceConfigGlConfigAdditionalCharge>>>;
  recognition?: Maybe<SendReportCaseV1FinanceDetailsFinanceConfigGlConfigRecognition>;
  refunds?: Maybe<SendReportCaseV1FinanceDetailsFinanceConfigGlConfigRefunds>;
  submission?: Maybe<SendReportCaseV1FinanceDetailsFinanceConfigGlConfigSubmission>;
};

export type SendReportCaseV1FinanceDetailsFinanceConfigGlConfigAdditionalCharge = MongoSubdocument & {
  __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfigGLConfigAdditionalCharge';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1FinanceDetailsFinanceConfigGlConfigRecognition = {
  __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfigGLConfigRecognition';
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
};

export type SendReportCaseV1FinanceDetailsFinanceConfigGlConfigRefunds = {
  __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfigGLConfigRefunds';
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
};

export type SendReportCaseV1FinanceDetailsFinanceConfigGlConfigSubmission = {
  __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfigGLConfigSubmission';
  amount?: Maybe<Scalars['Float']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
};

export type SendReportCaseV1FinanceDetailsInput = {
  transactions?: InputMaybe<SendReportCaseV1FinanceDetailsTransactionsInput>;
};

export type SendReportCaseV1FinanceDetailsRevenueRecognition = {
  __typename?: 'SendReportCaseV1FinanceDetailsRevenueRecognition';
  recognition?: Maybe<SendReportCaseV1FinanceDetailsRevenueRecognitionRecognition>;
  submission?: Maybe<SendReportCaseV1FinanceDetailsRevenueRecognitionSubmission>;
};

export type SendReportCaseV1FinanceDetailsRevenueRecognitionRecognition = {
  __typename?: 'SendReportCaseV1FinanceDetailsRevenueRecognitionRecognition';
  amount?: Maybe<Scalars['Float']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
  recognizedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1FinanceDetailsRevenueRecognitionSubmission = {
  __typename?: 'SendReportCaseV1FinanceDetailsRevenueRecognitionSubmission';
  amount?: Maybe<Scalars['Float']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
  recognizedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1FinanceDetailsTransactionAdhocTransaction = MongoSubdocument & {
  __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction';
  amount?: Maybe<Scalars['Float']['output']>;
  approval?: Maybe<SendReportCaseV1FinanceDetailsTransactionAdhocTransactionApproval>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  financeReference?: Maybe<SendReportCaseV1FinanceDetailsTransactionAdhocTransactionFinanceReference>;
  id: Scalars['ObjectID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  requestedBy?: Maybe<StaffUser>;
  status?: Maybe<Scalars['String']['output']>;
  transactionReference?: Maybe<SendReportCaseV1FinanceDetailsTransactionAdhocTransactionTransactionReference>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1FinanceDetailsTransactionAdhocTransactionApproval = {
  __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionApproval';
  applicantRespondedAt?: Maybe<Scalars['DateTime']['output']>;
  isApplicantApprovalRequired?: Maybe<Scalars['Boolean']['output']>;
  isApplicantApproved?: Maybe<Scalars['Boolean']['output']>;
};

export type SendReportCaseV1FinanceDetailsTransactionAdhocTransactionApprovalInput = {
  isApplicantApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isApplicantApproved?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SendReportCaseV1FinanceDetailsTransactionAdhocTransactionFinanceReference = {
  __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionFinanceReference';
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
  recognizedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1FinanceDetailsTransactionAdhocTransactionInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  approval?: InputMaybe<SendReportCaseV1FinanceDetailsTransactionAdhocTransactionApprovalInput>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type SendReportCaseV1FinanceDetailsTransactionAdhocTransactionTransactionReference = {
  __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionTransactionReference';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorOccurredAt?: Maybe<Scalars['DateTime']['output']>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  reconciliationId?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type SendReportCaseV1FinanceDetailsTransactionSubmission = {
  __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmission';
  amount?: Maybe<Scalars['Float']['output']>;
  transactionReference?: Maybe<SendReportCaseV1FinanceDetailsTransactionSubmissionTransactionReference>;
};

export type SendReportCaseV1FinanceDetailsTransactionSubmissionTransactionReference = {
  __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmissionTransactionReference';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorOccurredAt?: Maybe<Scalars['DateTime']['output']>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  reconciliationId?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type SendReportCaseV1FinanceDetailsTransactions = {
  __typename?: 'SendReportCaseV1FinanceDetailsTransactions';
  adhocTransactions?: Maybe<Array<Maybe<SendReportCaseV1FinanceDetailsTransactionAdhocTransaction>>>;
  submission?: Maybe<SendReportCaseV1FinanceDetailsTransactionSubmission>;
};

export type SendReportCaseV1FinanceDetailsTransactionsInput = {
  adhocTransactions?: InputMaybe<Array<InputMaybe<SendReportCaseV1FinanceDetailsTransactionAdhocTransactionInput>>>;
};

export type SendReportCaseV1MergePdfFilesInput = {
  blobPaths: Array<InputMaybe<FileInfoInput>>;
  caseId: Scalars['ObjectID']['input'];
  fileName: Scalars['String']['input'];
};

export type SendReportCaseV1Message = MongoSubdocument & {
  __typename?: 'SendReportCaseV1Message';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  embedding?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  initiatedBy?: Maybe<StaffUser>;
  isHiddenFromApplicant?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  sentBy?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1MessageInput = {
  embedding?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  isHiddenFromApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
};

export type SendReportCaseV1MutationResult = MutationResult & {
  __typename?: 'SendReportCaseV1MutationResult';
  sendReportCaseV1?: Maybe<SendReportCaseV1>;
  status: MutationStatus;
};

export type SendReportCaseV1ProcessPaymentInput = {
  paymentAmount: Scalars['Float']['input'];
};

export type SendReportCaseV1RevisionRequest = {
  __typename?: 'SendReportCaseV1RevisionRequest';
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  requestedBy?: Maybe<StaffUser>;
  requestedChanges?: Maybe<SendReportCaseV1RevisionRequestRequestChanges>;
  revisionSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  revisionSummary?: Maybe<Scalars['String']['output']>;
};

export type SendReportCaseV1RevisionRequestInput = {
  requestedChanges?: InputMaybe<SendReportCaseV1RevisionRequestRequestChangesInput>;
  revisionSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  revisionSummary?: InputMaybe<Scalars['String']['input']>;
};

export type SendReportCaseV1RevisionRequestRequestChanges = {
  __typename?: 'SendReportCaseV1RevisionRequestRequestChanges';
  requestUpdatedDestination?: Maybe<Scalars['Boolean']['output']>;
};

export type SendReportCaseV1RevisionRequestRequestChangesInput = {
  requestUpdatedDestination?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SendReportCaseV1Search = {
  __typename?: 'SendReportCaseV1Search';
  hash?: Maybe<Scalars['String']['output']>;
  indexedAt?: Maybe<Scalars['DateTime']['output']>;
  indexingFailedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1StateInput = {
  newState?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type SendReportCaseV1UpdateInput = {
  activityLog?: InputMaybe<Array<InputMaybe<SendReportCaseV1ActivityLogInput>>>;
  adhocPayment?: InputMaybe<SendReportCaseV1AdhocPaymentRequestInput>;
  archiveEligibleAt?: InputMaybe<Scalars['DateTime']['input']>;
  assets?: InputMaybe<SendReportCaseV1AssetsInput>;
  caseDetails?: InputMaybe<SendReportCaseV1CaseDetailsInput>;
  caseFlagged?: InputMaybe<Array<InputMaybe<SendReportCaseV1CaseFlaggedInput>>>;
  caseName?: InputMaybe<Scalars['String']['input']>;
  caseType?: InputMaybe<Scalars['String']['input']>;
  expirationEligibleAt?: InputMaybe<Scalars['DateTime']['input']>;
  financeDetails?: InputMaybe<SendReportCaseV1FinanceDetailsInput>;
  id: Scalars['ObjectID']['input'];
  messages?: InputMaybe<Array<InputMaybe<SendReportCaseV1MessageInput>>>;
  payment?: InputMaybe<SendReportCaseV1ProcessPaymentInput>;
  purgeEligibleAt?: InputMaybe<Scalars['DateTime']['input']>;
  revisionRequest?: InputMaybe<SendReportCaseV1RevisionRequestInput>;
  state?: InputMaybe<SendReportCaseV1StateInput>;
  systemTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StaffRole = MongoBase & {
  __typename?: 'StaffRole';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  isDefault: Scalars['Boolean']['output'];
  permissions: StaffRolePermissions;
  roleName: Scalars['String']['output'];
  roleSubtype: Scalars['String']['output'];
  roleType?: Maybe<Scalars['String']['output']>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StaffRoleApplicantUserPermissions = {
  __typename?: 'StaffRoleApplicantUserPermissions';
  canAddOrRemoveTags: Scalars['Boolean']['output'];
  canBlockAccess: Scalars['Boolean']['output'];
  canSearchApplicants: Scalars['Boolean']['output'];
  canUpdatePersonalInformation: Scalars['Boolean']['output'];
};

export type StaffRoleApplicantUserPermissionsInput = {
  canAddOrRemoveTags?: InputMaybe<Scalars['Boolean']['input']>;
  canBlockAccess?: InputMaybe<Scalars['Boolean']['input']>;
  canSearchApplicants?: InputMaybe<Scalars['Boolean']['input']>;
  canUpdatePersonalInformation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StaffRoleCreateInput = {
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<StaffRolePermissionsInput>;
  roleName?: InputMaybe<Scalars['String']['input']>;
  roleSubtype?: InputMaybe<Scalars['String']['input']>;
};

export type StaffRoleCredCasePermissions = {
  __typename?: 'StaffRoleCredCasePermissions';
  canAssignCaseWorker: Scalars['Boolean']['output'];
  canAssignSelf: Scalars['Boolean']['output'];
  canBeAssignedCases: Scalars['Boolean']['output'];
  canIssueRefunds: Scalars['Boolean']['output'];
  canOverrideCaseState: Scalars['Boolean']['output'];
  canReopenCases: Scalars['Boolean']['output'];
  canSearchCases: Scalars['Boolean']['output'];
  canUnassignCaseWorker: Scalars['Boolean']['output'];
  canUnassignSelf: Scalars['Boolean']['output'];
  canViewCaseHistory: Scalars['Boolean']['output'];
  canViewCasesAssignedToOthers: Scalars['Boolean']['output'];
  canViewUnassignedCases: Scalars['Boolean']['output'];
};

export type StaffRoleCredCasePermissionsInput = {
  canAssignCaseWorker?: InputMaybe<Scalars['Boolean']['input']>;
  canAssignSelf?: InputMaybe<Scalars['Boolean']['input']>;
  canBeAssignedCases?: InputMaybe<Scalars['Boolean']['input']>;
  canIssueRefunds?: InputMaybe<Scalars['Boolean']['input']>;
  canOverrideCaseState?: InputMaybe<Scalars['Boolean']['input']>;
  canReopenCases?: InputMaybe<Scalars['Boolean']['input']>;
  canSearchCases?: InputMaybe<Scalars['Boolean']['input']>;
  canUnassignCaseWorker?: InputMaybe<Scalars['Boolean']['input']>;
  canUnassignSelf?: InputMaybe<Scalars['Boolean']['input']>;
  canViewCaseHistory?: InputMaybe<Scalars['Boolean']['input']>;
  canViewCasesAssignedToOthers?: InputMaybe<Scalars['Boolean']['input']>;
  canViewUnassignedCases?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StaffRoleEntityPermissions = {
  __typename?: 'StaffRoleEntityPermissions';
  canAddEntities: Scalars['Boolean']['output'];
  canDeleteEntities: Scalars['Boolean']['output'];
  canEditEntities: Scalars['Boolean']['output'];
  canSearchEntities: Scalars['Boolean']['output'];
};

export type StaffRoleEntityPermissionsInput = {
  canAddEntities?: InputMaybe<Scalars['Boolean']['input']>;
  canDeleteEntities?: InputMaybe<Scalars['Boolean']['input']>;
  canEditEntities?: InputMaybe<Scalars['Boolean']['input']>;
  canSearchEntities?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StaffRoleIdCasePermissions = {
  __typename?: 'StaffRoleIdCasePermissions';
  canAssignCaseWorker: Scalars['Boolean']['output'];
  canAssignSelf: Scalars['Boolean']['output'];
  canBeAssignedCases: Scalars['Boolean']['output'];
  canIssueRefunds: Scalars['Boolean']['output'];
  canOverrideCaseState: Scalars['Boolean']['output'];
  canReopenCases: Scalars['Boolean']['output'];
  canSearchCases: Scalars['Boolean']['output'];
  canUnassignCaseWorker: Scalars['Boolean']['output'];
  canUnassignSelf: Scalars['Boolean']['output'];
  canViewCaseHistory: Scalars['Boolean']['output'];
  canViewCasesAssignedToOthers: Scalars['Boolean']['output'];
  canViewUnassignedCases: Scalars['Boolean']['output'];
};

export type StaffRoleIdCasePermissionsInput = {
  canAssignCaseWorker?: InputMaybe<Scalars['Boolean']['input']>;
  canAssignSelf?: InputMaybe<Scalars['Boolean']['input']>;
  canBeAssignedCases?: InputMaybe<Scalars['Boolean']['input']>;
  canIssueRefunds?: InputMaybe<Scalars['Boolean']['input']>;
  canOverrideCaseState?: InputMaybe<Scalars['Boolean']['input']>;
  canReopenCases?: InputMaybe<Scalars['Boolean']['input']>;
  canSearchCases?: InputMaybe<Scalars['Boolean']['input']>;
  canUnassignCaseWorker?: InputMaybe<Scalars['Boolean']['input']>;
  canUnassignSelf?: InputMaybe<Scalars['Boolean']['input']>;
  canViewCaseHistory?: InputMaybe<Scalars['Boolean']['input']>;
  canViewCasesAssignedToOthers?: InputMaybe<Scalars['Boolean']['input']>;
  canViewUnassignedCases?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StaffRoleMutationResult = MutationResult & {
  __typename?: 'StaffRoleMutationResult';
  staffRole?: Maybe<StaffRole>;
  status: MutationStatus;
};

export type StaffRolePermissions = {
  __typename?: 'StaffRolePermissions';
  applicantUserPermissions: StaffRoleApplicantUserPermissions;
  credCasePermissions: StaffRoleCredCasePermissions;
  entityPermissions: StaffRoleEntityPermissions;
  idCasePermissions: StaffRoleIdCasePermissions;
  rolePermissions: StaffRoleRolePermissions;
  sendCasePermissions: StaffRoleSendCasePermissions;
  staffUserPermissions: StaffRoleStaffUserPermissions;
};

export type StaffRolePermissionsInput = {
  applicantUserPermissions?: InputMaybe<StaffRoleApplicantUserPermissionsInput>;
  credCasePermissions?: InputMaybe<StaffRoleCredCasePermissionsInput>;
  entityPermissions?: InputMaybe<StaffRoleEntityPermissionsInput>;
  idCasePermissions?: InputMaybe<StaffRoleIdCasePermissionsInput>;
  rolePermissions?: InputMaybe<StaffRoleRolePermissionsInput>;
  sendCasePermissions?: InputMaybe<StaffRoleSendCasePermissionsInput>;
  staffUserPermissions?: InputMaybe<StaffRoleStaffUserPermissionsInput>;
};

export type StaffRoleRolePermissions = {
  __typename?: 'StaffRoleRolePermissions';
  canAddRoles: Scalars['Boolean']['output'];
  canEditRoles: Scalars['Boolean']['output'];
  canSearchRoles: Scalars['Boolean']['output'];
};

export type StaffRoleRolePermissionsInput = {
  canAddRoles?: InputMaybe<Scalars['Boolean']['input']>;
  canEditRoles?: InputMaybe<Scalars['Boolean']['input']>;
  canSearchRoles?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StaffRoleSendCasePermissions = {
  __typename?: 'StaffRoleSendCasePermissions';
  canAssignCaseWorker: Scalars['Boolean']['output'];
  canAssignSelf: Scalars['Boolean']['output'];
  canBeAssignedCases: Scalars['Boolean']['output'];
  canIssueRefunds: Scalars['Boolean']['output'];
  canOverrideCaseState: Scalars['Boolean']['output'];
  canReopenCases: Scalars['Boolean']['output'];
  canSearchCases: Scalars['Boolean']['output'];
  canUnassignCaseWorker: Scalars['Boolean']['output'];
  canUnassignSelf: Scalars['Boolean']['output'];
  canViewCaseHistory: Scalars['Boolean']['output'];
  canViewCasesAssignedToOthers: Scalars['Boolean']['output'];
  canViewUnassignedCases: Scalars['Boolean']['output'];
};

export type StaffRoleSendCasePermissionsInput = {
  canAssignCaseWorker?: InputMaybe<Scalars['Boolean']['input']>;
  canAssignSelf?: InputMaybe<Scalars['Boolean']['input']>;
  canBeAssignedCases?: InputMaybe<Scalars['Boolean']['input']>;
  canIssueRefunds?: InputMaybe<Scalars['Boolean']['input']>;
  canOverrideCaseState?: InputMaybe<Scalars['Boolean']['input']>;
  canReopenCases?: InputMaybe<Scalars['Boolean']['input']>;
  canSearchCases?: InputMaybe<Scalars['Boolean']['input']>;
  canUnassignCaseWorker?: InputMaybe<Scalars['Boolean']['input']>;
  canUnassignSelf?: InputMaybe<Scalars['Boolean']['input']>;
  canViewCaseHistory?: InputMaybe<Scalars['Boolean']['input']>;
  canViewCasesAssignedToOthers?: InputMaybe<Scalars['Boolean']['input']>;
  canViewUnassignedCases?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StaffRoleStaffUserPermissions = {
  __typename?: 'StaffRoleStaffUserPermissions';
  canAddOrRemoveTags: Scalars['Boolean']['output'];
  canAssignRoles: Scalars['Boolean']['output'];
  canBlockAccess: Scalars['Boolean']['output'];
  canSearchStaff: Scalars['Boolean']['output'];
};

export type StaffRoleStaffUserPermissionsInput = {
  canAddOrRemoveTags?: InputMaybe<Scalars['Boolean']['input']>;
  canAssignRoles?: InputMaybe<Scalars['Boolean']['input']>;
  canBlockAccess?: InputMaybe<Scalars['Boolean']['input']>;
  canSearchStaff?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StaffRoleUpdateInput = {
  id: Scalars['ObjectID']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<StaffRolePermissionsInput>;
  roleName?: InputMaybe<Scalars['String']['input']>;
  roleSubtype?: InputMaybe<Scalars['String']['input']>;
};

export type StaffUser = MongoBase & {
  __typename?: 'StaffUser';
  accessBlocked?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  role?: Maybe<StaffRole>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  search?: Maybe<StaffUserSearch>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
};

export type StaffUserDeleteInput = {
  id: Scalars['ObjectID']['input'];
};

export type StaffUserIdentityDetailsResult = {
  __typename?: 'StaffUserIdentityDetailsResult';
  firstName?: Maybe<Scalars['String']['output']>;
  restOfName?: Maybe<Scalars['String']['output']>;
};

export type StaffUserMutationResult = MutationResult & {
  __typename?: 'StaffUserMutationResult';
  staffUser?: Maybe<StaffUser>;
  status: MutationStatus;
};

export type StaffUserResult = {
  __typename?: 'StaffUserResult';
  accessBlocked?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ObjectID']['output']>;
  identityDetails?: Maybe<StaffUserIdentityDetailsResult>;
  role?: Maybe<StaffUserSearchRoleResult>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
};

export type StaffUserSearch = {
  __typename?: 'StaffUserSearch';
  hash?: Maybe<Scalars['String']['output']>;
  indexedAt?: Maybe<Scalars['Date']['output']>;
  indexingFailedAt?: Maybe<Scalars['Date']['output']>;
};

export type StaffUserSearchFacets = {
  __typename?: 'StaffUserSearchFacets';
  accessBlocked?: Maybe<Array<Maybe<FacetDetail>>>;
  createdAt?: Maybe<Array<Maybe<FacetDetail>>>;
  role?: Maybe<Array<Maybe<FacetDetail>>>;
  schemaVersion?: Maybe<Array<Maybe<FacetDetail>>>;
  tags?: Maybe<Array<Maybe<FacetDetail>>>;
  updatedAt?: Maybe<Array<Maybe<FacetDetail>>>;
};

export type StaffUserSearchFilterDetail = {
  accessBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schemaVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StaffUserSearchInput = {
  options?: InputMaybe<StaffUserSearchOptions>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};

export type StaffUserSearchOptions = {
  filter?: InputMaybe<StaffUserSearchFilterDetail>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  top?: InputMaybe<Scalars['Int']['input']>;
};

export type StaffUserSearchResult = {
  __typename?: 'StaffUserSearchResult';
  count?: Maybe<Scalars['Int']['output']>;
  facets?: Maybe<StaffUserSearchFacets>;
  staffUserResults?: Maybe<Array<Maybe<StaffUserResult>>>;
};

export type StaffUserSearchRoleResult = {
  __typename?: 'StaffUserSearchRoleResult';
  id?: Maybe<Scalars['ObjectID']['output']>;
  roleName?: Maybe<Scalars['String']['output']>;
};

export type StaffUserUpdateInput = {
  accessBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ObjectID']['input'];
  role?: InputMaybe<Scalars['ObjectID']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type User = MongoBase & {
  __typename?: 'User';
  accessBlocked?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  schemaVersion?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
};

export type UserData = {
  __typename?: 'UserData';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type UserReIndexResult = {
  __typename?: 'UserReIndexResult';
  applicantUserReIndexErrors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  staffUserReIndexErrors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type VerifiedCredentialVerificationCaseSummary = {
  __typename?: 'VerifiedCredentialVerificationCaseSummary';
  caseDetails: VerifiedCredentialVerificationCaseSummaryCaseDetails;
  id: Scalars['ObjectID']['output'];
};

export type VerifiedCredentialVerificationCaseSummaryCaseDetails = {
  __typename?: 'VerifiedCredentialVerificationCaseSummaryCaseDetails';
  application: VerifiedCredentialVerificationCaseSummaryCaseDetailsApplication;
};

export type VerifiedCredentialVerificationCaseSummaryCaseDetailsApplication = {
  __typename?: 'VerifiedCredentialVerificationCaseSummaryCaseDetailsApplication';
  credentialTitle: Scalars['String']['output'];
  issuingInstitutionName: Scalars['String']['output'];
};

export type ApplicantCasesActiveCaseListContainerIdentityVerificationCasesV1ByApplicantQueryQueryVariables = Exact<{
  applicantId: Scalars['ObjectID']['input'];
}>;

export type ApplicantCasesActiveCaseListContainerIdentityVerificationCasesV1ByApplicantQueryQuery = {
  __typename?: 'Query';
  identityVerificationCasesV1ByApplicant?: Array<{
    __typename?: 'IdentityVerificationCaseV1';
    caseName: string;
    caseType?: string | null;
    schemaVersion?: string | null;
    state: string;
    id: any;
    lastActivityAt?: any | null;
  } | null> | null;
};

export type ApplicantCasesActiveCaseListContainerCredentialVerificationCasesV1ByApplicantQueryQueryVariables = Exact<{
  applicantId: Scalars['ObjectID']['input'];
}>;

export type ApplicantCasesActiveCaseListContainerCredentialVerificationCasesV1ByApplicantQueryQuery = {
  __typename?: 'Query';
  credentialVerificationCasesV1ByApplicant?: Array<{
    __typename?: 'CredentialVerificationCaseV1';
    caseName?: string | null;
    caseType?: string | null;
    schemaVersion?: string | null;
    state: string;
    id: any;
    lastActivityAt?: any | null;
  } | null> | null;
};

export type ApplicantCasesActiveCaseListContainerSendReportCasesV1ByApplicantQueryQueryVariables = Exact<{
  applicantId: Scalars['ObjectID']['input'];
}>;

export type ApplicantCasesActiveCaseListContainerSendReportCasesV1ByApplicantQueryQuery = {
  __typename?: 'Query';
  sendReportCasesV1ByApplicant?: Array<{
    __typename?: 'SendReportCaseV1';
    caseName?: string | null;
    caseType?: string | null;
    schemaVersion?: string | null;
    state: string;
    id: any;
    lastActivityAt?: any | null;
  } | null> | null;
};

export type ApplicantCasesActiveCaseListContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  caseName: string;
  caseType?: string | null;
  schemaVersion?: string | null;
  state: string;
  id: any;
  lastActivityAt?: any | null;
};

export type ApplicantCasesActiveCaseListContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  caseName?: string | null;
  caseType?: string | null;
  schemaVersion?: string | null;
  state: string;
  id: any;
  lastActivityAt?: any | null;
};

export type ApplicantCasesActiveCaseListContainerSendReportCaseV1FieldsFragment = {
  __typename?: 'SendReportCaseV1';
  caseName?: string | null;
  caseType?: string | null;
  schemaVersion?: string | null;
  state: string;
  id: any;
  lastActivityAt?: any | null;
};

export type ApplicantArchivedCaseListContainerArchivedCasesByApplicantIdQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type ApplicantArchivedCaseListContainerArchivedCasesByApplicantIdQuery = {
  __typename?: 'Query';
  archivedCasesByApplicantId?: Array<{ __typename?: 'ArchivedCaseSummary'; caseName: string; caseType: string; state: string; archivedAt: any; id: any } | null> | null;
};

export type ApplicantArchivedCaseLisContainerArchivedCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedCaseSummary';
  caseName: string;
  caseType: string;
  state: string;
  archivedAt: any;
  id: any;
};

export type ApplicantCasesCredentialVerificationArchiveSummaryContainerArchivedCredentialVerificationCaseSummaryQueryVariables = Exact<{
  archivedCredentialVerificationCaseSummaryId: Scalars['ObjectID']['input'];
}>;

export type ApplicantCasesCredentialVerificationArchiveSummaryContainerArchivedCredentialVerificationCaseSummaryQuery = {
  __typename?: 'Query';
  archivedCredentialVerificationCaseSummary?: {
    __typename?: 'ArchivedCredentialVerificationCaseSummary';
    submittedAt: any;
    archivedAt: any;
    lastActivityAt: any;
    state: string;
    id: any;
    createdAt: any;
    applicant: { __typename?: 'ApplicantUser'; id: any };
    caseDetails: {
      __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetails';
      applicationReview: {
        __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReview';
        decision: { __typename?: 'ArchivedCaseSummaryDecision'; completedAt?: any | null; result?: string | null };
      };
      application: {
        __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplication';
        credentialType: string;
        issuingInstitutionName?: string | null;
        credentialTitle: string;
        nameOnCredential: string;
        dateCredentialIssuedAt: any;
        sendDestinationName: string;
        program?: string | null;
      };
    };
    financeDetails: {
      __typename?: 'ArchivedCaseSummaryFinanceDetails';
      transactions?: {
        __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactions';
        adhocTransactions?: Array<{
          __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
          amount?: number | null;
          reason?: string | null;
          transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null } | null;
        } | null> | null;
        submission?: {
          __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission';
          amount?: number | null;
          transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null } | null;
        } | null;
      } | null;
    };
    files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
  } | null;
};

export type ApplicantCasesCredentialVerificationArchiveSummaryContainerApplicantUserQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type ApplicantCasesCredentialVerificationArchiveSummaryContainerApplicantUserQuery = {
  __typename?: 'Query';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    createdAt?: any | null;
    displayName?: string | null;
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      professional?: {
        __typename?: 'ApplicantUserProfessional';
        primaryEducationalInformation?: Array<{ __typename?: 'ApplicantUserPrimaryEducationalInformation'; attendanceStartedAt?: any | null; id: any } | null> | null;
      } | null;
    } | null;
    termsAndConditions?: Array<{
      __typename?: 'ApplicantUserTermsAndCondition';
      id: any;
      acceptanceOf?: string | null;
      attestedAt?: any | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      version?: number | null;
    } | null> | null;
  } | null;
};

export type ApplicantCasesCredentialVerificationArchiveSummaryContainerArchivedCredentialVerificationCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedCredentialVerificationCaseSummary';
  submittedAt: any;
  archivedAt: any;
  lastActivityAt: any;
  state: string;
  id: any;
  createdAt: any;
  applicant: { __typename?: 'ApplicantUser'; id: any };
  caseDetails: {
    __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetails';
    applicationReview: {
      __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReview';
      decision: { __typename?: 'ArchivedCaseSummaryDecision'; completedAt?: any | null; result?: string | null };
    };
    application: {
      __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplication';
      credentialType: string;
      issuingInstitutionName?: string | null;
      credentialTitle: string;
      nameOnCredential: string;
      dateCredentialIssuedAt: any;
      sendDestinationName: string;
      program?: string | null;
    };
  };
  financeDetails: {
    __typename?: 'ArchivedCaseSummaryFinanceDetails';
    transactions?: {
      __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactions';
      adhocTransactions?: Array<{
        __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
        amount?: number | null;
        reason?: string | null;
        transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null } | null;
      } | null> | null;
      submission?: {
        __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission';
        amount?: number | null;
        transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null } | null;
      } | null;
    } | null;
  };
  files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
};

export type ApplicantCasesCredentialVerificationArchiveSummaryContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  createdAt?: any | null;
  displayName?: string | null;
  id: any;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    professional?: {
      __typename?: 'ApplicantUserProfessional';
      primaryEducationalInformation?: Array<{ __typename?: 'ApplicantUserPrimaryEducationalInformation'; attendanceStartedAt?: any | null; id: any } | null> | null;
    } | null;
  } | null;
  termsAndConditions?: Array<{
    __typename?: 'ApplicantUserTermsAndCondition';
    id: any;
    acceptanceOf?: string | null;
    attestedAt?: any | null;
    createdAt?: any | null;
    updatedAt?: any | null;
    version?: number | null;
  } | null> | null;
};

export type CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    caseName?: string | null;
    submittedAt?: any | null;
    id: any;
    lastActivityAt?: any | null;
    applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
    caseDetails?: {
      __typename?: 'CredentialVerificationCaseV1CaseDetails';
      application?: {
        __typename?: 'CredentialVerificationCaseV1Application';
        nameOnCredential?: string | null;
        isCredentialInEnglish?: boolean | null;
        isNameOnCredentialMatchPassport?: boolean | null;
        credentialType?: string | null;
        credentialTitle?: string | null;
        dateCredentialIssuedAt?: any | null;
        program?: string | null;
        otherIssuingInstitution?: {
          __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution';
          addressLine1?: string | null;
          addressLine2?: string | null;
          city?: string | null;
          country?: string | null;
          institutionName?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        issuingInstitution?: {
          __typename?: 'Entity';
          entityName?: string | null;
          isIssuingInstitution?: boolean | null;
          isClient?: boolean | null;
          id: any;
          issuingInstitution?: {
            __typename?: 'EntityIssuingInstitution';
            address?: {
              __typename?: 'EntityAddressInfo';
              addressLine1?: string | null;
              addressLine2?: string | null;
              city?: string | null;
              country?: string | null;
              stateOrProvince?: string | null;
              zipOrPostalCode?: string | null;
            } | null;
          } | null;
        } | null;
        sendDestination?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
        credentialAssets?: { __typename?: 'CredentialVerificationCaseV1CredentialAssets'; credential?: string | null; translation?: string | null } | null;
      } | null;
      applicationReview?: {
        __typename?: 'CredentialVerificationCaseV1ApplicationReview';
        decision?: {
          __typename?: 'CredentialVerificationCaseV1ApplicationReviewDecision';
          completedAt?: any | null;
          result?: string | null;
          rejectionReason?: string | null;
        } | null;
      } | null;
    } | null;
    revisionRequest?: {
      __typename?: 'CredentialVerificationCaseV1RevisionRequest';
      requestedChanges?: {
        __typename?: 'CredentialVerificationCaseV1RequestedChanges';
        requestUpdatedCredentialDetails?: boolean | null;
        requestUpdatedIssuingInstitution?: boolean | null;
        requestUploadCredential?: boolean | null;
        requestUploadTranslation?: boolean | null;
      } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1CaseDetailsApplicationContainerEntitiesQueryVariables = Exact<{ [key: string]: never }>;

export type CasesCredentialVerificationV1CaseDetailsApplicationContainerEntitiesQuery = {
  __typename?: 'Query';
  entities?: Array<{
    __typename?: 'Entity';
    entityName?: string | null;
    isIssuingInstitution?: boolean | null;
    isClient?: boolean | null;
    id: any;
    issuingInstitution?: {
      __typename?: 'EntityIssuingInstitution';
      address?: {
        __typename?: 'EntityAddressInfo';
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
    } | null;
  } | null> | null;
};

export type CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1UpdateMutationVariables = Exact<{
  input: CredentialVerificationCaseV1UpdateInput;
}>;

export type CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1Update?: {
    __typename?: 'CredentialVerificationCaseV1MutationResult';
    credentialVerificationCaseV1?: {
      __typename?: 'CredentialVerificationCaseV1';
      caseName?: string | null;
      submittedAt?: any | null;
      id: any;
      lastActivityAt?: any | null;
      applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
      caseDetails?: {
        __typename?: 'CredentialVerificationCaseV1CaseDetails';
        application?: {
          __typename?: 'CredentialVerificationCaseV1Application';
          nameOnCredential?: string | null;
          isCredentialInEnglish?: boolean | null;
          isNameOnCredentialMatchPassport?: boolean | null;
          credentialType?: string | null;
          credentialTitle?: string | null;
          dateCredentialIssuedAt?: any | null;
          program?: string | null;
          otherIssuingInstitution?: {
            __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution';
            addressLine1?: string | null;
            addressLine2?: string | null;
            city?: string | null;
            country?: string | null;
            institutionName?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
          issuingInstitution?: {
            __typename?: 'Entity';
            entityName?: string | null;
            isIssuingInstitution?: boolean | null;
            isClient?: boolean | null;
            id: any;
            issuingInstitution?: {
              __typename?: 'EntityIssuingInstitution';
              address?: {
                __typename?: 'EntityAddressInfo';
                addressLine1?: string | null;
                addressLine2?: string | null;
                city?: string | null;
                country?: string | null;
                stateOrProvince?: string | null;
                zipOrPostalCode?: string | null;
              } | null;
            } | null;
          } | null;
          sendDestination?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
          credentialAssets?: { __typename?: 'CredentialVerificationCaseV1CredentialAssets'; credential?: string | null; translation?: string | null } | null;
        } | null;
        applicationReview?: {
          __typename?: 'CredentialVerificationCaseV1ApplicationReview';
          decision?: {
            __typename?: 'CredentialVerificationCaseV1ApplicationReviewDecision';
            completedAt?: any | null;
            result?: string | null;
            rejectionReason?: string | null;
          } | null;
        } | null;
      } | null;
      revisionRequest?: {
        __typename?: 'CredentialVerificationCaseV1RevisionRequest';
        requestedChanges?: {
          __typename?: 'CredentialVerificationCaseV1RequestedChanges';
          requestUpdatedCredentialDetails?: boolean | null;
          requestUpdatedIssuingInstitution?: boolean | null;
          requestUploadCredential?: boolean | null;
          requestUploadTranslation?: boolean | null;
        } | null;
      } | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  } | null;
};

export type CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  caseName?: string | null;
  submittedAt?: any | null;
  id: any;
  lastActivityAt?: any | null;
  applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
  caseDetails?: {
    __typename?: 'CredentialVerificationCaseV1CaseDetails';
    application?: {
      __typename?: 'CredentialVerificationCaseV1Application';
      nameOnCredential?: string | null;
      isCredentialInEnglish?: boolean | null;
      isNameOnCredentialMatchPassport?: boolean | null;
      credentialType?: string | null;
      credentialTitle?: string | null;
      dateCredentialIssuedAt?: any | null;
      program?: string | null;
      otherIssuingInstitution?: {
        __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution';
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        country?: string | null;
        institutionName?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
      issuingInstitution?: {
        __typename?: 'Entity';
        entityName?: string | null;
        isIssuingInstitution?: boolean | null;
        isClient?: boolean | null;
        id: any;
        issuingInstitution?: {
          __typename?: 'EntityIssuingInstitution';
          address?: {
            __typename?: 'EntityAddressInfo';
            addressLine1?: string | null;
            addressLine2?: string | null;
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
        } | null;
      } | null;
      sendDestination?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
      credentialAssets?: { __typename?: 'CredentialVerificationCaseV1CredentialAssets'; credential?: string | null; translation?: string | null } | null;
    } | null;
    applicationReview?: {
      __typename?: 'CredentialVerificationCaseV1ApplicationReview';
      decision?: {
        __typename?: 'CredentialVerificationCaseV1ApplicationReviewDecision';
        completedAt?: any | null;
        result?: string | null;
        rejectionReason?: string | null;
      } | null;
    } | null;
  } | null;
  revisionRequest?: {
    __typename?: 'CredentialVerificationCaseV1RevisionRequest';
    requestedChanges?: {
      __typename?: 'CredentialVerificationCaseV1RequestedChanges';
      requestUpdatedCredentialDetails?: boolean | null;
      requestUpdatedIssuingInstitution?: boolean | null;
      requestUploadCredential?: boolean | null;
      requestUploadTranslation?: boolean | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1CaseDetailsApplicationContainerApplicantUserFieldsFragment = { __typename?: 'ApplicantUser'; displayName?: string | null; id: any };

export type CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CaseDetailsFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1CaseDetails';
  application?: {
    __typename?: 'CredentialVerificationCaseV1Application';
    nameOnCredential?: string | null;
    isCredentialInEnglish?: boolean | null;
    isNameOnCredentialMatchPassport?: boolean | null;
    credentialType?: string | null;
    credentialTitle?: string | null;
    dateCredentialIssuedAt?: any | null;
    program?: string | null;
    otherIssuingInstitution?: {
      __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution';
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      country?: string | null;
      institutionName?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
    issuingInstitution?: {
      __typename?: 'Entity';
      entityName?: string | null;
      isIssuingInstitution?: boolean | null;
      isClient?: boolean | null;
      id: any;
      issuingInstitution?: {
        __typename?: 'EntityIssuingInstitution';
        address?: {
          __typename?: 'EntityAddressInfo';
          addressLine1?: string | null;
          addressLine2?: string | null;
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
      } | null;
    } | null;
    sendDestination?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
    credentialAssets?: { __typename?: 'CredentialVerificationCaseV1CredentialAssets'; credential?: string | null; translation?: string | null } | null;
  } | null;
  applicationReview?: {
    __typename?: 'CredentialVerificationCaseV1ApplicationReview';
    decision?: {
      __typename?: 'CredentialVerificationCaseV1ApplicationReviewDecision';
      completedAt?: any | null;
      result?: string | null;
      rejectionReason?: string | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RevisionRequestFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1RevisionRequest';
  requestedChanges?: {
    __typename?: 'CredentialVerificationCaseV1RequestedChanges';
    requestUpdatedCredentialDetails?: boolean | null;
    requestUpdatedIssuingInstitution?: boolean | null;
    requestUploadCredential?: boolean | null;
    requestUploadTranslation?: boolean | null;
  } | null;
};

export type CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1Application';
  nameOnCredential?: string | null;
  isCredentialInEnglish?: boolean | null;
  isNameOnCredentialMatchPassport?: boolean | null;
  credentialType?: string | null;
  credentialTitle?: string | null;
  dateCredentialIssuedAt?: any | null;
  program?: string | null;
  otherIssuingInstitution?: {
    __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution';
    addressLine1?: string | null;
    addressLine2?: string | null;
    city?: string | null;
    country?: string | null;
    institutionName?: string | null;
    stateOrProvince?: string | null;
    zipOrPostalCode?: string | null;
  } | null;
  issuingInstitution?: {
    __typename?: 'Entity';
    entityName?: string | null;
    isIssuingInstitution?: boolean | null;
    isClient?: boolean | null;
    id: any;
    issuingInstitution?: {
      __typename?: 'EntityIssuingInstitution';
      address?: {
        __typename?: 'EntityAddressInfo';
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
    } | null;
  } | null;
  sendDestination?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
  credentialAssets?: { __typename?: 'CredentialVerificationCaseV1CredentialAssets'; credential?: string | null; translation?: string | null } | null;
};

export type CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CredentialAssetsFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1CredentialAssets';
  credential?: string | null;
  translation?: string | null;
};

export type CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1ApplicationReview';
  decision?: {
    __typename?: 'CredentialVerificationCaseV1ApplicationReviewDecision';
    completedAt?: any | null;
    result?: string | null;
    rejectionReason?: string | null;
  } | null;
};

export type CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RequestedChangesFragment = {
  __typename?: 'CredentialVerificationCaseV1RequestedChanges';
  requestUpdatedCredentialDetails?: boolean | null;
  requestUpdatedIssuingInstitution?: boolean | null;
  requestUploadCredential?: boolean | null;
  requestUploadTranslation?: boolean | null;
};

export type CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution';
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  country?: string | null;
  institutionName?: string | null;
  stateOrProvince?: string | null;
  zipOrPostalCode?: string | null;
};

export type CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityFieldsFragment = {
  __typename?: 'Entity';
  entityName?: string | null;
  isIssuingInstitution?: boolean | null;
  isClient?: boolean | null;
  id: any;
  issuingInstitution?: {
    __typename?: 'EntityIssuingInstitution';
    address?: {
      __typename?: 'EntityAddressInfo';
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1ApplicationReviewDecision';
  completedAt?: any | null;
  result?: string | null;
  rejectionReason?: string | null;
};

export type CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityAddressInfoFieldsFragment = {
  __typename?: 'EntityIssuingInstitution';
  address?: {
    __typename?: 'EntityAddressInfo';
    addressLine1?: string | null;
    addressLine2?: string | null;
    city?: string | null;
    country?: string | null;
    stateOrProvince?: string | null;
    zipOrPostalCode?: string | null;
  } | null;
};

export type CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1MutationResultFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1MutationResult';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    caseName?: string | null;
    submittedAt?: any | null;
    id: any;
    lastActivityAt?: any | null;
    applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
    caseDetails?: {
      __typename?: 'CredentialVerificationCaseV1CaseDetails';
      application?: {
        __typename?: 'CredentialVerificationCaseV1Application';
        nameOnCredential?: string | null;
        isCredentialInEnglish?: boolean | null;
        isNameOnCredentialMatchPassport?: boolean | null;
        credentialType?: string | null;
        credentialTitle?: string | null;
        dateCredentialIssuedAt?: any | null;
        program?: string | null;
        otherIssuingInstitution?: {
          __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution';
          addressLine1?: string | null;
          addressLine2?: string | null;
          city?: string | null;
          country?: string | null;
          institutionName?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        issuingInstitution?: {
          __typename?: 'Entity';
          entityName?: string | null;
          isIssuingInstitution?: boolean | null;
          isClient?: boolean | null;
          id: any;
          issuingInstitution?: {
            __typename?: 'EntityIssuingInstitution';
            address?: {
              __typename?: 'EntityAddressInfo';
              addressLine1?: string | null;
              addressLine2?: string | null;
              city?: string | null;
              country?: string | null;
              stateOrProvince?: string | null;
              zipOrPostalCode?: string | null;
            } | null;
          } | null;
        } | null;
        sendDestination?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
        credentialAssets?: { __typename?: 'CredentialVerificationCaseV1CredentialAssets'; credential?: string | null; translation?: string | null } | null;
      } | null;
      applicationReview?: {
        __typename?: 'CredentialVerificationCaseV1ApplicationReview';
        decision?: {
          __typename?: 'CredentialVerificationCaseV1ApplicationReviewDecision';
          completedAt?: any | null;
          result?: string | null;
          rejectionReason?: string | null;
        } | null;
      } | null;
    } | null;
    revisionRequest?: {
      __typename?: 'CredentialVerificationCaseV1RevisionRequest';
      requestedChanges?: {
        __typename?: 'CredentialVerificationCaseV1RequestedChanges';
        requestUpdatedCredentialDetails?: boolean | null;
        requestUpdatedIssuingInstitution?: boolean | null;
        requestUploadCredential?: boolean | null;
        requestUploadTranslation?: boolean | null;
      } | null;
    } | null;
  } | null;
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
};

export type CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    state: string;
    id: any;
    lastActivityAt?: any | null;
    messages?: Array<{
      __typename?: 'CredentialVerificationCaseV1Message';
      isHiddenFromApplicant?: boolean | null;
      sentBy?: string | null;
      embedding?: string | null;
      message?: string | null;
      id: any;
      createdAt?: any | null;
    } | null> | null;
    revisionRequest?: {
      __typename?: 'CredentialVerificationCaseV1RevisionRequest';
      requestedAt?: any | null;
      requestedChanges?: {
        __typename?: 'CredentialVerificationCaseV1RequestedChanges';
        requestUpdatedCredentialDetails?: boolean | null;
        requestUpdatedIssuingInstitution?: boolean | null;
        requestUploadCredential?: boolean | null;
        requestUploadTranslation?: boolean | null;
      } | null;
    } | null;
    applicant?: {
      __typename?: 'ApplicantUser';
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        identityDetails?: { __typename?: 'ApplicantUserIdentityDetails'; lastName?: string | null; restOfName?: string | null } | null;
      } | null;
    } | null;
    financeDetails?: {
      __typename?: 'CredentialVerificationCaseV1FinanceDetails';
      serviceFee?: number | null;
      transactions?: {
        __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
        adhocTransactions?: Array<{
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions';
          reason?: string | null;
          amount?: number | null;
          status?: string | null;
          id: any;
          createdAt?: any | null;
          transactionReference?: {
            __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
            referenceId?: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1UpdateMutationVariables = Exact<{
  input: CredentialVerificationCaseV1UpdateInput;
}>;

export type CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1Update?: {
    __typename?: 'CredentialVerificationCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    credentialVerificationCaseV1?: {
      __typename?: 'CredentialVerificationCaseV1';
      state: string;
      id: any;
      lastActivityAt?: any | null;
      messages?: Array<{
        __typename?: 'CredentialVerificationCaseV1Message';
        isHiddenFromApplicant?: boolean | null;
        sentBy?: string | null;
        embedding?: string | null;
        message?: string | null;
        id: any;
        createdAt?: any | null;
      } | null> | null;
      revisionRequest?: {
        __typename?: 'CredentialVerificationCaseV1RevisionRequest';
        requestedAt?: any | null;
        requestedChanges?: {
          __typename?: 'CredentialVerificationCaseV1RequestedChanges';
          requestUpdatedCredentialDetails?: boolean | null;
          requestUpdatedIssuingInstitution?: boolean | null;
          requestUploadCredential?: boolean | null;
          requestUploadTranslation?: boolean | null;
        } | null;
      } | null;
      applicant?: {
        __typename?: 'ApplicantUser';
        id: any;
        personalInformation?: {
          __typename?: 'ApplicantUserPersonalInformation';
          identityDetails?: { __typename?: 'ApplicantUserIdentityDetails'; lastName?: string | null; restOfName?: string | null } | null;
        } | null;
      } | null;
      financeDetails?: {
        __typename?: 'CredentialVerificationCaseV1FinanceDetails';
        serviceFee?: number | null;
        transactions?: {
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
          adhocTransactions?: Array<{
            __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions';
            reason?: string | null;
            amount?: number | null;
            status?: string | null;
            id: any;
            createdAt?: any | null;
            transactionReference?: {
              __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
              referenceId?: string | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1MutationResultFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    state: string;
    id: any;
    lastActivityAt?: any | null;
    messages?: Array<{
      __typename?: 'CredentialVerificationCaseV1Message';
      isHiddenFromApplicant?: boolean | null;
      sentBy?: string | null;
      embedding?: string | null;
      message?: string | null;
      id: any;
      createdAt?: any | null;
    } | null> | null;
    revisionRequest?: {
      __typename?: 'CredentialVerificationCaseV1RevisionRequest';
      requestedAt?: any | null;
      requestedChanges?: {
        __typename?: 'CredentialVerificationCaseV1RequestedChanges';
        requestUpdatedCredentialDetails?: boolean | null;
        requestUpdatedIssuingInstitution?: boolean | null;
        requestUploadCredential?: boolean | null;
        requestUploadTranslation?: boolean | null;
      } | null;
    } | null;
    applicant?: {
      __typename?: 'ApplicantUser';
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        identityDetails?: { __typename?: 'ApplicantUserIdentityDetails'; lastName?: string | null; restOfName?: string | null } | null;
      } | null;
    } | null;
    financeDetails?: {
      __typename?: 'CredentialVerificationCaseV1FinanceDetails';
      serviceFee?: number | null;
      transactions?: {
        __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
        adhocTransactions?: Array<{
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions';
          reason?: string | null;
          amount?: number | null;
          status?: string | null;
          id: any;
          createdAt?: any | null;
          transactionReference?: {
            __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
            referenceId?: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  state: string;
  id: any;
  lastActivityAt?: any | null;
  messages?: Array<{
    __typename?: 'CredentialVerificationCaseV1Message';
    isHiddenFromApplicant?: boolean | null;
    sentBy?: string | null;
    embedding?: string | null;
    message?: string | null;
    id: any;
    createdAt?: any | null;
  } | null> | null;
  revisionRequest?: {
    __typename?: 'CredentialVerificationCaseV1RevisionRequest';
    requestedAt?: any | null;
    requestedChanges?: {
      __typename?: 'CredentialVerificationCaseV1RequestedChanges';
      requestUpdatedCredentialDetails?: boolean | null;
      requestUpdatedIssuingInstitution?: boolean | null;
      requestUploadCredential?: boolean | null;
      requestUploadTranslation?: boolean | null;
    } | null;
  } | null;
  applicant?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      identityDetails?: { __typename?: 'ApplicantUserIdentityDetails'; lastName?: string | null; restOfName?: string | null } | null;
    } | null;
  } | null;
  financeDetails?: {
    __typename?: 'CredentialVerificationCaseV1FinanceDetails';
    serviceFee?: number | null;
    transactions?: {
      __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
      adhocTransactions?: Array<{
        __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions';
        reason?: string | null;
        amount?: number | null;
        status?: string | null;
        id: any;
        createdAt?: any | null;
        transactionReference?: {
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
          referenceId?: string | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetails';
  serviceFee?: number | null;
  transactions?: {
    __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
    adhocTransactions?: Array<{
      __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions';
      reason?: string | null;
      amount?: number | null;
      status?: string | null;
      id: any;
      createdAt?: any | null;
      transactionReference?: { __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
    } | null> | null;
  } | null;
};

export type CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
  adhocTransactions?: Array<{
    __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions';
    reason?: string | null;
    amount?: number | null;
    status?: string | null;
    id: any;
    createdAt?: any | null;
    transactionReference?: { __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
  } | null> | null;
};

export type CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions';
  reason?: string | null;
  amount?: number | null;
  status?: string | null;
  id: any;
  createdAt?: any | null;
  transactionReference?: { __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
};

export type CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RevisionRequestFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1RevisionRequest';
  requestedAt?: any | null;
  requestedChanges?: {
    __typename?: 'CredentialVerificationCaseV1RequestedChanges';
    requestUpdatedCredentialDetails?: boolean | null;
    requestUpdatedIssuingInstitution?: boolean | null;
    requestUploadCredential?: boolean | null;
    requestUploadTranslation?: boolean | null;
  } | null;
};

export type CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1MessageFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1Message';
  isHiddenFromApplicant?: boolean | null;
  sentBy?: string | null;
  embedding?: string | null;
  message?: string | null;
  id: any;
  createdAt?: any | null;
};

export type CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RequestedChangesFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1RequestedChanges';
  requestUpdatedCredentialDetails?: boolean | null;
  requestUpdatedIssuingInstitution?: boolean | null;
  requestUploadCredential?: boolean | null;
  requestUploadTranslation?: boolean | null;
};

export type CasesCredentialVerificationV1CaseDetailsMessagesContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  id: any;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    identityDetails?: { __typename?: 'ApplicantUserIdentityDetails'; lastName?: string | null; restOfName?: string | null } | null;
  } | null;
};

export type CasesCredentialVerificationV1CaseDetailsMessagesContainerApplicantUserPaymentInstrumentQueryVariables = Exact<{
  applicantUserId: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationV1CaseDetailsMessagesContainerApplicantUserPaymentInstrumentQuery = {
  __typename?: 'Query';
  applicantUserPaymentInstrument?: {
    __typename?: 'PaymentInstrument';
    cardNumber?: string | null;
    cardType?: string | null;
    expirationMonth?: string | null;
    expirationYear?: string | null;
    paymentInstrumentId?: string | null;
    state?: string | null;
    id?: string | null;
    billTo?: {
      __typename?: 'PaymentBillingInfo';
      billingAddressLine1?: string | null;
      billingAddressLine2?: string | null;
      billingCity?: string | null;
      billingCountry?: string | null;
      billingEmail?: string | null;
      billingFirstName?: string | null;
      billingLastName?: string | null;
      billingPhone?: string | null;
      billingPostalCode?: string | null;
      billingState?: string | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1CaseDetailsMessagesContainerPaymentInstrumentFieldsFragment = {
  __typename?: 'PaymentInstrument';
  cardNumber?: string | null;
  cardType?: string | null;
  expirationMonth?: string | null;
  expirationYear?: string | null;
  paymentInstrumentId?: string | null;
  state?: string | null;
  id?: string | null;
  billTo?: {
    __typename?: 'PaymentBillingInfo';
    billingAddressLine1?: string | null;
    billingAddressLine2?: string | null;
    billingCity?: string | null;
    billingCountry?: string | null;
    billingEmail?: string | null;
    billingFirstName?: string | null;
    billingLastName?: string | null;
    billingPhone?: string | null;
    billingPostalCode?: string | null;
    billingState?: string | null;
  } | null;
};

export type CasesCredentialVerificationV1CaseDetailsMessagesContainerApplicantUserCybersourcePublicKeyIdQueryVariables = Exact<{ [key: string]: never }>;

export type CasesCredentialVerificationV1CaseDetailsMessagesContainerApplicantUserCybersourcePublicKeyIdQuery = {
  __typename?: 'Query';
  applicantUserCybersourcePublicKeyId?: string | null;
};

export type CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    state: string;
    id: any;
    lastActivityAt?: any | null;
    caseDetails?: {
      __typename?: 'CredentialVerificationCaseV1CaseDetails';
      application?: {
        __typename?: 'CredentialVerificationCaseV1Application';
        credentialType?: string | null;
        credentialTitle?: string | null;
        isCredentialInEnglish?: boolean | null;
        isNameOnCredentialMatchPassport?: boolean | null;
        isAttestationComplete?: boolean | null;
        dateCredentialIssuedAt?: any | null;
        program?: string | null;
        nameOnCredential?: string | null;
        credentialAssets?: { __typename?: 'CredentialVerificationCaseV1CredentialAssets'; credential?: string | null; translation?: string | null } | null;
        sendDestination?: { __typename?: 'Entity'; entityName?: string | null; isIssuingInstitution?: boolean | null; isClient?: boolean | null; id: any } | null;
        issuingInstitution?: { __typename?: 'Entity'; id: any } | null;
        otherIssuingInstitution?: {
          __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution';
          addressLine1?: string | null;
          city?: string | null;
          country?: string | null;
          institutionName?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
      } | null;
    } | null;
    financeDetails?: {
      __typename?: 'CredentialVerificationCaseV1FinanceDetails';
      serviceFee?: number | null;
      transactions?: {
        __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
        submission?: {
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmission';
          transactionReference?: { __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference'; status?: string | null } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1LazyQueryQueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1LazyQueryQuery = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    state: string;
    id: any;
    updatedAt?: any | null;
    financeDetails?: {
      __typename?: 'CredentialVerificationCaseV1FinanceDetails';
      transactions?: {
        __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
        submission?: {
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmission';
          transactionReference?: {
            __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference';
            isSuccess?: boolean | null;
            status?: string | null;
            errorMessage?: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
    caseDetails?: {
      __typename?: 'CredentialVerificationCaseV1CaseDetails';
      application?: { __typename?: 'CredentialVerificationCaseV1Application'; sendDestination?: { __typename?: 'Entity'; id: any } | null } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  state: string;
  id: any;
  lastActivityAt?: any | null;
  caseDetails?: {
    __typename?: 'CredentialVerificationCaseV1CaseDetails';
    application?: {
      __typename?: 'CredentialVerificationCaseV1Application';
      credentialType?: string | null;
      credentialTitle?: string | null;
      isCredentialInEnglish?: boolean | null;
      isNameOnCredentialMatchPassport?: boolean | null;
      isAttestationComplete?: boolean | null;
      dateCredentialIssuedAt?: any | null;
      program?: string | null;
      nameOnCredential?: string | null;
      credentialAssets?: { __typename?: 'CredentialVerificationCaseV1CredentialAssets'; credential?: string | null; translation?: string | null } | null;
      sendDestination?: { __typename?: 'Entity'; entityName?: string | null; isIssuingInstitution?: boolean | null; isClient?: boolean | null; id: any } | null;
      issuingInstitution?: { __typename?: 'Entity'; id: any } | null;
      otherIssuingInstitution?: {
        __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution';
        addressLine1?: string | null;
        city?: string | null;
        country?: string | null;
        institutionName?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
    } | null;
  } | null;
  financeDetails?: {
    __typename?: 'CredentialVerificationCaseV1FinanceDetails';
    serviceFee?: number | null;
    transactions?: {
      __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
      submission?: {
        __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmission';
        transactionReference?: { __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference'; status?: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
  submission?: {
    __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmission';
    transactionReference?: {
      __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference';
      isSuccess?: boolean | null;
      status?: string | null;
      errorMessage?: string | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1CreateContainerEntitiesQueryVariables = Exact<{ [key: string]: never }>;

export type CasesCredentialVerificationV1CreateContainerEntitiesQuery = {
  __typename?: 'Query';
  entities?: Array<{ __typename?: 'Entity'; entityName?: string | null; isIssuingInstitution?: boolean | null; isClient?: boolean | null; id: any } | null> | null;
};

export type CasesCredentialVerificationV1CreateContainerEntityFieldsFragment = {
  __typename?: 'Entity';
  entityName?: string | null;
  isIssuingInstitution?: boolean | null;
  isClient?: boolean | null;
  id: any;
};

export type CasesCredentialVerificationV1CreateContainerSendReportCasesV1ByApplicantQueryVariables = Exact<{
  applicantId: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationV1CreateContainerSendReportCasesV1ByApplicantQuery = {
  __typename?: 'Query';
  sendReportCasesV1ByApplicant?: Array<{
    __typename?: 'SendReportCaseV1';
    state: string;
    caseName?: string | null;
    id: any;
    lastActivityAt?: any | null;
    caseDetails?: {
      __typename?: 'SendReportCaseV1CaseDetails';
      application?: {
        __typename?: 'SendReportCaseV1CaseDetailsApplication';
        credential?: { __typename?: 'CredentialVerificationCaseV1'; id: any } | null;
        destination?: { __typename?: 'Entity'; id: any } | null;
      } | null;
    } | null;
  } | null> | null;
};

export type CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1UpdateMutationVariables = Exact<{
  input: CredentialVerificationCaseV1UpdateInput;
}>;

export type CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1Update?: {
    __typename?: 'CredentialVerificationCaseV1MutationResult';
    credentialVerificationCaseV1?: {
      __typename?: 'CredentialVerificationCaseV1';
      state: string;
      id: any;
      lastActivityAt?: any | null;
      caseDetails?: {
        __typename?: 'CredentialVerificationCaseV1CaseDetails';
        application?: {
          __typename?: 'CredentialVerificationCaseV1Application';
          credentialType?: string | null;
          credentialTitle?: string | null;
          isCredentialInEnglish?: boolean | null;
          isNameOnCredentialMatchPassport?: boolean | null;
          isAttestationComplete?: boolean | null;
          dateCredentialIssuedAt?: any | null;
          program?: string | null;
          nameOnCredential?: string | null;
          credentialAssets?: { __typename?: 'CredentialVerificationCaseV1CredentialAssets'; credential?: string | null; translation?: string | null } | null;
          sendDestination?: { __typename?: 'Entity'; entityName?: string | null; isIssuingInstitution?: boolean | null; isClient?: boolean | null; id: any } | null;
          issuingInstitution?: { __typename?: 'Entity'; id: any } | null;
          otherIssuingInstitution?: {
            __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution';
            addressLine1?: string | null;
            city?: string | null;
            country?: string | null;
            institutionName?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
        } | null;
      } | null;
      financeDetails?: {
        __typename?: 'CredentialVerificationCaseV1FinanceDetails';
        serviceFee?: number | null;
        transactions?: {
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
          submission?: {
            __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmission';
            transactionReference?: { __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference'; status?: string | null } | null;
          } | null;
        } | null;
      } | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  } | null;
};

export type CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1DeleteMutationVariables = Exact<{
  input: CredentialVerificationCaseV1DeleteInput;
}>;

export type CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1DeleteMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1Delete?: {
    __typename?: 'CredentialVerificationCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  } | null;
};

export type CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1MutationResultFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1MutationResult';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    state: string;
    id: any;
    lastActivityAt?: any | null;
    caseDetails?: {
      __typename?: 'CredentialVerificationCaseV1CaseDetails';
      application?: {
        __typename?: 'CredentialVerificationCaseV1Application';
        credentialType?: string | null;
        credentialTitle?: string | null;
        isCredentialInEnglish?: boolean | null;
        isNameOnCredentialMatchPassport?: boolean | null;
        isAttestationComplete?: boolean | null;
        dateCredentialIssuedAt?: any | null;
        program?: string | null;
        nameOnCredential?: string | null;
        credentialAssets?: { __typename?: 'CredentialVerificationCaseV1CredentialAssets'; credential?: string | null; translation?: string | null } | null;
        sendDestination?: { __typename?: 'Entity'; entityName?: string | null; isIssuingInstitution?: boolean | null; isClient?: boolean | null; id: any } | null;
        issuingInstitution?: { __typename?: 'Entity'; id: any } | null;
        otherIssuingInstitution?: {
          __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution';
          addressLine1?: string | null;
          city?: string | null;
          country?: string | null;
          institutionName?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
      } | null;
    } | null;
    financeDetails?: {
      __typename?: 'CredentialVerificationCaseV1FinanceDetails';
      serviceFee?: number | null;
      transactions?: {
        __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
        submission?: {
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmission';
          transactionReference?: { __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference'; status?: string | null } | null;
        } | null;
      } | null;
    } | null;
  } | null;
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
};

export type CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1ApplicationFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1Application';
  credentialType?: string | null;
  credentialTitle?: string | null;
  isCredentialInEnglish?: boolean | null;
  isNameOnCredentialMatchPassport?: boolean | null;
  isAttestationComplete?: boolean | null;
  dateCredentialIssuedAt?: any | null;
  program?: string | null;
  nameOnCredential?: string | null;
  credentialAssets?: { __typename?: 'CredentialVerificationCaseV1CredentialAssets'; credential?: string | null; translation?: string | null } | null;
  sendDestination?: { __typename?: 'Entity'; entityName?: string | null; isIssuingInstitution?: boolean | null; isClient?: boolean | null; id: any } | null;
  issuingInstitution?: { __typename?: 'Entity'; id: any } | null;
  otherIssuingInstitution?: {
    __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution';
    addressLine1?: string | null;
    city?: string | null;
    country?: string | null;
    institutionName?: string | null;
    stateOrProvince?: string | null;
    zipOrPostalCode?: string | null;
  } | null;
};

export type CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1CredentialAssetsFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1CredentialAssets';
  credential?: string | null;
  translation?: string | null;
};

export type CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1OtherIssuingInstitutionFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution';
  addressLine1?: string | null;
  city?: string | null;
  country?: string | null;
  institutionName?: string | null;
  stateOrProvince?: string | null;
  zipOrPostalCode?: string | null;
};

export type CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1FinanceDetailsFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetails';
  serviceFee?: number | null;
  transactions?: {
    __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
    submission?: {
      __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmission';
      transactionReference?: { __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference'; status?: string | null } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1CreateContainerSendReportCaseV1FieldsFragment = {
  __typename?: 'SendReportCaseV1';
  state: string;
  caseName?: string | null;
  id: any;
  lastActivityAt?: any | null;
  caseDetails?: {
    __typename?: 'SendReportCaseV1CaseDetails';
    application?: {
      __typename?: 'SendReportCaseV1CaseDetailsApplication';
      credential?: { __typename?: 'CredentialVerificationCaseV1'; id: any } | null;
      destination?: { __typename?: 'Entity'; id: any } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    id: any;
    lastActivityAt?: any | null;
    financeDetails?: {
      __typename?: 'CredentialVerificationCaseV1FinanceDetails';
      transactions?: {
        __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
        submission?: {
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmission';
          amount?: number | null;
          transactionReference?: {
            __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference';
            completedAt?: any | null;
            referenceId?: string | null;
            vendor?: string | null;
          } | null;
        } | null;
        adhocTransactions?: Array<{
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions';
          amount?: number | null;
          reason?: string | null;
          requestedAt?: any | null;
          id: any;
          createdAt?: any | null;
          updatedAt?: any | null;
          approval?: {
            __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsApproval';
            applicantRespondedAt?: any | null;
            isApplicantApprovalRequired?: boolean | null;
            isApplicantApproved?: boolean | null;
          } | null;
          financeReference?: {
            __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFinanceReference';
            recognizedAt?: any | null;
            creditGlAccount?: string | null;
            debitGlAccount?: string | null;
          } | null;
          transactionReference?: {
            __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
            completedAt?: any | null;
            referenceId?: string | null;
            vendor?: string | null;
            isSuccess?: boolean | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  id: any;
  lastActivityAt?: any | null;
  financeDetails?: {
    __typename?: 'CredentialVerificationCaseV1FinanceDetails';
    transactions?: {
      __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
      submission?: {
        __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmission';
        amount?: number | null;
        transactionReference?: {
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference';
          completedAt?: any | null;
          referenceId?: string | null;
          vendor?: string | null;
        } | null;
      } | null;
      adhocTransactions?: Array<{
        __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions';
        amount?: number | null;
        reason?: string | null;
        requestedAt?: any | null;
        id: any;
        createdAt?: any | null;
        updatedAt?: any | null;
        approval?: {
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsApproval';
          applicantRespondedAt?: any | null;
          isApplicantApprovalRequired?: boolean | null;
          isApplicantApproved?: boolean | null;
        } | null;
        financeReference?: {
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFinanceReference';
          recognizedAt?: any | null;
          creditGlAccount?: string | null;
          debitGlAccount?: string | null;
        } | null;
        transactionReference?: {
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
          completedAt?: any | null;
          referenceId?: string | null;
          vendor?: string | null;
          isSuccess?: boolean | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1FinanceDetailsFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetails';
  transactions?: {
    __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
    submission?: {
      __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmission';
      amount?: number | null;
      transactionReference?: {
        __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference';
        completedAt?: any | null;
        referenceId?: string | null;
        vendor?: string | null;
      } | null;
    } | null;
    adhocTransactions?: Array<{
      __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions';
      amount?: number | null;
      reason?: string | null;
      requestedAt?: any | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
      approval?: {
        __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsApproval';
        applicantRespondedAt?: any | null;
        isApplicantApprovalRequired?: boolean | null;
        isApplicantApproved?: boolean | null;
      } | null;
      financeReference?: {
        __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFinanceReference';
        recognizedAt?: any | null;
        creditGlAccount?: string | null;
        debitGlAccount?: string | null;
      } | null;
      transactionReference?: {
        __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
        completedAt?: any | null;
        referenceId?: string | null;
        vendor?: string | null;
        isSuccess?: boolean | null;
      } | null;
    } | null> | null;
  } | null;
};

export type CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserUpdateMutationVariables = Exact<{
  input: ApplicantUserUpdateInput;
}>;

export type CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserUpdateMutation = {
  __typename?: 'Mutation';
  applicantUserUpdate: {
    __typename?: 'ApplicantUserMutationResult';
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
    applicantUser?: {
      __typename?: 'ApplicantUser';
      id: any;
      files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        nameOnDocumentAssets?: Array<{ __typename?: 'ApplicantUserNameOnDocumentAsset'; documentName?: string | null; id: any } | null> | null;
      } | null;
    } | null;
  };
};

export type CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserQueryVariables = Exact<{
  applicantUserId: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserQuery = {
  __typename?: 'Query';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      nameOnDocumentAssets?: Array<{ __typename?: 'ApplicantUserNameOnDocumentAsset'; documentName?: string | null; id: any } | null> | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserFileCreateAuthHeaderMutationVariables = Exact<{
  input: ApplicantUserBlobFileInput;
}>;

export type CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserFileCreateAuthHeaderMutation = {
  __typename?: 'Mutation';
  applicantUserFileCreateAuthHeader: {
    __typename?: 'ApplicantUserBlobContentAuthHeaderResult';
    authHeader?: {
      __typename?: 'BlobAuthHeader';
      authHeader?: string | null;
      blobPath?: string | null;
      blobName?: string | null;
      requestDate?: string | null;
      indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
      metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserMutationResultFieldsFragment = {
  __typename?: 'ApplicantUserMutationResult';
  status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      nameOnDocumentAssets?: Array<{ __typename?: 'ApplicantUserNameOnDocumentAsset'; documentName?: string | null; id: any } | null> | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserAuthHeaderMutationResultFieldsFragment = {
  __typename?: 'ApplicantUserBlobContentAuthHeaderResult';
  authHeader?: {
    __typename?: 'BlobAuthHeader';
    authHeader?: string | null;
    blobPath?: string | null;
    blobName?: string | null;
    requestDate?: string | null;
    indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
    metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
  } | null;
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
};

export type CasesCredentialVerificationV1UploadNameOnDocumentContainerBlobAuthHeaderFieldsFragment = {
  __typename?: 'BlobAuthHeader';
  authHeader?: string | null;
  blobPath?: string | null;
  blobName?: string | null;
  requestDate?: string | null;
  indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
  metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
};

export type CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    nameOnDocumentAssets?: Array<{ __typename?: 'ApplicantUserNameOnDocumentAsset'; documentName?: string | null; id: any } | null> | null;
  } | null;
};

export type ApplicantIdentityVerificationArchiveSummaryContainerArchivedIdentityVerificationCaseSummaryQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type ApplicantIdentityVerificationArchiveSummaryContainerArchivedIdentityVerificationCaseSummaryQuery = {
  __typename?: 'Query';
  archivedIdentityVerificationCaseSummary?: {
    __typename?: 'ArchivedIdentityVerificationCaseSummary';
    archivedAt: any;
    createdAt: any;
    lastActivityAt: any;
    state: string;
    submittedAt: any;
    id: any;
    applicant: { __typename?: 'ApplicantUser'; id: any };
    caseDetails: {
      __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetails';
      application: {
        __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplication';
        passportDetails: {
          __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails';
          isPassportExpirationDateVisible?: boolean | null;
          isPassportInLatinCharacters?: boolean | null;
          passportCountry?: string | null;
          passportExpiresAt?: any | null;
          passportIssuedAt?: any | null;
          passportNumber?: string | null;
        };
      };
      applicationReview: {
        __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReview';
        decision: {
          __typename?: 'ArchivedCaseSummaryDecision';
          completedAt?: any | null;
          rejectionReason?: string | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; createdAt?: any | null; displayName?: string | null; id: any } | null;
        };
      };
    };
    files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
    financeDetails: {
      __typename?: 'ArchivedCaseSummaryFinanceDetails';
      transactions?: {
        __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactions';
        adhocTransactions?: Array<{
          __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
          amount?: number | null;
          reason?: string | null;
          transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null } | null;
        } | null> | null;
        submission?: {
          __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission';
          amount?: number | null;
          transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null } | null;
        } | null;
      } | null;
    };
  } | null;
};

export type ApplicantIdentityVerificationArchiveSummaryContainerApplicantUserQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type ApplicantIdentityVerificationArchiveSummaryContainerApplicantUserQuery = {
  __typename?: 'Query';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    displayName?: string | null;
    id: any;
    createdAt?: any | null;
    termsAndConditions?: Array<{
      __typename?: 'ApplicantUserTermsAndCondition';
      acceptanceOf?: string | null;
      attestedAt?: any | null;
      version?: number | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
    } | null> | null;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      professional?: {
        __typename?: 'ApplicantUserProfessional';
        primaryEducationalInformation?: Array<{
          __typename?: 'ApplicantUserPrimaryEducationalInformation';
          degreeTitle?: string | null;
          id: any;
          issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type ApplicantIdentityVerificationArchiveSummaryContainerArchivedIdentityVerificationCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedIdentityVerificationCaseSummary';
  archivedAt: any;
  createdAt: any;
  lastActivityAt: any;
  state: string;
  submittedAt: any;
  id: any;
  applicant: { __typename?: 'ApplicantUser'; id: any };
  caseDetails: {
    __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetails';
    application: {
      __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplication';
      passportDetails: {
        __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails';
        isPassportExpirationDateVisible?: boolean | null;
        isPassportInLatinCharacters?: boolean | null;
        passportCountry?: string | null;
        passportExpiresAt?: any | null;
        passportIssuedAt?: any | null;
        passportNumber?: string | null;
      };
    };
    applicationReview: {
      __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReview';
      decision: {
        __typename?: 'ArchivedCaseSummaryDecision';
        completedAt?: any | null;
        rejectionReason?: string | null;
        result?: string | null;
        completedBy?: { __typename?: 'StaffUser'; createdAt?: any | null; displayName?: string | null; id: any } | null;
      };
    };
  };
  files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
  financeDetails: {
    __typename?: 'ArchivedCaseSummaryFinanceDetails';
    transactions?: {
      __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactions';
      adhocTransactions?: Array<{
        __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
        amount?: number | null;
        reason?: string | null;
        transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null } | null;
      } | null> | null;
      submission?: {
        __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission';
        amount?: number | null;
        transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null } | null;
      } | null;
    } | null;
  };
};

export type ApplicantIdentityVerificationArchiveSummaryContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  displayName?: string | null;
  id: any;
  createdAt?: any | null;
  termsAndConditions?: Array<{
    __typename?: 'ApplicantUserTermsAndCondition';
    acceptanceOf?: string | null;
    attestedAt?: any | null;
    version?: number | null;
    id: any;
    createdAt?: any | null;
    updatedAt?: any | null;
  } | null> | null;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    professional?: {
      __typename?: 'ApplicantUserProfessional';
      primaryEducationalInformation?: Array<{
        __typename?: 'ApplicantUserPrimaryEducationalInformation';
        degreeTitle?: string | null;
        id: any;
        issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    caseType?: string | null;
    state: string;
    submittedAt?: any | null;
    id: any;
    lastActivityAt?: any | null;
    files?: Array<{ __typename?: 'FileInfo'; name: string; url: string } | null> | null;
    caseDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetails';
      application?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
        passportDetails?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
          passportCountry?: string | null;
          passportExpiresAt?: any | null;
          passportIssuedAt?: any | null;
          passportNumber?: string | null;
          isPassportExpirationDateVisible?: boolean | null;
          isPassportInLatinCharacters?: boolean | null;
        } | null;
      } | null;
      applicationReview?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
        decision?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision';
          completedAt?: any | null;
          rejectionReason?: string | null;
          result?: string | null;
        } | null;
      } | null;
    } | null;
    revisionRequest?: {
      __typename?: 'IdentityVerificationCaseV1RevisionRequest';
      requestedChanges?: {
        __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges';
        requestUpdatedPassportDetails?: boolean | null;
        requestUploadExpirationPage?: boolean | null;
        requestUploadPassport?: boolean | null;
        requestUploadPassportTranslation?: boolean | null;
        requestUploadPhoto?: boolean | null;
      } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1UpdateMutationVariables = Exact<{
  input: IdentityVerificationCaseV1UpdateInput;
}>;

export type CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1Update: {
    __typename?: 'IdentityVerificationCaseV1MutationResult';
    identityVerificationCaseV1?: {
      __typename?: 'IdentityVerificationCaseV1';
      caseType?: string | null;
      state: string;
      submittedAt?: any | null;
      id: any;
      lastActivityAt?: any | null;
      files?: Array<{ __typename?: 'FileInfo'; name: string; url: string } | null> | null;
      caseDetails?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetails';
        application?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
          passportDetails?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
            passportCountry?: string | null;
            passportExpiresAt?: any | null;
            passportIssuedAt?: any | null;
            passportNumber?: string | null;
            isPassportExpirationDateVisible?: boolean | null;
            isPassportInLatinCharacters?: boolean | null;
          } | null;
        } | null;
        applicationReview?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
          decision?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision';
            completedAt?: any | null;
            rejectionReason?: string | null;
            result?: string | null;
          } | null;
        } | null;
      } | null;
      revisionRequest?: {
        __typename?: 'IdentityVerificationCaseV1RevisionRequest';
        requestedChanges?: {
          __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges';
          requestUpdatedPassportDetails?: boolean | null;
          requestUploadExpirationPage?: boolean | null;
          requestUploadPassport?: boolean | null;
          requestUploadPassportTranslation?: boolean | null;
          requestUploadPhoto?: boolean | null;
        } | null;
      } | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1MutationResultFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1MutationResult';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    caseType?: string | null;
    state: string;
    submittedAt?: any | null;
    id: any;
    lastActivityAt?: any | null;
    files?: Array<{ __typename?: 'FileInfo'; name: string; url: string } | null> | null;
    caseDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetails';
      application?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
        passportDetails?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
          passportCountry?: string | null;
          passportExpiresAt?: any | null;
          passportIssuedAt?: any | null;
          passportNumber?: string | null;
          isPassportExpirationDateVisible?: boolean | null;
          isPassportInLatinCharacters?: boolean | null;
        } | null;
      } | null;
      applicationReview?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
        decision?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision';
          completedAt?: any | null;
          rejectionReason?: string | null;
          result?: string | null;
        } | null;
      } | null;
    } | null;
    revisionRequest?: {
      __typename?: 'IdentityVerificationCaseV1RevisionRequest';
      requestedChanges?: {
        __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges';
        requestUpdatedPassportDetails?: boolean | null;
        requestUploadExpirationPage?: boolean | null;
        requestUploadPassport?: boolean | null;
        requestUploadPassportTranslation?: boolean | null;
        requestUploadPhoto?: boolean | null;
      } | null;
    } | null;
  } | null;
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
};

export type CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  caseType?: string | null;
  state: string;
  submittedAt?: any | null;
  id: any;
  lastActivityAt?: any | null;
  files?: Array<{ __typename?: 'FileInfo'; name: string; url: string } | null> | null;
  caseDetails?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetails';
    application?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
      passportDetails?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
        passportCountry?: string | null;
        passportExpiresAt?: any | null;
        passportIssuedAt?: any | null;
        passportNumber?: string | null;
        isPassportExpirationDateVisible?: boolean | null;
        isPassportInLatinCharacters?: boolean | null;
      } | null;
    } | null;
    applicationReview?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
      decision?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision';
        completedAt?: any | null;
        rejectionReason?: string | null;
        result?: string | null;
      } | null;
    } | null;
  } | null;
  revisionRequest?: {
    __typename?: 'IdentityVerificationCaseV1RevisionRequest';
    requestedChanges?: {
      __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges';
      requestUpdatedPassportDetails?: boolean | null;
      requestUploadExpirationPage?: boolean | null;
      requestUploadPassport?: boolean | null;
      requestUploadPassportTranslation?: boolean | null;
      requestUploadPhoto?: boolean | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1CaseDetailsApplicationContainerFileInfoFieldsFragment = { __typename?: 'FileInfo'; name: string; url: string };

export type CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetails';
  application?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
    passportDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
      passportCountry?: string | null;
      passportExpiresAt?: any | null;
      passportIssuedAt?: any | null;
      passportNumber?: string | null;
      isPassportExpirationDateVisible?: boolean | null;
      isPassportInLatinCharacters?: boolean | null;
    } | null;
  } | null;
  applicationReview?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
    decision?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision';
      completedAt?: any | null;
      rejectionReason?: string | null;
      result?: string | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1RevisionRequest';
  requestedChanges?: {
    __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges';
    requestUpdatedPassportDetails?: boolean | null;
    requestUploadExpirationPage?: boolean | null;
    requestUploadPassport?: boolean | null;
    requestUploadPassportTranslation?: boolean | null;
    requestUploadPhoto?: boolean | null;
  } | null;
};

export type CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
  passportDetails?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
    passportCountry?: string | null;
    passportExpiresAt?: any | null;
    passportIssuedAt?: any | null;
    passportNumber?: string | null;
    isPassportExpirationDateVisible?: boolean | null;
    isPassportInLatinCharacters?: boolean | null;
  } | null;
};

export type CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
  decision?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision';
    completedAt?: any | null;
    rejectionReason?: string | null;
    result?: string | null;
  } | null;
};

export type CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges';
  requestUpdatedPassportDetails?: boolean | null;
  requestUploadExpirationPage?: boolean | null;
  requestUploadPassport?: boolean | null;
  requestUploadPassportTranslation?: boolean | null;
  requestUploadPhoto?: boolean | null;
};

export type CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
  passportCountry?: string | null;
  passportExpiresAt?: any | null;
  passportIssuedAt?: any | null;
  passportNumber?: string | null;
  isPassportExpirationDateVisible?: boolean | null;
  isPassportInLatinCharacters?: boolean | null;
};

export type CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewDecisionFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision';
  completedAt?: any | null;
  rejectionReason?: string | null;
  result?: string | null;
};

export type CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1UpdateMutationVariables = Exact<{
  input: IdentityVerificationCaseV1UpdateInput;
}>;

export type CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1Update: {
    __typename?: 'IdentityVerificationCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    identityVerificationCaseV1?: {
      __typename?: 'IdentityVerificationCaseV1';
      state: string;
      id: any;
      lastActivityAt?: any | null;
      revisionRequest?: {
        __typename?: 'IdentityVerificationCaseV1RevisionRequest';
        requestedChanges?: { __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges'; requestUploadNotarizedIdForm?: boolean | null } | null;
      } | null;
      assets?: {
        __typename?: 'IdentityVerificationCaseV1Assets';
        shared?: { __typename?: 'IdentityVerificationCaseV1AssetsShared'; notarizedIdForm?: string | null } | null;
      } | null;
    } | null;
  };
};

export type CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1MutationResultFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    state: string;
    id: any;
    lastActivityAt?: any | null;
    revisionRequest?: {
      __typename?: 'IdentityVerificationCaseV1RevisionRequest';
      requestedChanges?: { __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges'; requestUploadNotarizedIdForm?: boolean | null } | null;
    } | null;
    assets?: {
      __typename?: 'IdentityVerificationCaseV1Assets';
      shared?: { __typename?: 'IdentityVerificationCaseV1AssetsShared'; notarizedIdForm?: string | null } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  fileName: Scalars['String']['input'];
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    state: string;
    id: any;
    lastActivityAt?: any | null;
    fileByFileName?: { __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null;
    revisionRequest?: {
      __typename?: 'IdentityVerificationCaseV1RevisionRequest';
      requestedChanges?: { __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges'; requestUploadNotarizedIdForm?: boolean | null } | null;
    } | null;
    assets?: {
      __typename?: 'IdentityVerificationCaseV1Assets';
      shared?: { __typename?: 'IdentityVerificationCaseV1AssetsShared'; notarizedIdForm?: string | null } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  state: string;
  id: any;
  lastActivityAt?: any | null;
  revisionRequest?: {
    __typename?: 'IdentityVerificationCaseV1RevisionRequest';
    requestedChanges?: { __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges'; requestUploadNotarizedIdForm?: boolean | null } | null;
  } | null;
  assets?: {
    __typename?: 'IdentityVerificationCaseV1Assets';
    shared?: { __typename?: 'IdentityVerificationCaseV1AssetsShared'; notarizedIdForm?: string | null } | null;
  } | null;
};

export type CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1FileInfoFieldsFragment = {
  __typename?: 'FileInfo';
  url: string;
  type?: string | null;
  size?: number | null;
  name: string;
};

export type CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1RevisionRequest';
  requestedChanges?: { __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges'; requestUploadNotarizedIdForm?: boolean | null } | null;
};

export type CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges';
  requestUploadNotarizedIdForm?: boolean | null;
};

export type CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    state: string;
    id: any;
    updatedAt?: any | null;
    messages?: Array<{
      __typename?: 'IdentityVerificationCaseV1Message';
      isHiddenFromApplicant?: boolean | null;
      message?: string | null;
      embedding?: string | null;
      sentBy?: string | null;
      id: any;
      createdAt?: any | null;
    } | null> | null;
    applicant?: {
      __typename?: 'ApplicantUser';
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        identityDetails?: { __typename?: 'ApplicantUserIdentityDetails'; lastName?: string | null; restOfName?: string | null } | null;
      } | null;
    } | null;
    financeDetails?: {
      __typename?: 'IdentityVerificationCaseV1FinanceDetails';
      transactions?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
        adhocTransactions?: Array<{
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction';
          reason?: string | null;
          amount?: number | null;
          createdAt?: any | null;
          id: any;
          transactionReference?: {
            __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
            referenceId?: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
    revisionRequest?: {
      __typename?: 'IdentityVerificationCaseV1RevisionRequest';
      requestedChanges?: { __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges'; requestScheduleNotaryCam?: boolean | null } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1UpdateMutationVariables = Exact<{
  input: IdentityVerificationCaseV1UpdateInput;
}>;

export type CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1Update: {
    __typename?: 'IdentityVerificationCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    identityVerificationCaseV1?: {
      __typename?: 'IdentityVerificationCaseV1';
      state: string;
      id: any;
      updatedAt?: any | null;
      messages?: Array<{
        __typename?: 'IdentityVerificationCaseV1Message';
        isHiddenFromApplicant?: boolean | null;
        message?: string | null;
        embedding?: string | null;
        sentBy?: string | null;
        id: any;
        createdAt?: any | null;
      } | null> | null;
      applicant?: {
        __typename?: 'ApplicantUser';
        id: any;
        personalInformation?: {
          __typename?: 'ApplicantUserPersonalInformation';
          identityDetails?: { __typename?: 'ApplicantUserIdentityDetails'; lastName?: string | null; restOfName?: string | null } | null;
        } | null;
      } | null;
      financeDetails?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetails';
        transactions?: {
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
          adhocTransactions?: Array<{
            __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction';
            reason?: string | null;
            amount?: number | null;
            createdAt?: any | null;
            id: any;
            transactionReference?: {
              __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
              referenceId?: string | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
      revisionRequest?: {
        __typename?: 'IdentityVerificationCaseV1RevisionRequest';
        requestedChanges?: { __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges'; requestScheduleNotaryCam?: boolean | null } | null;
      } | null;
    } | null;
  };
};

export type CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1MutationResultFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    state: string;
    id: any;
    updatedAt?: any | null;
    messages?: Array<{
      __typename?: 'IdentityVerificationCaseV1Message';
      isHiddenFromApplicant?: boolean | null;
      message?: string | null;
      embedding?: string | null;
      sentBy?: string | null;
      id: any;
      createdAt?: any | null;
    } | null> | null;
    applicant?: {
      __typename?: 'ApplicantUser';
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        identityDetails?: { __typename?: 'ApplicantUserIdentityDetails'; lastName?: string | null; restOfName?: string | null } | null;
      } | null;
    } | null;
    financeDetails?: {
      __typename?: 'IdentityVerificationCaseV1FinanceDetails';
      transactions?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
        adhocTransactions?: Array<{
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction';
          reason?: string | null;
          amount?: number | null;
          createdAt?: any | null;
          id: any;
          transactionReference?: {
            __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
            referenceId?: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
    revisionRequest?: {
      __typename?: 'IdentityVerificationCaseV1RevisionRequest';
      requestedChanges?: { __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges'; requestScheduleNotaryCam?: boolean | null } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  state: string;
  id: any;
  updatedAt?: any | null;
  messages?: Array<{
    __typename?: 'IdentityVerificationCaseV1Message';
    isHiddenFromApplicant?: boolean | null;
    message?: string | null;
    embedding?: string | null;
    sentBy?: string | null;
    id: any;
    createdAt?: any | null;
  } | null> | null;
  applicant?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      identityDetails?: { __typename?: 'ApplicantUserIdentityDetails'; lastName?: string | null; restOfName?: string | null } | null;
    } | null;
  } | null;
  financeDetails?: {
    __typename?: 'IdentityVerificationCaseV1FinanceDetails';
    transactions?: {
      __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
      adhocTransactions?: Array<{
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction';
        reason?: string | null;
        amount?: number | null;
        createdAt?: any | null;
        id: any;
        transactionReference?: { __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
      } | null> | null;
    } | null;
  } | null;
  revisionRequest?: {
    __typename?: 'IdentityVerificationCaseV1RevisionRequest';
    requestedChanges?: { __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges'; requestScheduleNotaryCam?: boolean | null } | null;
  } | null;
};

export type CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1RevisionRequest';
  requestedChanges?: { __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges'; requestScheduleNotaryCam?: boolean | null } | null;
};

export type CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestChangesFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges';
  requestScheduleNotaryCam?: boolean | null;
};

export type CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetails';
  transactions?: {
    __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
    adhocTransactions?: Array<{
      __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction';
      reason?: string | null;
      amount?: number | null;
      createdAt?: any | null;
      id: any;
      transactionReference?: { __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
    } | null> | null;
  } | null;
};

export type CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
  adhocTransactions?: Array<{
    __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction';
    reason?: string | null;
    amount?: number | null;
    createdAt?: any | null;
    id: any;
    transactionReference?: { __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
  } | null> | null;
};

export type CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction';
  reason?: string | null;
  amount?: number | null;
  createdAt?: any | null;
  id: any;
  transactionReference?: { __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
};

export type CasesIdentityVerificationV1CaseDetailsMessagesContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  id: any;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    identityDetails?: { __typename?: 'ApplicantUserIdentityDetails'; lastName?: string | null; restOfName?: string | null } | null;
  } | null;
};

export type CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1MessageFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1Message';
  isHiddenFromApplicant?: boolean | null;
  message?: string | null;
  embedding?: string | null;
  sentBy?: string | null;
  id: any;
  createdAt?: any | null;
};

export type CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    state: string;
    id: any;
    updatedAt?: any | null;
    caseDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetails';
      application?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
        isAttestationComplete?: boolean | null;
        caseWorkerModifiedPassportDetails?: boolean | null;
        attestedAt?: any | null;
        notarizationDetails?: { __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationNotarizationDetails'; isNotarizationComplete?: boolean | null } | null;
        passportAssets?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets';
          passport?: string | null;
          passportExpiration?: string | null;
          passportExpirationUploadedAt?: any | null;
          passportExpirationVersion?: string | null;
          passportTranslation?: string | null;
          passportTranslationUploadedAt?: any | null;
          passportTranslationVersion?: string | null;
          passportUploadedAt?: any | null;
          passportVersion?: string | null;
        } | null;
        passportDetails?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
          isPassportExpirationDateVisible?: boolean | null;
          isPassportInLatinCharacters?: boolean | null;
          passportCountry?: string | null;
          passportExpiresAt?: any | null;
          passportIssuedAt?: any | null;
          passportNumber?: string | null;
        } | null;
        photoAssets?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets';
          photo?: string | null;
          photoUploadedAt?: any | null;
          photoVersion?: string | null;
        } | null;
      } | null;
    } | null;
    files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
    financeDetails?: {
      __typename?: 'IdentityVerificationCaseV1FinanceDetails';
      serviceFee?: number | null;
      transactions?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
        submission?: {
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission';
          transactionReference?: {
            __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference';
            isSuccess?: boolean | null;
            status?: string | null;
            errorMessage?: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1DraftContainerEntitiesQueryVariables = Exact<{ [key: string]: never }>;

export type CasesIdentityVerificationV1DraftContainerEntitiesQuery = {
  __typename?: 'Query';
  entities?: Array<{ __typename?: 'Entity'; entityName?: string | null; isIssuingInstitution?: boolean | null; isClient?: boolean | null; id: any } | null> | null;
};

export type CasesIdentityVerificationV1DraftContainerProcessPaymentPollingQueryVariables = Exact<{
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationV1DraftContainerProcessPaymentPollingQuery = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    id: any;
    state: string;
    financeDetails?: {
      __typename?: 'IdentityVerificationCaseV1FinanceDetails';
      transactions?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
        submission?: {
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission';
          transactionReference?: {
            __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference';
            isSuccess?: boolean | null;
            status?: string | null;
            errorMessage?: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1DraftContainerApplicantUserPaymentInstrumentQueryVariables = Exact<{
  applicantUserId: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationV1DraftContainerApplicantUserPaymentInstrumentQuery = {
  __typename?: 'Query';
  applicantUserPaymentInstrument?: {
    __typename?: 'PaymentInstrument';
    cardNumber?: string | null;
    cardType?: string | null;
    expirationMonth?: string | null;
    expirationYear?: string | null;
    paymentInstrumentId?: string | null;
    state?: string | null;
    id?: string | null;
    billTo?: {
      __typename?: 'PaymentBillingInfo';
      billingAddressLine1?: string | null;
      billingAddressLine2?: string | null;
      billingCity?: string | null;
      billingCountry?: string | null;
      billingEmail?: string | null;
      billingFirstName?: string | null;
      billingLastName?: string | null;
      billingPhone?: string | null;
      billingPostalCode?: string | null;
      billingState?: string | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1DraftContainerApplicantUserPaymentInstrumentFieldsFragment = {
  __typename?: 'PaymentInstrument';
  cardNumber?: string | null;
  cardType?: string | null;
  expirationMonth?: string | null;
  expirationYear?: string | null;
  paymentInstrumentId?: string | null;
  state?: string | null;
  id?: string | null;
  billTo?: {
    __typename?: 'PaymentBillingInfo';
    billingAddressLine1?: string | null;
    billingAddressLine2?: string | null;
    billingCity?: string | null;
    billingCountry?: string | null;
    billingEmail?: string | null;
    billingFirstName?: string | null;
    billingLastName?: string | null;
    billingPhone?: string | null;
    billingPostalCode?: string | null;
    billingState?: string | null;
  } | null;
};

export type CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1UpdateMutationVariables = Exact<{
  input: IdentityVerificationCaseV1UpdateInput;
}>;

export type CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1Update: {
    __typename?: 'IdentityVerificationCaseV1MutationResult';
    identityVerificationCaseV1?: {
      __typename?: 'IdentityVerificationCaseV1';
      state: string;
      id: any;
      updatedAt?: any | null;
      caseDetails?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetails';
        application?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
          isAttestationComplete?: boolean | null;
          caseWorkerModifiedPassportDetails?: boolean | null;
          attestedAt?: any | null;
          notarizationDetails?: { __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationNotarizationDetails'; isNotarizationComplete?: boolean | null } | null;
          passportAssets?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets';
            passport?: string | null;
            passportExpiration?: string | null;
            passportExpirationUploadedAt?: any | null;
            passportExpirationVersion?: string | null;
            passportTranslation?: string | null;
            passportTranslationUploadedAt?: any | null;
            passportTranslationVersion?: string | null;
            passportUploadedAt?: any | null;
            passportVersion?: string | null;
          } | null;
          passportDetails?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
            isPassportExpirationDateVisible?: boolean | null;
            isPassportInLatinCharacters?: boolean | null;
            passportCountry?: string | null;
            passportExpiresAt?: any | null;
            passportIssuedAt?: any | null;
            passportNumber?: string | null;
          } | null;
          photoAssets?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets';
            photo?: string | null;
            photoUploadedAt?: any | null;
            photoVersion?: string | null;
          } | null;
        } | null;
      } | null;
      files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
      financeDetails?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetails';
        serviceFee?: number | null;
        transactions?: {
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
          submission?: {
            __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission';
            transactionReference?: {
              __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference';
              isSuccess?: boolean | null;
              status?: string | null;
              errorMessage?: string | null;
            } | null;
          } | null;
        } | null;
      } | null;
    } | null;
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
  };
};

export type CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetails';
  application?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
    isAttestationComplete?: boolean | null;
    caseWorkerModifiedPassportDetails?: boolean | null;
    attestedAt?: any | null;
    notarizationDetails?: { __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationNotarizationDetails'; isNotarizationComplete?: boolean | null } | null;
    passportAssets?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets';
      passport?: string | null;
      passportExpiration?: string | null;
      passportExpirationUploadedAt?: any | null;
      passportExpirationVersion?: string | null;
      passportTranslation?: string | null;
      passportTranslationUploadedAt?: any | null;
      passportTranslationVersion?: string | null;
      passportUploadedAt?: any | null;
      passportVersion?: string | null;
    } | null;
    passportDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
      isPassportExpirationDateVisible?: boolean | null;
      isPassportInLatinCharacters?: boolean | null;
      passportCountry?: string | null;
      passportExpiresAt?: any | null;
      passportIssuedAt?: any | null;
      passportNumber?: string | null;
    } | null;
    photoAssets?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets';
      photo?: string | null;
      photoUploadedAt?: any | null;
      photoVersion?: string | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1DraftContainerFileInfoFieldsFragment = {
  __typename?: 'FileInfo';
  name: string;
  size?: number | null;
  type?: string | null;
  url: string;
};

export type CasesIdentityVerificationV1DraftContainerEntityFieldsFragment = {
  __typename?: 'Entity';
  entityName?: string | null;
  isIssuingInstitution?: boolean | null;
  isClient?: boolean | null;
  id: any;
};

export type CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1ApplicationFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
  isAttestationComplete?: boolean | null;
  caseWorkerModifiedPassportDetails?: boolean | null;
  attestedAt?: any | null;
  notarizationDetails?: { __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationNotarizationDetails'; isNotarizationComplete?: boolean | null } | null;
  passportAssets?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets';
    passport?: string | null;
    passportExpiration?: string | null;
    passportExpirationUploadedAt?: any | null;
    passportExpirationVersion?: string | null;
    passportTranslation?: string | null;
    passportTranslationUploadedAt?: any | null;
    passportTranslationVersion?: string | null;
    passportUploadedAt?: any | null;
    passportVersion?: string | null;
  } | null;
  passportDetails?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
    isPassportExpirationDateVisible?: boolean | null;
    isPassportInLatinCharacters?: boolean | null;
    passportCountry?: string | null;
    passportExpiresAt?: any | null;
    passportIssuedAt?: any | null;
    passportNumber?: string | null;
  } | null;
  photoAssets?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets';
    photo?: string | null;
    photoUploadedAt?: any | null;
    photoVersion?: string | null;
  } | null;
};

export type CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPhotoAssetsFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets';
  photo?: string | null;
  photoUploadedAt?: any | null;
  photoVersion?: string | null;
};

export type CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
  isPassportExpirationDateVisible?: boolean | null;
  isPassportInLatinCharacters?: boolean | null;
  passportCountry?: string | null;
  passportExpiresAt?: any | null;
  passportIssuedAt?: any | null;
  passportNumber?: string | null;
};

export type CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportAssetsFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets';
  passport?: string | null;
  passportExpiration?: string | null;
  passportExpirationUploadedAt?: any | null;
  passportExpirationVersion?: string | null;
  passportTranslation?: string | null;
  passportTranslationUploadedAt?: any | null;
  passportTranslationVersion?: string | null;
  passportUploadedAt?: any | null;
  passportVersion?: string | null;
};

export type CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1FinanceDetailsFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetails';
  serviceFee?: number | null;
  transactions?: {
    __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
    submission?: {
      __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission';
      transactionReference?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference';
        isSuccess?: boolean | null;
        status?: string | null;
        errorMessage?: string | null;
      } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1MutationResultFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1MutationResult';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    state: string;
    id: any;
    updatedAt?: any | null;
    caseDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetails';
      application?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
        isAttestationComplete?: boolean | null;
        caseWorkerModifiedPassportDetails?: boolean | null;
        attestedAt?: any | null;
        notarizationDetails?: { __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationNotarizationDetails'; isNotarizationComplete?: boolean | null } | null;
        passportAssets?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets';
          passport?: string | null;
          passportExpiration?: string | null;
          passportExpirationUploadedAt?: any | null;
          passportExpirationVersion?: string | null;
          passportTranslation?: string | null;
          passportTranslationUploadedAt?: any | null;
          passportTranslationVersion?: string | null;
          passportUploadedAt?: any | null;
          passportVersion?: string | null;
        } | null;
        passportDetails?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
          isPassportExpirationDateVisible?: boolean | null;
          isPassportInLatinCharacters?: boolean | null;
          passportCountry?: string | null;
          passportExpiresAt?: any | null;
          passportIssuedAt?: any | null;
          passportNumber?: string | null;
        } | null;
        photoAssets?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets';
          photo?: string | null;
          photoUploadedAt?: any | null;
          photoVersion?: string | null;
        } | null;
      } | null;
    } | null;
    files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
    financeDetails?: {
      __typename?: 'IdentityVerificationCaseV1FinanceDetails';
      serviceFee?: number | null;
      transactions?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
        submission?: {
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission';
          transactionReference?: {
            __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference';
            isSuccess?: boolean | null;
            status?: string | null;
            errorMessage?: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
  status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
};

export type CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  state: string;
  id: any;
  updatedAt?: any | null;
  caseDetails?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetails';
    application?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
      isAttestationComplete?: boolean | null;
      caseWorkerModifiedPassportDetails?: boolean | null;
      attestedAt?: any | null;
      notarizationDetails?: { __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationNotarizationDetails'; isNotarizationComplete?: boolean | null } | null;
      passportAssets?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets';
        passport?: string | null;
        passportExpiration?: string | null;
        passportExpirationUploadedAt?: any | null;
        passportExpirationVersion?: string | null;
        passportTranslation?: string | null;
        passportTranslationUploadedAt?: any | null;
        passportTranslationVersion?: string | null;
        passportUploadedAt?: any | null;
        passportVersion?: string | null;
      } | null;
      passportDetails?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
        isPassportExpirationDateVisible?: boolean | null;
        isPassportInLatinCharacters?: boolean | null;
        passportCountry?: string | null;
        passportExpiresAt?: any | null;
        passportIssuedAt?: any | null;
        passportNumber?: string | null;
      } | null;
      photoAssets?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets';
        photo?: string | null;
        photoUploadedAt?: any | null;
        photoVersion?: string | null;
      } | null;
    } | null;
  } | null;
  files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
  financeDetails?: {
    __typename?: 'IdentityVerificationCaseV1FinanceDetails';
    serviceFee?: number | null;
    transactions?: {
      __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
      submission?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission';
        transactionReference?: {
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference';
          isSuccess?: boolean | null;
          status?: string | null;
          errorMessage?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1DeleteMutationVariables = Exact<{
  input: IdentityVerificationCaseV1DeleteInput;
}>;

export type CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1DeleteMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1Delete: {
    __typename?: 'IdentityVerificationCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesIdentityVerificationV1TransactionsContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationV1TransactionsContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    id: any;
    lastActivityAt?: any | null;
    financeDetails?: {
      __typename?: 'IdentityVerificationCaseV1FinanceDetails';
      transactions?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
        submission?: {
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission';
          amount?: number | null;
          transactionReference?: {
            __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference';
            completedAt?: any | null;
            referenceId?: string | null;
            vendor?: string | null;
          } | null;
        } | null;
        adhocTransactions?: Array<{
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction';
          amount?: number | null;
          reason?: string | null;
          requestedAt?: any | null;
          id: any;
          createdAt?: any | null;
          updatedAt?: any | null;
          approval?: {
            __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionApproval';
            applicantRespondedAt?: any | null;
            isApplicantApprovalRequired?: boolean | null;
            isApplicantApproved?: boolean | null;
          } | null;
          financeReference?: {
            __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFinanceReference';
            completedAt?: any | null;
            creditGlAccount?: string | null;
            debitGlAccount?: string | null;
          } | null;
          transactionReference?: {
            __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
            completedAt?: any | null;
            referenceId?: string | null;
            vendor?: string | null;
            isSuccess?: boolean | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1TransactionsContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  id: any;
  lastActivityAt?: any | null;
  financeDetails?: {
    __typename?: 'IdentityVerificationCaseV1FinanceDetails';
    transactions?: {
      __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
      submission?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission';
        amount?: number | null;
        transactionReference?: {
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference';
          completedAt?: any | null;
          referenceId?: string | null;
          vendor?: string | null;
        } | null;
      } | null;
      adhocTransactions?: Array<{
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction';
        amount?: number | null;
        reason?: string | null;
        requestedAt?: any | null;
        id: any;
        createdAt?: any | null;
        updatedAt?: any | null;
        approval?: {
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionApproval';
          applicantRespondedAt?: any | null;
          isApplicantApprovalRequired?: boolean | null;
          isApplicantApproved?: boolean | null;
        } | null;
        financeReference?: {
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFinanceReference';
          completedAt?: any | null;
          creditGlAccount?: string | null;
          debitGlAccount?: string | null;
        } | null;
        transactionReference?: {
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
          completedAt?: any | null;
          referenceId?: string | null;
          vendor?: string | null;
          isSuccess?: boolean | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type ApplicantUserIdVerificationTransactionsFinanceDetailsFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetails';
  transactions?: {
    __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
    submission?: {
      __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission';
      amount?: number | null;
      transactionReference?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference';
        completedAt?: any | null;
        referenceId?: string | null;
        vendor?: string | null;
      } | null;
    } | null;
    adhocTransactions?: Array<{
      __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction';
      amount?: number | null;
      reason?: string | null;
      requestedAt?: any | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
      approval?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionApproval';
        applicantRespondedAt?: any | null;
        isApplicantApprovalRequired?: boolean | null;
        isApplicantApproved?: boolean | null;
      } | null;
      financeReference?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFinanceReference';
        completedAt?: any | null;
        creditGlAccount?: string | null;
        debitGlAccount?: string | null;
      } | null;
      transactionReference?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
        completedAt?: any | null;
        referenceId?: string | null;
        vendor?: string | null;
        isSuccess?: boolean | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ApplicantCasesSectionLayoutContainerCredentialVerificationCaseV1CurrentQueryVariables = Exact<{
  applicantId: Scalars['ObjectID']['input'];
}>;

export type ApplicantCasesSectionLayoutContainerCredentialVerificationCaseV1CurrentQuery = {
  __typename?: 'Query';
  credentialVerificationCaseV1Current?: {
    __typename?: 'CredentialVerificationCaseV1';
    caseName?: string | null;
    caseType?: string | null;
    schemaVersion?: string | null;
    state: string;
    id: any;
    updatedAt?: any | null;
    caseDetails?: {
      __typename?: 'CredentialVerificationCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'CredentialVerificationCaseV1ApplicationReview';
        decision?: { __typename?: 'CredentialVerificationCaseV1ApplicationReviewDecision'; result?: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type ApplicantCasesSectionLayoutContainerApplicantUserCurrentQueryVariables = Exact<{ [key: string]: never }>;

export type ApplicantCasesSectionLayoutContainerApplicantUserCurrentQuery = {
  __typename?: 'Query';
  applicantUserCurrent?: {
    __typename?: 'ApplicantUser';
    displayName?: string | null;
    hasVerifiedCredential?: boolean | null;
    hasVerifiedIdentity?: boolean | null;
    id: any;
  } | null;
};

export type ApplicantSectionLayoutContainerSendReportCaseV1CurrentQueryVariables = Exact<{
  applicantId: Scalars['ObjectID']['input'];
}>;

export type ApplicantSectionLayoutContainerSendReportCaseV1CurrentQuery = {
  __typename?: 'Query';
  sendReportCaseV1Current?: {
    __typename?: 'SendReportCaseV1';
    caseName?: string | null;
    caseType?: string | null;
    schemaVersion?: string | null;
    state: string;
    id: any;
    updatedAt?: any | null;
    lastActivityAt?: any | null;
    caseDetails?: {
      __typename?: 'SendReportCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
        decision?: { __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewDecision'; result?: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type ApplicantCasesSectionLayoutContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  caseName?: string | null;
  caseType?: string | null;
  schemaVersion?: string | null;
  state: string;
  id: any;
  updatedAt?: any | null;
  caseDetails?: {
    __typename?: 'CredentialVerificationCaseV1CaseDetails';
    applicationReview?: {
      __typename?: 'CredentialVerificationCaseV1ApplicationReview';
      decision?: { __typename?: 'CredentialVerificationCaseV1ApplicationReviewDecision'; result?: string | null } | null;
    } | null;
  } | null;
};

export type ApplicantCasesSectionLayoutContainerSendReportCaseV1FieldsFragment = {
  __typename?: 'SendReportCaseV1';
  caseName?: string | null;
  caseType?: string | null;
  schemaVersion?: string | null;
  state: string;
  id: any;
  updatedAt?: any | null;
  lastActivityAt?: any | null;
  caseDetails?: {
    __typename?: 'SendReportCaseV1CaseDetails';
    applicationReview?: {
      __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
      decision?: { __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewDecision'; result?: string | null } | null;
    } | null;
  } | null;
};

export type ApplicantCasesSectionLayoutContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  state: string;
  id: any;
  caseDetails?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetails';
    applicationReview?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
      decision?: { __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision'; result?: string | null } | null;
    } | null;
  } | null;
};

export type ApplicantCasesSectionLayoutContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  displayName?: string | null;
  hasVerifiedCredential?: boolean | null;
  hasVerifiedIdentity?: boolean | null;
  id: any;
};

export type ApplicantCasesSendReportArchiveSummaryContainerArchivedSendReportCaseSummaryQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type ApplicantCasesSendReportArchiveSummaryContainerArchivedSendReportCaseSummaryQuery = {
  __typename?: 'Query';
  archivedSendReportCaseSummary?: {
    __typename?: 'ArchivedSendReportCaseSummary';
    archivedAt: any;
    createdAt: any;
    lastActivityAt: any;
    state: string;
    submittedAt: any;
    id: any;
    applicant: { __typename?: 'ApplicantUser'; id: any };
    caseDetails: {
      __typename?: 'ArchivedSendReportCaseSummaryCaseDetails';
      application: { __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplication'; credentialTitle: string; destinationName: string };
      applicationReview: {
        __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReview';
        decision: {
          __typename?: 'ArchivedCaseSummaryDecision';
          completedAt?: any | null;
          rejectionReason?: string | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; id: any; createdAt?: any | null; displayName?: string | null } | null;
        };
      };
    };
    financeDetails: {
      __typename?: 'ArchivedCaseSummaryFinanceDetails';
      transactions?: {
        __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactions';
        adhocTransactions?: Array<{
          __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
          amount?: number | null;
          reason?: string | null;
          transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null } | null;
        } | null> | null;
        submission?: {
          __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission';
          amount?: number | null;
          transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null } | null;
        } | null;
      } | null;
    };
  } | null;
};

export type ApplicantCasesSendReportArchiveSummaryContainerApplicantUserQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type ApplicantCasesSendReportArchiveSummaryContainerApplicantUserQuery = {
  __typename?: 'Query';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    displayName?: string | null;
    id: any;
    createdAt?: any | null;
    termsAndConditions?: Array<{
      __typename?: 'ApplicantUserTermsAndCondition';
      acceptanceOf?: string | null;
      attestedAt?: any | null;
      version?: number | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
    } | null> | null;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      professional?: {
        __typename?: 'ApplicantUserProfessional';
        primaryEducationalInformation?: Array<{
          __typename?: 'ApplicantUserPrimaryEducationalInformation';
          degreeTitle?: string | null;
          id: any;
          issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type ApplicantCasesSendReportArchiveSummaryContainerArchivedSendReportCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedSendReportCaseSummary';
  archivedAt: any;
  createdAt: any;
  lastActivityAt: any;
  state: string;
  submittedAt: any;
  id: any;
  applicant: { __typename?: 'ApplicantUser'; id: any };
  caseDetails: {
    __typename?: 'ArchivedSendReportCaseSummaryCaseDetails';
    application: { __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplication'; credentialTitle: string; destinationName: string };
    applicationReview: {
      __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReview';
      decision: {
        __typename?: 'ArchivedCaseSummaryDecision';
        completedAt?: any | null;
        rejectionReason?: string | null;
        result?: string | null;
        completedBy?: { __typename?: 'StaffUser'; id: any; createdAt?: any | null; displayName?: string | null } | null;
      };
    };
  };
  financeDetails: {
    __typename?: 'ArchivedCaseSummaryFinanceDetails';
    transactions?: {
      __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactions';
      adhocTransactions?: Array<{
        __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
        amount?: number | null;
        reason?: string | null;
        transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null } | null;
      } | null> | null;
      submission?: {
        __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission';
        amount?: number | null;
        transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null } | null;
      } | null;
    } | null;
  };
};

export type ApplicantCasesSendReportArchiveSummaryContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  displayName?: string | null;
  id: any;
  createdAt?: any | null;
  termsAndConditions?: Array<{
    __typename?: 'ApplicantUserTermsAndCondition';
    acceptanceOf?: string | null;
    attestedAt?: any | null;
    version?: number | null;
    id: any;
    createdAt?: any | null;
    updatedAt?: any | null;
  } | null> | null;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    professional?: {
      __typename?: 'ApplicantUserProfessional';
      primaryEducationalInformation?: Array<{
        __typename?: 'ApplicantUserPrimaryEducationalInformation';
        degreeTitle?: string | null;
        id: any;
        issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type SendReportV1CaseDetailsApplicationContainerSendReportCaseV1QueryVariables = Exact<{
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type SendReportV1CaseDetailsApplicationContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    id: any;
    submittedAt?: any | null;
    caseDetails?: {
      __typename?: 'SendReportCaseV1CaseDetails';
      application?: {
        __typename?: 'SendReportCaseV1CaseDetailsApplication';
        credential?: {
          __typename?: 'CredentialVerificationCaseV1';
          caseDetails?: {
            __typename?: 'CredentialVerificationCaseV1CaseDetails';
            application?: {
              __typename?: 'CredentialVerificationCaseV1Application';
              credentialTitle?: string | null;
              issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null } | null;
              otherIssuingInstitution?: { __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution'; institutionName?: string | null } | null;
            } | null;
          } | null;
        } | null;
        destination?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
      } | null;
      applicationReview?: {
        __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
        decision?: { __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewDecision'; result?: string | null; completedAt?: any | null } | null;
      } | null;
    } | null;
    revisionRequest?: {
      __typename?: 'SendReportCaseV1RevisionRequest';
      requestedChanges?: { __typename?: 'SendReportCaseV1RevisionRequestRequestChanges'; requestUpdatedDestination?: boolean | null } | null;
    } | null;
  } | null;
};

export type SendReportV1CaseDetailsApplicationContainerEntitiesQueryVariables = Exact<{ [key: string]: never }>;

export type SendReportV1CaseDetailsApplicationContainerEntitiesQuery = {
  __typename?: 'Query';
  entities?: Array<{ __typename?: 'Entity'; entityName?: string | null; isIssuingInstitution?: boolean | null; isClient?: boolean | null; id: any } | null> | null;
};

export type SendReportV1CaseDetailsApplicationContainerSendReportCaseV1UpdateMutationVariables = Exact<{
  input: SendReportCaseV1UpdateInput;
}>;

export type SendReportV1CaseDetailsApplicationContainerSendReportCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  sendReportCaseV1Update: {
    __typename?: 'SendReportCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    sendReportCaseV1?: {
      __typename?: 'SendReportCaseV1';
      id: any;
      state: string;
      caseDetails?: {
        __typename?: 'SendReportCaseV1CaseDetails';
        application?: {
          __typename?: 'SendReportCaseV1CaseDetailsApplication';
          destination?: { __typename?: 'Entity'; id: any } | null;
          credential?: { __typename?: 'CredentialVerificationCaseV1'; id: any } | null;
        } | null;
      } | null;
    } | null;
  };
};

export type SendReportV1CaseDetailsApplicationContainerEntityFieldsFragment = {
  __typename?: 'Entity';
  entityName?: string | null;
  isIssuingInstitution?: boolean | null;
  isClient?: boolean | null;
  id: any;
};

export type SendReportV1CaseDetailsApplicationContainerSendReportCaseV1FieldsFragment = {
  __typename?: 'SendReportCaseV1';
  id: any;
  submittedAt?: any | null;
  caseDetails?: {
    __typename?: 'SendReportCaseV1CaseDetails';
    application?: {
      __typename?: 'SendReportCaseV1CaseDetailsApplication';
      credential?: {
        __typename?: 'CredentialVerificationCaseV1';
        caseDetails?: {
          __typename?: 'CredentialVerificationCaseV1CaseDetails';
          application?: {
            __typename?: 'CredentialVerificationCaseV1Application';
            credentialTitle?: string | null;
            issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null } | null;
            otherIssuingInstitution?: { __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution'; institutionName?: string | null } | null;
          } | null;
        } | null;
      } | null;
      destination?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
    } | null;
    applicationReview?: {
      __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
      decision?: { __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewDecision'; result?: string | null; completedAt?: any | null } | null;
    } | null;
  } | null;
  revisionRequest?: {
    __typename?: 'SendReportCaseV1RevisionRequest';
    requestedChanges?: { __typename?: 'SendReportCaseV1RevisionRequestRequestChanges'; requestUpdatedDestination?: boolean | null } | null;
  } | null;
};

export type CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1QueryVariables = Exact<{
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    state: string;
    id: any;
    lastActivityAt?: any | null;
    messages?: Array<{
      __typename?: 'SendReportCaseV1Message';
      isHiddenFromApplicant?: boolean | null;
      sentBy?: string | null;
      embedding?: string | null;
      message?: string | null;
      id: any;
      createdAt?: any | null;
    } | null> | null;
    revisionRequest?: {
      __typename?: 'SendReportCaseV1RevisionRequest';
      requestedAt?: any | null;
      requestedChanges?: { __typename?: 'SendReportCaseV1RevisionRequestRequestChanges'; requestUpdatedDestination?: boolean | null } | null;
    } | null;
    applicant?: {
      __typename?: 'ApplicantUser';
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        identityDetails?: { __typename?: 'ApplicantUserIdentityDetails'; lastName?: string | null; restOfName?: string | null } | null;
      } | null;
    } | null;
    financeDetails?: {
      __typename?: 'SendReportCaseV1FinanceDetails';
      transactions?: {
        __typename?: 'SendReportCaseV1FinanceDetailsTransactions';
        adhocTransactions?: Array<{
          __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction';
          reason?: string | null;
          amount?: number | null;
          id: any;
          createdAt?: any | null;
          transactionReference?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1UpdateMutationVariables = Exact<{
  input: SendReportCaseV1UpdateInput;
}>;

export type CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  sendReportCaseV1Update: {
    __typename?: 'SendReportCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    sendReportCaseV1?: {
      __typename?: 'SendReportCaseV1';
      state: string;
      id: any;
      lastActivityAt?: any | null;
      messages?: Array<{
        __typename?: 'SendReportCaseV1Message';
        isHiddenFromApplicant?: boolean | null;
        sentBy?: string | null;
        embedding?: string | null;
        message?: string | null;
        id: any;
        createdAt?: any | null;
      } | null> | null;
      revisionRequest?: {
        __typename?: 'SendReportCaseV1RevisionRequest';
        requestedAt?: any | null;
        requestedChanges?: { __typename?: 'SendReportCaseV1RevisionRequestRequestChanges'; requestUpdatedDestination?: boolean | null } | null;
      } | null;
      applicant?: {
        __typename?: 'ApplicantUser';
        id: any;
        personalInformation?: {
          __typename?: 'ApplicantUserPersonalInformation';
          identityDetails?: { __typename?: 'ApplicantUserIdentityDetails'; lastName?: string | null; restOfName?: string | null } | null;
        } | null;
      } | null;
      financeDetails?: {
        __typename?: 'SendReportCaseV1FinanceDetails';
        transactions?: {
          __typename?: 'SendReportCaseV1FinanceDetailsTransactions';
          adhocTransactions?: Array<{
            __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction';
            reason?: string | null;
            amount?: number | null;
            id: any;
            createdAt?: any | null;
            transactionReference?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
          } | null> | null;
        } | null;
      } | null;
    } | null;
  };
};

export type CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1MutationResultFieldsFragment = {
  __typename?: 'SendReportCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    state: string;
    id: any;
    lastActivityAt?: any | null;
    messages?: Array<{
      __typename?: 'SendReportCaseV1Message';
      isHiddenFromApplicant?: boolean | null;
      sentBy?: string | null;
      embedding?: string | null;
      message?: string | null;
      id: any;
      createdAt?: any | null;
    } | null> | null;
    revisionRequest?: {
      __typename?: 'SendReportCaseV1RevisionRequest';
      requestedAt?: any | null;
      requestedChanges?: { __typename?: 'SendReportCaseV1RevisionRequestRequestChanges'; requestUpdatedDestination?: boolean | null } | null;
    } | null;
    applicant?: {
      __typename?: 'ApplicantUser';
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        identityDetails?: { __typename?: 'ApplicantUserIdentityDetails'; lastName?: string | null; restOfName?: string | null } | null;
      } | null;
    } | null;
    financeDetails?: {
      __typename?: 'SendReportCaseV1FinanceDetails';
      transactions?: {
        __typename?: 'SendReportCaseV1FinanceDetailsTransactions';
        adhocTransactions?: Array<{
          __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction';
          reason?: string | null;
          amount?: number | null;
          id: any;
          createdAt?: any | null;
          transactionReference?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FieldsFragment = {
  __typename?: 'SendReportCaseV1';
  state: string;
  id: any;
  lastActivityAt?: any | null;
  messages?: Array<{
    __typename?: 'SendReportCaseV1Message';
    isHiddenFromApplicant?: boolean | null;
    sentBy?: string | null;
    embedding?: string | null;
    message?: string | null;
    id: any;
    createdAt?: any | null;
  } | null> | null;
  revisionRequest?: {
    __typename?: 'SendReportCaseV1RevisionRequest';
    requestedAt?: any | null;
    requestedChanges?: { __typename?: 'SendReportCaseV1RevisionRequestRequestChanges'; requestUpdatedDestination?: boolean | null } | null;
  } | null;
  applicant?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      identityDetails?: { __typename?: 'ApplicantUserIdentityDetails'; lastName?: string | null; restOfName?: string | null } | null;
    } | null;
  } | null;
  financeDetails?: {
    __typename?: 'SendReportCaseV1FinanceDetails';
    transactions?: {
      __typename?: 'SendReportCaseV1FinanceDetailsTransactions';
      adhocTransactions?: Array<{
        __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction';
        reason?: string | null;
        amount?: number | null;
        id: any;
        createdAt?: any | null;
        transactionReference?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsFieldsFragment = {
  __typename?: 'SendReportCaseV1FinanceDetails';
  transactions?: {
    __typename?: 'SendReportCaseV1FinanceDetailsTransactions';
    adhocTransactions?: Array<{
      __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction';
      reason?: string | null;
      amount?: number | null;
      id: any;
      createdAt?: any | null;
      transactionReference?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
    } | null> | null;
  } | null;
};

export type CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionsFieldsFragment = {
  __typename?: 'SendReportCaseV1FinanceDetailsTransactions';
  adhocTransactions?: Array<{
    __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction';
    reason?: string | null;
    amount?: number | null;
    id: any;
    createdAt?: any | null;
    transactionReference?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
  } | null> | null;
};

export type CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFieldsFragment = {
  __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction';
  reason?: string | null;
  amount?: number | null;
  id: any;
  createdAt?: any | null;
  transactionReference?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
};

export type CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestFieldsFragment = {
  __typename?: 'SendReportCaseV1RevisionRequest';
  requestedAt?: any | null;
  requestedChanges?: { __typename?: 'SendReportCaseV1RevisionRequestRequestChanges'; requestUpdatedDestination?: boolean | null } | null;
};

export type CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1MessageFieldsFragment = {
  __typename?: 'SendReportCaseV1Message';
  isHiddenFromApplicant?: boolean | null;
  sentBy?: string | null;
  embedding?: string | null;
  message?: string | null;
  id: any;
  createdAt?: any | null;
};

export type CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestRequestedChangesFieldsFragment = {
  __typename?: 'SendReportCaseV1RevisionRequestRequestChanges';
  requestUpdatedDestination?: boolean | null;
};

export type CasesSendReportV1CaseDetailsMessagesContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  id: any;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    identityDetails?: { __typename?: 'ApplicantUserIdentityDetails'; lastName?: string | null; restOfName?: string | null } | null;
  } | null;
};

export type SendReportV1CreateContainerSendReportCaseV1QueryVariables = Exact<{
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type SendReportV1CreateContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    state: string;
    id: any;
    financeDetails?: {
      __typename?: 'SendReportCaseV1FinanceDetails';
      serviceFee?: number | null;
      transactions?: {
        __typename?: 'SendReportCaseV1FinanceDetailsTransactions';
        submission?: {
          __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmission';
          transactionReference?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmissionTransactionReference'; status?: string | null } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type SendReportV1CreateContainerVerifiedCredentialVerificationCaseSummariesByApplicantQueryVariables = Exact<{
  applicantId: Scalars['ObjectID']['input'];
}>;

export type SendReportV1CreateContainerVerifiedCredentialVerificationCaseSummariesByApplicantQuery = {
  __typename?: 'Query';
  verifiedCredentialVerificationCaseSummariesByApplicant?: Array<{
    __typename?: 'VerifiedCredentialVerificationCaseSummary';
    id: any;
    caseDetails: {
      __typename?: 'VerifiedCredentialVerificationCaseSummaryCaseDetails';
      application: { __typename?: 'VerifiedCredentialVerificationCaseSummaryCaseDetailsApplication'; credentialTitle: string; issuingInstitutionName: string };
    };
  } | null> | null;
};

export type SendReportV1CreateContainerVerifiedCredentialVerificationCaseSummaryFieldsFragment = {
  __typename?: 'VerifiedCredentialVerificationCaseSummary';
  id: any;
  caseDetails: {
    __typename?: 'VerifiedCredentialVerificationCaseSummaryCaseDetails';
    application: { __typename?: 'VerifiedCredentialVerificationCaseSummaryCaseDetailsApplication'; credentialTitle: string; issuingInstitutionName: string };
  };
};

export type SendReportV1CreateContainerVerifiedCredentialVerificationCaseSummaryCaseDetailsFieldsFragment = {
  __typename?: 'VerifiedCredentialVerificationCaseSummaryCaseDetails';
  application: { __typename?: 'VerifiedCredentialVerificationCaseSummaryCaseDetailsApplication'; credentialTitle: string; issuingInstitutionName: string };
};

export type SendReportV1CreateContainerEntitiesQueryVariables = Exact<{ [key: string]: never }>;

export type SendReportV1CreateContainerEntitiesQuery = {
  __typename?: 'Query';
  entities?: Array<{ __typename?: 'Entity'; entityName?: string | null; isIssuingInstitution?: boolean | null; isClient?: boolean | null; id: any } | null> | null;
};

export type SendReportV1CreateContainerSendReportCaseV1LazyQueryQueryVariables = Exact<{
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type SendReportV1CreateContainerSendReportCaseV1LazyQueryQuery = {
  __typename?: 'Query';
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    caseName?: string | null;
    caseType?: string | null;
    schemaVersion?: string | null;
    state: string;
    lastActivityAt?: any | null;
    id: any;
    updatedAt?: any | null;
    financeDetails?: {
      __typename?: 'SendReportCaseV1FinanceDetails';
      transactions?: {
        __typename?: 'SendReportCaseV1FinanceDetailsTransactions';
        submission?: {
          __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmission';
          transactionReference?: {
            __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmissionTransactionReference';
            isSuccess?: boolean | null;
            status?: string | null;
            errorMessage?: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type SendReportV1CreateContainerSendReportCaseV1DeleteMutationVariables = Exact<{
  input: SendReportCaseV1DeleteInput;
}>;

export type SendReportV1CreateContainerSendReportCaseV1DeleteMutation = {
  __typename?: 'Mutation';
  sendReportCaseV1Delete: { __typename?: 'SendReportCaseV1MutationResult'; status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean } };
};

export type SendReportV1CreateContainerSendReportCaseV1FinanceDetailsTransactionsFieldsFragment = {
  __typename?: 'SendReportCaseV1FinanceDetailsTransactions';
  submission?: {
    __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmission';
    transactionReference?: {
      __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmissionTransactionReference';
      isSuccess?: boolean | null;
      status?: string | null;
      errorMessage?: string | null;
    } | null;
  } | null;
};

export type SendReportV1CreateContainerSendReportCaseV1UpdateMutationVariables = Exact<{
  input: SendReportCaseV1UpdateInput;
}>;

export type SendReportV1CreateContainerSendReportCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  sendReportCaseV1Update: {
    __typename?: 'SendReportCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    sendReportCaseV1?: {
      __typename?: 'SendReportCaseV1';
      id: any;
      financeDetails?: {
        __typename?: 'SendReportCaseV1FinanceDetails';
        transactions?: {
          __typename?: 'SendReportCaseV1FinanceDetailsTransactions';
          submission?: {
            __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmission';
            transactionReference?: {
              __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmissionTransactionReference';
              isSuccess?: boolean | null;
              status?: string | null;
              errorMessage?: string | null;
            } | null;
          } | null;
        } | null;
      } | null;
      caseDetails?: {
        __typename?: 'SendReportCaseV1CaseDetails';
        application?: {
          __typename?: 'SendReportCaseV1CaseDetailsApplication';
          isAttestationComplete?: boolean | null;
          destination?: { __typename?: 'Entity'; id: any } | null;
          credential?: { __typename?: 'CredentialVerificationCaseV1'; id: any } | null;
        } | null;
      } | null;
    } | null;
  };
};

export type SendReportV1CreateContainerSendReportCaseV1MutationResultFieldsFragment = {
  __typename?: 'SendReportCaseV1';
  id: any;
  financeDetails?: {
    __typename?: 'SendReportCaseV1FinanceDetails';
    transactions?: {
      __typename?: 'SendReportCaseV1FinanceDetailsTransactions';
      submission?: {
        __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmission';
        transactionReference?: {
          __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmissionTransactionReference';
          isSuccess?: boolean | null;
          status?: string | null;
          errorMessage?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
  caseDetails?: {
    __typename?: 'SendReportCaseV1CaseDetails';
    application?: {
      __typename?: 'SendReportCaseV1CaseDetailsApplication';
      isAttestationComplete?: boolean | null;
      destination?: { __typename?: 'Entity'; id: any } | null;
      credential?: { __typename?: 'CredentialVerificationCaseV1'; id: any } | null;
    } | null;
  } | null;
};

export type SendReportV1CreateContainerSendReportCaseV1MutationApplicationFieldsFragment = {
  __typename?: 'SendReportCaseV1CaseDetailsApplication';
  isAttestationComplete?: boolean | null;
  destination?: { __typename?: 'Entity'; id: any } | null;
  credential?: { __typename?: 'CredentialVerificationCaseV1'; id: any } | null;
};

export type SendReportV1CreateContainerSendReportCaseV1FieldsFragment = {
  __typename?: 'SendReportCaseV1';
  state: string;
  id: any;
  financeDetails?: {
    __typename?: 'SendReportCaseV1FinanceDetails';
    serviceFee?: number | null;
    transactions?: {
      __typename?: 'SendReportCaseV1FinanceDetailsTransactions';
      submission?: {
        __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmission';
        transactionReference?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmissionTransactionReference'; status?: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type SendReportV1CreateContainerEntityFieldsFragment = {
  __typename?: 'Entity';
  entityName?: string | null;
  isIssuingInstitution?: boolean | null;
  isClient?: boolean | null;
  id: any;
};

export type CasesSendReportV1TransactionsContainerSendReportCaseV1QueryVariables = Exact<{
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportV1TransactionsContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    id: any;
    lastActivityAt?: any | null;
    financeDetails?: {
      __typename?: 'SendReportCaseV1FinanceDetails';
      transactions?: {
        __typename?: 'SendReportCaseV1FinanceDetailsTransactions';
        submission?: {
          __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmission';
          amount?: number | null;
          transactionReference?: {
            __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmissionTransactionReference';
            completedAt?: any | null;
            referenceId?: string | null;
            vendor?: string | null;
          } | null;
        } | null;
        adhocTransactions?: Array<{
          __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction';
          amount?: number | null;
          reason?: string | null;
          requestedAt?: any | null;
          id: any;
          createdAt?: any | null;
          updatedAt?: any | null;
          approval?: {
            __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionApproval';
            applicantRespondedAt?: any | null;
            isApplicantApprovalRequired?: boolean | null;
            isApplicantApproved?: boolean | null;
          } | null;
          financeReference?: {
            __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionFinanceReference';
            recognizedAt?: any | null;
            creditGlAccount?: string | null;
            debitGlAccount?: string | null;
          } | null;
          transactionReference?: {
            __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionTransactionReference';
            completedAt?: any | null;
            referenceId?: string | null;
            vendor?: string | null;
            isSuccess?: boolean | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type CasesSendReportV1TransactionsContainerSendReportCaseV1FieldsFragment = {
  __typename?: 'SendReportCaseV1';
  id: any;
  lastActivityAt?: any | null;
  financeDetails?: {
    __typename?: 'SendReportCaseV1FinanceDetails';
    transactions?: {
      __typename?: 'SendReportCaseV1FinanceDetailsTransactions';
      submission?: {
        __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmission';
        amount?: number | null;
        transactionReference?: {
          __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmissionTransactionReference';
          completedAt?: any | null;
          referenceId?: string | null;
          vendor?: string | null;
        } | null;
      } | null;
      adhocTransactions?: Array<{
        __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction';
        amount?: number | null;
        reason?: string | null;
        requestedAt?: any | null;
        id: any;
        createdAt?: any | null;
        updatedAt?: any | null;
        approval?: {
          __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionApproval';
          applicantRespondedAt?: any | null;
          isApplicantApprovalRequired?: boolean | null;
          isApplicantApproved?: boolean | null;
        } | null;
        financeReference?: {
          __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionFinanceReference';
          recognizedAt?: any | null;
          creditGlAccount?: string | null;
          debitGlAccount?: string | null;
        } | null;
        transactionReference?: {
          __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionTransactionReference';
          completedAt?: any | null;
          referenceId?: string | null;
          vendor?: string | null;
          isSuccess?: boolean | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type ApplicantUserSendReportVerificationTransactionsFinanceDetailsFieldsFragment = {
  __typename?: 'SendReportCaseV1FinanceDetails';
  transactions?: {
    __typename?: 'SendReportCaseV1FinanceDetailsTransactions';
    submission?: {
      __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmission';
      amount?: number | null;
      transactionReference?: {
        __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmissionTransactionReference';
        completedAt?: any | null;
        referenceId?: string | null;
        vendor?: string | null;
      } | null;
    } | null;
    adhocTransactions?: Array<{
      __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction';
      amount?: number | null;
      reason?: string | null;
      requestedAt?: any | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
      approval?: {
        __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionApproval';
        applicantRespondedAt?: any | null;
        isApplicantApprovalRequired?: boolean | null;
        isApplicantApproved?: boolean | null;
      } | null;
      financeReference?: {
        __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionFinanceReference';
        recognizedAt?: any | null;
        creditGlAccount?: string | null;
        debitGlAccount?: string | null;
      } | null;
      transactionReference?: {
        __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionTransactionReference';
        completedAt?: any | null;
        referenceId?: string | null;
        vendor?: string | null;
        isSuccess?: boolean | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ApplicantContactDetailsContainerApplicantUserQueryVariables = Exact<{
  applicantUserId: Scalars['ObjectID']['input'];
}>;

export type ApplicantContactDetailsContainerApplicantUserQuery = {
  __typename?: 'Query';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    isProfileSubmitted?: boolean | null;
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      identityDetails?: {
        __typename?: 'ApplicantUserIdentityDetails';
        dateOfBirth?: any | null;
        gender?: string | null;
        generationalSuffix?: string | null;
        lastName?: string | null;
        legalNameConsistsOfOneName?: boolean | null;
        restOfName?: string | null;
      } | null;
      contactInformation?: {
        __typename?: 'ApplicantUserContactInformation';
        emailAddress?: string | null;
        primaryPhone?: string | null;
        address?: {
          __typename?: 'ApplicantUserAddress';
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          streetAddressLine1?: string | null;
          streetAddressLine2?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; id: any } | null> | null;
      } | null;
      citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
    } | null;
    termsAndConditions?: Array<{ __typename?: 'ApplicantUserTermsAndCondition'; acceptanceOf?: string | null; version?: number | null; id: any } | null> | null;
  } | null;
};

export type ApplicantContactDetailsContainerApplicantUserUpdateMutationVariables = Exact<{
  input: ApplicantUserUpdateInput;
}>;

export type ApplicantContactDetailsContainerApplicantUserUpdateMutation = {
  __typename?: 'Mutation';
  applicantUserUpdate: {
    __typename?: 'ApplicantUserMutationResult';
    applicantUser?: {
      __typename?: 'ApplicantUser';
      isProfileSubmitted?: boolean | null;
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        identityDetails?: {
          __typename?: 'ApplicantUserIdentityDetails';
          dateOfBirth?: any | null;
          gender?: string | null;
          generationalSuffix?: string | null;
          lastName?: string | null;
          legalNameConsistsOfOneName?: boolean | null;
          restOfName?: string | null;
        } | null;
        contactInformation?: {
          __typename?: 'ApplicantUserContactInformation';
          emailAddress?: string | null;
          primaryPhone?: string | null;
          address?: {
            __typename?: 'ApplicantUserAddress';
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            streetAddressLine1?: string | null;
            streetAddressLine2?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
          phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; id: any } | null> | null;
        } | null;
        citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
      } | null;
      termsAndConditions?: Array<{ __typename?: 'ApplicantUserTermsAndCondition'; acceptanceOf?: string | null; version?: number | null; id: any } | null> | null;
    } | null;
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
  };
};

export type ApplicantContactDetailsContainerApplicantUserMutationResultFieldsFragment = {
  __typename?: 'ApplicantUserMutationResult';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    isProfileSubmitted?: boolean | null;
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      identityDetails?: {
        __typename?: 'ApplicantUserIdentityDetails';
        dateOfBirth?: any | null;
        gender?: string | null;
        generationalSuffix?: string | null;
        lastName?: string | null;
        legalNameConsistsOfOneName?: boolean | null;
        restOfName?: string | null;
      } | null;
      contactInformation?: {
        __typename?: 'ApplicantUserContactInformation';
        emailAddress?: string | null;
        primaryPhone?: string | null;
        address?: {
          __typename?: 'ApplicantUserAddress';
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          streetAddressLine1?: string | null;
          streetAddressLine2?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; id: any } | null> | null;
      } | null;
      citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
    } | null;
    termsAndConditions?: Array<{ __typename?: 'ApplicantUserTermsAndCondition'; acceptanceOf?: string | null; version?: number | null; id: any } | null> | null;
  } | null;
  status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
};

export type ApplicantContactDetailsContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  isProfileSubmitted?: boolean | null;
  id: any;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    identityDetails?: {
      __typename?: 'ApplicantUserIdentityDetails';
      dateOfBirth?: any | null;
      gender?: string | null;
      generationalSuffix?: string | null;
      lastName?: string | null;
      legalNameConsistsOfOneName?: boolean | null;
      restOfName?: string | null;
    } | null;
    contactInformation?: {
      __typename?: 'ApplicantUserContactInformation';
      emailAddress?: string | null;
      primaryPhone?: string | null;
      address?: {
        __typename?: 'ApplicantUserAddress';
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        streetAddressLine1?: string | null;
        streetAddressLine2?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
      phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; id: any } | null> | null;
    } | null;
    citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
  } | null;
  termsAndConditions?: Array<{ __typename?: 'ApplicantUserTermsAndCondition'; acceptanceOf?: string | null; version?: number | null; id: any } | null> | null;
};

export type ApplicantContactDetailsContainerApplicantUserTermsAndConditionFieldsFragment = {
  __typename?: 'ApplicantUserTermsAndCondition';
  acceptanceOf?: string | null;
  version?: number | null;
  id: any;
};

export type ApplicantContactDetailsContainerApplicantUserPersonalInformationFieldsFragment = {
  __typename?: 'ApplicantUserPersonalInformation';
  identityDetails?: {
    __typename?: 'ApplicantUserIdentityDetails';
    dateOfBirth?: any | null;
    gender?: string | null;
    generationalSuffix?: string | null;
    lastName?: string | null;
    legalNameConsistsOfOneName?: boolean | null;
    restOfName?: string | null;
  } | null;
  contactInformation?: {
    __typename?: 'ApplicantUserContactInformation';
    emailAddress?: string | null;
    primaryPhone?: string | null;
    address?: {
      __typename?: 'ApplicantUserAddress';
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      streetAddressLine1?: string | null;
      streetAddressLine2?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
    phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; id: any } | null> | null;
  } | null;
  citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
};

export type ApplicantContactDetailsContainerApplicantUserContactInformationFieldsFragment = {
  __typename?: 'ApplicantUserContactInformation';
  emailAddress?: string | null;
  primaryPhone?: string | null;
  address?: {
    __typename?: 'ApplicantUserAddress';
    city?: string | null;
    country?: string | null;
    stateOrProvince?: string | null;
    streetAddressLine1?: string | null;
    streetAddressLine2?: string | null;
    zipOrPostalCode?: string | null;
  } | null;
  phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; id: any } | null> | null;
};

export type ApplicantContactDetailsContainerApplicantUserIdentityDetailsFieldsFragment = {
  __typename?: 'ApplicantUserIdentityDetails';
  dateOfBirth?: any | null;
  gender?: string | null;
  generationalSuffix?: string | null;
  lastName?: string | null;
  legalNameConsistsOfOneName?: boolean | null;
  restOfName?: string | null;
};

export type ApplicantContactDetailsContainerApplicantUserAddressFieldsFragment = {
  __typename?: 'ApplicantUserAddress';
  city?: string | null;
  country?: string | null;
  stateOrProvince?: string | null;
  streetAddressLine1?: string | null;
  streetAddressLine2?: string | null;
  zipOrPostalCode?: string | null;
};

export type ApplicantContactDetailsContainerApplicantUserPhoneFieldsFragment = {
  __typename?: 'ApplicantUserPhone';
  phoneNumber?: string | null;
  phoneType?: string | null;
  id: any;
};

export type ApplicantContactDetailsContainerApplicantUserCitizenshipFieldsFragment = {
  __typename?: 'ApplicantUserCitizenship';
  currentCitizenOf?: Array<string | null> | null;
};

export type ApplicantIdVerificationPreviewContainerApplicantUserQueryVariables = Exact<{
  applicantUserId: Scalars['ObjectID']['input'];
}>;

export type ApplicantIdVerificationPreviewContainerApplicantUserQuery = {
  __typename?: 'Query';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    isProfileSubmitted?: boolean | null;
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; name: string; url: string } | null> | null;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; id: any } | null> | null;
      citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
      contactInformation?: {
        __typename?: 'ApplicantUserContactInformation';
        emailAddress?: string | null;
        primaryPhone?: string | null;
        address?: {
          __typename?: 'ApplicantUserAddress';
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          streetAddressLine1?: string | null;
          streetAddressLine2?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; id: any } | null> | null;
      } | null;
      identityDetails?: {
        __typename?: 'ApplicantUserIdentityDetails';
        dateOfBirth?: any | null;
        gender?: string | null;
        generationalSuffix?: string | null;
        lastName?: string | null;
        legalNameConsistsOfOneName?: boolean | null;
        restOfName?: string | null;
      } | null;
      professional?: {
        __typename?: 'ApplicantUserProfessional';
        citizenshipAtTimeEnteredMedicalInstitution?: string | null;
        healthProfession?: string | null;
        primaryEducationalInformation?: Array<{
          __typename?: 'ApplicantUserPrimaryEducationalInformation';
          attendanceEndedAt?: any | null;
          attendanceStartedAt?: any | null;
          degreeIssuedAt?: any | null;
          degreeTitle?: string | null;
          graduationYear?: number | null;
          id: any;
          issuingInstitution?: {
            __typename?: 'Entity';
            entityName?: string | null;
            id: any;
            issuingInstitution?: {
              __typename?: 'EntityIssuingInstitution';
              address?: {
                __typename?: 'EntityAddressInfo';
                addressLine1?: string | null;
                city?: string | null;
                stateOrProvince?: string | null;
                zipOrPostalCode?: string | null;
                country?: string | null;
              } | null;
            } | null;
          } | null;
          otherIssuingInstitution?: {
            __typename?: 'ApplicantUserOtherIssuingInstitution';
            addressLine1?: string | null;
            city?: string | null;
            country?: string | null;
            name?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
    termsAndConditions?: Array<{
      __typename?: 'ApplicantUserTermsAndCondition';
      acceptanceOf?: string | null;
      attestedAt?: any | null;
      version?: number | null;
      id: any;
    } | null> | null;
  } | null;
};

export type ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    id: any;
    caseDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetails';
      application?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
        isAttestationComplete?: boolean | null;
        passportDetails?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
          isPassportExpirationDateVisible?: boolean | null;
          isPassportInLatinCharacters?: boolean | null;
          passportCountry?: string | null;
          passportExpiresAt?: any | null;
          passportIssuedAt?: any | null;
          passportNumber?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1UpdateMutationVariables = Exact<{
  input: IdentityVerificationCaseV1UpdateInput;
}>;

export type ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1Update: {
    __typename?: 'IdentityVerificationCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
    identityVerificationCaseV1?: {
      __typename?: 'IdentityVerificationCaseV1';
      id: any;
      caseDetails?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetails';
        application?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
          isAttestationComplete?: boolean | null;
          passportDetails?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
            isPassportExpirationDateVisible?: boolean | null;
            isPassportInLatinCharacters?: boolean | null;
            passportCountry?: string | null;
            passportExpiresAt?: any | null;
            passportIssuedAt?: any | null;
            passportNumber?: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
  };
};

export type ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1DeleteMutationVariables = Exact<{
  input: IdentityVerificationCaseV1DeleteInput;
}>;

export type ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1DeleteMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1Delete: {
    __typename?: 'IdentityVerificationCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
    identityVerificationCaseV1?: {
      __typename?: 'IdentityVerificationCaseV1';
      id: any;
      caseDetails?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetails';
        application?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
          isAttestationComplete?: boolean | null;
          passportDetails?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
            isPassportExpirationDateVisible?: boolean | null;
            isPassportInLatinCharacters?: boolean | null;
            passportCountry?: string | null;
            passportExpiresAt?: any | null;
            passportIssuedAt?: any | null;
            passportNumber?: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
  };
};

export type ApplicantIdVerificationPreviewContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  isProfileSubmitted?: boolean | null;
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; name: string; url: string } | null> | null;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; id: any } | null> | null;
    citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
    contactInformation?: {
      __typename?: 'ApplicantUserContactInformation';
      emailAddress?: string | null;
      primaryPhone?: string | null;
      address?: {
        __typename?: 'ApplicantUserAddress';
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        streetAddressLine1?: string | null;
        streetAddressLine2?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
      phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; id: any } | null> | null;
    } | null;
    identityDetails?: {
      __typename?: 'ApplicantUserIdentityDetails';
      dateOfBirth?: any | null;
      gender?: string | null;
      generationalSuffix?: string | null;
      lastName?: string | null;
      legalNameConsistsOfOneName?: boolean | null;
      restOfName?: string | null;
    } | null;
    professional?: {
      __typename?: 'ApplicantUserProfessional';
      citizenshipAtTimeEnteredMedicalInstitution?: string | null;
      healthProfession?: string | null;
      primaryEducationalInformation?: Array<{
        __typename?: 'ApplicantUserPrimaryEducationalInformation';
        attendanceEndedAt?: any | null;
        attendanceStartedAt?: any | null;
        degreeIssuedAt?: any | null;
        degreeTitle?: string | null;
        graduationYear?: number | null;
        id: any;
        issuingInstitution?: {
          __typename?: 'Entity';
          entityName?: string | null;
          id: any;
          issuingInstitution?: {
            __typename?: 'EntityIssuingInstitution';
            address?: {
              __typename?: 'EntityAddressInfo';
              addressLine1?: string | null;
              city?: string | null;
              stateOrProvince?: string | null;
              zipOrPostalCode?: string | null;
              country?: string | null;
            } | null;
          } | null;
        } | null;
        otherIssuingInstitution?: {
          __typename?: 'ApplicantUserOtherIssuingInstitution';
          addressLine1?: string | null;
          city?: string | null;
          country?: string | null;
          name?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
  termsAndConditions?: Array<{
    __typename?: 'ApplicantUserTermsAndCondition';
    acceptanceOf?: string | null;
    attestedAt?: any | null;
    version?: number | null;
    id: any;
  } | null> | null;
};

export type ApplicantIdVerificationPreviewContainerFileInfoFieldsFragment = { __typename?: 'FileInfo'; name: string; url: string };

export type ApplicantIdVerificationPreviewContainerApplicantUserPersonalInformationFieldsFragment = {
  __typename?: 'ApplicantUserPersonalInformation';
  applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; id: any } | null> | null;
  citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
  contactInformation?: {
    __typename?: 'ApplicantUserContactInformation';
    emailAddress?: string | null;
    primaryPhone?: string | null;
    address?: {
      __typename?: 'ApplicantUserAddress';
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      streetAddressLine1?: string | null;
      streetAddressLine2?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
    phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; id: any } | null> | null;
  } | null;
  identityDetails?: {
    __typename?: 'ApplicantUserIdentityDetails';
    dateOfBirth?: any | null;
    gender?: string | null;
    generationalSuffix?: string | null;
    lastName?: string | null;
    legalNameConsistsOfOneName?: boolean | null;
    restOfName?: string | null;
  } | null;
  professional?: {
    __typename?: 'ApplicantUserProfessional';
    citizenshipAtTimeEnteredMedicalInstitution?: string | null;
    healthProfession?: string | null;
    primaryEducationalInformation?: Array<{
      __typename?: 'ApplicantUserPrimaryEducationalInformation';
      attendanceEndedAt?: any | null;
      attendanceStartedAt?: any | null;
      degreeIssuedAt?: any | null;
      degreeTitle?: string | null;
      graduationYear?: number | null;
      id: any;
      issuingInstitution?: {
        __typename?: 'Entity';
        entityName?: string | null;
        id: any;
        issuingInstitution?: {
          __typename?: 'EntityIssuingInstitution';
          address?: {
            __typename?: 'EntityAddressInfo';
            addressLine1?: string | null;
            city?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
            country?: string | null;
          } | null;
        } | null;
      } | null;
      otherIssuingInstitution?: {
        __typename?: 'ApplicantUserOtherIssuingInstitution';
        addressLine1?: string | null;
        city?: string | null;
        country?: string | null;
        name?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ApplicantIdVerificationPreviewContainerApplicantUserTermsAndConditionFieldsFragment = {
  __typename?: 'ApplicantUserTermsAndCondition';
  acceptanceOf?: string | null;
  attestedAt?: any | null;
  version?: number | null;
  id: any;
};

export type ApplicantIdVerificationPreviewContainerEntityFieldsFragment = { __typename?: 'Entity'; entityName?: string | null; id: any };

export type ApplicantIdVerificationPreviewContainerApplicantUserCitizenshipFieldsFragment = {
  __typename?: 'ApplicantUserCitizenship';
  currentCitizenOf?: Array<string | null> | null;
};

export type ApplicantIdVerificationPreviewContainerApplicantUserContactInformationFieldFragment = {
  __typename?: 'ApplicantUserContactInformation';
  emailAddress?: string | null;
  primaryPhone?: string | null;
  address?: {
    __typename?: 'ApplicantUserAddress';
    city?: string | null;
    country?: string | null;
    stateOrProvince?: string | null;
    streetAddressLine1?: string | null;
    streetAddressLine2?: string | null;
    zipOrPostalCode?: string | null;
  } | null;
  phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; id: any } | null> | null;
};

export type ApplicantIdVerificationPreviewContainerApplicantUserIdentityDetailsFieldsFragment = {
  __typename?: 'ApplicantUserIdentityDetails';
  dateOfBirth?: any | null;
  gender?: string | null;
  generationalSuffix?: string | null;
  lastName?: string | null;
  legalNameConsistsOfOneName?: boolean | null;
  restOfName?: string | null;
};

export type ApplicantIdVerificationPreviewContainerApplicantUserProfessionalFieldsFragment = {
  __typename?: 'ApplicantUserProfessional';
  citizenshipAtTimeEnteredMedicalInstitution?: string | null;
  healthProfession?: string | null;
  primaryEducationalInformation?: Array<{
    __typename?: 'ApplicantUserPrimaryEducationalInformation';
    attendanceEndedAt?: any | null;
    attendanceStartedAt?: any | null;
    degreeIssuedAt?: any | null;
    degreeTitle?: string | null;
    graduationYear?: number | null;
    id: any;
    issuingInstitution?: {
      __typename?: 'Entity';
      entityName?: string | null;
      id: any;
      issuingInstitution?: {
        __typename?: 'EntityIssuingInstitution';
        address?: {
          __typename?: 'EntityAddressInfo';
          addressLine1?: string | null;
          city?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
          country?: string | null;
        } | null;
      } | null;
    } | null;
    otherIssuingInstitution?: {
      __typename?: 'ApplicantUserOtherIssuingInstitution';
      addressLine1?: string | null;
      city?: string | null;
      country?: string | null;
      name?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
  } | null> | null;
};

export type ApplicantIdVerificationPreviewContainerApplicantUserAddressFieldsFragment = {
  __typename?: 'ApplicantUserAddress';
  city?: string | null;
  country?: string | null;
  stateOrProvince?: string | null;
  streetAddressLine1?: string | null;
  streetAddressLine2?: string | null;
  zipOrPostalCode?: string | null;
};

export type ApplicantIdVerificationPreviewContainerApplicantUserPhoneFieldsFragment = {
  __typename?: 'ApplicantUserPhone';
  phoneNumber?: string | null;
  phoneType?: string | null;
  id: any;
};

export type ApplicantIdVerificationPreviewContainerApplicantUserPrimaryEducationalInformationFieldsFragment = {
  __typename?: 'ApplicantUserPrimaryEducationalInformation';
  attendanceEndedAt?: any | null;
  attendanceStartedAt?: any | null;
  degreeIssuedAt?: any | null;
  degreeTitle?: string | null;
  graduationYear?: number | null;
  id: any;
  issuingInstitution?: {
    __typename?: 'Entity';
    entityName?: string | null;
    id: any;
    issuingInstitution?: {
      __typename?: 'EntityIssuingInstitution';
      address?: {
        __typename?: 'EntityAddressInfo';
        addressLine1?: string | null;
        city?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
        country?: string | null;
      } | null;
    } | null;
  } | null;
  otherIssuingInstitution?: {
    __typename?: 'ApplicantUserOtherIssuingInstitution';
    addressLine1?: string | null;
    city?: string | null;
    country?: string | null;
    name?: string | null;
    stateOrProvince?: string | null;
    zipOrPostalCode?: string | null;
  } | null;
};

export type ApplicantIdVerificationPreviewContainerApplicantUserIssuingInstitutionAddressFieldsFragment = {
  __typename?: 'EntityAddressInfo';
  addressLine1?: string | null;
  city?: string | null;
  stateOrProvince?: string | null;
  zipOrPostalCode?: string | null;
  country?: string | null;
};

export type ApplicantIdVerificationPreviewContainerApplicantUserOtherIssuingInstitutionFieldsFragment = {
  __typename?: 'ApplicantUserOtherIssuingInstitution';
  addressLine1?: string | null;
  city?: string | null;
  country?: string | null;
  name?: string | null;
  stateOrProvince?: string | null;
  zipOrPostalCode?: string | null;
};

export type ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  id: any;
  caseDetails?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetails';
    application?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
      isAttestationComplete?: boolean | null;
      passportDetails?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
        isPassportExpirationDateVisible?: boolean | null;
        isPassportInLatinCharacters?: boolean | null;
        passportCountry?: string | null;
        passportExpiresAt?: any | null;
        passportIssuedAt?: any | null;
        passportNumber?: string | null;
      } | null;
    } | null;
  } | null;
};

export type ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetails';
  application?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
    isAttestationComplete?: boolean | null;
    passportDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
      isPassportExpirationDateVisible?: boolean | null;
      isPassportInLatinCharacters?: boolean | null;
      passportCountry?: string | null;
      passportExpiresAt?: any | null;
      passportIssuedAt?: any | null;
      passportNumber?: string | null;
    } | null;
  } | null;
};

export type ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
  passportDetails?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
    isPassportExpirationDateVisible?: boolean | null;
    isPassportInLatinCharacters?: boolean | null;
    passportCountry?: string | null;
    passportExpiresAt?: any | null;
    passportIssuedAt?: any | null;
    passportNumber?: string | null;
  } | null;
};

export type ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
  isPassportExpirationDateVisible?: boolean | null;
  isPassportInLatinCharacters?: boolean | null;
  passportCountry?: string | null;
  passportExpiresAt?: any | null;
  passportIssuedAt?: any | null;
  passportNumber?: string | null;
};

export type ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1MutationResultFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    id: any;
    caseDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetails';
      application?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
        isAttestationComplete?: boolean | null;
        passportDetails?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
          isPassportExpirationDateVisible?: boolean | null;
          isPassportInLatinCharacters?: boolean | null;
          passportCountry?: string | null;
          passportExpiresAt?: any | null;
          passportIssuedAt?: any | null;
          passportNumber?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type IdVerificationProcessPaymentContainerApplicantUserCybersourcePublicKeyIdQueryVariables = Exact<{ [key: string]: never }>;

export type IdVerificationProcessPaymentContainerApplicantUserCybersourcePublicKeyIdQuery = { __typename?: 'Query'; applicantUserCybersourcePublicKeyId?: string | null };

export type IdVerificationProcessPaymentContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type IdVerificationProcessPaymentContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    state: string;
    id: any;
    financeDetails?: {
      __typename?: 'IdentityVerificationCaseV1FinanceDetails';
      serviceFee?: number | null;
      transactions?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
        submission?: {
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission';
          transactionReference?: { __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference'; isSuccess?: boolean | null } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type IdVerificationProcessPaymentContainerApplicantUserQueryVariables = Exact<{
  applicantUserId: Scalars['ObjectID']['input'];
}>;

export type IdVerificationProcessPaymentContainerApplicantUserQuery = {
  __typename?: 'Query';
  applicantUser?: { __typename?: 'ApplicantUser'; isProfileSubmitted?: boolean | null; id: any } | null;
};

export type IdVerificationProcessPaymentContainerIdentityVerificationCaseV1UpdateMutationVariables = Exact<{
  input: IdentityVerificationCaseV1UpdateInput;
}>;

export type IdVerificationProcessPaymentContainerIdentityVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1Update: {
    __typename?: 'IdentityVerificationCaseV1MutationResult';
    identityVerificationCaseV1?: {
      __typename?: 'IdentityVerificationCaseV1';
      state: string;
      id: any;
      financeDetails?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetails';
        serviceFee?: number | null;
        transactions?: {
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
          submission?: {
            __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission';
            transactionReference?: { __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference'; isSuccess?: boolean | null } | null;
          } | null;
        } | null;
      } | null;
    } | null;
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
  };
};

export type IdVerificationProcessPaymentContainerApplicantUserUpdateMutationVariables = Exact<{
  input: ApplicantUserUpdateInput;
}>;

export type IdVerificationProcessPaymentContainerApplicantUserUpdateMutation = {
  __typename?: 'Mutation';
  applicantUserUpdate: {
    __typename?: 'ApplicantUserMutationResult';
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
    applicantUser?: { __typename?: 'ApplicantUser'; isProfileSubmitted?: boolean | null; id: any } | null;
  };
};

export type IdVerificationProcessPaymentContainerIdentityVerificationCaseV1DeleteMutationVariables = Exact<{
  input: IdentityVerificationCaseV1DeleteInput;
}>;

export type IdVerificationProcessPaymentContainerIdentityVerificationCaseV1DeleteMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1Delete: {
    __typename?: 'IdentityVerificationCaseV1MutationResult';
    identityVerificationCaseV1?: {
      __typename?: 'IdentityVerificationCaseV1';
      state: string;
      id: any;
      financeDetails?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetails';
        serviceFee?: number | null;
        transactions?: {
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
          submission?: {
            __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission';
            transactionReference?: { __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference'; isSuccess?: boolean | null } | null;
          } | null;
        } | null;
      } | null;
    } | null;
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
  };
};

export type IdVerificationProcessPaymentContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  state: string;
  id: any;
  financeDetails?: {
    __typename?: 'IdentityVerificationCaseV1FinanceDetails';
    serviceFee?: number | null;
    transactions?: {
      __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
      submission?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission';
        transactionReference?: { __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference'; isSuccess?: boolean | null } | null;
      } | null;
    } | null;
  } | null;
};

export type IdVerificationProcessPaymentContainerIdentityVerificationCaseV1FinanceDetailsFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetails';
  serviceFee?: number | null;
  transactions?: {
    __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
    submission?: {
      __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission';
      transactionReference?: { __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference'; isSuccess?: boolean | null } | null;
    } | null;
  } | null;
};

export type IdVerificationProcessPaymentContainerApplicantUserFieldsFragment = { __typename?: 'ApplicantUser'; isProfileSubmitted?: boolean | null; id: any };

export type IdVerificationProcessPaymentContainerIdentityVerificationCaseV1MutationResultFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1MutationResult';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    state: string;
    id: any;
    financeDetails?: {
      __typename?: 'IdentityVerificationCaseV1FinanceDetails';
      serviceFee?: number | null;
      transactions?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
        submission?: {
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission';
          transactionReference?: { __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference'; isSuccess?: boolean | null } | null;
        } | null;
      } | null;
    } | null;
  } | null;
  status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
};

export type IdVerificationProcessPaymentContainerApplicantUserMutationResultFieldsFragment = {
  __typename?: 'ApplicantUserMutationResult';
  status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
  applicantUser?: { __typename?: 'ApplicantUser'; isProfileSubmitted?: boolean | null; id: any } | null;
};

export type ApplicantPassportDetailsContainerIdentityVerificationCaseV1CurrentQueryVariables = Exact<{
  applicantId: Scalars['ObjectID']['input'];
}>;

export type ApplicantPassportDetailsContainerIdentityVerificationCaseV1CurrentQuery = {
  __typename?: 'Query';
  identityVerificationCaseV1Current?: {
    __typename?: 'IdentityVerificationCaseV1';
    id: any;
    caseDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetails';
      application?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
        passportDetails?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
          passportCountry?: string | null;
          passportExpiresAt?: any | null;
          passportIssuedAt?: any | null;
          passportNumber?: string | null;
          isPassportExpirationDateVisible?: boolean | null;
          isPassportInLatinCharacters?: boolean | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type PassportDetailsContainerCurrentFilesQueryQueryVariables = Exact<{
  applicantId: Scalars['ObjectID']['input'];
}>;

export type PassportDetailsContainerCurrentFilesQueryQuery = {
  __typename?: 'Query';
  identityVerificationCaseV1Current?: {
    __typename?: 'IdentityVerificationCaseV1';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
  } | null;
};

export type ApplicantPassportDetailsContainerApplicantUserQueryVariables = Exact<{
  applicantUserId: Scalars['ObjectID']['input'];
}>;

export type ApplicantPassportDetailsContainerApplicantUserQuery = {
  __typename?: 'Query';
  applicantUser?: { __typename?: 'ApplicantUser'; isProfileSubmitted?: boolean | null; id: any } | null;
};

export type ApplicantPassportDetailsContainerIdentityVerificationCaseV1UpdateMutationVariables = Exact<{
  input: IdentityVerificationCaseV1UpdateInput;
}>;

export type ApplicantPassportDetailsContainerIdentityVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1Update: {
    __typename?: 'IdentityVerificationCaseV1MutationResult';
    identityVerificationCaseV1?: {
      __typename?: 'IdentityVerificationCaseV1';
      id: any;
      caseDetails?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetails';
        application?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
          passportDetails?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
            passportCountry?: string | null;
            passportExpiresAt?: any | null;
            passportIssuedAt?: any | null;
            passportNumber?: string | null;
            isPassportExpirationDateVisible?: boolean | null;
            isPassportInLatinCharacters?: boolean | null;
          } | null;
        } | null;
      } | null;
    } | null;
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
  };
};

export type ApplicantPassportDetailsContainerIdentityVerificationCaseV1DeleteMutationVariables = Exact<{
  input: IdentityVerificationCaseV1DeleteInput;
}>;

export type ApplicantPassportDetailsContainerIdentityVerificationCaseV1DeleteMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1Delete: {
    __typename?: 'IdentityVerificationCaseV1MutationResult';
    identityVerificationCaseV1?: {
      __typename?: 'IdentityVerificationCaseV1';
      id: any;
      caseDetails?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetails';
        application?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
          passportDetails?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
            passportCountry?: string | null;
            passportExpiresAt?: any | null;
            passportIssuedAt?: any | null;
            passportNumber?: string | null;
            isPassportExpirationDateVisible?: boolean | null;
            isPassportInLatinCharacters?: boolean | null;
          } | null;
        } | null;
      } | null;
    } | null;
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
  };
};

export type ApplicantPassportDetailsContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  id: any;
  caseDetails?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetails';
    application?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
      passportDetails?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
        passportCountry?: string | null;
        passportExpiresAt?: any | null;
        passportIssuedAt?: any | null;
        passportNumber?: string | null;
        isPassportExpirationDateVisible?: boolean | null;
        isPassportInLatinCharacters?: boolean | null;
      } | null;
    } | null;
  } | null;
};

export type ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetails';
  application?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
    passportDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
      passportCountry?: string | null;
      passportExpiresAt?: any | null;
      passportIssuedAt?: any | null;
      passportNumber?: string | null;
      isPassportExpirationDateVisible?: boolean | null;
      isPassportInLatinCharacters?: boolean | null;
    } | null;
  } | null;
};

export type ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
  passportDetails?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
    passportCountry?: string | null;
    passportExpiresAt?: any | null;
    passportIssuedAt?: any | null;
    passportNumber?: string | null;
    isPassportExpirationDateVisible?: boolean | null;
    isPassportInLatinCharacters?: boolean | null;
  } | null;
};

export type ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
  passportCountry?: string | null;
  passportExpiresAt?: any | null;
  passportIssuedAt?: any | null;
  passportNumber?: string | null;
  isPassportExpirationDateVisible?: boolean | null;
  isPassportInLatinCharacters?: boolean | null;
};

export type ApplicantPassportDetailsContainerApplicantUserFieldsFragment = { __typename?: 'ApplicantUser'; isProfileSubmitted?: boolean | null; id: any };

export type ApplicantPassportDetailsContainerIdentityVerificationCaseV1MutationResultFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1MutationResult';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    id: any;
    caseDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetails';
      application?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
        passportDetails?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
          passportCountry?: string | null;
          passportExpiresAt?: any | null;
          passportIssuedAt?: any | null;
          passportNumber?: string | null;
          isPassportExpirationDateVisible?: boolean | null;
          isPassportInLatinCharacters?: boolean | null;
        } | null;
      } | null;
    } | null;
  } | null;
  status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
};

export type IdVerificationPaymentPollingContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type IdVerificationPaymentPollingContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    id: any;
    financeDetails?: {
      __typename?: 'IdentityVerificationCaseV1FinanceDetails';
      transactions?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
        submission?: {
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission';
          transactionReference?: {
            __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference';
            isSuccess?: boolean | null;
            errorMessage?: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type IdVerificationPaymentPollingContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  id: any;
  financeDetails?: {
    __typename?: 'IdentityVerificationCaseV1FinanceDetails';
    transactions?: {
      __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
      submission?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission';
        transactionReference?: {
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference';
          isSuccess?: boolean | null;
          errorMessage?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type PaymentContainerApplicantUserCybersourcePublicKeyIdQueryQueryVariables = Exact<{ [key: string]: never }>;

export type PaymentContainerApplicantUserCybersourcePublicKeyIdQueryQuery = { __typename?: 'Query'; applicantUserCybersourcePublicKeyId?: string | null };

export type ApplicantPrimaryEducationDetailsContainerApplicantUserQueryVariables = Exact<{
  applicantUserId: Scalars['ObjectID']['input'];
}>;

export type ApplicantPrimaryEducationDetailsContainerApplicantUserQuery = {
  __typename?: 'Query';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    isProfileSubmitted?: boolean | null;
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      professional?: {
        __typename?: 'ApplicantUserProfessional';
        citizenshipAtTimeEnteredMedicalInstitution?: string | null;
        primaryEducationalInformation?: Array<{
          __typename?: 'ApplicantUserPrimaryEducationalInformation';
          attendanceEndedAt?: any | null;
          attendanceStartedAt?: any | null;
          degreeIssuedAt?: any | null;
          degreeTitle?: string | null;
          graduationYear?: number | null;
          id: any;
          issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
          otherIssuingInstitution?: {
            __typename?: 'ApplicantUserOtherIssuingInstitution';
            addressLine1?: string | null;
            city?: string | null;
            country?: string | null;
            name?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type ApplicantPrimaryEducationDetailsContainerApplicantUserUpdateMutationVariables = Exact<{
  input: ApplicantUserUpdateInput;
}>;

export type ApplicantPrimaryEducationDetailsContainerApplicantUserUpdateMutation = {
  __typename?: 'Mutation';
  applicantUserUpdate: {
    __typename?: 'ApplicantUserMutationResult';
    applicantUser?: {
      __typename?: 'ApplicantUser';
      isProfileSubmitted?: boolean | null;
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        professional?: {
          __typename?: 'ApplicantUserProfessional';
          citizenshipAtTimeEnteredMedicalInstitution?: string | null;
          primaryEducationalInformation?: Array<{
            __typename?: 'ApplicantUserPrimaryEducationalInformation';
            attendanceEndedAt?: any | null;
            attendanceStartedAt?: any | null;
            degreeIssuedAt?: any | null;
            degreeTitle?: string | null;
            graduationYear?: number | null;
            id: any;
            issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
            otherIssuingInstitution?: {
              __typename?: 'ApplicantUserOtherIssuingInstitution';
              addressLine1?: string | null;
              city?: string | null;
              country?: string | null;
              name?: string | null;
              stateOrProvince?: string | null;
              zipOrPostalCode?: string | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
    } | null;
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
  };
};

export type ApplicantPrimaryEducationDetailsContainerEntitiesQueryVariables = Exact<{ [key: string]: never }>;

export type ApplicantPrimaryEducationDetailsContainerEntitiesQuery = {
  __typename?: 'Query';
  entities?: Array<{ __typename?: 'Entity'; entityName?: string | null; isIssuingInstitution?: boolean | null; id: any } | null> | null;
};

export type ApplicantPrimaryEducationDetailsContainerApplicantUserMutationResultFieldsFragment = {
  __typename?: 'ApplicantUserMutationResult';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    isProfileSubmitted?: boolean | null;
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      professional?: {
        __typename?: 'ApplicantUserProfessional';
        citizenshipAtTimeEnteredMedicalInstitution?: string | null;
        primaryEducationalInformation?: Array<{
          __typename?: 'ApplicantUserPrimaryEducationalInformation';
          attendanceEndedAt?: any | null;
          attendanceStartedAt?: any | null;
          degreeIssuedAt?: any | null;
          degreeTitle?: string | null;
          graduationYear?: number | null;
          id: any;
          issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
          otherIssuingInstitution?: {
            __typename?: 'ApplicantUserOtherIssuingInstitution';
            addressLine1?: string | null;
            city?: string | null;
            country?: string | null;
            name?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
  status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
};

export type ApplicantPrimaryEducationDetailsContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  isProfileSubmitted?: boolean | null;
  id: any;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    professional?: {
      __typename?: 'ApplicantUserProfessional';
      citizenshipAtTimeEnteredMedicalInstitution?: string | null;
      primaryEducationalInformation?: Array<{
        __typename?: 'ApplicantUserPrimaryEducationalInformation';
        attendanceEndedAt?: any | null;
        attendanceStartedAt?: any | null;
        degreeIssuedAt?: any | null;
        degreeTitle?: string | null;
        graduationYear?: number | null;
        id: any;
        issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
        otherIssuingInstitution?: {
          __typename?: 'ApplicantUserOtherIssuingInstitution';
          addressLine1?: string | null;
          city?: string | null;
          country?: string | null;
          name?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type ApplicantPrimaryEducationDetailsContainerApplicantUserPersonalInformationFieldsFragment = {
  __typename?: 'ApplicantUserPersonalInformation';
  professional?: {
    __typename?: 'ApplicantUserProfessional';
    citizenshipAtTimeEnteredMedicalInstitution?: string | null;
    primaryEducationalInformation?: Array<{
      __typename?: 'ApplicantUserPrimaryEducationalInformation';
      attendanceEndedAt?: any | null;
      attendanceStartedAt?: any | null;
      degreeIssuedAt?: any | null;
      degreeTitle?: string | null;
      graduationYear?: number | null;
      id: any;
      issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
      otherIssuingInstitution?: {
        __typename?: 'ApplicantUserOtherIssuingInstitution';
        addressLine1?: string | null;
        city?: string | null;
        country?: string | null;
        name?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ApplicantPrimaryEducationDetailsContainerApplicantUserProfessionalFieldsFragment = {
  __typename?: 'ApplicantUserProfessional';
  citizenshipAtTimeEnteredMedicalInstitution?: string | null;
  primaryEducationalInformation?: Array<{
    __typename?: 'ApplicantUserPrimaryEducationalInformation';
    attendanceEndedAt?: any | null;
    attendanceStartedAt?: any | null;
    degreeIssuedAt?: any | null;
    degreeTitle?: string | null;
    graduationYear?: number | null;
    id: any;
    issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
    otherIssuingInstitution?: {
      __typename?: 'ApplicantUserOtherIssuingInstitution';
      addressLine1?: string | null;
      city?: string | null;
      country?: string | null;
      name?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
  } | null> | null;
};

export type ApplicantPrimaryEducationDetailsContainerApplicantUserPrimaryEducationalInformationFieldsFragment = {
  __typename?: 'ApplicantUserPrimaryEducationalInformation';
  attendanceEndedAt?: any | null;
  attendanceStartedAt?: any | null;
  degreeIssuedAt?: any | null;
  degreeTitle?: string | null;
  graduationYear?: number | null;
  id: any;
  issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
  otherIssuingInstitution?: {
    __typename?: 'ApplicantUserOtherIssuingInstitution';
    addressLine1?: string | null;
    city?: string | null;
    country?: string | null;
    name?: string | null;
    stateOrProvince?: string | null;
    zipOrPostalCode?: string | null;
  } | null;
};

export type ApplicantPrimaryEducationDetailsContainerApplicantUserOtherIssuingInstitutionFieldsFragment = {
  __typename?: 'ApplicantUserOtherIssuingInstitution';
  addressLine1?: string | null;
  city?: string | null;
  country?: string | null;
  name?: string | null;
  stateOrProvince?: string | null;
  zipOrPostalCode?: string | null;
};

export type ApplicantPrimaryEducationDetailsContainerEntityFieldsFragment = {
  __typename?: 'Entity';
  entityName?: string | null;
  isIssuingInstitution?: boolean | null;
  id: any;
};

export type ApplicantProfileApplyToEditContainerApplicantUserQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type ApplicantProfileApplyToEditContainerApplicantUserQuery = {
  __typename?: 'Query';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: { __typename?: 'ApplicantUserPersonalInformation'; applyingTo?: Array<{ __typename?: 'Entity'; id: any } | null> | null } | null;
  } | null;
};

export type ApplicantProfileApplyToEditContainerEntitiesQueryVariables = Exact<{ [key: string]: never }>;

export type ApplicantProfileApplyToEditContainerEntitiesQuery = {
  __typename?: 'Query';
  entities?: Array<{ __typename?: 'Entity'; entityName?: string | null; isClient?: boolean | null; id: any } | null> | null;
};

export type ApplicantProfileApplyToEditContainerApplicantUserUpdateMutationVariables = Exact<{
  input: ApplicantUserUpdateInput;
}>;

export type ApplicantProfileApplyToEditContainerApplicantUserUpdateMutation = {
  __typename?: 'Mutation';
  applicantUserUpdate: {
    __typename?: 'ApplicantUserMutationResult';
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
    applicantUser?: {
      __typename?: 'ApplicantUser';
      id: any;
      personalInformation?: { __typename?: 'ApplicantUserPersonalInformation'; applyingTo?: Array<{ __typename?: 'Entity'; id: any } | null> | null } | null;
    } | null;
  };
};

export type ApplicantProfileApplyToEditContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  id: any;
  personalInformation?: { __typename?: 'ApplicantUserPersonalInformation'; applyingTo?: Array<{ __typename?: 'Entity'; id: any } | null> | null } | null;
};

export type ApplicantProfileApplyToEditContainerEntityFieldsFragment = { __typename?: 'Entity'; entityName?: string | null; isClient?: boolean | null; id: any };

export type ApplicantProfileApplyToEditContainerApplicantUserMutationResultFieldsFragment = {
  __typename?: 'ApplicantUserMutationResult';
  status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: { __typename?: 'ApplicantUserPersonalInformation'; applyingTo?: Array<{ __typename?: 'Entity'; id: any } | null> | null } | null;
  } | null;
};

export type ApplicantProfileApplyToViewContainerApplicantUserQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type ApplicantProfileApplyToViewContainerApplicantUserQuery = {
  __typename?: 'Query';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; id: any } | null> | null;
    } | null;
  } | null;
};

export type ApplicantProfileApplyToViewContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  id: any;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; id: any } | null> | null;
  } | null;
};

export type ApplicantProfileCitizenshipEditContainerApplicantUserQueryVariables = Exact<{
  applicantUserId: Scalars['ObjectID']['input'];
}>;

export type ApplicantProfileCitizenshipEditContainerApplicantUserQuery = {
  __typename?: 'Query';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
    } | null;
  } | null;
};

export type ApplicantProfileCitizenshipEditContainerApplicantUserUpdateMutationVariables = Exact<{
  input: ApplicantUserUpdateInput;
}>;

export type ApplicantProfileCitizenshipEditContainerApplicantUserUpdateMutation = {
  __typename?: 'Mutation';
  applicantUserUpdate: {
    __typename?: 'ApplicantUserMutationResult';
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
    applicantUser?: {
      __typename?: 'ApplicantUser';
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
      } | null;
    } | null;
  };
};

export type ApplicantProfileCitizenshipEditContainerApplicantUserMutationResultFieldsFragment = {
  __typename?: 'ApplicantUserMutationResult';
  status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
    } | null;
  } | null;
};

export type ApplicantProfileCitizenshipEditContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  id: any;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
  } | null;
};

export type ApplicantProfileCitizenshipEditContainerApplicantUserPersonalInformationFieldsFragment = {
  __typename?: 'ApplicantUserPersonalInformation';
  citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
};

export type ApplicantProfileCitizenshipViewContainerApplicantUserQueryVariables = Exact<{
  applicantUserId: Scalars['ObjectID']['input'];
}>;

export type ApplicantProfileCitizenshipViewContainerApplicantUserQuery = {
  __typename?: 'Query';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
    } | null;
  } | null;
};

export type ApplicantProfileCitizenshipViewContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  id: any;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
  } | null;
};

export type ApplicantProfileCitizenshipViewContainerApplicantUserPersonalInformationFieldsFragment = {
  __typename?: 'ApplicantUserPersonalInformation';
  citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
};

export type ApplicantProfileContactEditContainerApplicantUserPersonalInformationFieldsFragment = {
  __typename?: 'ApplicantUserPersonalInformation';
  contactInformation?: {
    __typename?: 'ApplicantUserContactInformation';
    emailAddress?: string | null;
    primaryPhone?: string | null;
    address?: {
      __typename?: 'ApplicantUserAddress';
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      streetAddressLine1?: string | null;
      streetAddressLine2?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
    phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; id: any } | null> | null;
  } | null;
};

export type ApplicantProfileContactEditContainerApplicantUserContactInformationFieldsFragment = {
  __typename?: 'ApplicantUserContactInformation';
  emailAddress?: string | null;
  primaryPhone?: string | null;
  address?: {
    __typename?: 'ApplicantUserAddress';
    city?: string | null;
    country?: string | null;
    stateOrProvince?: string | null;
    streetAddressLine1?: string | null;
    streetAddressLine2?: string | null;
    zipOrPostalCode?: string | null;
  } | null;
  phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; id: any } | null> | null;
};

export type ApplicantProfileContactEditContainerApplicantUserAddressFieldsFragment = {
  __typename?: 'ApplicantUserAddress';
  city?: string | null;
  country?: string | null;
  stateOrProvince?: string | null;
  streetAddressLine1?: string | null;
  streetAddressLine2?: string | null;
  zipOrPostalCode?: string | null;
};

export type ApplicantProfileContactEditContainerApplicantUserPhoneFieldsFragment = {
  __typename?: 'ApplicantUserPhone';
  phoneNumber?: string | null;
  phoneType?: string | null;
  id: any;
};

export type ApplicantProfileContactContainerApplicantUserQueryVariables = Exact<{
  applicantUserId: Scalars['ObjectID']['input'];
}>;

export type ApplicantProfileContactContainerApplicantUserQuery = {
  __typename?: 'Query';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      contactInformation?: {
        __typename?: 'ApplicantUserContactInformation';
        emailAddress?: string | null;
        primaryPhone?: string | null;
        address?: {
          __typename?: 'ApplicantUserAddress';
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          streetAddressLine1?: string | null;
          streetAddressLine2?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; id: any } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type ApplicantProfileContactContainerApplicantUserUpdateMutationVariables = Exact<{
  input: ApplicantUserUpdateInput;
}>;

export type ApplicantProfileContactContainerApplicantUserUpdateMutation = {
  __typename?: 'Mutation';
  applicantUserUpdate: {
    __typename?: 'ApplicantUserMutationResult';
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
    applicantUser?: {
      __typename?: 'ApplicantUser';
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        contactInformation?: {
          __typename?: 'ApplicantUserContactInformation';
          emailAddress?: string | null;
          primaryPhone?: string | null;
          address?: {
            __typename?: 'ApplicantUserAddress';
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            streetAddressLine1?: string | null;
            streetAddressLine2?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
          phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; id: any } | null> | null;
        } | null;
      } | null;
    } | null;
  };
};

export type ApplicantProfileContactContainerApplicantUserMutationResultFieldsFragment = {
  __typename?: 'ApplicantUserMutationResult';
  status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      contactInformation?: {
        __typename?: 'ApplicantUserContactInformation';
        emailAddress?: string | null;
        primaryPhone?: string | null;
        address?: {
          __typename?: 'ApplicantUserAddress';
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          streetAddressLine1?: string | null;
          streetAddressLine2?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; id: any } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type ApplicantProfileContactContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  id: any;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    contactInformation?: {
      __typename?: 'ApplicantUserContactInformation';
      emailAddress?: string | null;
      primaryPhone?: string | null;
      address?: {
        __typename?: 'ApplicantUserAddress';
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        streetAddressLine1?: string | null;
        streetAddressLine2?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
      phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; id: any } | null> | null;
    } | null;
  } | null;
};

export type ApplicantProfileIdentityDocumentUploadContainerApplicantUserUpdateMutationVariables = Exact<{
  input: ApplicantUserUpdateInput;
}>;

export type ApplicantProfileIdentityDocumentUploadContainerApplicantUserUpdateMutation = {
  __typename?: 'Mutation';
  applicantUserUpdate: {
    __typename?: 'ApplicantUserMutationResult';
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
    applicantUser?: {
      __typename?: 'ApplicantUser';
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        nameOnDocumentAssets?: Array<{
          __typename?: 'ApplicantUserNameOnDocumentAsset';
          documentName?: string | null;
          isDeleteRequested?: boolean | null;
          uploadedAt?: any | null;
          id: any;
          createdAt?: any | null;
          updatedAt?: any | null;
        } | null> | null;
      } | null;
      files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
    } | null;
  };
};

export type ApplicantProfileIdentityDocumentUploadContainerApplicantUserQueryVariables = Exact<{
  applicantUserId: Scalars['ObjectID']['input'];
}>;

export type ApplicantProfileIdentityDocumentUploadContainerApplicantUserQuery = {
  __typename?: 'Query';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      nameOnDocumentAssets?: Array<{
        __typename?: 'ApplicantUserNameOnDocumentAsset';
        documentName?: string | null;
        isDeleteRequested?: boolean | null;
        uploadedAt?: any | null;
        id: any;
        createdAt?: any | null;
        updatedAt?: any | null;
      } | null> | null;
    } | null;
    files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
  } | null;
};

export type ApplicantProfileIdentityDocumentUploadContainerApplicantUserFileCreateAuthHeaderMutationVariables = Exact<{
  input: ApplicantUserBlobFileInput;
}>;

export type ApplicantProfileIdentityDocumentUploadContainerApplicantUserFileCreateAuthHeaderMutation = {
  __typename?: 'Mutation';
  applicantUserFileCreateAuthHeader: {
    __typename?: 'ApplicantUserBlobContentAuthHeaderResult';
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
    authHeader?: {
      __typename?: 'BlobAuthHeader';
      authHeader?: string | null;
      blobPath?: string | null;
      blobName?: string | null;
      requestDate?: string | null;
      indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
      metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
    } | null;
  };
};

export type ApplicantProfileIdentityDocumentUploadContainerApplicantUserFileRemoveMutationVariables = Exact<{
  input: ApplicantUserPublicFileRemoveInput;
}>;

export type ApplicantProfileIdentityDocumentUploadContainerApplicantUserFileRemoveMutation = {
  __typename?: 'Mutation';
  applicantUserFileRemove: {
    __typename?: 'ApplicantUserMutationResult';
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
    applicantUser?: {
      __typename?: 'ApplicantUser';
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        nameOnDocumentAssets?: Array<{
          __typename?: 'ApplicantUserNameOnDocumentAsset';
          documentName?: string | null;
          isDeleteRequested?: boolean | null;
          uploadedAt?: any | null;
          id: any;
          createdAt?: any | null;
          updatedAt?: any | null;
        } | null> | null;
      } | null;
      files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
    } | null;
  };
};

export type ApplicantProfileIdentityDocumentUploadContainerApplicantUserMutationResultFieldsFragment = {
  __typename?: 'ApplicantUserMutationResult';
  status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      nameOnDocumentAssets?: Array<{
        __typename?: 'ApplicantUserNameOnDocumentAsset';
        documentName?: string | null;
        isDeleteRequested?: boolean | null;
        uploadedAt?: any | null;
        id: any;
        createdAt?: any | null;
        updatedAt?: any | null;
      } | null> | null;
    } | null;
    files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
  } | null;
};

export type ApplicantProfileIdentityDocumentUploadContainerApplicantUserAuthHeaderMutationResultFieldsFragment = {
  __typename?: 'ApplicantUserBlobContentAuthHeaderResult';
  status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
  authHeader?: {
    __typename?: 'BlobAuthHeader';
    authHeader?: string | null;
    blobPath?: string | null;
    blobName?: string | null;
    requestDate?: string | null;
    indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
    metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
  } | null;
};

export type ApplicantProfileIdentityDocumentUploadContainerAuthHeaderFieldsFragment = {
  __typename?: 'BlobAuthHeader';
  authHeader?: string | null;
  blobPath?: string | null;
  blobName?: string | null;
  requestDate?: string | null;
  indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
  metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
};

export type ApplicantProfileIdentityDocumentUploadContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  id: any;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    nameOnDocumentAssets?: Array<{
      __typename?: 'ApplicantUserNameOnDocumentAsset';
      documentName?: string | null;
      isDeleteRequested?: boolean | null;
      uploadedAt?: any | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
    } | null> | null;
  } | null;
  files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
};

export type ApplicantProfileIdentityContainerQueryQueryVariables = Exact<{
  applicantUserId: Scalars['ObjectID']['input'];
}>;

export type ApplicantProfileIdentityContainerQueryQuery = {
  __typename?: 'Query';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      identityDetails?: {
        __typename?: 'ApplicantUserIdentityDetails';
        dateOfBirth?: any | null;
        gender?: string | null;
        generationalSuffix?: string | null;
        lastName?: string | null;
        legalNameConsistsOfOneName?: boolean | null;
        restOfName?: string | null;
      } | null;
      contactInformation?: { __typename?: 'ApplicantUserContactInformation'; emailAddress?: string | null } | null;
      nameOnDocumentAssets?: Array<{
        __typename?: 'ApplicantUserNameOnDocumentAsset';
        documentName?: string | null;
        isDeleteRequested?: boolean | null;
        uploadedAt?: any | null;
        id: any;
        createdAt?: any | null;
        updatedAt?: any | null;
      } | null> | null;
    } | null;
    termsAndConditions?: Array<{
      __typename?: 'ApplicantUserTermsAndCondition';
      acceptanceOf?: string | null;
      attestedAt?: any | null;
      version?: number | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
    } | null> | null;
  } | null;
};

export type ApplicantProfileIdentityContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  id: any;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    identityDetails?: {
      __typename?: 'ApplicantUserIdentityDetails';
      dateOfBirth?: any | null;
      gender?: string | null;
      generationalSuffix?: string | null;
      lastName?: string | null;
      legalNameConsistsOfOneName?: boolean | null;
      restOfName?: string | null;
    } | null;
    contactInformation?: { __typename?: 'ApplicantUserContactInformation'; emailAddress?: string | null } | null;
    nameOnDocumentAssets?: Array<{
      __typename?: 'ApplicantUserNameOnDocumentAsset';
      documentName?: string | null;
      isDeleteRequested?: boolean | null;
      uploadedAt?: any | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
    } | null> | null;
  } | null;
  termsAndConditions?: Array<{
    __typename?: 'ApplicantUserTermsAndCondition';
    acceptanceOf?: string | null;
    attestedAt?: any | null;
    version?: number | null;
    id: any;
    createdAt?: any | null;
    updatedAt?: any | null;
  } | null> | null;
};

export type ApplicantProfileIdentityContainerApplicantUserPersonalInformationFieldsFragment = {
  __typename?: 'ApplicantUserPersonalInformation';
  identityDetails?: {
    __typename?: 'ApplicantUserIdentityDetails';
    dateOfBirth?: any | null;
    gender?: string | null;
    generationalSuffix?: string | null;
    lastName?: string | null;
    legalNameConsistsOfOneName?: boolean | null;
    restOfName?: string | null;
  } | null;
  contactInformation?: { __typename?: 'ApplicantUserContactInformation'; emailAddress?: string | null } | null;
  nameOnDocumentAssets?: Array<{
    __typename?: 'ApplicantUserNameOnDocumentAsset';
    documentName?: string | null;
    isDeleteRequested?: boolean | null;
    uploadedAt?: any | null;
    id: any;
    createdAt?: any | null;
    updatedAt?: any | null;
  } | null> | null;
};

export type ApplicantProfileProfessionEditContainerEntitiesQueryVariables = Exact<{ [key: string]: never }>;

export type ApplicantProfileProfessionEditContainerEntitiesQuery = {
  __typename?: 'Query';
  entities?: Array<{ __typename?: 'Entity'; entityName?: string | null; isIssuingInstitution?: boolean | null; id: any } | null> | null;
};

export type ApplicantProfileProfessionEditContainerApplicantUserUpdateMutationVariables = Exact<{
  input: ApplicantUserUpdateInput;
}>;

export type ApplicantProfileProfessionEditContainerApplicantUserUpdateMutation = {
  __typename?: 'Mutation';
  applicantUserUpdate: {
    __typename?: 'ApplicantUserMutationResult';
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
    applicantUser?: {
      __typename?: 'ApplicantUser';
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        professional?: {
          __typename?: 'ApplicantUserProfessional';
          citizenshipAtTimeEnteredMedicalInstitution?: string | null;
          healthProfession?: string | null;
          primaryEducationalInformation?: Array<{
            __typename?: 'ApplicantUserPrimaryEducationalInformation';
            attendanceEndedAt?: any | null;
            attendanceStartedAt?: any | null;
            degreeIssuedAt?: any | null;
            degreeTitle?: string | null;
            graduationYear?: number | null;
            id: any;
            issuingInstitution?: {
              __typename?: 'Entity';
              entityName?: string | null;
              id: any;
              issuingInstitution?: {
                __typename?: 'EntityIssuingInstitution';
                address?: {
                  __typename?: 'EntityAddressInfo';
                  addressLine1?: string | null;
                  city?: string | null;
                  stateOrProvince?: string | null;
                  zipOrPostalCode?: string | null;
                  country?: string | null;
                } | null;
              } | null;
            } | null;
            otherIssuingInstitution?: {
              __typename?: 'ApplicantUserOtherIssuingInstitution';
              addressLine1?: string | null;
              city?: string | null;
              country?: string | null;
              name?: string | null;
              stateOrProvince?: string | null;
              zipOrPostalCode?: string | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
    } | null;
  };
};

export type ApplicantProfileProfessionEditContainerApplicantUserProfessionalFieldsFragment = {
  __typename?: 'ApplicantUserProfessional';
  citizenshipAtTimeEnteredMedicalInstitution?: string | null;
  healthProfession?: string | null;
  primaryEducationalInformation?: Array<{
    __typename?: 'ApplicantUserPrimaryEducationalInformation';
    attendanceEndedAt?: any | null;
    attendanceStartedAt?: any | null;
    degreeIssuedAt?: any | null;
    degreeTitle?: string | null;
    graduationYear?: number | null;
    id: any;
    issuingInstitution?: {
      __typename?: 'Entity';
      entityName?: string | null;
      id: any;
      issuingInstitution?: {
        __typename?: 'EntityIssuingInstitution';
        address?: {
          __typename?: 'EntityAddressInfo';
          addressLine1?: string | null;
          city?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
          country?: string | null;
        } | null;
      } | null;
    } | null;
    otherIssuingInstitution?: {
      __typename?: 'ApplicantUserOtherIssuingInstitution';
      addressLine1?: string | null;
      city?: string | null;
      country?: string | null;
      name?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
  } | null> | null;
};

export type ApplicantProfileProfessionEditContainerApplicantUserMutationResultFieldsFragment = {
  __typename?: 'ApplicantUserMutationResult';
  status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      professional?: {
        __typename?: 'ApplicantUserProfessional';
        citizenshipAtTimeEnteredMedicalInstitution?: string | null;
        healthProfession?: string | null;
        primaryEducationalInformation?: Array<{
          __typename?: 'ApplicantUserPrimaryEducationalInformation';
          attendanceEndedAt?: any | null;
          attendanceStartedAt?: any | null;
          degreeIssuedAt?: any | null;
          degreeTitle?: string | null;
          graduationYear?: number | null;
          id: any;
          issuingInstitution?: {
            __typename?: 'Entity';
            entityName?: string | null;
            id: any;
            issuingInstitution?: {
              __typename?: 'EntityIssuingInstitution';
              address?: {
                __typename?: 'EntityAddressInfo';
                addressLine1?: string | null;
                city?: string | null;
                stateOrProvince?: string | null;
                zipOrPostalCode?: string | null;
                country?: string | null;
              } | null;
            } | null;
          } | null;
          otherIssuingInstitution?: {
            __typename?: 'ApplicantUserOtherIssuingInstitution';
            addressLine1?: string | null;
            city?: string | null;
            country?: string | null;
            name?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type ApplicantProfileProfessionEditContainerEntityFieldsFragment = {
  __typename?: 'Entity';
  entityName?: string | null;
  isIssuingInstitution?: boolean | null;
  id: any;
};

export type ApplicantProfileProfessionViewContainerApplicantUserQueryVariables = Exact<{
  applicantUserId: Scalars['ObjectID']['input'];
}>;

export type ApplicantProfileProfessionViewContainerApplicantUserQuery = {
  __typename?: 'Query';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      professional?: {
        __typename?: 'ApplicantUserProfessional';
        citizenshipAtTimeEnteredMedicalInstitution?: string | null;
        healthProfession?: string | null;
        primaryEducationalInformation?: Array<{
          __typename?: 'ApplicantUserPrimaryEducationalInformation';
          attendanceEndedAt?: any | null;
          attendanceStartedAt?: any | null;
          degreeIssuedAt?: any | null;
          degreeTitle?: string | null;
          graduationYear?: number | null;
          id: any;
          issuingInstitution?: {
            __typename?: 'Entity';
            entityName?: string | null;
            id: any;
            issuingInstitution?: {
              __typename?: 'EntityIssuingInstitution';
              address?: {
                __typename?: 'EntityAddressInfo';
                addressLine1?: string | null;
                city?: string | null;
                stateOrProvince?: string | null;
                zipOrPostalCode?: string | null;
                country?: string | null;
              } | null;
            } | null;
          } | null;
          otherIssuingInstitution?: {
            __typename?: 'ApplicantUserOtherIssuingInstitution';
            addressLine1?: string | null;
            city?: string | null;
            country?: string | null;
            name?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type ApplicantProfileProfessionViewContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  id: any;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    professional?: {
      __typename?: 'ApplicantUserProfessional';
      citizenshipAtTimeEnteredMedicalInstitution?: string | null;
      healthProfession?: string | null;
      primaryEducationalInformation?: Array<{
        __typename?: 'ApplicantUserPrimaryEducationalInformation';
        attendanceEndedAt?: any | null;
        attendanceStartedAt?: any | null;
        degreeIssuedAt?: any | null;
        degreeTitle?: string | null;
        graduationYear?: number | null;
        id: any;
        issuingInstitution?: {
          __typename?: 'Entity';
          entityName?: string | null;
          id: any;
          issuingInstitution?: {
            __typename?: 'EntityIssuingInstitution';
            address?: {
              __typename?: 'EntityAddressInfo';
              addressLine1?: string | null;
              city?: string | null;
              stateOrProvince?: string | null;
              zipOrPostalCode?: string | null;
              country?: string | null;
            } | null;
          } | null;
        } | null;
        otherIssuingInstitution?: {
          __typename?: 'ApplicantUserOtherIssuingInstitution';
          addressLine1?: string | null;
          city?: string | null;
          country?: string | null;
          name?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type ApplicantProfileProfessionViewContainerApplicantUserPersonalInformationFieldsFragment = {
  __typename?: 'ApplicantUserPersonalInformation';
  professional?: {
    __typename?: 'ApplicantUserProfessional';
    citizenshipAtTimeEnteredMedicalInstitution?: string | null;
    healthProfession?: string | null;
    primaryEducationalInformation?: Array<{
      __typename?: 'ApplicantUserPrimaryEducationalInformation';
      attendanceEndedAt?: any | null;
      attendanceStartedAt?: any | null;
      degreeIssuedAt?: any | null;
      degreeTitle?: string | null;
      graduationYear?: number | null;
      id: any;
      issuingInstitution?: {
        __typename?: 'Entity';
        entityName?: string | null;
        id: any;
        issuingInstitution?: {
          __typename?: 'EntityIssuingInstitution';
          address?: {
            __typename?: 'EntityAddressInfo';
            addressLine1?: string | null;
            city?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
            country?: string | null;
          } | null;
        } | null;
      } | null;
      otherIssuingInstitution?: {
        __typename?: 'ApplicantUserOtherIssuingInstitution';
        addressLine1?: string | null;
        city?: string | null;
        country?: string | null;
        name?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ApplicantQualifyingQuestionsContainerApplicantUserCurrentQueryVariables = Exact<{ [key: string]: never }>;

export type ApplicantQualifyingQuestionsContainerApplicantUserCurrentQuery = {
  __typename?: 'Query';
  applicantUserCurrent?: {
    __typename?: 'ApplicantUser';
    isProfileSubmitted?: boolean | null;
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; isClient?: boolean | null; id: any } | null> | null;
      professional?: { __typename?: 'ApplicantUserProfessional'; healthProfession?: string | null } | null;
    } | null;
    termsAndConditions?: Array<{
      __typename?: 'ApplicantUserTermsAndCondition';
      acceptanceOf?: string | null;
      attestedAt?: any | null;
      version?: number | null;
      id: any;
    } | null> | null;
  } | null;
};

export type ApplicantQualifyingQuestionsContainerEntitiesQueryVariables = Exact<{ [key: string]: never }>;

export type ApplicantQualifyingQuestionsContainerEntitiesQuery = {
  __typename?: 'Query';
  entities?: Array<{ __typename?: 'Entity'; entityName?: string | null; isClient?: boolean | null; id: any } | null> | null;
};

export type ApplicantQualifyingQuestionsContainerApplicantUserUpdateMutationVariables = Exact<{
  input: ApplicantUserUpdateInput;
}>;

export type ApplicantQualifyingQuestionsContainerApplicantUserUpdateMutation = {
  __typename?: 'Mutation';
  applicantUserUpdate: {
    __typename?: 'ApplicantUserMutationResult';
    applicantUser?: {
      __typename?: 'ApplicantUser';
      isProfileSubmitted?: boolean | null;
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; isClient?: boolean | null; id: any } | null> | null;
        professional?: { __typename?: 'ApplicantUserProfessional'; healthProfession?: string | null } | null;
      } | null;
      termsAndConditions?: Array<{
        __typename?: 'ApplicantUserTermsAndCondition';
        acceptanceOf?: string | null;
        attestedAt?: any | null;
        version?: number | null;
        id: any;
      } | null> | null;
    } | null;
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
  };
};

export type ApplicantQualifyingQuestionsContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  isProfileSubmitted?: boolean | null;
  id: any;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; isClient?: boolean | null; id: any } | null> | null;
    professional?: { __typename?: 'ApplicantUserProfessional'; healthProfession?: string | null } | null;
  } | null;
  termsAndConditions?: Array<{
    __typename?: 'ApplicantUserTermsAndCondition';
    acceptanceOf?: string | null;
    attestedAt?: any | null;
    version?: number | null;
    id: any;
  } | null> | null;
};

export type ApplicantQualifyingQuestionsContainerApplicantUserPersonalInformationFieldsFragment = {
  __typename?: 'ApplicantUserPersonalInformation';
  applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; isClient?: boolean | null; id: any } | null> | null;
  professional?: { __typename?: 'ApplicantUserProfessional'; healthProfession?: string | null } | null;
};

export type ApplicantQualifyingQuestionsContainerApplicantUserTermsAndConditionFieldsFragment = {
  __typename?: 'ApplicantUserTermsAndCondition';
  acceptanceOf?: string | null;
  attestedAt?: any | null;
  version?: number | null;
  id: any;
};

export type ApplicantQualifyingQuestionsContainerEntityFieldsFragment = { __typename?: 'Entity'; entityName?: string | null; isClient?: boolean | null; id: any };

export type ApplicantQualifyingQuestionsContainerApplicantUserProfessionalFieldsFragment = { __typename?: 'ApplicantUserProfessional'; healthProfession?: string | null };

export type ApplicantQualifyingQuestionsContainerApplicantUserMutationResultFieldsFragment = {
  __typename?: 'ApplicantUserMutationResult';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    isProfileSubmitted?: boolean | null;
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; isClient?: boolean | null; id: any } | null> | null;
      professional?: { __typename?: 'ApplicantUserProfessional'; healthProfession?: string | null } | null;
    } | null;
    termsAndConditions?: Array<{
      __typename?: 'ApplicantUserTermsAndCondition';
      acceptanceOf?: string | null;
      attestedAt?: any | null;
      version?: number | null;
      id: any;
    } | null> | null;
  } | null;
  status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
};

export type ApplicantUpdateCardModalContainerApplicantUserUpdatePaymentInstrumentMutationVariables = Exact<{
  input: ApplicantUserUpdatePaymentInstrumentInput;
}>;

export type ApplicantUpdateCardModalContainerApplicantUserUpdatePaymentInstrumentMutation = {
  __typename?: 'Mutation';
  applicantUserUpdatePaymentInstrument: {
    __typename?: 'PaymentInstrumentResult';
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
    paymentInstrument?: {
      __typename?: 'PaymentInstrument';
      cardNumber?: string | null;
      cardType?: string | null;
      expirationMonth?: string | null;
      expirationYear?: string | null;
      paymentInstrumentId?: string | null;
      state?: string | null;
      id?: string | null;
      billTo?: {
        __typename?: 'PaymentBillingInfo';
        billingAddressLine1?: string | null;
        billingAddressLine2?: string | null;
        billingCity?: string | null;
        billingCountry?: string | null;
        billingEmail?: string | null;
        billingFirstName?: string | null;
        billingLastName?: string | null;
        billingPhone?: string | null;
        billingPostalCode?: string | null;
        billingState?: string | null;
      } | null;
    } | null;
  };
};

export type ApplicantUpdateCardModalContainerPaymentInstrumentMutationResultFieldsFragment = {
  __typename?: 'PaymentInstrumentResult';
  status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
  paymentInstrument?: {
    __typename?: 'PaymentInstrument';
    cardNumber?: string | null;
    cardType?: string | null;
    expirationMonth?: string | null;
    expirationYear?: string | null;
    paymentInstrumentId?: string | null;
    state?: string | null;
    id?: string | null;
    billTo?: {
      __typename?: 'PaymentBillingInfo';
      billingAddressLine1?: string | null;
      billingAddressLine2?: string | null;
      billingCity?: string | null;
      billingCountry?: string | null;
      billingEmail?: string | null;
      billingFirstName?: string | null;
      billingLastName?: string | null;
      billingPhone?: string | null;
      billingPostalCode?: string | null;
      billingState?: string | null;
    } | null;
  } | null;
};

export type ApplicantUpdateCardModalContainerPaymentInstrumentFieldsFragment = {
  __typename?: 'PaymentInstrument';
  cardNumber?: string | null;
  cardType?: string | null;
  expirationMonth?: string | null;
  expirationYear?: string | null;
  paymentInstrumentId?: string | null;
  state?: string | null;
  id?: string | null;
  billTo?: {
    __typename?: 'PaymentBillingInfo';
    billingAddressLine1?: string | null;
    billingAddressLine2?: string | null;
    billingCity?: string | null;
    billingCountry?: string | null;
    billingEmail?: string | null;
    billingFirstName?: string | null;
    billingLastName?: string | null;
    billingPhone?: string | null;
    billingPostalCode?: string | null;
    billingState?: string | null;
  } | null;
};

export type ApplicantSectionLayoutContainerApplicantUserCurrentQueryVariables = Exact<{ [key: string]: never }>;

export type ApplicantSectionLayoutContainerApplicantUserCurrentQuery = {
  __typename?: 'Query';
  applicantUserCurrent?: { __typename?: 'ApplicantUser'; accessBlocked?: boolean | null; id: any } | null;
};

export type ApplicantSectionLayoutContainerApplicantUserCurrentFieldsFragment = { __typename?: 'ApplicantUser'; accessBlocked?: boolean | null; id: any };

export type ApplicantSharedEcfmgHeaderContainerApplicantUserCurrentQueryQueryVariables = Exact<{ [key: string]: never }>;

export type ApplicantSharedEcfmgHeaderContainerApplicantUserCurrentQueryQuery = {
  __typename?: 'Query';
  applicantUserCurrent?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      identityDetails?: {
        __typename?: 'ApplicantUserIdentityDetails';
        restOfName?: string | null;
        legalNameConsistsOfOneName?: boolean | null;
        lastName?: string | null;
      } | null;
    } | null;
  } | null;
};

export type ApplicantSharedEcfmgHeaderContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  id: any;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    identityDetails?: {
      __typename?: 'ApplicantUserIdentityDetails';
      restOfName?: string | null;
      legalNameConsistsOfOneName?: boolean | null;
      lastName?: string | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  fileName: Scalars['String']['input'];
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    id: any;
    fileByFileName?: { __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null;
  } | null;
};

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1UpdateMutationVariables = Exact<{
  input: CredentialVerificationCaseV1UpdateInput;
}>;

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1Update?: {
    __typename?: 'CredentialVerificationCaseV1MutationResult';
    credentialVerificationCaseV1?: {
      __typename?: 'CredentialVerificationCaseV1';
      id: any;
      caseDetails?: {
        __typename?: 'CredentialVerificationCaseV1CaseDetails';
        application?: {
          __typename?: 'CredentialVerificationCaseV1Application';
          credentialAssets?: { __typename?: 'CredentialVerificationCaseV1CredentialAssets'; credential?: string | null; translation?: string | null } | null;
        } | null;
        applicationReview?: {
          __typename?: 'CredentialVerificationCaseV1ApplicationReview';
          privateCaseDetails?: {
            __typename?: 'CredentialVerificationCaseV1PrivateCaseDetails';
            entitySuppliedCredential?: { __typename?: 'CredentialVerificationCaseV1EntitySuppliedCredential'; credential?: string | null; translation?: string | null } | null;
          } | null;
        } | null;
      } | null;
      assets?: {
        __typename?: 'CredentialVerificationCaseV1Assets';
        private?: {
          __typename?: 'CredentialVerificationCaseV1AssetsPrivate';
          verificationForm?: string | null;
          verificationPacket?: string | null;
          verificationPacketResponse?: string | null;
          verificationComponentPacket?: string | null;
        } | null;
      } | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  } | null;
};

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FileByFileNameFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  id: any;
  fileByFileName?: { __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null;
};

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FileCreateAuthHeaderMutationVariables = Exact<{
  input: CredentialVerificationCaseV1BlobFileInput;
}>;

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FileCreateAuthHeaderMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1FileCreateAuthHeader: {
    __typename?: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult';
    authHeader?: {
      __typename?: 'BlobAuthHeader';
      authHeader?: string | null;
      blobPath?: string | null;
      blobName?: string | null;
      requestDate?: string | null;
      indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
      metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1PdfFileCreateAuthHeaderMutationVariables = Exact<{
  input: CredentialVerificationCaseV1BlobFileInput;
}>;

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1PdfFileCreateAuthHeaderMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1PdfFileCreateAuthHeader: {
    __typename?: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult';
    authHeader?: {
      __typename?: 'BlobAuthHeader';
      authHeader?: string | null;
      blobPath?: string | null;
      blobName?: string | null;
      requestDate?: string | null;
      indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
      metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1ImageFileCreateAuthHeaderMutationVariables = Exact<{
  input: CredentialVerificationCaseV1BlobFileInput;
}>;

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1ImageFileCreateAuthHeaderMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1ImageFileCreateAuthHeader: {
    __typename?: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult';
    authHeader?: {
      __typename?: 'BlobAuthHeader';
      authHeader?: string | null;
      blobPath?: string | null;
      blobName?: string | null;
      requestDate?: string | null;
      indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
      metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1MutationResultFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1MutationResult';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    id: any;
    caseDetails?: {
      __typename?: 'CredentialVerificationCaseV1CaseDetails';
      application?: {
        __typename?: 'CredentialVerificationCaseV1Application';
        credentialAssets?: { __typename?: 'CredentialVerificationCaseV1CredentialAssets'; credential?: string | null; translation?: string | null } | null;
      } | null;
      applicationReview?: {
        __typename?: 'CredentialVerificationCaseV1ApplicationReview';
        privateCaseDetails?: {
          __typename?: 'CredentialVerificationCaseV1PrivateCaseDetails';
          entitySuppliedCredential?: { __typename?: 'CredentialVerificationCaseV1EntitySuppliedCredential'; credential?: string | null; translation?: string | null } | null;
        } | null;
      } | null;
    } | null;
    assets?: {
      __typename?: 'CredentialVerificationCaseV1Assets';
      private?: {
        __typename?: 'CredentialVerificationCaseV1AssetsPrivate';
        verificationForm?: string | null;
        verificationPacket?: string | null;
        verificationPacketResponse?: string | null;
        verificationComponentPacket?: string | null;
      } | null;
    } | null;
  } | null;
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
};

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1BlobContentAuthHeaderResultFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult';
  authHeader?: {
    __typename?: 'BlobAuthHeader';
    authHeader?: string | null;
    blobPath?: string | null;
    blobName?: string | null;
    requestDate?: string | null;
    indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
    metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
  } | null;
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
};

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFieldsFragment = {
  __typename?: 'BlobAuthHeader';
  authHeader?: string | null;
  blobPath?: string | null;
  blobName?: string | null;
  requestDate?: string | null;
  indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
  metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
};

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  id: any;
  caseDetails?: {
    __typename?: 'CredentialVerificationCaseV1CaseDetails';
    application?: {
      __typename?: 'CredentialVerificationCaseV1Application';
      credentialAssets?: { __typename?: 'CredentialVerificationCaseV1CredentialAssets'; credential?: string | null; translation?: string | null } | null;
    } | null;
    applicationReview?: {
      __typename?: 'CredentialVerificationCaseV1ApplicationReview';
      privateCaseDetails?: {
        __typename?: 'CredentialVerificationCaseV1PrivateCaseDetails';
        entitySuppliedCredential?: { __typename?: 'CredentialVerificationCaseV1EntitySuppliedCredential'; credential?: string | null; translation?: string | null } | null;
      } | null;
    } | null;
  } | null;
  assets?: {
    __typename?: 'CredentialVerificationCaseV1Assets';
    private?: {
      __typename?: 'CredentialVerificationCaseV1AssetsPrivate';
      verificationForm?: string | null;
      verificationPacket?: string | null;
      verificationPacketResponse?: string | null;
      verificationComponentPacket?: string | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerFileInfoFieldsFragment = {
  __typename?: 'FileInfo';
  url: string;
  type?: string | null;
  size?: number | null;
  name: string;
};

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  fileName: Scalars['String']['input'];
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    id: any;
    fileByFileName?: { __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null;
    files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
  } | null;
};

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1UpdateMutationVariables = Exact<{
  input: IdentityVerificationCaseV1UpdateInput;
}>;

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1Update: {
    __typename?: 'IdentityVerificationCaseV1MutationResult';
    identityVerificationCaseV1?: {
      __typename?: 'IdentityVerificationCaseV1';
      id: any;
      caseDetails?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetails';
        application?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
          passportAssets?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets';
            passport?: string | null;
            passportExpiration?: string | null;
            passportTranslation?: string | null;
          } | null;
          photoAssets?: { __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets'; photo?: string | null } | null;
        } | null;
      } | null;
      assets?: {
        __typename?: 'IdentityVerificationCaseV1Assets';
        shared?: { __typename?: 'IdentityVerificationCaseV1AssetsShared'; idForm?: string | null; notarizedIdForm?: string | null } | null;
        private?: { __typename?: 'IdentityVerificationCaseV1AssetsPrivate'; redactedNotarizedIdForm?: string | null } | null;
      } | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FileByFileNameFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  id: any;
  fileByFileName?: { __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null;
  files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
};

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FileCreateAuthHeaderMutationVariables = Exact<{
  input: IdentityVerificationCaseV1BlobFileInput;
}>;

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FileCreateAuthHeaderMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1FileCreateAuthHeader: {
    __typename?: 'IdentityVerificationCaseV1BlobContentAuthHeaderResult';
    authHeader?: {
      __typename?: 'BlobAuthHeader';
      authHeader?: string | null;
      blobPath?: string | null;
      blobName?: string | null;
      requestDate?: string | null;
      indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
      metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1PdfFileCreateAuthHeaderMutationVariables = Exact<{
  input: IdentityVerificationCaseV1BlobFileInput;
}>;

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1PdfFileCreateAuthHeaderMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1PdfFileCreateAuthHeader: {
    __typename?: 'IdentityVerificationCaseV1BlobContentAuthHeaderResult';
    authHeader?: {
      __typename?: 'BlobAuthHeader';
      authHeader?: string | null;
      blobPath?: string | null;
      blobName?: string | null;
      requestDate?: string | null;
      indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
      metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1ImageFileCreateAuthHeaderMutationVariables = Exact<{
  input: IdentityVerificationCaseV1BlobFileInput;
}>;

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1ImageFileCreateAuthHeaderMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1ImageFileCreateAuthHeader: {
    __typename?: 'IdentityVerificationCaseV1BlobContentAuthHeaderResult';
    authHeader?: {
      __typename?: 'BlobAuthHeader';
      authHeader?: string | null;
      blobPath?: string | null;
      blobName?: string | null;
      requestDate?: string | null;
      indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
      metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1MutationResultFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1MutationResult';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    id: any;
    caseDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetails';
      application?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
        passportAssets?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets';
          passport?: string | null;
          passportExpiration?: string | null;
          passportTranslation?: string | null;
        } | null;
        photoAssets?: { __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets'; photo?: string | null } | null;
      } | null;
    } | null;
    assets?: {
      __typename?: 'IdentityVerificationCaseV1Assets';
      shared?: { __typename?: 'IdentityVerificationCaseV1AssetsShared'; idForm?: string | null; notarizedIdForm?: string | null } | null;
      private?: { __typename?: 'IdentityVerificationCaseV1AssetsPrivate'; redactedNotarizedIdForm?: string | null } | null;
    } | null;
  } | null;
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
};

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1BlobContentAuthHeaderResult';
  authHeader?: {
    __typename?: 'BlobAuthHeader';
    authHeader?: string | null;
    blobPath?: string | null;
    blobName?: string | null;
    requestDate?: string | null;
    indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
    metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
  } | null;
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
};

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFieldsFragment = {
  __typename?: 'BlobAuthHeader';
  authHeader?: string | null;
  blobPath?: string | null;
  blobName?: string | null;
  requestDate?: string | null;
  indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
  metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
};

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  id: any;
  caseDetails?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetails';
    application?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
      passportAssets?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets';
        passport?: string | null;
        passportExpiration?: string | null;
        passportTranslation?: string | null;
      } | null;
      photoAssets?: { __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets'; photo?: string | null } | null;
    } | null;
  } | null;
  assets?: {
    __typename?: 'IdentityVerificationCaseV1Assets';
    shared?: { __typename?: 'IdentityVerificationCaseV1AssetsShared'; idForm?: string | null; notarizedIdForm?: string | null } | null;
    private?: { __typename?: 'IdentityVerificationCaseV1AssetsPrivate'; redactedNotarizedIdForm?: string | null } | null;
  } | null;
};

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerFileInfoFieldsFragment = {
  __typename?: 'FileInfo';
  url: string;
  type?: string | null;
  size?: number | null;
  name: string;
};

export type ApplicantSharedFileUploadProcessMaliciousFileScanMutationVariables = Exact<{
  input: ProcessMaliciousFileScanInput;
}>;

export type ApplicantSharedFileUploadProcessMaliciousFileScanMutation = {
  __typename?: 'Mutation';
  processMaliciousFileScan?: {
    __typename?: 'ProcessMaliciousFileScanMutationResult';
    scanResult?: string | null;
    isMalicious?: boolean | null;
    isSafe?: boolean | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  } | null;
};

export type MaintenanceMessageProviderGetServerDateQueryVariables = Exact<{ [key: string]: never }>;

export type MaintenanceMessageProviderGetServerDateQuery = { __typename?: 'Query'; serverDate?: string | null };

export type ServerDateQueryVariables = Exact<{ [key: string]: never }>;

export type ServerDateQuery = { __typename?: 'Query'; serverDate?: string | null };

export type ApplicantPaymentInstrumentDisplayContainerApplicantUserPaymentInstrumentQueryVariables = Exact<{
  applicantUserId: Scalars['ObjectID']['input'];
}>;

export type ApplicantPaymentInstrumentDisplayContainerApplicantUserPaymentInstrumentQuery = {
  __typename?: 'Query';
  applicantUserPaymentInstrument?: {
    __typename?: 'PaymentInstrument';
    cardNumber?: string | null;
    cardType?: string | null;
    expirationMonth?: string | null;
    expirationYear?: string | null;
    paymentInstrumentId?: string | null;
    state?: string | null;
    id?: string | null;
    billTo?: {
      __typename?: 'PaymentBillingInfo';
      billingAddressLine1?: string | null;
      billingAddressLine2?: string | null;
      billingCity?: string | null;
      billingCountry?: string | null;
      billingEmail?: string | null;
      billingFirstName?: string | null;
      billingLastName?: string | null;
      billingPhone?: string | null;
      billingPostalCode?: string | null;
      billingState?: string | null;
    } | null;
  } | null;
};

export type ApplicantPaymentInstrumentDisplayContainerPaymentInstrumentFieldsFragment = {
  __typename?: 'PaymentInstrument';
  cardNumber?: string | null;
  cardType?: string | null;
  expirationMonth?: string | null;
  expirationYear?: string | null;
  paymentInstrumentId?: string | null;
  state?: string | null;
  id?: string | null;
  billTo?: {
    __typename?: 'PaymentBillingInfo';
    billingAddressLine1?: string | null;
    billingAddressLine2?: string | null;
    billingCity?: string | null;
    billingCountry?: string | null;
    billingEmail?: string | null;
    billingFirstName?: string | null;
    billingLastName?: string | null;
    billingPhone?: string | null;
    billingPostalCode?: string | null;
    billingState?: string | null;
  } | null;
};

export const ApplicantCasesActiveCaseListContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantCasesActiveCaseListContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantCasesActiveCaseListContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const ApplicantCasesActiveCaseListContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantCasesActiveCaseListContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantCasesActiveCaseListContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const ApplicantCasesActiveCaseListContainerSendReportCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantCasesActiveCaseListContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantCasesActiveCaseListContainerSendReportCaseV1FieldsFragment, unknown>;
export const ApplicantArchivedCaseLisContainerArchivedCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantArchivedCaseLisContainerArchivedCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantArchivedCaseLisContainerArchivedCaseSummaryFieldsFragment, unknown>;
export const ApplicantCasesCredentialVerificationArchiveSummaryContainerArchivedCredentialVerificationCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantCasesCredentialVerificationArchiveSummaryContainerArchivedCredentialVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'decision' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'issuingInstitutionName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sendDestinationName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'program' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'adhocTransactions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transactionReference' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'submission' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transactionReference' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantCasesCredentialVerificationArchiveSummaryContainerArchivedCredentialVerificationCaseSummaryFieldsFragment, unknown>;
export const ApplicantCasesCredentialVerificationArchiveSummaryContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantCasesCredentialVerificationArchiveSummaryContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'professional' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryEducationalInformation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantCasesCredentialVerificationArchiveSummaryContainerApplicantUserFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CaseDetailsApplicationContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CaseDetailsApplicationContainerApplicantUserFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1OtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityAddressInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityAddressInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityAddressInfoFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityAddressInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityAddressInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CredentialAssetsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CredentialAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CredentialAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'translation' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CredentialAssetsFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Application' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendDestination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CredentialAssetsFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialInEnglish' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNameOnCredentialMatchPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'program' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityAddressInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1OtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityAddressInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CredentialAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CredentialAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'translation' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReviewDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReviewDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1OtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityAddressInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityAddressInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CredentialAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CredentialAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'translation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReviewDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Application' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendDestination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CredentialAssetsFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialInEnglish' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNameOnCredentialMatchPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'program' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CaseDetailsFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RequestedChangesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RequestedChanges' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedCredentialDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadTranslation' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RequestedChangesFragment, unknown>;
export const CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RevisionRequestFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RequestedChanges' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RequestedChanges' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedCredentialDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadTranslation' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RevisionRequestFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CaseDetailsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RevisionRequestFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1OtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityAddressInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityAddressInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CredentialAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CredentialAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'translation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Application' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendDestination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CredentialAssetsFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialInEnglish' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNameOnCredentialMatchPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'program' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReviewDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RequestedChanges' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedCredentialDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadTranslation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RequestedChanges' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1Fields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1OtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityAddressInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityAddressInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CredentialAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CredentialAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'translation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Application' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendDestination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CredentialAssetsFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialInEnglish' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNameOnCredentialMatchPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'program' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReviewDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RequestedChanges' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedCredentialDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadTranslation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RequestedChanges' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CaseDetailsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RevisionRequestFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1MutationResultFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1MessageFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1MessageFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1MessageFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RequestedChangesFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedCredentialDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadTranslation' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RequestedChangesFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RevisionRequestFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RequestedChangesFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedCredentialDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadTranslation' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RevisionRequestFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CaseDetailsMessagesContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CaseDetailsMessagesContainerApplicantUserFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFieldsFragment,
  unknown
>;
export const CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'serviceFee' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields'
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1MessageFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RevisionRequestFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedCredentialDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadTranslation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1MessageFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RequestedChangesFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'serviceFee' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1Fields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1MessageFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedCredentialDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadTranslation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RequestedChangesFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'serviceFee' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1MessageFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RevisionRequestFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1MutationResultFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CaseDetailsMessagesContainerPaymentInstrumentFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerPaymentInstrumentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentInstrument' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'billingAddressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingAddressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingCity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingCountry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingFirstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingLastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingPostalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingState' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'cardNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cardType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentInstrumentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CaseDetailsMessagesContainerPaymentInstrumentFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactionReference' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1CredentialAssetsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1CredentialAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CredentialAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'translation' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1CredentialAssetsFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CreateContainerEntityFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CreateContainerEntityFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1OtherIssuingInstitutionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1OtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1OtherIssuingInstitutionFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1ApplicationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Application' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialInEnglish' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNameOnCredentialMatchPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1CredentialAssetsFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'program' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendDestination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerEntityFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1CredentialAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CredentialAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'translation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1OtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1ApplicationFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1FinanceDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'serviceFee' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1FinanceDetailsFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1ApplicationFields' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1FinanceDetailsFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1CredentialAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CredentialAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'translation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1OtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Application' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialInEnglish' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNameOnCredentialMatchPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1CredentialAssetsFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'program' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendDestination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerEntityFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'serviceFee' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1Fields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1CredentialAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CredentialAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'translation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1OtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Application' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialInEnglish' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNameOnCredentialMatchPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1CredentialAssetsFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'program' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendDestination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerEntityFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'serviceFee' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1ApplicationFields' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1FinanceDetailsFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1MutationResultFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CreateContainerSendReportCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credential' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'destination' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CreateContainerSendReportCaseV1FieldsFragment, unknown>;
export const CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1FinanceDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approval' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'applicantRespondedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'financeReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'recognizedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1FinanceDetailsFieldsFragment, unknown>;
export const CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1FinanceDetailsFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approval' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'applicantRespondedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'financeReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'recognizedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nameOnDocumentAssets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserFieldsFragment, unknown>;
export const CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nameOnDocumentAssets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserMutationResultFieldsFragment, unknown>;
export const CasesCredentialVerificationV1UploadNameOnDocumentContainerBlobAuthHeaderFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1UploadNameOnDocumentContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1UploadNameOnDocumentContainerBlobAuthHeaderFieldsFragment, unknown>;
export const CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserAuthHeaderMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserAuthHeaderMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserBlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1UploadNameOnDocumentContainerBlobAuthHeaderFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1UploadNameOnDocumentContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserAuthHeaderMutationResultFieldsFragment, unknown>;
export const ApplicantIdentityVerificationArchiveSummaryContainerArchivedIdentityVerificationCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdentityVerificationArchiveSummaryContainerArchivedIdentityVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'passportDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'decision' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'completedBy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'adhocTransactions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transactionReference' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'completedAt' } }] }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'submission' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transactionReference' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantIdentityVerificationArchiveSummaryContainerArchivedIdentityVerificationCaseSummaryFieldsFragment, unknown>;
export const ApplicantIdentityVerificationArchiveSummaryContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdentityVerificationArchiveSummaryContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'professional' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryEducationalInformation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'issuingInstitution' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantIdentityVerificationArchiveSummaryContainerApplicantUserFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsApplicationContainerFileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsApplicationContainerFileInfoFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewDecisionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewDecisionFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewDecisionFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewDecisionFields'
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedPassportDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadExpirationPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassportTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPhoto' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedPassportDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadExpirationPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassportTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPhoto' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewDecisionFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedPassportDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadExpirationPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassportTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPhoto' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1Fields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewDecisionFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedPassportDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadExpirationPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassportTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPhoto' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1MutationResultFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUploadNotarizedIdForm' } }] }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUploadNotarizedIdForm' } }] }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shared' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'notarizedIdForm' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUploadNotarizedIdForm' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUploadNotarizedIdForm' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shared' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'notarizedIdForm' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1MutationResultFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1FileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1FileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1FileInfoFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1MessageFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1MessageFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1MessageFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsMessagesContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsMessagesContainerApplicantUserFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFieldsFragment,
  unknown
>;
export const CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFields'
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestChangesFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestScheduleNotaryCam' } }] }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestChangesFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestChangesFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestScheduleNotaryCam' } }] }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1MessageFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestScheduleNotaryCam' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1MessageFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestChangesFields' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1Fields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1MessageFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestScheduleNotaryCam' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestChangesFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1MessageFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1MutationResultFieldsFragment, unknown>;
export const CasesIdentityVerificationV1DraftContainerApplicantUserPaymentInstrumentFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerApplicantUserPaymentInstrumentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentInstrument' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'billingAddressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingAddressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingCity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingCountry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingFirstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingLastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingPostalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingState' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'cardNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cardType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentInstrumentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1DraftContainerApplicantUserPaymentInstrumentFieldsFragment, unknown>;
export const CasesIdentityVerificationV1DraftContainerEntityFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1DraftContainerEntityFieldsFragment, unknown>;
export const CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportAssetsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'passport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpirationUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpirationVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportTranslationUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportTranslationVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportVersion' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportAssetsFieldsFragment, unknown>;
export const CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFieldsFragment, unknown>;
export const CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPhotoAssetsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPhotoAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'photo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'photoUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'photoVersion' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPhotoAssetsFieldsFragment, unknown>;
export const CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1ApplicationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseWorkerModifiedPassportDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notarizationDetails' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isNotarizationComplete' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportAssetsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photoAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPhotoAssetsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'passport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpirationUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpirationVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportTranslationUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportTranslationVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportVersion' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPhotoAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'photo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'photoUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'photoVersion' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1ApplicationFieldsFragment, unknown>;
export const CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1ApplicationFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'passport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpirationUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpirationVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportTranslationUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportTranslationVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportVersion' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPhotoAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'photo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'photoUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'photoVersion' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseWorkerModifiedPassportDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notarizationDetails' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isNotarizationComplete' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportAssetsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photoAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPhotoAssetsFields' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsFieldsFragment, unknown>;
export const CasesIdentityVerificationV1DraftContainerFileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1DraftContainerFileInfoFieldsFragment, unknown>;
export const CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1FinanceDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'serviceFee' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1FinanceDetailsFieldsFragment, unknown>;
export const CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1FinanceDetailsFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'passport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpirationUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpirationVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportTranslationUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportTranslationVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportVersion' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPhotoAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'photo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'photoUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'photoVersion' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseWorkerModifiedPassportDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notarizationDetails' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isNotarizationComplete' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportAssetsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photoAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPhotoAssetsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1ApplicationFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'serviceFee' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1Fields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'passport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpirationUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpirationVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportTranslationUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportTranslationVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportVersion' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPhotoAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'photo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'photoUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'photoVersion' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseWorkerModifiedPassportDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notarizationDetails' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isNotarizationComplete' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportAssetsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photoAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPhotoAssetsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1ApplicationFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'serviceFee' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1FinanceDetailsFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1MutationResultFieldsFragment, unknown>;
export const ApplicantUserIdVerificationTransactionsFinanceDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantUserIdVerificationTransactionsFinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approval' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'applicantRespondedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'financeReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantUserIdVerificationTransactionsFinanceDetailsFieldsFragment, unknown>;
export const CasesIdentityVerificationV1TransactionsContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1TransactionsContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantUserIdVerificationTransactionsFinanceDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantUserIdVerificationTransactionsFinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approval' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'applicantRespondedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'financeReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1TransactionsContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const ApplicantCasesSectionLayoutContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantCasesSectionLayoutContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'decision' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'result' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantCasesSectionLayoutContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const ApplicantCasesSectionLayoutContainerSendReportCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantCasesSectionLayoutContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'decision' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'result' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantCasesSectionLayoutContainerSendReportCaseV1FieldsFragment, unknown>;
export const ApplicantCasesSectionLayoutContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantCasesSectionLayoutContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'decision' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'result' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantCasesSectionLayoutContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const ApplicantCasesSectionLayoutContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantCasesSectionLayoutContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasVerifiedCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasVerifiedIdentity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantCasesSectionLayoutContainerApplicantUserFieldsFragment, unknown>;
export const ApplicantCasesSendReportArchiveSummaryContainerArchivedSendReportCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantCasesSendReportArchiveSummaryContainerArchivedSendReportCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'destinationName' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'decision' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'completedBy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'adhocTransactions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transactionReference' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'completedAt' } }] }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'submission' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transactionReference' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantCasesSendReportArchiveSummaryContainerArchivedSendReportCaseSummaryFieldsFragment, unknown>;
export const ApplicantCasesSendReportArchiveSummaryContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantCasesSendReportArchiveSummaryContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'professional' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryEducationalInformation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'issuingInstitution' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantCasesSendReportArchiveSummaryContainerApplicantUserFieldsFragment, unknown>;
export const SendReportV1CaseDetailsApplicationContainerEntityFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CaseDetailsApplicationContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SendReportV1CaseDetailsApplicationContainerEntityFieldsFragment, unknown>;
export const SendReportV1CaseDetailsApplicationContainerSendReportCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CaseDetailsApplicationContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credential' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'caseDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'application' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'issuingInstitution' },
                                          selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'entityName' } }] }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'otherIssuingInstitution' },
                                          selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'institutionName' } }] }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'destination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'decision' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'result' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requestedChanges' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedDestination' } }] }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SendReportV1CaseDetailsApplicationContainerSendReportCaseV1FieldsFragment, unknown>;
export const CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1MessageFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1MessageFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1MessageFieldsFragment, unknown>;
export const CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestRequestedChangesFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestRequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequestRequestChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedDestination' } }] }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestRequestedChangesFieldsFragment, unknown>;
export const CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestRequestedChangesFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestRequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequestRequestChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedDestination' } }] }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestFieldsFragment, unknown>;
export const CasesSendReportV1CaseDetailsMessagesContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CaseDetailsMessagesContainerApplicantUserFieldsFragment, unknown>;
export const CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFieldsFragment, unknown>;
export const CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionsFieldsFragment, unknown>;
export const CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionsFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsFieldsFragment, unknown>;
export const CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1MessageFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestRequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequestRequestChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedDestination' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1MessageFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestRequestedChangesFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionsFields' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FieldsFragment, unknown>;
export const CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1MessageFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestRequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequestRequestChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedDestination' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestRequestedChangesFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionsFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1MessageFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1MutationResultFieldsFragment, unknown>;
export const SendReportV1CreateContainerVerifiedCredentialVerificationCaseSummaryCaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CreateContainerVerifiedCredentialVerificationCaseSummaryCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VerifiedCredentialVerificationCaseSummaryCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'issuingInstitutionName' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SendReportV1CreateContainerVerifiedCredentialVerificationCaseSummaryCaseDetailsFieldsFragment, unknown>;
export const SendReportV1CreateContainerVerifiedCredentialVerificationCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CreateContainerVerifiedCredentialVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VerifiedCredentialVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SendReportV1CreateContainerVerifiedCredentialVerificationCaseSummaryCaseDetailsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CreateContainerVerifiedCredentialVerificationCaseSummaryCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VerifiedCredentialVerificationCaseSummaryCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'issuingInstitutionName' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SendReportV1CreateContainerVerifiedCredentialVerificationCaseSummaryFieldsFragment, unknown>;
export const SendReportV1CreateContainerSendReportCaseV1FinanceDetailsTransactionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CreateContainerSendReportCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactionReference' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SendReportV1CreateContainerSendReportCaseV1FinanceDetailsTransactionsFieldsFragment, unknown>;
export const SendReportV1CreateContainerSendReportCaseV1MutationApplicationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CreateContainerSendReportCaseV1MutationApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destination' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credential' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SendReportV1CreateContainerSendReportCaseV1MutationApplicationFieldsFragment, unknown>;
export const SendReportV1CreateContainerSendReportCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CreateContainerSendReportCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SendReportV1CreateContainerSendReportCaseV1FinanceDetailsTransactionsFields' } }]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SendReportV1CreateContainerSendReportCaseV1MutationApplicationFields' } }]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CreateContainerSendReportCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactionReference' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CreateContainerSendReportCaseV1MutationApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destination' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credential' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SendReportV1CreateContainerSendReportCaseV1MutationResultFieldsFragment, unknown>;
export const SendReportV1CreateContainerSendReportCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CreateContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'serviceFee' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'submission' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transactionReference' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }] }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SendReportV1CreateContainerSendReportCaseV1FieldsFragment, unknown>;
export const SendReportV1CreateContainerEntityFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CreateContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SendReportV1CreateContainerEntityFieldsFragment, unknown>;
export const ApplicantUserSendReportVerificationTransactionsFinanceDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantUserSendReportVerificationTransactionsFinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approval' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'applicantRespondedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'financeReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'recognizedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantUserSendReportVerificationTransactionsFinanceDetailsFieldsFragment, unknown>;
export const CasesSendReportV1TransactionsContainerSendReportCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1TransactionsContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantUserSendReportVerificationTransactionsFinanceDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantUserSendReportVerificationTransactionsFinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approval' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'applicantRespondedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'financeReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'recognizedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1TransactionsContainerSendReportCaseV1FieldsFragment, unknown>;
export const ApplicantContactDetailsContainerApplicantUserIdentityDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserIdentityDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserIdentityDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantContactDetailsContainerApplicantUserIdentityDetailsFieldsFragment, unknown>;
export const ApplicantContactDetailsContainerApplicantUserAddressFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserAddressFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantContactDetailsContainerApplicantUserAddressFieldsFragment, unknown>;
export const ApplicantContactDetailsContainerApplicantUserPhoneFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserPhoneFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPhone' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantContactDetailsContainerApplicantUserPhoneFieldsFragment, unknown>;
export const ApplicantContactDetailsContainerApplicantUserContactInformationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserContactInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserContactInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserAddressFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phone' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserPhoneFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserAddressFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserPhoneFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPhone' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantContactDetailsContainerApplicantUserContactInformationFieldsFragment, unknown>;
export const ApplicantContactDetailsContainerApplicantUserCitizenshipFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserCitizenshipFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserCitizenship' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
    }
  ]
} as unknown as DocumentNode<ApplicantContactDetailsContainerApplicantUserCitizenshipFieldsFragment, unknown>;
export const ApplicantContactDetailsContainerApplicantUserPersonalInformationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserIdentityDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserContactInformationFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserCitizenshipFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserAddressFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserPhoneFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPhone' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserIdentityDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserIdentityDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserContactInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserContactInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserAddressFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phone' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserPhoneFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserCitizenshipFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserCitizenship' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
    }
  ]
} as unknown as DocumentNode<ApplicantContactDetailsContainerApplicantUserPersonalInformationFieldsFragment, unknown>;
export const ApplicantContactDetailsContainerApplicantUserTermsAndConditionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserTermsAndConditionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserTermsAndCondition' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantContactDetailsContainerApplicantUserTermsAndConditionFieldsFragment, unknown>;
export const ApplicantContactDetailsContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserTermsAndConditionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserIdentityDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserIdentityDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserAddressFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserPhoneFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPhone' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserContactInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserContactInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserAddressFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phone' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserPhoneFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserCitizenshipFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserCitizenship' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserIdentityDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserContactInformationFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserCitizenshipFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserTermsAndConditionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserTermsAndCondition' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantContactDetailsContainerApplicantUserFieldsFragment, unknown>;
export const ApplicantContactDetailsContainerApplicantUserMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserIdentityDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserIdentityDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserAddressFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserPhoneFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPhone' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserContactInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserContactInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserAddressFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phone' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserPhoneFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserCitizenshipFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserCitizenship' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserIdentityDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserContactInformationFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserCitizenshipFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserTermsAndConditionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserTermsAndCondition' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserTermsAndConditionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantContactDetailsContainerApplicantUserMutationResultFieldsFragment, unknown>;
export const ApplicantIdVerificationPreviewContainerFileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantIdVerificationPreviewContainerFileInfoFieldsFragment, unknown>;
export const ApplicantIdVerificationPreviewContainerEntityFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantIdVerificationPreviewContainerEntityFieldsFragment, unknown>;
export const ApplicantIdVerificationPreviewContainerApplicantUserCitizenshipFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserCitizenshipFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserCitizenship' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
    }
  ]
} as unknown as DocumentNode<ApplicantIdVerificationPreviewContainerApplicantUserCitizenshipFieldsFragment, unknown>;
export const ApplicantIdVerificationPreviewContainerApplicantUserAddressFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserAddressFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantIdVerificationPreviewContainerApplicantUserAddressFieldsFragment, unknown>;
export const ApplicantIdVerificationPreviewContainerApplicantUserPhoneFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserPhoneFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPhone' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantIdVerificationPreviewContainerApplicantUserPhoneFieldsFragment, unknown>;
export const ApplicantIdVerificationPreviewContainerApplicantUserContactInformationFieldFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserContactInformationField' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserContactInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserAddressFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phone' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserPhoneFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserAddressFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserPhoneFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPhone' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantIdVerificationPreviewContainerApplicantUserContactInformationFieldFragment, unknown>;
export const ApplicantIdVerificationPreviewContainerApplicantUserIdentityDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserIdentityDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserIdentityDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantIdVerificationPreviewContainerApplicantUserIdentityDetailsFieldsFragment, unknown>;
export const ApplicantIdVerificationPreviewContainerApplicantUserIssuingInstitutionAddressFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserIssuingInstitutionAddressFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityAddressInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantIdVerificationPreviewContainerApplicantUserIssuingInstitutionAddressFieldsFragment, unknown>;
export const ApplicantIdVerificationPreviewContainerApplicantUserOtherIssuingInstitutionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserOtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserOtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantIdVerificationPreviewContainerApplicantUserOtherIssuingInstitutionFieldsFragment, unknown>;
export const ApplicantIdVerificationPreviewContainerApplicantUserPrimaryEducationalInformationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserPrimaryEducationalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPrimaryEducationalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserIssuingInstitutionAddressFields' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserOtherIssuingInstitutionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserIssuingInstitutionAddressFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityAddressInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserOtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserOtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantIdVerificationPreviewContainerApplicantUserPrimaryEducationalInformationFieldsFragment, unknown>;
export const ApplicantIdVerificationPreviewContainerApplicantUserProfessionalFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEducationalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserPrimaryEducationalInformationFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserIssuingInstitutionAddressFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityAddressInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserOtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserOtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserPrimaryEducationalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPrimaryEducationalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserIssuingInstitutionAddressFields' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserOtherIssuingInstitutionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantIdVerificationPreviewContainerApplicantUserProfessionalFieldsFragment, unknown>;
export const ApplicantIdVerificationPreviewContainerApplicantUserPersonalInformationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerEntityFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserCitizenshipFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserContactInformationField' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserIdentityDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserProfessionalFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserAddressFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserPhoneFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPhone' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserIssuingInstitutionAddressFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityAddressInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserOtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserOtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserPrimaryEducationalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPrimaryEducationalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserIssuingInstitutionAddressFields' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserOtherIssuingInstitutionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserCitizenshipFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserCitizenship' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserContactInformationField' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserContactInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserAddressFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phone' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserPhoneFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserIdentityDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserIdentityDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEducationalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserPrimaryEducationalInformationFields' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantIdVerificationPreviewContainerApplicantUserPersonalInformationFieldsFragment, unknown>;
export const ApplicantIdVerificationPreviewContainerApplicantUserTermsAndConditionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserTermsAndConditionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserTermsAndCondition' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantIdVerificationPreviewContainerApplicantUserTermsAndConditionFieldsFragment, unknown>;
export const ApplicantIdVerificationPreviewContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserTermsAndConditionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserCitizenshipFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserCitizenship' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserAddressFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserPhoneFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPhone' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserContactInformationField' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserContactInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserAddressFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phone' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserPhoneFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserIdentityDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserIdentityDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserIssuingInstitutionAddressFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityAddressInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserOtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserOtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserPrimaryEducationalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPrimaryEducationalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserIssuingInstitutionAddressFields' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserOtherIssuingInstitutionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEducationalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserPrimaryEducationalInformationFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerEntityFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserCitizenshipFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserContactInformationField' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserIdentityDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserProfessionalFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserTermsAndConditionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserTermsAndCondition' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantIdVerificationPreviewContainerApplicantUserFieldsFragment, unknown>;
export const ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFieldsFragment, unknown>;
export const ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationFieldsFragment, unknown>;
export const ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsFieldsFragment, unknown>;
export const ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1MutationResultFieldsFragment, unknown>;
export const IdVerificationProcessPaymentContainerIdentityVerificationCaseV1FinanceDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'serviceFee' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<IdVerificationProcessPaymentContainerIdentityVerificationCaseV1FinanceDetailsFieldsFragment, unknown>;
export const IdVerificationProcessPaymentContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1FinanceDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'serviceFee' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<IdVerificationProcessPaymentContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const IdVerificationProcessPaymentContainerIdentityVerificationCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1Fields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'serviceFee' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1FinanceDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<IdVerificationProcessPaymentContainerIdentityVerificationCaseV1MutationResultFieldsFragment, unknown>;
export const IdVerificationProcessPaymentContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<IdVerificationProcessPaymentContainerApplicantUserFieldsFragment, unknown>;
export const IdVerificationProcessPaymentContainerApplicantUserMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerApplicantUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<IdVerificationProcessPaymentContainerApplicantUserMutationResultFieldsFragment, unknown>;
export const ApplicantPassportDetailsContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantPassportDetailsContainerApplicantUserFieldsFragment, unknown>;
export const ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFieldsFragment, unknown>;
export const ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFieldsFragment, unknown>;
export const ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsFieldsFragment, unknown>;
export const ApplicantPassportDetailsContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantPassportDetailsContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const ApplicantPassportDetailsContainerIdentityVerificationCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1Fields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantPassportDetailsContainerIdentityVerificationCaseV1MutationResultFieldsFragment, unknown>;
export const IdVerificationPaymentPollingContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IdVerificationPaymentPollingContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'submission' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transactionReference' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<IdVerificationPaymentPollingContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const ApplicantPrimaryEducationDetailsContainerApplicantUserOtherIssuingInstitutionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserOtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserOtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantPrimaryEducationDetailsContainerApplicantUserOtherIssuingInstitutionFieldsFragment, unknown>;
export const ApplicantPrimaryEducationDetailsContainerApplicantUserPrimaryEducationalInformationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserPrimaryEducationalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPrimaryEducationalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserOtherIssuingInstitutionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserOtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserOtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantPrimaryEducationDetailsContainerApplicantUserPrimaryEducationalInformationFieldsFragment, unknown>;
export const ApplicantPrimaryEducationDetailsContainerApplicantUserProfessionalFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEducationalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserPrimaryEducationalInformationFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserOtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserOtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserPrimaryEducationalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPrimaryEducationalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserOtherIssuingInstitutionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantPrimaryEducationDetailsContainerApplicantUserProfessionalFieldsFragment, unknown>;
export const ApplicantPrimaryEducationDetailsContainerApplicantUserPersonalInformationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserProfessionalFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserOtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserOtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserPrimaryEducationalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPrimaryEducationalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserOtherIssuingInstitutionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEducationalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserPrimaryEducationalInformationFields' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantPrimaryEducationDetailsContainerApplicantUserPersonalInformationFieldsFragment, unknown>;
export const ApplicantPrimaryEducationDetailsContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserOtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserOtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserPrimaryEducationalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPrimaryEducationalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserOtherIssuingInstitutionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEducationalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserPrimaryEducationalInformationFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserProfessionalFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantPrimaryEducationDetailsContainerApplicantUserFieldsFragment, unknown>;
export const ApplicantPrimaryEducationDetailsContainerApplicantUserMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserOtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserOtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserPrimaryEducationalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPrimaryEducationalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserOtherIssuingInstitutionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEducationalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserPrimaryEducationalInformationFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserProfessionalFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantPrimaryEducationDetailsContainerApplicantUserMutationResultFieldsFragment, unknown>;
export const ApplicantPrimaryEducationDetailsContainerEntityFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantPrimaryEducationDetailsContainerEntityFieldsFragment, unknown>;
export const ApplicantProfileApplyToEditContainerEntityFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileApplyToEditContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileApplyToEditContainerEntityFieldsFragment, unknown>;
export const ApplicantProfileApplyToEditContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileApplyToEditContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applyingTo' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileApplyToEditContainerApplicantUserFieldsFragment, unknown>;
export const ApplicantProfileApplyToEditContainerApplicantUserMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileApplyToEditContainerApplicantUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileApplyToEditContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileApplyToEditContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applyingTo' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileApplyToEditContainerApplicantUserMutationResultFieldsFragment, unknown>;
export const ApplicantProfileApplyToViewContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileApplyToViewContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applyingTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileApplyToViewContainerApplicantUserFieldsFragment, unknown>;
export const ApplicantProfileCitizenshipEditContainerApplicantUserPersonalInformationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileCitizenshipEditContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileCitizenshipEditContainerApplicantUserPersonalInformationFieldsFragment, unknown>;
export const ApplicantProfileCitizenshipEditContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileCitizenshipEditContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileCitizenshipEditContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileCitizenshipEditContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileCitizenshipEditContainerApplicantUserFieldsFragment, unknown>;
export const ApplicantProfileCitizenshipEditContainerApplicantUserMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileCitizenshipEditContainerApplicantUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileCitizenshipEditContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileCitizenshipEditContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileCitizenshipEditContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileCitizenshipEditContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileCitizenshipEditContainerApplicantUserMutationResultFieldsFragment, unknown>;
export const ApplicantProfileCitizenshipViewContainerApplicantUserPersonalInformationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileCitizenshipViewContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileCitizenshipViewContainerApplicantUserPersonalInformationFieldsFragment, unknown>;
export const ApplicantProfileCitizenshipViewContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileCitizenshipViewContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileCitizenshipViewContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileCitizenshipViewContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileCitizenshipViewContainerApplicantUserFieldsFragment, unknown>;
export const ApplicantProfileContactEditContainerApplicantUserAddressFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserAddressFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileContactEditContainerApplicantUserAddressFieldsFragment, unknown>;
export const ApplicantProfileContactEditContainerApplicantUserPhoneFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserPhoneFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPhone' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileContactEditContainerApplicantUserPhoneFieldsFragment, unknown>;
export const ApplicantProfileContactEditContainerApplicantUserContactInformationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserContactInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserContactInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserAddressFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phone' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserPhoneFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserAddressFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserPhoneFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPhone' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileContactEditContainerApplicantUserContactInformationFieldsFragment, unknown>;
export const ApplicantProfileContactEditContainerApplicantUserPersonalInformationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserContactInformationFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserAddressFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserPhoneFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPhone' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserContactInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserContactInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserAddressFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phone' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserPhoneFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileContactEditContainerApplicantUserPersonalInformationFieldsFragment, unknown>;
export const ApplicantProfileContactContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserAddressFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserPhoneFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPhone' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserContactInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserContactInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserAddressFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phone' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserPhoneFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserContactInformationFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileContactContainerApplicantUserFieldsFragment, unknown>;
export const ApplicantProfileContactContainerApplicantUserMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactContainerApplicantUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileContactContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserAddressFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserPhoneFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPhone' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserContactInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserContactInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserAddressFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phone' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserPhoneFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserContactInformationFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileContactContainerApplicantUserMutationResultFieldsFragment, unknown>;
export const ApplicantProfileIdentityDocumentUploadContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nameOnDocumentAssets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDeleteRequested' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileIdentityDocumentUploadContainerApplicantUserFieldsFragment, unknown>;
export const ApplicantProfileIdentityDocumentUploadContainerApplicantUserMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerApplicantUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nameOnDocumentAssets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDeleteRequested' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileIdentityDocumentUploadContainerApplicantUserMutationResultFieldsFragment, unknown>;
export const ApplicantProfileIdentityDocumentUploadContainerAuthHeaderFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileIdentityDocumentUploadContainerAuthHeaderFieldsFragment, unknown>;
export const ApplicantProfileIdentityDocumentUploadContainerApplicantUserAuthHeaderMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerApplicantUserAuthHeaderMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserBlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerAuthHeaderFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileIdentityDocumentUploadContainerApplicantUserAuthHeaderMutationResultFieldsFragment, unknown>;
export const ApplicantProfileIdentityContainerApplicantUserPersonalInformationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileIdentityContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nameOnDocumentAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDeleteRequested' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileIdentityContainerApplicantUserPersonalInformationFieldsFragment, unknown>;
export const ApplicantProfileIdentityContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileIdentityContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileIdentityContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileIdentityContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nameOnDocumentAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDeleteRequested' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileIdentityContainerApplicantUserFieldsFragment, unknown>;
export const ApplicantProfileProfessionEditContainerApplicantUserProfessionalFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileProfessionEditContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEducationalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'issuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'otherIssuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileProfessionEditContainerApplicantUserProfessionalFieldsFragment, unknown>;
export const ApplicantProfileProfessionEditContainerApplicantUserMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileProfessionEditContainerApplicantUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'personalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'professional' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileProfessionEditContainerApplicantUserProfessionalFields' } }]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileProfessionEditContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEducationalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'issuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'otherIssuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileProfessionEditContainerApplicantUserMutationResultFieldsFragment, unknown>;
export const ApplicantProfileProfessionEditContainerEntityFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileProfessionEditContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileProfessionEditContainerEntityFieldsFragment, unknown>;
export const ApplicantProfileProfessionViewContainerApplicantUserPersonalInformationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileProfessionViewContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'primaryEducationalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'issuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'issuingInstitution' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'address' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'otherIssuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileProfessionViewContainerApplicantUserPersonalInformationFieldsFragment, unknown>;
export const ApplicantProfileProfessionViewContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileProfessionViewContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileProfessionViewContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileProfessionViewContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'primaryEducationalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'issuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'issuingInstitution' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'address' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'otherIssuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileProfessionViewContainerApplicantUserFieldsFragment, unknown>;
export const ApplicantQualifyingQuestionsContainerEntityFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantQualifyingQuestionsContainerEntityFieldsFragment, unknown>;
export const ApplicantQualifyingQuestionsContainerApplicantUserProfessionalFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } }] }
    }
  ]
} as unknown as DocumentNode<ApplicantQualifyingQuestionsContainerApplicantUserProfessionalFieldsFragment, unknown>;
export const ApplicantQualifyingQuestionsContainerApplicantUserPersonalInformationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerEntityFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserProfessionalFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } }] }
    }
  ]
} as unknown as DocumentNode<ApplicantQualifyingQuestionsContainerApplicantUserPersonalInformationFieldsFragment, unknown>;
export const ApplicantQualifyingQuestionsContainerApplicantUserTermsAndConditionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserTermsAndConditionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserTermsAndCondition' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantQualifyingQuestionsContainerApplicantUserTermsAndConditionFieldsFragment, unknown>;
export const ApplicantQualifyingQuestionsContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserTermsAndConditionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerEntityFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserProfessionalFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserTermsAndConditionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserTermsAndCondition' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantQualifyingQuestionsContainerApplicantUserFieldsFragment, unknown>;
export const ApplicantQualifyingQuestionsContainerApplicantUserMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerEntityFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserProfessionalFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserTermsAndConditionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserTermsAndCondition' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserTermsAndConditionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantQualifyingQuestionsContainerApplicantUserMutationResultFieldsFragment, unknown>;
export const ApplicantUpdateCardModalContainerPaymentInstrumentFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantUpdateCardModalContainerPaymentInstrumentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentInstrument' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'billingAddressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingAddressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingCity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingCountry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingFirstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingLastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingPostalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingState' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'cardNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cardType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentInstrumentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantUpdateCardModalContainerPaymentInstrumentFieldsFragment, unknown>;
export const ApplicantUpdateCardModalContainerPaymentInstrumentMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantUpdateCardModalContainerPaymentInstrumentMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentInstrumentResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentInstrument' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantUpdateCardModalContainerPaymentInstrumentFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantUpdateCardModalContainerPaymentInstrumentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentInstrument' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'billingAddressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingAddressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingCity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingCountry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingFirstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingLastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingPostalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingState' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'cardNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cardType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentInstrumentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantUpdateCardModalContainerPaymentInstrumentMutationResultFieldsFragment, unknown>;
export const ApplicantSectionLayoutContainerApplicantUserCurrentFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantSectionLayoutContainerApplicantUserCurrentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantSectionLayoutContainerApplicantUserCurrentFieldsFragment, unknown>;
export const ApplicantSharedEcfmgHeaderContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantSharedECFMGHeaderContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantSharedEcfmgHeaderContainerApplicantUserFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerFileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerFileInfoFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FileByFileNameFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FileByFileNameFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fileByFileName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fileName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerFileInfoFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FileByFileNameFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credentialAssets' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'translation' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'privateCaseDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'entitySuppliedCredential' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'translation' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'private' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'verificationForm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verificationPacket' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verificationPacketResponse' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verificationComponentPacket' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1Fields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credentialAssets' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'translation' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'privateCaseDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'entitySuppliedCredential' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'translation' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'private' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'verificationForm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verificationPacket' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verificationPacketResponse' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verificationComponentPacket' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1MutationResultFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1BlobContentAuthHeaderResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1BlobContentAuthHeaderResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1BlobContentAuthHeaderResultFieldsFragment,
  unknown
>;
export const CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerFileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerFileInfoFieldsFragment, unknown>;
export const CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FileByFileNameFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FileByFileNameFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fileByFileName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fileName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FileByFileNameFieldsFragment, unknown>;
export const CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'passportAssets' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'passport' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportExpiration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportTranslation' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photoAssets' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'photo' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shared' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'idForm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'notarizedIdForm' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'private' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'redactedNotarizedIdForm' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1Fields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'passportAssets' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'passport' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportExpiration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportTranslation' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photoAssets' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'photo' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shared' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'idForm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'notarizedIdForm' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'private' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'redactedNotarizedIdForm' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1MutationResultFieldsFragment, unknown>;
export const CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFieldsFragment, unknown>;
export const CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFieldsFragment,
  unknown
>;
export const ApplicantPaymentInstrumentDisplayContainerPaymentInstrumentFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPaymentInstrumentDisplayContainerPaymentInstrumentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentInstrument' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'billingAddressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingAddressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingCity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingCountry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingFirstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingLastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingPostalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingState' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'cardNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cardType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentInstrumentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantPaymentInstrumentDisplayContainerPaymentInstrumentFieldsFragment, unknown>;
export const ApplicantCasesActiveCaseListContainerIdentityVerificationCasesV1ByApplicantQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantCasesActiveCaseListContainerIdentityVerificationCasesV1ByApplicantQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCasesV1ByApplicant' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'applicantId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantCasesActiveCaseListContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantCasesActiveCaseListContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ApplicantCasesActiveCaseListContainerIdentityVerificationCasesV1ByApplicantQueryQuery,
  ApplicantCasesActiveCaseListContainerIdentityVerificationCasesV1ByApplicantQueryQueryVariables
>;
export const ApplicantCasesActiveCaseListContainerCredentialVerificationCasesV1ByApplicantQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantCasesActiveCaseListContainerCredentialVerificationCasesV1ByApplicantQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCasesV1ByApplicant' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'applicantId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantCasesActiveCaseListContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantCasesActiveCaseListContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ApplicantCasesActiveCaseListContainerCredentialVerificationCasesV1ByApplicantQueryQuery,
  ApplicantCasesActiveCaseListContainerCredentialVerificationCasesV1ByApplicantQueryQueryVariables
>;
export const ApplicantCasesActiveCaseListContainerSendReportCasesV1ByApplicantQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantCasesActiveCaseListContainerSendReportCasesV1ByApplicantQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCasesV1ByApplicant' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'applicantId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantCasesActiveCaseListContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantCasesActiveCaseListContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ApplicantCasesActiveCaseListContainerSendReportCasesV1ByApplicantQueryQuery,
  ApplicantCasesActiveCaseListContainerSendReportCasesV1ByApplicantQueryQueryVariables
>;
export const ApplicantArchivedCaseListContainerArchivedCasesByApplicantIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantArchivedCaseListContainerArchivedCasesByApplicantId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedCasesByApplicantId' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'applicantId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantArchivedCaseLisContainerArchivedCaseSummaryFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantArchivedCaseLisContainerArchivedCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantArchivedCaseListContainerArchivedCasesByApplicantIdQuery, ApplicantArchivedCaseListContainerArchivedCasesByApplicantIdQueryVariables>;
export const ApplicantCasesCredentialVerificationArchiveSummaryContainerArchivedCredentialVerificationCaseSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantCasesCredentialVerificationArchiveSummaryContainerArchivedCredentialVerificationCaseSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archivedCredentialVerificationCaseSummaryId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedCredentialVerificationCaseSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archivedCredentialVerificationCaseSummaryId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ApplicantCasesCredentialVerificationArchiveSummaryContainerArchivedCredentialVerificationCaseSummaryFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantCasesCredentialVerificationArchiveSummaryContainerArchivedCredentialVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'decision' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'issuingInstitutionName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sendDestinationName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'program' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'adhocTransactions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transactionReference' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'submission' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transactionReference' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ApplicantCasesCredentialVerificationArchiveSummaryContainerArchivedCredentialVerificationCaseSummaryQuery,
  ApplicantCasesCredentialVerificationArchiveSummaryContainerArchivedCredentialVerificationCaseSummaryQueryVariables
>;
export const ApplicantCasesCredentialVerificationArchiveSummaryContainerApplicantUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantCasesCredentialVerificationArchiveSummaryContainerApplicantUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantCasesCredentialVerificationArchiveSummaryContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantCasesCredentialVerificationArchiveSummaryContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'professional' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryEducationalInformation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ApplicantCasesCredentialVerificationArchiveSummaryContainerApplicantUserQuery,
  ApplicantCasesCredentialVerificationArchiveSummaryContainerApplicantUserQueryVariables
>;
export const CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1Fields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1OtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityAddressInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityAddressInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CredentialAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CredentialAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'translation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Application' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendDestination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CredentialAssetsFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialInEnglish' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNameOnCredentialMatchPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'program' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReviewDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RequestedChanges' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedCredentialDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadTranslation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RequestedChanges' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CaseDetailsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RevisionRequestFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1Query,
  CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1QueryVariables
>;
export const CasesCredentialVerificationV1CaseDetailsApplicationContainerEntitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntities' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityAddressInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityAddressInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CaseDetailsApplicationContainerEntitiesQuery,
  CasesCredentialVerificationV1CaseDetailsApplicationContainerEntitiesQueryVariables
>;
export const CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1MutationResultFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1OtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityAddressInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityAddressInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CredentialAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CredentialAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'translation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Application' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerEntityFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendDestination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CredentialAssetsFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialInEnglish' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNameOnCredentialMatchPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'program' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReviewDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1ApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RequestedChanges' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedCredentialDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadTranslation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RequestedChanges' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1CaseDetailsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1RevisionRequestFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1Fields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1UpdateMutation,
  CasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1UpdateMutationVariables
>;
export const CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1Fields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1MessageFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedCredentialDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadTranslation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RequestedChangesFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'serviceFee' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1MessageFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RevisionRequestFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1Query,
  CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1QueryVariables
>;
export const CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1MutationResultFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1MessageFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedCredentialDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadTranslation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RequestedChangesFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'serviceFee' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1MessageFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1RevisionRequestFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1FinanceDetailsFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1Fields' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1UpdateMutation,
  CasesCredentialVerificationV1CaseDetailsMessagesContainerCredentialVerificationCaseV1UpdateMutationVariables
>;
export const CasesCredentialVerificationV1CaseDetailsMessagesContainerApplicantUserPaymentInstrumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerApplicantUserPaymentInstrument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserPaymentInstrument' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerPaymentInstrumentFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerPaymentInstrumentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentInstrument' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'billingAddressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingAddressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingCity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingCountry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingFirstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingLastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingPostalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingState' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'cardNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cardType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentInstrumentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CaseDetailsMessagesContainerApplicantUserPaymentInstrumentQuery,
  CasesCredentialVerificationV1CaseDetailsMessagesContainerApplicantUserPaymentInstrumentQueryVariables
>;
export const CasesCredentialVerificationV1CaseDetailsMessagesContainerApplicantUserCybersourcePublicKeyIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsMessagesContainerApplicantUserCybersourcePublicKeyId' },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'applicantUserCybersourcePublicKeyId' } }] }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CaseDetailsMessagesContainerApplicantUserCybersourcePublicKeyIdQuery,
  CasesCredentialVerificationV1CaseDetailsMessagesContainerApplicantUserCybersourcePublicKeyIdQueryVariables
>;
export const CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1CredentialAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CredentialAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'translation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1OtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Application' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialInEnglish' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNameOnCredentialMatchPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1CredentialAssetsFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'program' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendDestination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerEntityFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'serviceFee' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1ApplicationFields' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1FinanceDetailsFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1Query,
  CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1QueryVariables
>;
export const CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1LazyQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1LazyQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'financeDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFields' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'caseDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'application' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sendDestination' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactionReference' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1LazyQueryQuery,
  CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1LazyQueryQueryVariables
>;
export const CasesCredentialVerificationV1CreateContainerEntitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerEntities' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerEntityFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CreateContainerEntitiesQuery, CasesCredentialVerificationV1CreateContainerEntitiesQueryVariables>;
export const CasesCredentialVerificationV1CreateContainerSendReportCasesV1ByApplicantDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerSendReportCasesV1ByApplicant' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCasesV1ByApplicant' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'applicantId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credential' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'destination' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CreateContainerSendReportCasesV1ByApplicantQuery,
  CasesCredentialVerificationV1CreateContainerSendReportCasesV1ByApplicantQueryVariables
>;
export const CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1MutationResultFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1CredentialAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CredentialAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'translation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1OtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Application' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialInEnglish' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNameOnCredentialMatchPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1CredentialAssetsFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'program' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendDestination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerEntityFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'serviceFee' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1ApplicationFields' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1FinanceDetailsFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1Fields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1UpdateMutation,
  CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1UpdateMutationVariables
>;
export const CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1DeleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1Delete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1DeleteInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1Delete' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'success' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1DeleteMutation,
  CasesCredentialVerificationV1CreateContainerCredentialVerificationCaseV1DeleteMutationVariables
>;
export const CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approval' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'applicantRespondedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'financeReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'recognizedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1FinanceDetailsFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1Query,
  CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1QueryVariables
>;
export const CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserUpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserUpdate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserMutationResultFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nameOnDocumentAssets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserUpdateMutation,
  CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserUpdateMutationVariables
>;
export const CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nameOnDocumentAssets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserQuery,
  CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserQueryVariables
>;
export const CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserFileCreateAuthHeaderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserFileCreateAuthHeader' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserBlobFileInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserFileCreateAuthHeader' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserAuthHeaderMutationResultFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1UploadNameOnDocumentContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserAuthHeaderMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserBlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1UploadNameOnDocumentContainerBlobAuthHeaderFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserFileCreateAuthHeaderMutation,
  CasesCredentialVerificationV1UploadNameOnDocumentContainerApplicantUserFileCreateAuthHeaderMutationVariables
>;
export const ApplicantIdentityVerificationArchiveSummaryContainerArchivedIdentityVerificationCaseSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantIdentityVerificationArchiveSummaryContainerArchivedIdentityVerificationCaseSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedIdentityVerificationCaseSummary' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdentityVerificationArchiveSummaryContainerArchivedIdentityVerificationCaseSummaryFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdentityVerificationArchiveSummaryContainerArchivedIdentityVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'passportDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'decision' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'completedBy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'adhocTransactions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transactionReference' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'completedAt' } }] }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'submission' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transactionReference' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ApplicantIdentityVerificationArchiveSummaryContainerArchivedIdentityVerificationCaseSummaryQuery,
  ApplicantIdentityVerificationArchiveSummaryContainerArchivedIdentityVerificationCaseSummaryQueryVariables
>;
export const ApplicantIdentityVerificationArchiveSummaryContainerApplicantUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantIdentityVerificationArchiveSummaryContainerApplicantUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdentityVerificationArchiveSummaryContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdentityVerificationArchiveSummaryContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'professional' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryEducationalInformation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'issuingInstitution' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ApplicantIdentityVerificationArchiveSummaryContainerApplicantUserQuery,
  ApplicantIdentityVerificationArchiveSummaryContainerApplicantUserQueryVariables
>;
export const CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1Fields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewDecisionFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedPassportDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadExpirationPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassportTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPhoto' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1Query,
  CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1QueryVariables
>;
export const CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1MutationResultFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewDecisionFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedPassportDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadExpirationPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassportTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPhoto' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1CaseDetailsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1RevisionRequestFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1Fields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1UpdateMutation,
  CasesIdentityVerificationV1CaseDetailsApplicationContainerIdentityVerificationCaseV1UpdateMutationVariables
>;
export const CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1MutationResultFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUploadNotarizedIdForm' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shared' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'notarizedIdForm' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1UpdateMutation,
  CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1UpdateMutationVariables
>;
export const CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fileByFileName' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fileName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1FileInfoFields' } }
                    ]
                  }
                },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1Fields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUploadNotarizedIdForm' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1FileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1RevisionRequestFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shared' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'notarizedIdForm' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1Query,
  CasesIdentityVerificationV1CaseDetailsFilesContainerIdentityVerificationCaseV1QueryVariables
>;
export const CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1Fields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1MessageFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestScheduleNotaryCam' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestChangesFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1MessageFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1Query,
  CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1QueryVariables
>;
export const CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1MutationResultFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1MessageFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestScheduleNotaryCam' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestChangesFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1MessageFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1FinanceDetailsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1RevisionRequestFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1Fields' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1UpdateMutation,
  CasesIdentityVerificationV1CaseDetailsMessagesContainerIdentityVerificationCaseV1UpdateMutationVariables
>;
export const CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'passport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpirationUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpirationVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportTranslationUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportTranslationVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportVersion' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPhotoAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'photo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'photoUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'photoVersion' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseWorkerModifiedPassportDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notarizationDetails' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isNotarizationComplete' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportAssetsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photoAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPhotoAssetsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1ApplicationFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'serviceFee' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1FinanceDetailsFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1Query,
  CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1QueryVariables
>;
export const CasesIdentityVerificationV1DraftContainerEntitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerEntities' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerEntityFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1DraftContainerEntitiesQuery, CasesIdentityVerificationV1DraftContainerEntitiesQueryVariables>;
export const CasesIdentityVerificationV1DraftContainerProcessPaymentPollingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerProcessPaymentPolling' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'financeDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'submission' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'transactionReference' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1DraftContainerProcessPaymentPollingQuery,
  CasesIdentityVerificationV1DraftContainerProcessPaymentPollingQueryVariables
>;
export const CasesIdentityVerificationV1DraftContainerApplicantUserPaymentInstrumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerApplicantUserPaymentInstrument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserPaymentInstrument' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerApplicantUserPaymentInstrumentFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerApplicantUserPaymentInstrumentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentInstrument' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'billingAddressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingAddressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingCity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingCountry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingFirstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingLastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingPostalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingState' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'cardNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cardType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentInstrumentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1DraftContainerApplicantUserPaymentInstrumentQuery,
  CasesIdentityVerificationV1DraftContainerApplicantUserPaymentInstrumentQueryVariables
>;
export const CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1MutationResultFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'passport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpirationUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpirationVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportTranslationUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportTranslationVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportVersion' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPhotoAssetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'photo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'photoUploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'photoVersion' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseWorkerModifiedPassportDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notarizationDetails' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isNotarizationComplete' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportAssetsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photoAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsApplicationPhotoAssetsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1ApplicationFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'serviceFee' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1CaseDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1FinanceDetailsFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1Fields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1UpdateMutation,
  CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1UpdateMutationVariables
>;
export const CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1DeleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1Delete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1DeleteInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1Delete' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'success' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1DeleteMutation,
  CasesIdentityVerificationV1DraftContainerIdentityVerificationCaseV1DeleteMutationVariables
>;
export const CasesIdentityVerificationV1TransactionsContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1TransactionsContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1TransactionsContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantUserIdVerificationTransactionsFinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approval' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'applicantRespondedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'financeReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1TransactionsContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantUserIdVerificationTransactionsFinanceDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1TransactionsContainerIdentityVerificationCaseV1Query,
  CasesIdentityVerificationV1TransactionsContainerIdentityVerificationCaseV1QueryVariables
>;
export const ApplicantCasesSectionLayoutContainerCredentialVerificationCaseV1CurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantCasesSectionLayoutContainerCredentialVerificationCaseV1Current' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1Current' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'applicantId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantCasesSectionLayoutContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantCasesSectionLayoutContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'decision' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'result' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ApplicantCasesSectionLayoutContainerCredentialVerificationCaseV1CurrentQuery,
  ApplicantCasesSectionLayoutContainerCredentialVerificationCaseV1CurrentQueryVariables
>;
export const ApplicantCasesSectionLayoutContainerApplicantUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantCasesSectionLayoutContainerApplicantUserCurrent' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserCurrent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantCasesSectionLayoutContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantCasesSectionLayoutContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasVerifiedCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasVerifiedIdentity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantCasesSectionLayoutContainerApplicantUserCurrentQuery, ApplicantCasesSectionLayoutContainerApplicantUserCurrentQueryVariables>;
export const ApplicantSectionLayoutContainerSendReportCaseV1CurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantSectionLayoutContainerSendReportCaseV1Current' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1Current' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'applicantId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantCasesSectionLayoutContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantCasesSectionLayoutContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'decision' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'result' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantSectionLayoutContainerSendReportCaseV1CurrentQuery, ApplicantSectionLayoutContainerSendReportCaseV1CurrentQueryVariables>;
export const ApplicantCasesSendReportArchiveSummaryContainerArchivedSendReportCaseSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantCasesSendReportArchiveSummaryContainerArchivedSendReportCaseSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedSendReportCaseSummary' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantCasesSendReportArchiveSummaryContainerArchivedSendReportCaseSummaryFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantCasesSendReportArchiveSummaryContainerArchivedSendReportCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'destinationName' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'decision' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'completedBy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'adhocTransactions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transactionReference' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'completedAt' } }] }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'submission' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transactionReference' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ApplicantCasesSendReportArchiveSummaryContainerArchivedSendReportCaseSummaryQuery,
  ApplicantCasesSendReportArchiveSummaryContainerArchivedSendReportCaseSummaryQueryVariables
>;
export const ApplicantCasesSendReportArchiveSummaryContainerApplicantUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantCasesSendReportArchiveSummaryContainerApplicantUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantCasesSendReportArchiveSummaryContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantCasesSendReportArchiveSummaryContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'professional' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryEducationalInformation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'issuingInstitution' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantCasesSendReportArchiveSummaryContainerApplicantUserQuery, ApplicantCasesSendReportArchiveSummaryContainerApplicantUserQueryVariables>;
export const SendReportV1CaseDetailsApplicationContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SendReportV1CaseDetailsApplicationContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SendReportV1CaseDetailsApplicationContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CaseDetailsApplicationContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credential' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'caseDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'application' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'issuingInstitution' },
                                          selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'entityName' } }] }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'otherIssuingInstitution' },
                                          selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'institutionName' } }] }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'destination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'decision' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'result' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requestedChanges' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedDestination' } }] }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SendReportV1CaseDetailsApplicationContainerSendReportCaseV1Query, SendReportV1CaseDetailsApplicationContainerSendReportCaseV1QueryVariables>;
export const SendReportV1CaseDetailsApplicationContainerEntitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SendReportV1CaseDetailsApplicationContainerEntities' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SendReportV1CaseDetailsApplicationContainerEntityFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CaseDetailsApplicationContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SendReportV1CaseDetailsApplicationContainerEntitiesQuery, SendReportV1CaseDetailsApplicationContainerEntitiesQueryVariables>;
export const SendReportV1CaseDetailsApplicationContainerSendReportCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendReportV1CaseDetailsApplicationContainerSendReportCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'success' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sendReportCaseV1' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'caseDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'application' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'destination' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'credential' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  SendReportV1CaseDetailsApplicationContainerSendReportCaseV1UpdateMutation,
  SendReportV1CaseDetailsApplicationContainerSendReportCaseV1UpdateMutationVariables
>;
export const CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1MessageFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestRequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequestRequestChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedDestination' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestRequestedChangesFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionsFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1MessageFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1Query, CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1QueryVariables>;
export const CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1MutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1MessageFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestRequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequestRequestChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedDestination' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestRequestedChangesFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsTransactionsFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1MessageFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1RevisionRequestFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1FinanceDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1UpdateMutation,
  CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1UpdateMutationVariables
>;
export const SendReportV1CreateContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SendReportV1CreateContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SendReportV1CreateContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CreateContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'serviceFee' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'submission' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transactionReference' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }] }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SendReportV1CreateContainerSendReportCaseV1Query, SendReportV1CreateContainerSendReportCaseV1QueryVariables>;
export const SendReportV1CreateContainerVerifiedCredentialVerificationCaseSummariesByApplicantDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SendReportV1CreateContainerVerifiedCredentialVerificationCaseSummariesByApplicant' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verifiedCredentialVerificationCaseSummariesByApplicant' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'applicantId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SendReportV1CreateContainerVerifiedCredentialVerificationCaseSummaryFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CreateContainerVerifiedCredentialVerificationCaseSummaryCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VerifiedCredentialVerificationCaseSummaryCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'issuingInstitutionName' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CreateContainerVerifiedCredentialVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VerifiedCredentialVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SendReportV1CreateContainerVerifiedCredentialVerificationCaseSummaryCaseDetailsFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  SendReportV1CreateContainerVerifiedCredentialVerificationCaseSummariesByApplicantQuery,
  SendReportV1CreateContainerVerifiedCredentialVerificationCaseSummariesByApplicantQueryVariables
>;
export const SendReportV1CreateContainerEntitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SendReportV1CreateContainerEntities' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entities' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SendReportV1CreateContainerEntityFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CreateContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SendReportV1CreateContainerEntitiesQuery, SendReportV1CreateContainerEntitiesQueryVariables>;
export const SendReportV1CreateContainerSendReportCaseV1LazyQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SendReportV1CreateContainerSendReportCaseV1LazyQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'financeDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SendReportV1CreateContainerSendReportCaseV1FinanceDetailsTransactionsFields' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CreateContainerSendReportCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactionReference' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SendReportV1CreateContainerSendReportCaseV1LazyQueryQuery, SendReportV1CreateContainerSendReportCaseV1LazyQueryQueryVariables>;
export const SendReportV1CreateContainerSendReportCaseV1DeleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendReportV1CreateContainerSendReportCaseV1Delete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1DeleteInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1Delete' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'success' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SendReportV1CreateContainerSendReportCaseV1DeleteMutation, SendReportV1CreateContainerSendReportCaseV1DeleteMutationVariables>;
export const SendReportV1CreateContainerSendReportCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendReportV1CreateContainerSendReportCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'success' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sendReportCaseV1' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SendReportV1CreateContainerSendReportCaseV1MutationResultFields' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CreateContainerSendReportCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactionReference' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CreateContainerSendReportCaseV1MutationApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destination' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credential' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CreateContainerSendReportCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SendReportV1CreateContainerSendReportCaseV1FinanceDetailsTransactionsFields' } }]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SendReportV1CreateContainerSendReportCaseV1MutationApplicationFields' } }]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SendReportV1CreateContainerSendReportCaseV1UpdateMutation, SendReportV1CreateContainerSendReportCaseV1UpdateMutationVariables>;
export const CasesSendReportV1TransactionsContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1TransactionsContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1TransactionsContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantUserSendReportVerificationTransactionsFinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approval' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'applicantRespondedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'financeReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'recognizedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1TransactionsContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantUserSendReportVerificationTransactionsFinanceDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1TransactionsContainerSendReportCaseV1Query, CasesSendReportV1TransactionsContainerSendReportCaseV1QueryVariables>;
export const ApplicantContactDetailsContainerApplicantUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserIdentityDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserIdentityDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserAddressFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserPhoneFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPhone' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserContactInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserContactInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserAddressFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phone' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserPhoneFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserCitizenshipFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserCitizenship' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserIdentityDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserContactInformationFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserCitizenshipFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserTermsAndConditionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserTermsAndCondition' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserTermsAndConditionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantContactDetailsContainerApplicantUserQuery, ApplicantContactDetailsContainerApplicantUserQueryVariables>;
export const ApplicantContactDetailsContainerApplicantUserUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserUpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserUpdate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserMutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserIdentityDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserIdentityDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserAddressFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserPhoneFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPhone' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserContactInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserContactInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserAddressFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phone' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserPhoneFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserCitizenshipFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserCitizenship' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserIdentityDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserContactInformationFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserCitizenshipFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserTermsAndConditionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserTermsAndCondition' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserTermsAndConditionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantContactDetailsContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantContactDetailsContainerApplicantUserUpdateMutation, ApplicantContactDetailsContainerApplicantUserUpdateMutationVariables>;
export const ApplicantIdVerificationPreviewContainerApplicantUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserCitizenshipFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserCitizenship' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserAddressFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserPhoneFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPhone' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserContactInformationField' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserContactInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserAddressFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phone' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserPhoneFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserIdentityDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserIdentityDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserIssuingInstitutionAddressFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityAddressInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserOtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserOtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserPrimaryEducationalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPrimaryEducationalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserIssuingInstitutionAddressFields' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserOtherIssuingInstitutionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEducationalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserPrimaryEducationalInformationFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerEntityFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserCitizenshipFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserContactInformationField' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserIdentityDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserProfessionalFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserTermsAndConditionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserTermsAndCondition' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerApplicantUserTermsAndConditionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantIdVerificationPreviewContainerApplicantUserQuery, ApplicantIdVerificationPreviewContainerApplicantUserQueryVariables>;
export const ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1Query,
  ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1QueryVariables
>;
export const ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1MutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1UpdateMutation,
  ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1UpdateMutationVariables
>;
export const ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1DeleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1Delete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1DeleteInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1Delete' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1MutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1CaseDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1DeleteMutation,
  ApplicantIdVerificationPreviewContainerIdentityVerificationCaseV1DeleteMutationVariables
>;
export const IdVerificationProcessPaymentContainerApplicantUserCybersourcePublicKeyIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerApplicantUserCybersourcePublicKeyId' },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'applicantUserCybersourcePublicKeyId' } }] }
    }
  ]
} as unknown as DocumentNode<
  IdVerificationProcessPaymentContainerApplicantUserCybersourcePublicKeyIdQuery,
  IdVerificationProcessPaymentContainerApplicantUserCybersourcePublicKeyIdQueryVariables
>;
export const IdVerificationProcessPaymentContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'serviceFee' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1FinanceDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  IdVerificationProcessPaymentContainerIdentityVerificationCaseV1Query,
  IdVerificationProcessPaymentContainerIdentityVerificationCaseV1QueryVariables
>;
export const IdVerificationProcessPaymentContainerApplicantUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerApplicantUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<IdVerificationProcessPaymentContainerApplicantUserQuery, IdVerificationProcessPaymentContainerApplicantUserQueryVariables>;
export const IdVerificationProcessPaymentContainerIdentityVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1MutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'serviceFee' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1FinanceDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1Fields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  IdVerificationProcessPaymentContainerIdentityVerificationCaseV1UpdateMutation,
  IdVerificationProcessPaymentContainerIdentityVerificationCaseV1UpdateMutationVariables
>;
export const IdVerificationProcessPaymentContainerApplicantUserUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerApplicantUserUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserUpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserUpdate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerApplicantUserMutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerApplicantUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<IdVerificationProcessPaymentContainerApplicantUserUpdateMutation, IdVerificationProcessPaymentContainerApplicantUserUpdateMutationVariables>;
export const IdVerificationProcessPaymentContainerIdentityVerificationCaseV1DeleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1Delete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1DeleteInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1Delete' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1MutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'serviceFee' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1FinanceDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'IdVerificationProcessPaymentContainerIdentityVerificationCaseV1Fields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  IdVerificationProcessPaymentContainerIdentityVerificationCaseV1DeleteMutation,
  IdVerificationProcessPaymentContainerIdentityVerificationCaseV1DeleteMutationVariables
>;
export const ApplicantPassportDetailsContainerIdentityVerificationCaseV1CurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1Current' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1Current' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'applicantId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ApplicantPassportDetailsContainerIdentityVerificationCaseV1CurrentQuery,
  ApplicantPassportDetailsContainerIdentityVerificationCaseV1CurrentQueryVariables
>;
export const PassportDetailsContainerCurrentFilesQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PassportDetailsContainerCurrentFilesQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1Current' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'applicantId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'files' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<PassportDetailsContainerCurrentFilesQueryQuery, PassportDetailsContainerCurrentFilesQueryQueryVariables>;
export const ApplicantPassportDetailsContainerApplicantUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerApplicantUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantPassportDetailsContainerApplicantUserQuery, ApplicantPassportDetailsContainerApplicantUserQueryVariables>;
export const ApplicantPassportDetailsContainerIdentityVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1MutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1Fields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ApplicantPassportDetailsContainerIdentityVerificationCaseV1UpdateMutation,
  ApplicantPassportDetailsContainerIdentityVerificationCaseV1UpdateMutationVariables
>;
export const ApplicantPassportDetailsContainerIdentityVerificationCaseV1DeleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1Delete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1DeleteInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1Delete' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1MutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPassportDetailsContainerIdentityVerificationCaseV1Fields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ApplicantPassportDetailsContainerIdentityVerificationCaseV1DeleteMutation,
  ApplicantPassportDetailsContainerIdentityVerificationCaseV1DeleteMutationVariables
>;
export const IdVerificationPaymentPollingContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IdVerificationPaymentPollingContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'IdVerificationPaymentPollingContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IdVerificationPaymentPollingContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'submission' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transactionReference' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  IdVerificationPaymentPollingContainerIdentityVerificationCaseV1Query,
  IdVerificationPaymentPollingContainerIdentityVerificationCaseV1QueryVariables
>;
export const PaymentContainerApplicantUserCybersourcePublicKeyIdQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PaymentContainerApplicantUserCybersourcePublicKeyIdQuery' },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'applicantUserCybersourcePublicKeyId' } }] }
    }
  ]
} as unknown as DocumentNode<PaymentContainerApplicantUserCybersourcePublicKeyIdQueryQuery, PaymentContainerApplicantUserCybersourcePublicKeyIdQueryQueryVariables>;
export const ApplicantPrimaryEducationDetailsContainerApplicantUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserOtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserOtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserPrimaryEducationalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPrimaryEducationalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserOtherIssuingInstitutionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEducationalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserPrimaryEducationalInformationFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserProfessionalFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantPrimaryEducationDetailsContainerApplicantUserQuery, ApplicantPrimaryEducationDetailsContainerApplicantUserQueryVariables>;
export const ApplicantPrimaryEducationDetailsContainerApplicantUserUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserUpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserUpdate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserMutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserOtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserOtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserPrimaryEducationalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPrimaryEducationalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserOtherIssuingInstitutionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEducationalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserPrimaryEducationalInformationFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserProfessionalFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ApplicantPrimaryEducationDetailsContainerApplicantUserUpdateMutation,
  ApplicantPrimaryEducationDetailsContainerApplicantUserUpdateMutationVariables
>;
export const ApplicantPrimaryEducationDetailsContainerEntitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerEntities' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerEntityFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPrimaryEducationDetailsContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantPrimaryEducationDetailsContainerEntitiesQuery, ApplicantPrimaryEducationDetailsContainerEntitiesQueryVariables>;
export const ApplicantProfileApplyToEditContainerApplicantUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantProfileApplyToEditContainerApplicantUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileApplyToEditContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileApplyToEditContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applyingTo' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileApplyToEditContainerApplicantUserQuery, ApplicantProfileApplyToEditContainerApplicantUserQueryVariables>;
export const ApplicantProfileApplyToEditContainerEntitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantProfileApplyToEditContainerEntities' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entities' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileApplyToEditContainerEntityFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileApplyToEditContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileApplyToEditContainerEntitiesQuery, ApplicantProfileApplyToEditContainerEntitiesQueryVariables>;
export const ApplicantProfileApplyToEditContainerApplicantUserUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplicantProfileApplyToEditContainerApplicantUserUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserUpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserUpdate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileApplyToEditContainerApplicantUserMutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileApplyToEditContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applyingTo' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileApplyToEditContainerApplicantUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileApplyToEditContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileApplyToEditContainerApplicantUserUpdateMutation, ApplicantProfileApplyToEditContainerApplicantUserUpdateMutationVariables>;
export const ApplicantProfileApplyToViewContainerApplicantUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantProfileApplyToViewContainerApplicantUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileApplyToViewContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileApplyToViewContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applyingTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileApplyToViewContainerApplicantUserQuery, ApplicantProfileApplyToViewContainerApplicantUserQueryVariables>;
export const ApplicantProfileCitizenshipEditContainerApplicantUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantProfileCitizenshipEditContainerApplicantUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileCitizenshipEditContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileCitizenshipEditContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileCitizenshipEditContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileCitizenshipEditContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileCitizenshipEditContainerApplicantUserQuery, ApplicantProfileCitizenshipEditContainerApplicantUserQueryVariables>;
export const ApplicantProfileCitizenshipEditContainerApplicantUserUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplicantProfileCitizenshipEditContainerApplicantUserUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserUpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserUpdate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileCitizenshipEditContainerApplicantUserMutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileCitizenshipEditContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileCitizenshipEditContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileCitizenshipEditContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileCitizenshipEditContainerApplicantUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileCitizenshipEditContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ApplicantProfileCitizenshipEditContainerApplicantUserUpdateMutation,
  ApplicantProfileCitizenshipEditContainerApplicantUserUpdateMutationVariables
>;
export const ApplicantProfileCitizenshipViewContainerApplicantUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantProfileCitizenshipViewContainerApplicantUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileCitizenshipViewContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileCitizenshipViewContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileCitizenshipViewContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileCitizenshipViewContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileCitizenshipViewContainerApplicantUserQuery, ApplicantProfileCitizenshipViewContainerApplicantUserQueryVariables>;
export const ApplicantProfileContactContainerApplicantUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantProfileContactContainerApplicantUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileContactContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserAddressFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserPhoneFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPhone' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserContactInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserContactInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserAddressFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phone' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserPhoneFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserContactInformationFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileContactContainerApplicantUserQuery, ApplicantProfileContactContainerApplicantUserQueryVariables>;
export const ApplicantProfileContactContainerApplicantUserUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplicantProfileContactContainerApplicantUserUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserUpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserUpdate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileContactContainerApplicantUserMutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserAddressFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserPhoneFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPhone' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserContactInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserContactInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserAddressFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phone' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserPhoneFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserContactInformationFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileContactEditContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileContactContainerApplicantUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileContactContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileContactContainerApplicantUserUpdateMutation, ApplicantProfileContactContainerApplicantUserUpdateMutationVariables>;
export const ApplicantProfileIdentityDocumentUploadContainerApplicantUserUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerApplicantUserUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserUpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserUpdate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerApplicantUserMutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nameOnDocumentAssets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDeleteRequested' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerApplicantUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ApplicantProfileIdentityDocumentUploadContainerApplicantUserUpdateMutation,
  ApplicantProfileIdentityDocumentUploadContainerApplicantUserUpdateMutationVariables
>;
export const ApplicantProfileIdentityDocumentUploadContainerApplicantUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerApplicantUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nameOnDocumentAssets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDeleteRequested' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileIdentityDocumentUploadContainerApplicantUserQuery, ApplicantProfileIdentityDocumentUploadContainerApplicantUserQueryVariables>;
export const ApplicantProfileIdentityDocumentUploadContainerApplicantUserFileCreateAuthHeaderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerApplicantUserFileCreateAuthHeader' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserBlobFileInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserFileCreateAuthHeader' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerApplicantUserAuthHeaderMutationResultFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerApplicantUserAuthHeaderMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserBlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerAuthHeaderFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ApplicantProfileIdentityDocumentUploadContainerApplicantUserFileCreateAuthHeaderMutation,
  ApplicantProfileIdentityDocumentUploadContainerApplicantUserFileCreateAuthHeaderMutationVariables
>;
export const ApplicantProfileIdentityDocumentUploadContainerApplicantUserFileRemoveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerApplicantUserFileRemove' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPublicFileRemoveInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserFileRemove' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerApplicantUserMutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nameOnDocumentAssets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDeleteRequested' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerApplicantUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileIdentityDocumentUploadContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ApplicantProfileIdentityDocumentUploadContainerApplicantUserFileRemoveMutation,
  ApplicantProfileIdentityDocumentUploadContainerApplicantUserFileRemoveMutationVariables
>;
export const ApplicantProfileIdentityContainerQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantProfileIdentityContainerQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileIdentityContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileIdentityContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nameOnDocumentAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDeleteRequested' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileIdentityContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileIdentityContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileIdentityContainerQueryQuery, ApplicantProfileIdentityContainerQueryQueryVariables>;
export const ApplicantProfileProfessionEditContainerEntitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantProfileProfessionEditContainerEntities' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileProfessionEditContainerEntityFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileProfessionEditContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileProfessionEditContainerEntitiesQuery, ApplicantProfileProfessionEditContainerEntitiesQueryVariables>;
export const ApplicantProfileProfessionEditContainerApplicantUserUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplicantProfileProfessionEditContainerApplicantUserUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserUpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserUpdate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileProfessionEditContainerApplicantUserMutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileProfessionEditContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEducationalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'issuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'otherIssuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileProfessionEditContainerApplicantUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'personalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'professional' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileProfessionEditContainerApplicantUserProfessionalFields' } }]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileProfessionEditContainerApplicantUserUpdateMutation, ApplicantProfileProfessionEditContainerApplicantUserUpdateMutationVariables>;
export const ApplicantProfileProfessionViewContainerApplicantUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantProfileProfessionViewContainerApplicantUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileProfessionViewContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileProfessionViewContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'primaryEducationalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'issuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'issuingInstitution' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'address' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'otherIssuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantProfileProfessionViewContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantProfileProfessionViewContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantProfileProfessionViewContainerApplicantUserQuery, ApplicantProfileProfessionViewContainerApplicantUserQueryVariables>;
export const ApplicantQualifyingQuestionsContainerApplicantUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserCurrent' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserCurrent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerEntityFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserProfessionalFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserTermsAndConditionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserTermsAndCondition' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserTermsAndConditionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantQualifyingQuestionsContainerApplicantUserCurrentQuery, ApplicantQualifyingQuestionsContainerApplicantUserCurrentQueryVariables>;
export const ApplicantQualifyingQuestionsContainerEntitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerEntities' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerEntityFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantQualifyingQuestionsContainerEntitiesQuery, ApplicantQualifyingQuestionsContainerEntitiesQueryVariables>;
export const ApplicantQualifyingQuestionsContainerApplicantUserUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserUpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserUpdate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserMutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerEntityFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserProfessionalFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserTermsAndConditionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserTermsAndCondition' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserTermsAndConditionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantQualifyingQuestionsContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantQualifyingQuestionsContainerApplicantUserUpdateMutation, ApplicantQualifyingQuestionsContainerApplicantUserUpdateMutationVariables>;
export const ApplicantUpdateCardModalContainerApplicantUserUpdatePaymentInstrumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplicantUpdateCardModalContainerApplicantUserUpdatePaymentInstrument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserUpdatePaymentInstrumentInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserUpdatePaymentInstrument' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantUpdateCardModalContainerPaymentInstrumentMutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantUpdateCardModalContainerPaymentInstrumentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentInstrument' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'billingAddressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingAddressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingCity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingCountry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingFirstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingLastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingPostalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingState' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'cardNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cardType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentInstrumentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantUpdateCardModalContainerPaymentInstrumentMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentInstrumentResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentInstrument' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantUpdateCardModalContainerPaymentInstrumentFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ApplicantUpdateCardModalContainerApplicantUserUpdatePaymentInstrumentMutation,
  ApplicantUpdateCardModalContainerApplicantUserUpdatePaymentInstrumentMutationVariables
>;
export const ApplicantSectionLayoutContainerApplicantUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantSectionLayoutContainerApplicantUserCurrent' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserCurrent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantSectionLayoutContainerApplicantUserCurrentFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantSectionLayoutContainerApplicantUserCurrentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantSectionLayoutContainerApplicantUserCurrentQuery, ApplicantSectionLayoutContainerApplicantUserCurrentQueryVariables>;
export const ApplicantSharedEcfmgHeaderContainerApplicantUserCurrentQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantSharedECFMGHeaderContainerApplicantUserCurrentQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserCurrent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantSharedECFMGHeaderContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantSharedECFMGHeaderContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantSharedEcfmgHeaderContainerApplicantUserCurrentQueryQuery, ApplicantSharedEcfmgHeaderContainerApplicantUserCurrentQueryQueryVariables>;
export const CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FileByFileNameFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FileByFileNameFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fileByFileName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fileName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerFileInfoFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1Query,
  CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1QueryVariables
>;
export const CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1MutationResultFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credentialAssets' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'translation' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'privateCaseDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'entitySuppliedCredential' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'translation' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'private' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'verificationForm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verificationPacket' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verificationPacketResponse' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verificationComponentPacket' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1Fields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1UpdateMutation,
  CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1UpdateMutationVariables
>;
export const CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FileCreateAuthHeaderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FileCreateAuthHeader' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1BlobFileInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1FileCreateAuthHeader' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1BlobContentAuthHeaderResultFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1BlobContentAuthHeaderResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FileCreateAuthHeaderMutation,
  CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FileCreateAuthHeaderMutationVariables
>;
export const CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1PdfFileCreateAuthHeaderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1PdfFileCreateAuthHeader' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1BlobFileInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1PdfFileCreateAuthHeader' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1BlobContentAuthHeaderResultFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1BlobContentAuthHeaderResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1PdfFileCreateAuthHeaderMutation,
  CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1PdfFileCreateAuthHeaderMutationVariables
>;
export const CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1ImageFileCreateAuthHeaderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1ImageFileCreateAuthHeader' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1BlobFileInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1ImageFileCreateAuthHeader' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1BlobContentAuthHeaderResultFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1BlobContentAuthHeaderResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1ImageFileCreateAuthHeaderMutation,
  CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1ImageFileCreateAuthHeaderMutationVariables
>;
export const CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FileByFileNameFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FileByFileNameFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fileByFileName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fileName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1Query,
  CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1QueryVariables
>;
export const CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1MutationResultFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'passportAssets' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'passport' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportExpiration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportTranslation' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photoAssets' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'photo' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shared' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'idForm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'notarizedIdForm' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'private' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'redactedNotarizedIdForm' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1Fields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1UpdateMutation,
  CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1UpdateMutationVariables
>;
export const CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FileCreateAuthHeaderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FileCreateAuthHeader' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1BlobFileInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1FileCreateAuthHeader' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FileCreateAuthHeaderMutation,
  CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FileCreateAuthHeaderMutationVariables
>;
export const CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1PdfFileCreateAuthHeaderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1PdfFileCreateAuthHeader' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1BlobFileInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1PdfFileCreateAuthHeader' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1PdfFileCreateAuthHeaderMutation,
  CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1PdfFileCreateAuthHeaderMutationVariables
>;
export const CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1ImageFileCreateAuthHeaderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1ImageFileCreateAuthHeader' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1BlobFileInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1ImageFileCreateAuthHeader' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1ImageFileCreateAuthHeaderMutation,
  CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1ImageFileCreateAuthHeaderMutationVariables
>;
export const ApplicantSharedFileUploadProcessMaliciousFileScanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplicantSharedFileUploadProcessMaliciousFileScan' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProcessMaliciousFileScanInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'processMaliciousFileScan' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'success' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'scanResult' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isMalicious' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSafe' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantSharedFileUploadProcessMaliciousFileScanMutation, ApplicantSharedFileUploadProcessMaliciousFileScanMutationVariables>;
export const MaintenanceMessageProviderGetServerDateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MaintenanceMessageProviderGetServerDate' },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'serverDate' } }] }
    }
  ]
} as unknown as DocumentNode<MaintenanceMessageProviderGetServerDateQuery, MaintenanceMessageProviderGetServerDateQueryVariables>;
export const ServerDateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ServerDate' },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'serverDate' } }] }
    }
  ]
} as unknown as DocumentNode<ServerDateQuery, ServerDateQueryVariables>;
export const ApplicantPaymentInstrumentDisplayContainerApplicantUserPaymentInstrumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantPaymentInstrumentDisplayContainerApplicantUserPaymentInstrument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserPaymentInstrument' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantPaymentInstrumentDisplayContainerPaymentInstrumentFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantPaymentInstrumentDisplayContainerPaymentInstrumentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentInstrument' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'billingAddressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingAddressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingCity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingCountry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingFirstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingLastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingPostalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billingState' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'cardNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cardType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentInstrumentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ApplicantPaymentInstrumentDisplayContainerApplicantUserPaymentInstrumentQuery,
  ApplicantPaymentInstrumentDisplayContainerApplicantUserPaymentInstrumentQueryVariables
>;
